webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _axiosM = __webpack_require__(65);

var _axiosM2 = _interopRequireDefault(_axiosM);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(23);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import cookie from 'js-cookie'
exports.default = function (options) {
  if (!(0, _browser.app)()) {
    var getUTMProp = _sa2.default.getUTMProp,
        getAnonymousID = _sa2.default.getAnonymousID,
        current_page_id = _sa2.default.current_page_id,
        current_page_name = _sa2.default.current_page_name,
        current_page_type = _sa2.default.current_page_type;


    var utmData = {};
    var cache_utm_source = null;

    try {
      utmData = getUTMProp();
      cache_utm_source = window.localStorage.getItem('the_utm_source') || null;
    } catch (err) {}

    utmData['theLatestUtmSource'] = cache_utm_source ? JSON.parse(cache_utm_source).value : '';
    // const userId = cookie.get('_b_m_c')
    var sensors = (0, _extends3.default)({
      // userId: userId || '',
      anonymousId: getAnonymousID(),
      currentPageType: current_page_type,
      currentPageName: current_page_name,
      currentPageId: current_page_id
    }, utmData);
    options.headers = {
      'TBS-Sensors': (0, _b2a.btoa)((0, _stringify2.default)(sensors))
    };
  }
  if ((0, _browser.android)()) {
    var url = options.url;
    options.url = url.replace('/app', 'app'); //兼容安卓
  }
  return (0, _axiosM2.default)(options);
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackerM = __webpack_require__(144);

var _trackerM2 = _interopRequireDefault(_trackerM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _trackerM2.default;

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(41),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  login: function login(data) {
    return (0, _axiosMock2.default)({
      url: '/app/authentication',
      method: 'POST',
      json: data
    });
  },
  sms: function sms(phone, captcha) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'VERIFY_CODE';

    return (0, _axiosMock2.default)({
      url: '/app/sms',
      method: 'POST',
      json: {
        'phone': phone,
        'captcha': captcha,
        'type': type
      }
    });
  },
  checkVerifiedMobile: function checkVerifiedMobile(phone) {
    return (0, _axiosMock2.default)({
      url: '/app/member/checkVerifiedMobile',
      method: 'PUT',
      json: phone
    });
  },
  verifiedMobile: function verifiedMobile(phone, captcha, password) {
    var data = {
      "verifiedMobile": phone
    };
    if (password) {
      data.password = password;
    }
    return (0, _axiosMock2.default)({
      url: '/app/member/verifiedMobile?captcha=' + captcha,
      method: 'PUT',
      json: data
    });
  },
  register: function register(phone, password, captcha) {
    return (0, _axiosMock2.default)({
      url: '/app/register?captcha=' + captcha,
      method: 'POST',
      json: {
        'principal': phone,
        'credential': password
      }
    });
  },
  merge: function merge(id) {
    return (0, _axiosMock2.default)({
      url: '/app/member/merge?id=' + id,
      method: 'POST',
      json: {}
    });
  },
  modification: function modification(phone, password, captcha) {
    return (0, _axiosMock2.default)({
      url: '/app/key/modification',
      method: 'POST',
      json: {
        'principal': phone,
        'from': captcha,
        'to': password
      }
    });
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAA1NTUzMzOAgIAzMzMzMzMzMzMzMzM2NjYzMzM0NDQ0NDQzMzMzMzM0NDQ0NDQ0NDQ0NDQ5OTkzMzM0NDRVVVUzMzON+zFHAAAAFnRSTlMAKPIC6KKemziWOpg86c6sgFwk5DYDEV2J5QAAAJRJREFUOMuNz1EOgjAQRdEiahUURKX7XyqZQrgfj5cwX03OTadNJ+aTDTTDt3op+djf5RdFLluhXi7/ON33QvxRjy2FuilwUzRXXAvcFLgpcC165xS4KUbcFN6jGCPorMf+7aXeTcH/u1stvKc2iqf3RGGcwjiFdQp1LfAXTKGuBW6LAddiqjfsLkW/7lhdZ57SiVkA+NoPtqaZ3NoAAAAASUVORK5CYII="

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(40),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sensors = window.sensorsDataAnalytic201505;
var is_production = "production" === 'production';
console.log(is_production, '###############');
var options = {
  // server_url: is_production?'https://datasink.thebeastshop.com/sa?project=production':'https://datasink.thebeastshop.com/sa?project=default',
  // server_url: 'https://datasink.thebeastshop.com/sa?project=default',
  server_url: 'https://datasink.thebeastshop.com/sa?project=production',
  platform_type: 'WAP'
};

var Sa = function () {
  function Sa(_ref) {
    var _ref$server_url = _ref.server_url,
        server_url = _ref$server_url === undefined ? '' : _ref$server_url,
        _ref$platform_type = _ref.platform_type,
        platform_type = _ref$platform_type === undefined ? '' : _ref$platform_type;
    (0, _classCallCheck3.default)(this, Sa);

    this.isSDKinit = false;
    this.server_url = server_url;

    // 公共属性
    this.is_login = false;
    this.vip_level = '';
    this.current_page_type = '';
    this.current_page_name = '';
    this.current_page_id = '';
    this.platform_type = platform_type;
    this.thelatest_utm_source = '';

    // 前向页面名称
    this.refer_page_name = '';
    this.refer_page_type = '';
    this.refer_page_id = '';
  }

  (0, _createClass3.default)(Sa, [{
    key: 'setParams',
    value: function setParams() {
      if (this.isSDKinit) return;

      this._setParam();
      this._registerApp();
    }
  }, {
    key: 'changeIdentify',
    value: function changeIdentify(distinctID) {
      sensors.identify(distinctID, true);
    }
  }, {
    key: 'track',
    value: function track() {
      return sensors.track.apply(sensors, arguments);
    }
  }, {
    key: 'addCart',
    value: function addCart(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('AddToShoppingCart', params);
    }
  }, {
    key: 'registerButtonClick',
    value: function registerButtonClick(name) {
      this.track('RegisterButtonClick', {
        button_name: name
      });
    }
  }, {
    key: 'getUTMProp',
    value: function getUTMProp() {
      var _sensors$getPresetPro = sensors.getPresetProperties(),
          $latest_utm_campaign = _sensors$getPresetPro.$latest_utm_campaign,
          $latest_utm_content = _sensors$getPresetPro.$latest_utm_content,
          $latest_utm_source = _sensors$getPresetPro.$latest_utm_source,
          $latest_utm_term = _sensors$getPresetPro.$latest_utm_term;

      return {
        theLatestUtmCampaign: $latest_utm_campaign,
        theLatestUtmContent: $latest_utm_content,
        theLatestUtmSource: $latest_utm_source,
        theLatestUtmTerm: $latest_utm_term
      };
    }
  }, {
    key: 'sharePage',
    value: function sharePage(type, options) {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('ShareClick', (0, _extends3.default)({
        share_type: type
      }, params, options));
    }
  }, {
    key: 'shareSave',
    value: function shareSave() {
      var params = (0, _extends3.default)({}, this.getReferPageName());

      this.track('MPShareSave', (0, _extends3.default)({}, params));
    }
  }, {
    key: 'editCart',
    value: function editCart(type) {
      this.track('EditShoppingCart', {
        shopping_cart_edit_type: type
      });
    }
  }, {
    key: 'buyNow',
    value: function buyNow(options) {
      var params = (0, _extends3.default)({}, this.getReferPageName(), options);

      this.track('buyNow', options);
    }
  }, {
    key: 'addIndex',
    value: function addIndex(index, num) {
      return index + num;
    }
  }, {
    key: 'setOpenid',
    value: function setOpenid(openId) {
      return sensors.setOpenid(openId);
    }
  }, {
    key: 'login',
    value: function login(id) {
      this.is_login = true;

      return sensors.login(id);
    }
  }, {
    key: 'setCurrentPageWithOutRefer',
    value: function setCurrentPageWithOutRefer(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 设置每个页面的公共属性

  }, {
    key: 'setCurrentPage',
    value: function setCurrentPage(type, name, id, options) {
      // this.refer_page_name = this.current_page_name
      // this.refer_page_type = this.current_page_type
      // this.refer_page_id = this.current_page_id
      var referData = this.getReferPageNameByCache();

      if (referData) {
        this.refer_page_name = referData.current_page_name;
        this.refer_page_type = referData.current_page_type;
        this.refer_page_id = referData.current_page_id;
      }

      this.current_page_type = type || '';
      this.current_page_name = name || '';
      this.current_page_id = id || '';

      this.setReferPageNameByCache({
        current_page_name: name || '',
        current_page_id: id || '',
        current_page_type: type || ''
      });

      return (0, _extends3.default)({}, options);
    }

    // 获取前向页面名称

  }, {
    key: 'getReferPageName',
    value: function getReferPageName() {
      return {
        refer_page_name: this.refer_page_name,
        refer_page_id: this.refer_page_id,
        refer_page_type: this.refer_page_type
      };
    }
  }, {
    key: 'getReferPageNameByCache',
    value: function getReferPageNameByCache() {
      return JSON.parse(window.sessionStorage.getItem('_sa_refer')) || null;
    }
  }, {
    key: 'setReferPageNameByCache',
    value: function setReferPageNameByCache(data) {
      window.sessionStorage.setItem('_sa_refer', (0, _stringify2.default)(data));
    }
  }, {
    key: 'getActivity',
    value: function getActivity(labels) {
      var activity = [];
      labels.forEach(function (label) {
        activity.push(label.type);
      });

      return activity;
    }
  }, {
    key: 'getProp',
    value: function getProp() {
      return sensors.getPresetProperties();
    }
  }, {
    key: 'getAnonymousID',
    value: function getAnonymousID() {
      return sensors.quick('getAnonymousID');
    }
  }, {
    key: 'clickNavBar',
    value: function clickNavBar(name) {
      return this.track('NavigationBar', {
        button_name: name
      });
    }
  }, {
    key: 'clickPerson',
    value: function clickPerson(name) {
      return this.track('PersonalCenter', {
        button_name: name
      });
    }
  }, {
    key: '_autoQuick',
    value: function _autoQuick() {
      return sensors.quick('autoTrack');
    }
  }, {
    key: 'init',
    value: function init() {
      this._registerPage();
      // this._autoQuick()

      sensors.init({
        server_url: this.server_url,
        heatmap: {
          // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          // 默认只有点击 a input button textarea 四种元素时，才会触发 $WebClick 元素点击事件
          clickmap: 'default'
        },
        show_log: true,
        use_client_time: true,
        app_js_bridge: true,
        send_type: 'beacon'
      });
    }
  }, {
    key: '_registerPage',
    value: function _registerPage() {
      var _this = this;

      sensors.registerPage({
        platform_type: this.platform_type,

        is_login: function is_login() {
          return _this.is_login;
        },

        vip_level: function vip_level() {
          return _this.vip_level;
        },

        current_page_type: function current_page_type() {
          return _this.current_page_type;
        },

        current_page_name: function current_page_name() {
          return _this.current_page_name;
        },

        current_page_id: function current_page_id() {
          return _this.current_page_id;
        },

        thelatest_utm_source: function thelatest_utm_source() {
          return _this.thelatest_utm_source;
        }
      });
    }
  }]);
  return Sa;
}();

module.exports = new Sa(options);

function loop() {}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__(73);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
var _resolve = void 0;
var _reject = void 0;

(function () {
  function install(Vue) {
    var Select = Vue.extend(_index2.default);
    var select = function select(list) {
      if (!$vm) {
        $vm = new Select({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      //clearVm($vm)
      $vm.list = list;
      $vm.$on('on-cancel', function () {
        $vm.show = false;
        _reject();
      });
      $vm.$on('on-confirm', function (data) {
        $vm.show = false;
        _resolve(data);
      });
      setTimeout(function () {
        $vm.show = true;
      }, 0);
      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
    Vue.mixin({
      created: function created() {
        this.$select = select;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{
    "country_id": 100042,
    "country_code": "+86",
    "country_name_en": "China",
    "country_name_cn": "中国大陆",
    "ab": "CN"
}, {
    "country_id": 100006,
    "country_code": "+244",
    "country_name_en": "Angola",
    "country_name_cn": "安哥拉",
    "ab": "AO"
}, {
    "country_id": 100007,
    "country_code": "+93",
    "country_name_en": "Afghanistan",
    "country_name_cn": "阿富汗",
    "ab": "AF"
}, {
    "country_id": 100008,
    "country_code": "+355",
    "country_name_en": "Albania",
    "country_name_cn": "阿尔巴尼亚",
    "ab": "AL"
}, {
    "country_id": 100009,
    "country_code": "+213",
    "country_name_en": "Algeria",
    "country_name_cn": "阿尔及利亚",
    "ab": "DZ"
}, {
    "country_id": 100010,
    "country_code": "+376",
    "country_name_en": "Andorra",
    "country_name_cn": "安道尔共和国",
    "ab": "AD"
}, {
    "country_id": 100011,
    "country_code": "+1264",
    "country_name_en": "Anguilla",
    "country_name_cn": "安圭拉岛",
    "ab": "AI"
}, {
    "country_id": 100012,
    "country_code": "+1268",
    "country_name_en": "AntiguaAndBarbuda",
    "country_name_cn": "安提瓜和巴布达",
    "ab": "AG"
}, {
    "country_id": 100013,
    "country_code": "+54",
    "country_name_en": "Argentina",
    "country_name_cn": "阿根廷",
    "ab": "AR"
}, {
    "country_id": 100014,
    "country_code": "+374",
    "country_name_en": "Armenia",
    "country_name_cn": "亚美尼亚",
    "ab": "AM"
}, {
    "country_id": 100015,
    "country_code": "+247",
    "country_name_en": "Ascension",
    "country_name_cn": "阿森松",
    "ab": "AU"
}, {
    "country_id": 100016,
    "country_code": "+61",
    "country_name_en": "Australia",
    "country_name_cn": "澳大利亚",
    "ab": "AU"
}, {
    "country_id": 100017,
    "country_code": "+43",
    "country_name_en": "Austria",
    "country_name_cn": "奥地利",
    "ab": "AT"
}, {
    "country_id": 100018,
    "country_code": "+994",
    "country_name_en": "Azerbaijan",
    "country_name_cn": "阿塞拜疆",
    "ab": "AZ"
}, {
    "country_id": 100019,
    "country_code": "+1242",
    "country_name_en": "Bahamas",
    "country_name_cn": "巴哈马",
    "ab": "BS"
}, {
    "country_id": 100020,
    "country_code": "+973",
    "country_name_en": "Bahrain",
    "country_name_cn": "巴林",
    "ab": "BH"
}, {
    "country_id": 100021,
    "country_code": "+880",
    "country_name_en": "Bangladesh",
    "country_name_cn": "孟加拉国",
    "ab": "BD"
}, {
    "country_id": 100022,
    "country_code": "+1246",
    "country_name_en": "Barbados",
    "country_name_cn": "巴巴多斯",
    "ab": "BB"
}, {
    "country_id": 100023,
    "country_code": "+375",
    "country_name_en": "Belarus",
    "country_name_cn": "白俄罗斯",
    "ab": "BY"
}, {
    "country_id": 100024,
    "country_code": "+32",
    "country_name_en": "Belgium",
    "country_name_cn": "比利时",
    "ab": "BE"
}, {
    "country_id": 100025,
    "country_code": "+501",
    "country_name_en": "Belize",
    "country_name_cn": "伯利兹",
    "ab": "BZ"
}, {
    "country_id": 100026,
    "country_code": "+229",
    "country_name_en": "Benin",
    "country_name_cn": "贝宁",
    "ab": "BJ"
}, {
    "country_id": 100027,
    "country_code": "+1441",
    "country_name_en": "BermudaIs",
    "country_name_cn": "百慕大群岛",
    "ab": "BM"
}, {
    "country_id": 100028,
    "country_code": "+591",
    "country_name_en": "Bolivia",
    "country_name_cn": "玻利维亚",
    "ab": "BO"
}, {
    "country_id": 100029,
    "country_code": "+267",
    "country_name_en": "Botswana",
    "country_name_cn": "博茨瓦纳",
    "ab": "BW"
}, {
    "country_id": 100030,
    "country_code": "+55",
    "country_name_en": "Brazil",
    "country_name_cn": "巴西",
    "ab": "BR"
}, {
    "country_id": 100031,
    "country_code": "+673",
    "country_name_en": "Brunei",
    "country_name_cn": "文莱",
    "ab": "BN"
}, {
    "country_id": 100032,
    "country_code": "+359",
    "country_name_en": "Bulgaria",
    "country_name_cn": "保加利亚",
    "ab": "BG"
}, {
    "country_id": 100033,
    "country_code": "+226",
    "country_name_en": "Burkina_faso",
    "country_name_cn": "布基纳法索",
    "ab": "BF"
}, {
    "country_id": 100034,
    "country_code": "+95",
    "country_name_en": "Burma",
    "country_name_cn": "缅甸",
    "ab": "MM"
}, {
    "country_id": 100035,
    "country_code": "+257",
    "country_name_en": "Burundi",
    "country_name_cn": "布隆迪",
    "ab": "BI"
}, {
    "country_id": 100036,
    "country_code": "+237",
    "country_name_en": "Cameroon",
    "country_name_cn": "喀麦隆",
    "ab": "CM"
}, {
    "country_id": 100037,
    "country_code": "+1",
    "country_name_en": "Canada",
    "country_name_cn": "加拿大",
    "ab": "CA"
}, {
    "country_id": 100038,
    "country_code": "+1345",
    "country_name_en": "Cayman_Is.",
    "country_name_cn": "开曼群岛",
    "ab": "CF"
}, {
    "country_id": 100039,
    "country_code": "+236",
    "country_name_en": "Central_African_Republic",
    "country_name_cn": "中非共和国",
    "ab": "CF"
}, {
    "country_id": 100040,
    "country_code": "+235",
    "country_name_en": "Chad",
    "country_name_cn": "乍得",
    "ab": "TD"
}, {
    "country_id": 100041,
    "country_code": "+56",
    "country_name_en": "Chile",
    "country_name_cn": "智利",
    "ab": "CL"
}, {
    "country_id": 100043,
    "country_code": "+57",
    "country_name_en": "Colombia",
    "country_name_cn": "哥伦比亚",
    "ab": "CO"
}, {
    "country_id": 100044,
    "country_code": "+242",
    "country_name_en": "Congo",
    "country_name_cn": "刚果",
    "ab": "CG"
}, {
    "country_id": 100045,
    "country_code": "+682",
    "country_name_en": "Cook_Is.",
    "country_name_cn": "库克群岛",
    "ab": "CK"
}, {
    "country_id": 100046,
    "country_code": "+506",
    "country_name_en": "Costa_Rica",
    "country_name_cn": "哥斯达黎加",
    "ab": "CR"
}, {
    "country_id": 100047,
    "country_code": "+53",
    "country_name_en": "Cuba",
    "country_name_cn": "古巴",
    "ab": "CU"
}, {
    "country_id": 100048,
    "country_code": "+357",
    "country_name_en": "Cyprus",
    "country_name_cn": "塞浦路斯",
    "ab": "CY"
}, {
    "country_id": 100049,
    "country_code": "+420",
    "country_name_en": "Czech_Republic",
    "country_name_cn": "捷克",
    "ab": "CZ"
}, {
    "country_id": 100050,
    "country_code": "+45",
    "country_name_en": "Denmark",
    "country_name_cn": "丹麦",
    "ab": "DK"
}, {
    "country_id": 100051,
    "country_code": "+253",
    "country_name_en": "Djibouti",
    "country_name_cn": "吉布提",
    "ab": "DJ"
}, {
    "country_id": 100052,
    "country_code": "+1890",
    "country_name_en": "Dominica_Rep.",
    "country_name_cn": "多米尼加共和国",
    "ab": "DO"
}, {
    "country_id": 100053,
    "country_code": "+593",
    "country_name_en": "Ecuador",
    "country_name_cn": "厄瓜多尔",
    "ab": "EC"
}, {
    "country_id": 100054,
    "country_code": "+20",
    "country_name_en": "Egypt",
    "country_name_cn": "埃及",
    "ab": "EG"
}, {
    "country_id": 100055,
    "country_code": "+503",
    "country_name_en": "EI_Salvador",
    "country_name_cn": "萨尔瓦多",
    "ab": "SV"
}, {
    "country_id": 100056,
    "country_code": "+372",
    "country_name_en": "Estonia",
    "country_name_cn": "爱沙尼亚",
    "ab": "EE"
}, {
    "country_id": 100057,
    "country_code": "+251",
    "country_name_en": "Ethiopia",
    "country_name_cn": "埃塞俄比亚",
    "ab": "ET"
}, {
    "country_id": 100058,
    "country_code": "+679",
    "country_name_en": "Fiji",
    "country_name_cn": "斐济",
    "ab": "FJ"
}, {
    "country_id": 100059,
    "country_code": "+358",
    "country_name_en": "Finland",
    "country_name_cn": "芬兰",
    "ab": "FI"
}, {
    "country_id": 100060,
    "country_code": "+33",
    "country_name_en": "France",
    "country_name_cn": "法国",
    "ab": "FR"
}, {
    "country_id": 100061,
    "country_code": "+594",
    "country_name_en": "French_Guiana",
    "country_name_cn": "法属圭亚那",
    "ab": "GF"
}, {
    "country_id": 100062,
    "country_code": "+241",
    "country_name_en": "Gabon",
    "country_name_cn": "加蓬",
    "ab": "GA"
}, {
    "country_id": 100063,
    "country_code": "+220",
    "country_name_en": "Gambia",
    "country_name_cn": "冈比亚",
    "ab": "GM"
}, {
    "country_id": 100064,
    "country_code": "+995",
    "country_name_en": "Georgia",
    "country_name_cn": "格鲁吉亚",
    "ab": "GE"
}, {
    "country_id": 100065,
    "country_code": "+49",
    "country_name_en": "Germany",
    "country_name_cn": "德国",
    "ab": "DE"
}, {
    "country_id": 100066,
    "country_code": "+233",
    "country_name_en": "Ghana",
    "country_name_cn": "加纳",
    "ab": "GH"
}, {
    "country_id": 100067,
    "country_code": "+350",
    "country_name_en": "Gibraltar",
    "country_name_cn": "直布罗陀",
    "ab": "GI"
}, {
    "country_id": 100068,
    "country_code": "+30",
    "country_name_en": "Greece",
    "country_name_cn": "希腊",
    "ab": "GR"
}, {
    "country_id": 100069,
    "country_code": "+1809",
    "country_name_en": "Grenada",
    "country_name_cn": "格林纳达",
    "ab": "GD"
}, {
    "country_id": 100070,
    "country_code": "+1671",
    "country_name_en": "Guam",
    "country_name_cn": "关岛",
    "ab": "GU"
}, {
    "country_id": 100071,
    "country_code": "+502",
    "country_name_en": "Guatemala",
    "country_name_cn": "危地马拉",
    "ab": "GT"
}, {
    "country_id": 100072,
    "country_code": "+224",
    "country_name_en": "Guinea",
    "country_name_cn": "几内亚",
    "ab": "GN"
}, {
    "country_id": 100073,
    "country_code": "+592",
    "country_name_en": "Guyana",
    "country_name_cn": "圭亚那",
    "ab": "GY"
}, {
    "country_id": 100074,
    "country_code": "+509",
    "country_name_en": "Haiti",
    "country_name_cn": "海地",
    "ab": "HT"
}, {
    "country_id": 100075,
    "country_code": "+504",
    "country_name_en": "Honduras",
    "country_name_cn": "洪都拉斯",
    "ab": "HN"
}, {
    "country_id": 100076,
    "country_code": "+852",
    "country_name_en": "Hongkong",
    "country_name_cn": "中国香港",
    "ab": "HK"
}, {
    "country_id": 100077,
    "country_code": "+36",
    "country_name_en": "Hungary",
    "country_name_cn": "匈牙利",
    "ab": "HU"
}, {
    "country_id": 100078,
    "country_code": "+354",
    "country_name_en": "Iceland",
    "country_name_cn": "冰岛",
    "ab": "IS"
}, {
    "country_id": 100079,
    "country_code": "+91",
    "country_name_en": "India",
    "country_name_cn": "印度",
    "ab": "IN"
}, {
    "country_id": 100080,
    "country_code": "+62",
    "country_name_en": "Indonesia",
    "country_name_cn": "印度尼西亚",
    "ab": "ID"
}, {
    "country_id": 100081,
    "country_code": "+98",
    "country_name_en": "Iran",
    "country_name_cn": "伊朗",
    "ab": "IR"
}, {
    "country_id": 100082,
    "country_code": "+964",
    "country_name_en": "Iraq",
    "country_name_cn": "伊拉克",
    "ab": "IQ"
}, {
    "country_id": 100083,
    "country_code": "+353",
    "country_name_en": "Ireland",
    "country_name_cn": "爱尔兰",
    "ab": "IE"
}, {
    "country_id": 100084,
    "country_code": "+972",
    "country_name_en": "Israel",
    "country_name_cn": "以色列",
    "ab": "IL"
}, {
    "country_id": 100085,
    "country_code": "+39",
    "country_name_en": "Italy",
    "country_name_cn": "意大利",
    "ab": "IT"
}, {
    "country_id": 100086,
    "country_code": "+225",
    "country_name_en": "Ivory_Coast",
    "country_name_cn": "科特迪瓦",
    "ab": "JM"
}, {
    "country_id": 100087,
    "country_code": "+1876",
    "country_name_en": "Jamaica",
    "country_name_cn": "牙买加",
    "ab": "JM"
}, {
    "country_id": 100088,
    "country_code": "+81",
    "country_name_en": "Japan",
    "country_name_cn": "日本",
    "ab": "JP"
}, {
    "country_id": 100089,
    "country_code": "+962",
    "country_name_en": "Jordan",
    "country_name_cn": "约旦",
    "ab": "JO"
}, {
    "country_id": 100090,
    "country_code": "+855",
    "country_name_en": "Kampuchea(Cambodia)",
    "country_name_cn": "柬埔寨",
    "ab": "KH"
}, {
    "country_id": 100091,
    "country_code": "+327",
    "country_name_en": "Kazakstan",
    "country_name_cn": "哈萨克斯坦",
    "ab": "KZ"
}, {
    "country_id": 100092,
    "country_code": "+254",
    "country_name_en": "Kenya",
    "country_name_cn": "肯尼亚",
    "ab": "KE"
}, {
    "country_id": 100093,
    "country_code": "+82",
    "country_name_en": "Korea",
    "country_name_cn": "韩国",
    "ab": "KR"
}, {
    "country_id": 100094,
    "country_code": "+965",
    "country_name_en": "Kuwait",
    "country_name_cn": "科威特",
    "ab": "KW"
}, {
    "country_id": 100095,
    "country_code": "+331",
    "country_name_en": "Kyrgyzstan",
    "country_name_cn": "吉尔吉斯坦",
    "ab": "KG"
}, {
    "country_id": 100096,
    "country_code": "+856",
    "country_name_en": "Laos",
    "country_name_cn": "老挝",
    "ab": "LA"
}, {
    "country_id": 100097,
    "country_code": "+371",
    "country_name_en": "Latvia",
    "country_name_cn": "拉脱维亚",
    "ab": "LV"
}, {
    "country_id": 100098,
    "country_code": "+961",
    "country_name_en": "Lebanon",
    "country_name_cn": "黎巴嫩",
    "ab": "LB"
}, {
    "country_id": 100099,
    "country_code": "+266",
    "country_name_en": "Lesotho",
    "country_name_cn": "莱索托",
    "ab": "LS"
}, {
    "country_id": 100100,
    "country_code": "+231",
    "country_name_en": "Liberia",
    "country_name_cn": "利比里亚",
    "ab": "LR"
}, {
    "country_id": 100101,
    "country_code": "+218",
    "country_name_en": "Libya",
    "country_name_cn": "利比亚",
    "ab": "LY"
}, {
    "country_id": 100102,
    "country_code": "+423",
    "country_name_en": "Liechtenstein",
    "country_name_cn": "列支敦士登",
    "ab": "LI"
}, {
    "country_id": 100103,
    "country_code": "+370",
    "country_name_en": "Lithuania",
    "country_name_cn": "立陶宛",
    "ab": "LT"
}, {
    "country_id": 100104,
    "country_code": "+352",
    "country_name_en": "Luxembourg",
    "country_name_cn": "卢森堡",
    "ab": "LU"
}, {
    "country_id": 100105,
    "country_code": "+853",
    "country_name_en": "Macao",
    "country_name_cn": "中国澳门",
    "ab": "MO"
}, {
    "country_id": 100106,
    "country_code": "+261",
    "country_name_en": "Madagascar",
    "country_name_cn": "马达加斯加",
    "ab": "MG"
}, {
    "country_id": 100107,
    "country_code": "+265",
    "country_name_en": "Malawi",
    "country_name_cn": "马拉维",
    "ab": "MW"
}, {
    "country_id": 100108,
    "country_code": "+60",
    "country_name_en": "Malaysia",
    "country_name_cn": "马来西亚",
    "ab": "MY"
}, {
    "country_id": 100109,
    "country_code": "+960",
    "country_name_en": "Maldives",
    "country_name_cn": "马尔代夫",
    "ab": "MV"
}, {
    "country_id": 100110,
    "country_code": "+223",
    "country_name_en": "Mali",
    "country_name_cn": "马里",
    "ab": "ML"
}, {
    "country_id": 100111,
    "country_code": "+356",
    "country_name_en": "Malta",
    "country_name_cn": "马耳他",
    "ab": "MT"
}, {
    "country_id": 100112,
    "country_code": "+1670",
    "country_name_en": "Mariana_Is",
    "country_name_cn": "马里亚那群岛",
    "ab": "MT"
}, {
    "country_id": 100113,
    "country_code": "+596",
    "country_name_en": "Martinique",
    "country_name_cn": "马提尼克",
    "ab": "MT"
}, {
    "country_id": 100114,
    "country_code": "+230",
    "country_name_en": "Mauritius",
    "country_name_cn": "毛里求斯",
    "ab": "MU"
}, {
    "country_id": 100115,
    "country_code": "+52",
    "country_name_en": "Mexico",
    "country_name_cn": "墨西哥",
    "ab": "MX"
}, {
    "country_id": 100116,
    "country_code": "+373",
    "country_name_en": "Moldova_Republic_of",
    "country_name_cn": "摩尔多瓦",
    "ab": "MD"
}, {
    "country_id": 100117,
    "country_code": "+377",
    "country_name_en": "Monaco",
    "country_name_cn": "摩纳哥",
    "ab": "MC"
}, {
    "country_id": 100118,
    "country_code": "+976",
    "country_name_en": "Mongolia",
    "country_name_cn": "蒙古",
    "ab": "MN"
}, {
    "country_id": 100119,
    "country_code": "+1664",
    "country_name_en": "Montserrat_Is",
    "country_name_cn": "蒙特塞拉特岛",
    "ab": "MS"
}, {
    "country_id": 100120,
    "country_code": "+212",
    "country_name_en": "Morocco",
    "country_name_cn": "摩洛哥",
    "ab": "MA"
}, {
    "country_id": 100121,
    "country_code": "+258",
    "country_name_en": "Mozambique",
    "country_name_cn": "莫桑比克",
    "ab": "MZ"
}, {
    "country_id": 100122,
    "country_code": "+264",
    "country_name_en": "Namibia",
    "country_name_cn": "纳米比亚",
    "ab": "NA"
}, {
    "country_id": 100123,
    "country_code": "+674",
    "country_name_en": "Nauru",
    "country_name_cn": "瑙鲁",
    "ab": "NR"
}, {
    "country_id": 100124,
    "country_code": "+977",
    "country_name_en": "Nepal",
    "country_name_cn": "尼泊尔",
    "ab": "NP"
}, {
    "country_id": 100125,
    "country_code": "+599",
    "country_name_en": "Netheriands_Antilles",
    "country_name_cn": "荷属安的列斯",
    "ab": "NL"
}, {
    "country_id": 100126,
    "country_code": "+31",
    "country_name_en": "Netherlands",
    "country_name_cn": "荷兰",
    "ab": "NL"
}, {
    "country_id": 100127,
    "country_code": "+64",
    "country_name_en": "New_Zealand",
    "country_name_cn": "新西兰",
    "ab": "NZ"
}, {
    "country_id": 100128,
    "country_code": "+505",
    "country_name_en": "Nicaragua",
    "country_name_cn": "尼加拉瓜",
    "ab": "NI"
}, {
    "country_id": 100129,
    "country_code": "+227",
    "country_name_en": "Niger",
    "country_name_cn": "尼日尔",
    "ab": "NE"
}, {
    "country_id": 100130,
    "country_code": "+234",
    "country_name_en": "Nigeria",
    "country_name_cn": "尼日利亚",
    "ab": "NG"
}, {
    "country_id": 100131,
    "country_code": "+850",
    "country_name_en": "North_Korea",
    "country_name_cn": "朝鲜",
    "ab": "KP"
}, {
    "country_id": 100132,
    "country_code": "+47",
    "country_name_en": "Norway",
    "country_name_cn": "挪威",
    "ab": "NO"
}, {
    "country_id": 100133,
    "country_code": "+968",
    "country_name_en": "Oman",
    "country_name_cn": "阿曼",
    "ab": "OM"
}, {
    "country_id": 100134,
    "country_code": "+92",
    "country_name_en": "Pakistan",
    "country_name_cn": "巴基斯坦",
    "ab": "PK"
}, {
    "country_id": 100135,
    "country_code": "+507",
    "country_name_en": "Panama",
    "country_name_cn": "巴拿马",
    "ab": "PA"
}, {
    "country_id": 100136,
    "country_code": "+675",
    "country_name_en": "Papua_New_Cuinea",
    "country_name_cn": "巴布亚新几内亚",
    "ab": "PG"
}, {
    "country_id": 100137,
    "country_code": "+595",
    "country_name_en": "Paraguay",
    "country_name_cn": "巴拉圭",
    "ab": "PY"
}, {
    "country_id": 100138,
    "country_code": "+51",
    "country_name_en": "Peru",
    "country_name_cn": "秘鲁",
    "ab": "PE"
}, {
    "country_id": 100139,
    "country_code": "+63",
    "country_name_en": "Philippines",
    "country_name_cn": "菲律宾",
    "ab": "PH"
}, {
    "country_id": 100140,
    "country_code": "+48",
    "country_name_en": "Poland",
    "country_name_cn": "波兰",
    "ab": "PL"
}, {
    "country_id": 100141,
    "country_code": "+689",
    "country_name_en": "French_Polynesia",
    "country_name_cn": "法属玻利尼西亚",
    "ab": "PF"
}, {
    "country_id": 100142,
    "country_code": "+351",
    "country_name_en": "Portugal",
    "country_name_cn": "葡萄牙",
    "ab": "PT"
}, {
    "country_id": 100143,
    "country_code": "+1787",
    "country_name_en": "Puerto_Rico",
    "country_name_cn": "波多黎各",
    "ab": "PR"
}, {
    "country_id": 100144,
    "country_code": "+974",
    "country_name_en": "Qatar",
    "country_name_cn": "卡塔尔",
    "ab": "QA"
}, {
    "country_id": 100145,
    "country_code": "+262",
    "country_name_en": "Reunion",
    "country_name_cn": "留尼旺",
    "ab": "RO"
}, {
    "country_id": 100146,
    "country_code": "+40",
    "country_name_en": "Romania",
    "country_name_cn": "罗马尼亚",
    "ab": "RO"
}, {
    "country_id": 100147,
    "country_code": "+7",
    "country_name_en": "Russia",
    "country_name_cn": "俄罗斯",
    "ab": "RU"
}, {
    "country_id": 100148,
    "country_code": "+1758",
    "country_name_en": "Saint_Lueia",
    "country_name_cn": "圣卢西亚",
    "ab": "LC"
}, {
    "country_id": 100149,
    "country_code": "+1784",
    "country_name_en": "Saint_Vincent",
    "country_name_cn": "圣文森特岛",
    "ab": "VC"
}, {
    "country_id": 100150,
    "country_code": "+684",
    "country_name_en": "Samoa_Eastern",
    "country_name_cn": "东萨摩亚(美)",
    "ab": "SM"
}, {
    "country_id": 100151,
    "country_code": "+685",
    "country_name_en": "Samoa_Western",
    "country_name_cn": "西萨摩亚",
    "ab": "SM"
}, {
    "country_id": 100152,
    "country_code": "+378",
    "country_name_en": "San_Marino",
    "country_name_cn": "圣马力诺",
    "ab": "SM"
}, {
    "country_id": 100153,
    "country_code": "+239",
    "country_name_en": "Sao_Tome_and_Principe",
    "country_name_cn": "圣多美和普林西比",
    "ab": "ST"
}, {
    "country_id": 100154,
    "country_code": "+966",
    "country_name_en": "Saudi_Arabia",
    "country_name_cn": "沙特阿拉伯",
    "ab": "SA"
}, {
    "country_id": 100155,
    "country_code": "+221",
    "country_name_en": "Senegal",
    "country_name_cn": "塞内加尔",
    "ab": "SN"
}, {
    "country_id": 100156,
    "country_code": "+248",
    "country_name_en": "Seychelles",
    "country_name_cn": "塞舌尔",
    "ab": "SC"
}, {
    "country_id": 100157,
    "country_code": "+232",
    "country_name_en": "Sierra_Leone",
    "country_name_cn": "塞拉利昂",
    "ab": "SL"
}, {
    "country_id": 100158,
    "country_code": "+65",
    "country_name_en": "Singapore",
    "country_name_cn": "新加坡",
    "ab": "SG"
}, {
    "country_id": 100159,
    "country_code": "+421",
    "country_name_en": "Slovakia",
    "country_name_cn": "斯洛伐克",
    "ab": "SK"
}, {
    "country_id": 100160,
    "country_code": "+386",
    "country_name_en": "Slovenia",
    "country_name_cn": "斯洛文尼亚",
    "ab": "SI"
}, {
    "country_id": 100161,
    "country_code": "+677",
    "country_name_en": "Solomon_Is",
    "country_name_cn": "所罗门群岛",
    "ab": "SB"
}, {
    "country_id": 100162,
    "country_code": "+252",
    "country_name_en": "Somali",
    "country_name_cn": "索马里",
    "ab": "SO"
}, {
    "country_id": 100163,
    "country_code": "+27",
    "country_name_en": "South_Africa",
    "country_name_cn": "南非",
    "ab": "ZA"
}, {
    "country_id": 100164,
    "country_code": "+34",
    "country_name_en": "Spain",
    "country_name_cn": "西班牙",
    "ab": "ES"
}, {
    "country_id": 100165,
    "country_code": "+94",
    "country_name_en": "Sri_Lanka",
    "country_name_cn": "斯里兰卡",
    "ab": "LK"
}, {
    "country_id": 100166,
    "country_code": "+1758",
    "country_name_en": "St.Lucia",
    "country_name_cn": "圣卢西亚",
    "ab": "LC"
}, {
    "country_id": 100167,
    "country_code": "+1784",
    "country_name_en": "St.Vincent",
    "country_name_cn": "圣文森特",
    "ab": "VC"
}, {
    "country_id": 100168,
    "country_code": "+249",
    "country_name_en": "Sudan",
    "country_name_cn": "苏丹",
    "ab": "SD"
}, {
    "country_id": 100169,
    "country_code": "+597",
    "country_name_en": "Suriname",
    "country_name_cn": "苏里南",
    "ab": "SR"
}, {
    "country_id": 100170,
    "country_code": "+268",
    "country_name_en": "Swaziland",
    "country_name_cn": "斯威士兰",
    "ab": "SZ"
}, {
    "country_id": 100171,
    "country_code": "+46",
    "country_name_en": "Sweden",
    "country_name_cn": "瑞典",
    "ab": "SE"
}, {
    "country_id": 100172,
    "country_code": "+41",
    "country_name_en": "Switzerland",
    "country_name_cn": "瑞士",
    "ab": "CH"
}, {
    "country_id": 100173,
    "country_code": "+963",
    "country_name_en": "Syria",
    "country_name_cn": "叙利亚",
    "ab": "SY"
}, {
    "country_id": 100174,
    "country_code": "+886",
    "country_name_en": "Taiwan",
    "country_name_cn": "中国台湾",
    "ab": "TW"
}, {
    "country_id": 100175,
    "country_code": "+992",
    "country_name_en": "Tajikstan",
    "country_name_cn": "塔吉克斯坦",
    "ab": "TJ"
}, {
    "country_id": 100176,
    "country_code": "+255",
    "country_name_en": "Tanzania",
    "country_name_cn": "坦桑尼亚",
    "ab": "TZ"
}, {
    "country_id": 100177,
    "country_code": "+66",
    "country_name_en": "Thailand",
    "country_name_cn": "泰国",
    "ab": "TH"
}, {
    "country_id": 100178,
    "country_code": "+228",
    "country_name_en": "Togo",
    "country_name_cn": "多哥",
    "ab": "TG"
}, {
    "country_id": 100179,
    "country_code": "+676",
    "country_name_en": "Tonga",
    "country_name_cn": "汤加",
    "ab": "TO"
}, {
    "country_id": 100180,
    "country_code": "+1809",
    "country_name_en": "Trinidad_and_Tobago",
    "country_name_cn": "特立尼达和多巴哥",
    "ab": "TT"
}, {
    "country_id": 100181,
    "country_code": "+216",
    "country_name_en": "Tunisia",
    "country_name_cn": "突尼斯",
    "ab": "TN"
}, {
    "country_id": 100182,
    "country_code": "+90",
    "country_name_en": "Turkey",
    "country_name_cn": "土耳其",
    "ab": "TR"
}, {
    "country_id": 100183,
    "country_code": "+993",
    "country_name_en": "Turkmenistan",
    "country_name_cn": "土库曼斯坦",
    "ab": "TM"
}, {
    "country_id": 100184,
    "country_code": "+256",
    "country_name_en": "Uganda",
    "country_name_cn": "乌干达",
    "ab": "UG"
}, {
    "country_id": 100185,
    "country_code": "+380",
    "country_name_en": "Ukraine",
    "country_name_cn": "乌克兰",
    "ab": "UA"
}, {
    "country_id": 100186,
    "country_code": "+971",
    "country_name_en": "United_Arab_Emirates",
    "country_name_cn": "阿拉伯联合酋长国",
    "ab": "AE"
}, {
    "country_id": 100187,
    "country_code": "+44",
    "country_name_en": "United_Kiongdom",
    "country_name_cn": "英国",
    "ab": "GB"
}, {
    "country_id": 100188,
    "country_code": "+1",
    "country_name_en": "United_States_of_America",
    "country_name_cn": "美国",
    "ab": "US"
}, {
    "country_id": 100189,
    "country_code": "+598",
    "country_name_en": "Uruguay",
    "country_name_cn": "乌拉圭",
    "ab": "UY"
}, {
    "country_id": 100190,
    "country_code": "+233",
    "country_name_en": "Uzbekistan",
    "country_name_cn": "乌兹别克斯坦",
    "ab": "UZ"
}, {
    "country_id": 100191,
    "country_code": "+58",
    "country_name_en": "Venezuela",
    "country_name_cn": "委内瑞拉",
    "ab": "VE"
}, {
    "country_id": 100192,
    "country_code": "+84",
    "country_name_en": "Vietnam",
    "country_name_cn": "越南",
    "ab": "VN"
}, {
    "country_id": 100193,
    "country_code": "+967",
    "country_name_en": "Yemen",
    "country_name_cn": "也门",
    "ab": "YE"
}, {
    "country_id": 100194,
    "country_code": "+381",
    "country_name_en": "Yugoslavia",
    "country_name_cn": "南斯拉夫",
    "ab": "YU"
}, {
    "country_id": 100195,
    "country_code": "+263",
    "country_name_en": "Zimbabwe",
    "country_name_cn": "津巴布韦",
    "ab": "ZW"
}, {
    "country_id": 100196,
    "country_code": "+243",
    "country_name_en": "Zaire",
    "country_name_cn": "扎伊尔",
    "ab": "ZR"
}, {
    "country_id": 100197,
    "country_code": "+260",
    "country_name_en": "Zambia",
    "country_name_cn": "赞比亚",
    "ab": "ZM"
}];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(69),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _events = __webpack_require__(52);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var on = function on() {
      var _bevent$$on;

      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      (_bevent$$on = _events2.default.$on).call.apply(_bevent$$on, [_events2.default].concat(arg));
    };

    var emit = function emit() {
      var _bevent$$emit;

      for (var _len2 = arguments.length, arg = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        arg[_key2] = arguments[_key2];
      }

      (_bevent$$emit = _events2.default.$emit).call.apply(_bevent$$emit, [_events2.default].concat(arg));
    };
    Vue.mixin({
      created: function created() {
        this._on = on;
        this._emit = emit;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    _vue2.default.use(install);
  }
})();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _toast = __webpack_require__(47);

var _toast2 = _interopRequireDefault(_toast);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
var _resolve = void 0;
var _reject = void 0;

(function () {
  function install(Vue) {
    var Toast = Vue.extend(_toast2.default);
    var toast = function toast(content) {
      if ((0, _browser.app)()) {
        return _bridge2.default.toast(content);
      }
      if (!content) {
        throw new Error('Plugins $toast args must be \'String\' ');
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.mask = false;
      $vm.toast = true;
      $vm.autoClose = true;
      $vm.content = content;
      $vm.$on('toast-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var alert = function alert(option) {
      if (!option) {
        throw new Error('Plugins $alert args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)()) {
        return _bridge2.default.alert(option);
      }

      // if (!/^[\u4e00-\u9fa5_a-zA-Z0-9@()!：；:,。"'\[\]]+$/g.test(option)) {
      //   throw new Error(`Plugins $alert args must be 'String' or 'Object'`);
      // }

      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.maskTouchHide = true;
      $vm.alert = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.buttonText && ($vm.primary = option.buttonText);
        $vm.title = option.title;
        $vm.content = option.content;
        $vm.buttonEmphasize = option.buttonEmphasize;
      } else {
        $vm.content = option;
      }
      $vm.$on('alert-hide', function (msg) {
        _resolve();
      });
      return new _promise2.default(function (resolve) {
        _resolve = resolve;
      });
    };

    var confirm = function confirm(option) {
      if (!option) {
        throw new Error('Plugins $confirm args must be \'String\' or \'Object\'');
      }
      if ((0, _browser.app)() && (0, _browser.ios)()) {
        return _bridge2.default.confirm(option);
      }
      if (!$vm) {
        $vm = new Toast({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.show = true;
      $vm.confirm = true;
      if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
        option.primaryButtonText && ($vm.primary = option.primaryButtonText);
        option.secondaryButtonText && ($vm.secondary = option.secondaryButtonText);
        $vm.content = option.content;
        $vm.title = option.title;
        $vm.primaryButtonEmphasize = option.primaryButtonEmphasize;
        $vm.secondaryButtonEmphasize = option.secondaryButtonEmphasize;
      } else {
        $vm.title = option;
      }
      $vm.$on('confirm-ensure', function () {
        _resolve();
      });
      $vm.$on('confirm-cancel', function () {
        _reject();
      });
      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
    // if (!Vue.$beast) {
    //   Vue.$beast = {}
    // }

    // Vue.$beast.toast = toast
    // Vue.$beast.alert = alert
    // Vue.$beast.confirm = confirm

    Vue.mixin({
      created: function created() {
        this.$toast = toast;
        this.$alert = alert;
        this.$confirm = confirm;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _loading = __webpack_require__(43);

var _loading2 = _interopRequireDefault(_loading);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
// let _resolve
// let _reject

(function () {
  function install(Vue) {
    var Loading = Vue.extend(_loading2.default);
    var showLoading = function showLoading(flag) {
      if ((0, _browser.app)()) {
        _bridge2.default.showLoading();
        return;
      }
      if (!$vm) {
        $vm = new Loading({
          el: document.createElement('div')
          // propsData: {
          //   mshow: true
          // }
        });
        document.body.appendChild($vm.$el);
      }
      $vm.white = flag ? true : false;
      $vm.mshow = true;
      $vm.$on('loading-hide', function (msg) {
        $vm.mshow = false;
      });
      // return new Promise((resolve) => {
      //   _resolve = resolve
      // })
    };

    var hideLoading = function hideLoading() {
      if ((0, _browser.app)()) {
        return _bridge2.default.hideLoading();
      }
      $vm && $vm.$emit('loading-hide');
    };

    Vue.mixin({
      created: function created() {
        this.$showLoading = showLoading;
        this.$hideLoading = hideLoading;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _browser = __webpack_require__(1);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function install(Vue) {
    var title = function title(_title) {
      var _this = this;

      if ((0, _browser.app)()) {
        _bridge2.default.setTitle(_title);
      }
      if ((typeof _title === 'undefined' ? 'undefined' : (0, _typeof3.default)(_title)) === 'object') {
        return;
      }
      document.title = _title;

      this.$nextTick(function () {
        _this._emit && _this._emit('change-title', _title);
      });
    };
    Vue.mixin({
      created: function created() {
        this.$setTitle = title;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    maskBackground: {
      default: '#000000'
    },
    maskClass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow;
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },


  computed: {
    mOpacity: function mOpacity() {
      return this.mask ? parseFloat(this.maskOpacity) : 0;
    },
    mBackground: function mBackground() {
      return this.mask ? this.maskBackground : '#000000';
    }
  },

  watch: {
    mshow: function mshow(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      val || this.$emit('mask-hide');
    }
  },
  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    },
    maskHide: function maskHide() {
      this.mask && this.maskTouchHide && (this.currentValue = false);
    }
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(35);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STYLES = {
  height: '100%',
  width: '100%',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
  opacity: 0.4,
  background: '#000000'
}; //
//
//
//

var handler = function handler(e) {
  e.preventDefault();
  // e.stopPropagation()
};

exports.default = {
  name: 'mask',
  props: {
    mshow: Boolean,
    mopacity: Number,
    zIndex: Number,
    mbackground: String,
    mclass: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      maskStyles: '',
      isShow: false
    };
  },
  created: function created() {
    this.showChange();
  },

  watch: {
    'zIndex': function zIndex(val) {
      this.showChange();
    },
    'mshow': function mshow(val) {
      // if(!val) {
      //   return
      // }
      this.showChange();
    }
  },
  methods: {
    maskTap: function maskTap() {
      this.$emit('maskTap');
    },
    showChange: function showChange() {
      // if(this.mshow){
      //   this.$el && this.$el.addEventListener('touchmove', handler, false)
      // }else{
      //   this.$el && this.$el.removeEventListener('touchmove', handler, false)
      // }
      this.mbackground !== undefined && (DEFAULT_STYLES.background = this.mbackground);
      this.zIndex !== undefined && (DEFAULT_STYLES.zIndex = this.zIndex);
      this.mopacity !== undefined && (DEFAULT_STYLES.opacity = this.mopacity);
      this.maskStyles = _utils2.default.setStyle(DEFAULT_STYLES).join(';');
      this.isShow = this.mshow;
    }
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  setStyle: function setStyle(opts) {
    var styles = [];
    (0, _keys2.default)(opts).forEach(function (style) {
      var origin = opts[style];
      styles.push(style + ':' + origin);
    });
    return styles;
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "beast-mask",
    class: _vm.mclass,
    style: (_vm.maskStyles),
    on: {
      "click": _vm.maskTap
    }
  })
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(39);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      ownZIndex: _index2.default.getZIndex()
    };
  },

  watch: {
    'show': function show(val) {
      val && (this.ownZIndex = _index2.default.getZIndex());
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base_index = 5000;
module.exports = {
  getZIndex: function getZIndex() {
    return base_index++;
  }
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j_max_index",
    class: {
      'relative-z-index': _vm.relative
    },
    style: ({
      zIndex: _vm.ownZIndex
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.currentValue
    }
  }, [_c('div', {
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('masks', {
    attrs: {
      "mshow": _vm.currentValue,
      "mopacity": _vm.mOpacity,
      "mbackground": _vm.mBackground,
      "mclass": _vm.maskClass
    },
    on: {
      "maskTap": _vm.maskHide
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogStyle,
    staticStyle: {
      "z-index": "1001!important"
    }
  }, [_vm._t("default")], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(46),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(11);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'loading',
  components: {
    dialogs: _index2.default
  },
  props: ['white'],
  data: function data() {
    return {
      mopacity: 0,
      mshow: false
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dialogs', {
    attrs: {
      "mshow": _vm.mshow,
      "scroll": false,
      "mask": false
    }
  }, [_c('div', {
    staticClass: "beast-loading__icon",
    class: {
      'icon_white': _vm.white
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(50),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _dialog = __webpack_require__(11);

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _confirm_state = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _data = {
  show: false,
  time: 2000,
  autoClose: false,
  toast: false,
  alert: false,
  confirm: false,
  primary: "确定",
  secondary: "取消",
  title: '',
  content: '',
  myClass: 'beast__toast'
};
exports.default = {
  components: {
    BDialog: _dialog2.default
  },
  data: function data() {
    return JSON.parse((0, _stringify2.default)(_data));
  },

  watch: {
    content: function content(val) {
      if (val) {
        this.show = true;
      }
    },
    toast: function toast(val) {
      if (val) {
        this.myClass = 'beast__toast';
      }
    },
    alert: function alert(val) {
      if (val) {
        this.myClass = 'beast__alert';
      }
    },
    confirm: function confirm(val) {
      if (val) {
        this.myClass = 'beast__confirm';
      }
    },
    show: function show(val) {
      var _this = this;

      this.autoClose && clearTimeout(this.timeout);
      if (val) {
        this.autoClose && (this.timeout = setTimeout(function () {
          _this.show = false;
        }, this.time));
      } else {
        this.toast && this.$emit('toast-hide');
        this.alert && this.$emit('alert-hide');
        if (this.confirm) {
          _confirm_state ? this.$emit('confirm-ensure') : this.$emit('confirm-cancel');
        }

        for (var _key in _data) {
          this[_key] = _data[_key];
        }
      }
    }
  },
  methods: {
    close: function close(event) {
      this.show = false;
    },
    cancel: function cancel(event) {
      _confirm_state = false;
      this.show = false;
    },
    ensure: function ensure(event) {
      _confirm_state = true;
      this.show = false;
    }
  }
};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mask": false,
      "mshow": _vm.show
    }
  }, [_c('div', {
    staticClass: "toast-wrap"
  }, [_c('div', {
    class: _vm.myClass
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('div', {
    class: {
      lighter: _vm.title
    }
  }, [_vm._v("\n            " + _vm._s(_vm.content) + "\n          ")])])]), _vm._v(" "), (_vm.alert) ? _c('div', {
    staticClass: "alert",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        " + _vm._s(_vm.primary) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.confirm) ? _c('div', {
    staticClass: "confirm"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.secondary))]), _vm._v(" "), _c('div', {
    staticClass: "ensure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.primary))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _toast = __webpack_require__(26);

var _toast2 = _interopRequireDefault(_toast);

var _loading = __webpack_require__(28);

var _loading2 = _interopRequireDefault(_loading);

var _events = __webpack_require__(25);

var _events2 = _interopRequireDefault(_events);

var _setTitle = __webpack_require__(30);

var _setTitle2 = _interopRequireDefault(_setTitle);

var _sa = __webpack_require__(17);

var _sa2 = _interopRequireDefault(_sa);

var _browser = __webpack_require__(1);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _vconsole = __webpack_require__(72);

var _vconsole2 = _interopRequireDefault(_vconsole);

var _b2a = __webpack_require__(23);

var _jsCookie = __webpack_require__(59);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';
var md5 = __webpack_require__(53);

var isDev = "production" == 'development';
var UA = typeof navigator !== 'undefined' && navigator ? navigator.userAgent || '' : '';
var appDebug = !!~UA.indexOf('BEAST_DEBUG');
var _search = _queryString2.default.parse(window.location.search);
var webDebug = 'beast_debug' in _search;
if (appDebug || webDebug) {
  new _vconsole2.default();
}
var utm_source = _search.utm_source || '';
var _cache_utm_source = window.localStorage.getItem('the_utm_source');
var cache_utm_source = _cache_utm_source ? JSON.parse(_cache_utm_source) : '';
var distinctID = _search.distinctID;
var userId = window.sessionStorage.getItem('_b_m');
var miniMember = _search._mini_m;

if (miniMember) {
  miniMember = JSON.parse(decodeURIComponent(miniMember));
}

if (utm_source) {
  updateUtmParam(utm_source);
  _sa2.default.thelatest_utm_source = utm_source;
} else if (!utm_source && cache_utm_source) {
  if (isMoreThanSevenDays(cache_utm_source.createTime)) {
    window.localStorage.removeItem('the_utm_source');
    _sa2.default.thelatest_utm_source = '';
  } else {
    _sa2.default.thelatest_utm_source = cache_utm_source.value;
  }
}

if (distinctID) {
  if (miniMember && (typeof miniMember === 'undefined' ? 'undefined' : (0, _typeof3.default)(miniMember)) === 'object') {
    _sa2.default.login(md5.hexMD5(miniMember.mobile));
  }
  _sa2.default.is_login = true;
  _sa2.default.platform_type = '微信小程序';
  _sa2.default.changeIdentify(distinctID, true);
} else if (userId) {
  userId = JSON.parse(userId);
  _sa2.default.is_login = true;
  _sa2.default.platform_type = 'WAP';
  _sa2.default.login(md5.hexMD5(userId.mobile));
}

_sa2.default.init();

window.sa = _sa2.default;

function isMoreThanSevenDays(time) {
  var curTime = new Date().getTime();
  return curTime - time > 7 * 24 * 3600 * 1000;
}

function updateUtmParam(value) {
  window.localStorage.setItem('the_utm_source', (0, _stringify2.default)({
    value: value,
    createTime: new Date().getTime()
  }));
}

_vue2.default.use(_toast2.default);
_vue2.default.use(_events2.default);
_vue2.default.use(_loading2.default);
_vue2.default.use(_setTitle2.default);
_vue2.default.config.productionTip = false;

exports.Page = function (page, options) {
  if (options.pageType) {
    _sa2.default.setCurrentPage(options.pageType);
  }
  _sa2.default._autoQuick();
  var vm = new _vue2.default(options);
  return vm;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = new _vue2.default({
  name: 'events'
});
exports.default = events;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) {
  return rstr2hex(rstr_md5(str2rstr_utf8(s)));
}
function b64_md5(s) {
  return rstr2b64(rstr_md5(str2rstr_utf8(s)));
}
function any_md5(s, e) {
  return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
}
function hex_hmac_md5(k, d) {
  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function b64_hmac_md5(k, d) {
  return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
}
function any_hmac_md5(k, d, e) {
  return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
}

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of a raw string
 */
function rstr_md5(s) {
  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
}

/*
 * Calculate the HMAC-MD5, of a key and some data (raw strings)
 */
function rstr_hmac_md5(key, data) {
  var bkey = rstr2binl(key);
  if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);

  var ipad = Array(16),
      opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input) {
  try {
    hexcase;
  } catch (e) {
    hexcase = 0;
  }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for (var i = 0; i < input.length; i++) {
    x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
  }
  return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input) {
  try {
    b64pad;
  } catch (e) {
    b64pad = '';
  }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for (var i = 0; i < len; i += 3) {
    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
    }
  }
  return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding) {
  var divisor = encoding.length;
  var i, j, q, x, quotient;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  var dividend = Array(Math.ceil(input.length / 2));
  for (i = 0; i < dividend.length; i++) {
    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
  }

  /*
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. All remainders are stored for later
   * use.
   */
  var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
  var remainders = Array(full_length);
  for (j = 0; j < full_length; j++) {
    quotient = Array();
    x = 0;
    for (i = 0; i < dividend.length; i++) {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
    }
    remainders[j] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  var output = "";
  for (i = remainders.length - 1; i >= 0; i--) {
    output += encoding.charAt(remainders[i]);
  }return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input) {
  var output = "";
  var i = -1;
  var x, y;

  while (++i < input.length) {
    /* Decode utf-16 surrogate pairs */
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    /* Encode output as utf-8 */
    if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
  }
  return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
  }return output;
}

function str2rstr_utf16be(input) {
  var output = "";
  for (var i = 0; i < input.length; i++) {
    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
  }return output;
}

/*
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binl(input) {
  var output = Array(input.length >> 2);
  for (var i = 0; i < output.length; i++) {
    output[i] = 0;
  }for (var i = 0; i < input.length * 8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
  }return output;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2rstr(input) {
  var output = "";
  for (var i = 0; i < input.length * 32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
  }return output;
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);
}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xFFFF;
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
module.exports = {
  hexMD5: hex_md5
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformLink = transformLink;
exports.trackSkip = trackSkip;
exports.normalSkip = normalSkip;
exports.appSkip = appSkip;
exports.transformMLink = transformMLink;
exports.getToMiniLink = getToMiniLink;
exports.getLinkPageData = getLinkPageData;

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _simpleSemver = __webpack_require__(155);

var _miniprogram = __webpack_require__(142);

var _miniLink = __webpack_require__(145);

var _url = __webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = _browser2.default.app() ? _browser2.default.app().version : '';

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

// const route = {
//   'index': '/',
//   'shop': '/shop?shopId=',
//   'brand': '/product/list?',
//   'cate': '/product/list?',
//   'search': '/product/list?',
//   'retail': '/retail?',
//   'article': `/article?articleId=`,
//   'customization-list': `/customization/list?`,
//   'big-furniture-tips': '/furniture/tips?',
//   'shop-story': '/shop/story?',
//   'group-purchase': '/group/purchase?',
//   'points-benefit': '/points/benefit?',
//   'points-mall': '/member/day/points?',
//   'points-list': '/points/list?',
//   'points-detail': '/member/day/points/detail?',
//   'points-coupon': '/points/coupon?',
//   'category': '/category?',
//   'store': '/store?',
//   'cart': '/cart?',
//   'member': '/my?',
//   'my': '/my?',
//   'discovery': '/discovery?',
//   'funny': '/funny?',
//   'thh-page': '/ruler/thh',
//   'welfare': '/my/benefit/all?',
//   'benefit': '/my/benefit?',
//   'benefit-policy': '/benefit?',
//   'order-list': '/my/orderlist?',
//   'profile-setting': '/my/profile/edit',
//   'product': '/product/',
//   'shopping-fund': '/shopping/fund?',
//   'member-speed': '/member/speed?'
// }

var params = {
  'brand': 'brandId'
  // 'product': '*'
};

var route = {
  'index': {
    key: '/',
    type: '首页'
  },
  'shop': {
    key: '/shop?shopId=',
    type: '店铺页'
  },
  'brand': {
    key: '/product/list?',
    type: '商品列表页-品牌列表'
  },
  'cate': {
    key: '/product/list?',
    type: '商品列表页-分类列表'
  },
  'search': {
    key: '/product/list?',
    type: '商品列表页-搜索列表'
  },
  'retail': {
    key: '/retail?',
    type: ''
  },
  'article': {
    key: '/article?articleId=',
    type: '专题页'
  },
  'customization-list': {
    key: '/customization/list?',
    type: '商品列表页-定制列表'
  },
  'big-furniture-tips': {
    key: '/furniture/tips?',
    type: '大家具'
  },
  'shop-story': {
    key: '/shop/story?',
    type: '封面故事页'
  },
  'shop-story-all': {
    key: '/shop/story/all?',
    type: '全部封面故事页'
  },
  'group-purchase': {
    key: '/group/purchase?',
    type: '团购'
  },
  'points-benefit': {
    key: '/points/benefit?',
    type: '积分特权'
  },
  'points-mall': {
    key: '/member/day/points?',
    type: '积分商城'
  },
  'points-list': {
    key: '/points/list?',
    type: '积分列表'
  },
  'points-detail': {
    key: '/member/day/points/detail?',
    type: '积分详情页'
  },
  'points-coupon': {
    key: '/points/coupon?',
    type: '积分优惠券页'
  },
  'category': {
    key: '/category?',
    type: '选购'
  },
  'category-v2': {
    key: '/category/v2?',
    type: '选购'
  },
  'store': {
    key: '/store?',
    type: '门店'
  },
  'cart': {
    key: '/cart?',
    type: '购物车'
  },
  'member': {
    key: '/my?',
    type: '我的'
  },
  'my': {
    key: '/my?',
    type: '我的'
  },
  'discovery': {
    key: '/discovery?',
    type: '发现'
  },
  'funny': {
    key: '/funny?',
    type: '发现'
  },
  'thh-page': {
    key: '/ruler/thh',
    type: '退换货'
  },
  'welfare': {
    key: '/my/benefit/all?',
    type: '我的福利'
  },
  'benefit': {
    key: '/my/benefit?',
    type: '我的特权'
  },
  'benefit-policy': {
    key: '/benefit?',
    type: '特权政策'
  },
  'order-list': {
    key: '/my/orderlist?',
    type: '订单列表'
  },
  'profile-setting': {
    key: '/my/profile/edit',
    type: '个人信息设置'
  },
  'product': {
    key: '/product/',
    type: '商品详情页-普通商品'
  },
  'shopping-fund': {
    key: '/shopping/fund?',
    type: '购物基金'
  },
  'member-speed': {
    key: '/member/speed?',
    type: '会员等级'
  },
  'flower-list': {
    key: '/flower/list?',
    type: '花市列表'
  },
  'select-gift': {
    key: '/select/gift?',
    type: '选礼物'
  },
  'select-gift-result': {
    key: '/select/gift/result?',
    type: '选礼物结果'
  }
};

var app = _browser2.default.app();
var ios = _browser2.default.ios();
var android = _browser2.default.android();
var uniapp = _browser2.default.uniapp();

function transformLink(_ref) {
  var link = _ref.link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$shopId = _ref.shopId,
      shopId = _ref$shopId === undefined ? '' : _ref$shopId,
      _ref$isMini = _ref.isMini,
      isMini = _ref$isMini === undefined ? false : _ref$isMini;

  var _link = isMini ? (0, _miniLink.transformMiniLink)({ link: link, title: title }) : transformMLink({ link: link, title: title, shopId: shopId });
  return _link;
}

function trackSkip(_ref2) {
  var _ref2$trackData = _ref2.trackData,
      trackData = _ref2$trackData === undefined ? {} : _ref2$trackData,
      _ref2$link = _ref2.link,
      link = _ref2$link === undefined ? '' : _ref2$link,
      _ref2$isMini = _ref2.isMini,
      isMini = _ref2$isMini === undefined ? false : _ref2$isMini,
      _ref2$toMiniProgram = _ref2.toMiniProgram,
      toMiniProgram = _ref2$toMiniProgram === undefined ? false : _ref2$toMiniProgram;

  if (!link || link === "#") {
    return;
  }

  (0, _track2.default)(trackData).then(function () {
    if (toMiniProgram) {
      //去小程序打开该页面
      openMiniProgram(link);
    } else if (isMini) {
      //小程序环境打开webview页面或者小程序内部页面
      (0, _miniprogram.navigateToMini)(link);
    } else {
      if (app) {
        _bridge2.default.open({
          url: link
        });
      } else {
        window.location.href = link;
      }
    }
  });
}

function normalSkip(_ref3) {
  var _ref3$link = _ref3.link,
      link = _ref3$link === undefined ? '' : _ref3$link,
      _ref3$isMini = _ref3.isMini,
      isMini = _ref3$isMini === undefined ? false : _ref3$isMini,
      _ref3$toMiniProgram = _ref3.toMiniProgram,
      toMiniProgram = _ref3$toMiniProgram === undefined ? false : _ref3$toMiniProgram;

  if (toMiniProgram) {
    //去小程序打开该页面
    openMiniProgram(link);
  } else if (isMini) {
    //小程序环境打开webview页面或者小程序内部页面
    (0, _miniprogram.navigateToMini)(link);
  } else {
    if (app) {
      _bridge2.default.open({
        url: link
      });
    } else {
      window.location.href = link;
    }
    // if(browser.app() && /^http/.test(link)) {
    //   bridge.open(link)
    // } else {
    //   window.location.href = link
    // }
  }
}

function openMiniProgram(link) {
  if ((0, _simpleSemver.lt)(version, '4.11.0')) {
    this.$alert({
      title: '请先去更新APP版本',
      content: '需要更新APP到最新版，才能进入查看哦！',
      buttonText: '知道了'
    }).then(function () {
      _bridge2.default.updateMobileVersion();
    });
  } else {
    _bridge2.default.openWXMiniProgram({
      path: link
    });
  }
}

function appSkip(link) {
  // if(uniapp) {
  //   bridge.open({
  //     url: link
  //   })
  // } else {
  //   window.location.href = link
  // }
  _bridge2.default.open({
    url: link
  });
}

// export function skip ({link='', isMini = false}) {
//   if(!link || link === "#") {
//     return 
//   }

//   if (isMini) {
//     navigateToMini(link)
//   }
//   else {
//     window.location.href = link
//   }
// }

function transformMLink(_ref4) {
  var link = _ref4.link,
      _ref4$title = _ref4.title,
      title = _ref4$title === undefined ? '' : _ref4$title,
      _ref4$shopId = _ref4.shopId,
      shopId = _ref4$shopId === undefined ? '' : _ref4$shopId;

  console.log('!!!!!!!!!!');
  if (!link.type) {
    return '';
  }
  var url = "";
  if (app) {
    url = 'beastapp://';
  }
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '#';
      break;
    case 'product':
      app ? url += 'product/' + link.value : url = '/product/' + link.value;
      break;
    case 'article':
      app ? url += 'article/' + link.value : url = '/article?articleId=' + link.value;
      break;
    case 'shop-story':
      app ? url += 'entry?name=shop-story&shopId=' + link.value : url = '/shop/story?shopId=' + link.value;
      break;
    case 'shop-story-all':
      app ? url += 'entry?name=shop-story-all&shopId=' + link.value : url = '/shop/story/all?shopId=' + link.value;
      break;
    case 'shop':
      app ? url += 'shop/' + link.value : url = '/shop?shopId=' + link.value;
      break;
    case 'list':
      app ? url += 'search?listId=' + link.value + '&title=' + title : url = '/product/list?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      app ? shopId ? url += 'search?shopId=' + shopId + '&new=1&title=' + title : url += 'search?new=1&title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&new=1&title=' + title : url = '/product/list?new=1&title=' + title;
      break;
    case 'all':
      app ? shopId ? url += 'search?shopId=' + shopId + '&title=' + title : url += 'search?title=' + title : shopId ? url = '/product/list?shopId=' + shopId + '&title=' + title : url = '/product/list?title=' + title;
      break;
    case 'brand':
      // ? url += `search?brandId=${link.value}&title=${title}`
      app ? url += 'entry?name=product-list&brandId=' + link.value + '&title=' + title : url = '/product/list?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      app ? url += 'search?labelId=' + link.value + '&title=' + title : url = '/product/list?labelId=' + link.value + '&title=' + title;
      break;
    case 'bu':
      var query = "";
      var idArr = link.value.split("-");
      if (!idArr.length) {
        return;
      }
      if (idArr.length === 2 && idArr[1]) {
        query = 'buId=' + idArr[0] + '&categoryId=' + idArr[1] + '&title=' + title;
      } else {
        query = 'buId=' + idArr[0] + '&title=' + title;
      }

      app ? url += 'search?' + query : url = '/product/list?' + query;
      break;
    case 'category':
      var cateStrs = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs += 'categoryId=' + v + '&';
      });

      app ? url += 'search?' + cateStrs + 'title=' + title : url = '/product/list?' + cateStrs + 'title=' + title;
      break;
    case 'oversea':
      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += 'search?overseasOnly=true&title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&title=' + title : url += '/product/list?overseasOnly=true&title=' + title;
      break;
    case 'categoryOversea':
      var cateStrs1 = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs1 += 'categoryId=' + v + '&';
      });

      app ? shopId ? url += 'search?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += 'search?overseasOnly=true&' + cateStrs1 + 'title=' + title : shopId ? url += '/product/list?shopId=' + shopId + '&overseasOnly=true&' + cateStrs1 + 'title=' + title : url += '/product/list?overseasOnly=true&' + cateStrs1 + 'title=' + title;
      break;
    case 'campaign':
      app ? url += 'search?campaignCode=' + link.value + '&title=' + title : url = '/product/list?campaignCode=' + link.value + '&title=' + title;
      break;
    case 'article-list':
      var idStrs = '';
      link.value.split(',').forEach(function (v, index) {
        idStrs += 'articleId=' + v + '&';
      });
      app ? url += 'entry?name=article-list&type=article-list&' + idStrs + 'title=' + title : url = '/article/list?type=article-list&' + idStrs + 'title=' + title;
      break;
    case 'lesson':
      app ? url += 'entry?name=article-list&type=LESSON&title=' + title : url = '/article/list?type=LESSON&title=' + title;
      break;
    case 'group':
      app ? url += 'entry?name=group-purchase&productId=' + link.value : url = '/group/purchase?productId=' + link.value;
      break;
    case 'customization-list':
      app ? url += 'entry?name=customization-list' : url = '/customization/list';
      break;
    case 'deeplink':
      app ? url = link.value : url = dealMLink(link.value);
      break;

    case 'custom':
      app ? url += 'entry?name=customization-list' : url = '';
      break;
    case 'discount':
      app ? url += 'search?param=discount&title=\u6298\u6263' : url = '/product/list?param=discount&title=\u6298\u6263';
      break;
    case 'retail':
      app ? url += 'entry?name=retail&title=\u5B9E\u4F53\u5E97' : url = '/retail';
      break;
    case 'index':
      app ? url += 'index' : url = '/';
      break;
    case 'program':
      url = '';
      break;
    case 'web':
      url = link.value;
      break;
    case 'selfdefine':
      app ? url = link.deeplink : url = link.waplink;
      break;
  }
  console.log(url, "$$$$$$$$$$");
  return url;
}

function dealMLink(link) {
  if (/^http/.test(link)) {
    //http
    return link;
  }
  if (link === 'beastapp://index') {
    link = '/';
  } else if (link === 'beastapp://my') {
    link = '/my';
  } else if (link === 'beastapp://profile-settings') {
    link = '/my/profile/edit';
  } else if (link === 'beastapp://order-list') {
    link = '/my/orderlist';
  } else if (link === 'beastapp://score') {
    link = '/my/score';
  } else if (link === 'beastapp://cart') {
    link = '/cart';
  } else if (link === 'beastapp://benefit') {
    link = '/my/benefit';
  } else {
    // link = splitQue(link)
    link = splitQue(link).que;
  }

  return link;
}

function dealMLinkPage(link) {
  var skip_page_type = '';

  if (/^http/.test(link)) {
    //http
    return {
      link: link,
      skip_page_type: skip_page_type
    };
  }
  if (link === 'beastapp://index') {
    skip_page_type = '首页';
    link = '/';
  } else if (link === 'beastapp://my') {
    skip_page_type = '我的';
    link = '/my';
  } else if (link === 'beastapp://profile-settings') {
    skip_page_type = '编辑个人信息';
    link = '/my/profile/edit';
  } else if (link === 'beastapp://order-list') {
    skip_page_type = '订单列表';
    link = '/my/orderlist';
  } else if (link === 'beastapp://score') {
    skip_page_type = '我的积分';
    link = '/my/score';
  } else if (link === 'beastapp://cart') {
    skip_page_type = '购物车';
    link = '/cart';
  } else if (link === 'beastapp://benefit') {
    skip_page_type = '我的特权';
    link = '/my/benefit';
  } else {
    skip_page_type = splitQue(link).trackType;
    link = splitQue(link).que;
  }

  return {
    link: link,
    skip_page_type: skip_page_type
  };
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  var trackType = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  // if (type && search) {
  //   que = matchQue(type, search)
  // }
  if (type && search) {
    var queObj = matchQue(type, search);
    que = queObj.que;
    trackType = queObj.trackType;
  }

  // return que
  return {
    que: que,
    trackType: trackType
  };
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  // const path = route[type[0]]
  // const pid = params[type[0]]
  if (route[type[0]]) {
    var path = route[type[0]].key;
    var trackType = route[type[0]].type || '';
    var pid = params[type[0]];

    if (path) {
      que = type[1] && pid ? pid === '*' ? '' + path + type[1] + '?' + query : '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
    } else {
      que = '/' + type[0].replace('-', '/');
    }

    // return que
    return {
      que: que,
      trackType: trackType
    };
  } else {
    return {
      que: '#',
      trackType: ''
    };
  }
}

function getToMiniLink(_ref5) {
  var link = _ref5.link,
      title = _ref5.title;

  var miniLink = (0, _miniLink.transformMiniLink)({ link: link, title: title });
  return miniLink.url;
}

function getLinkPageData(_ref6) {
  var link = _ref6.link,
      _ref6$title = _ref6.title,
      title = _ref6$title === undefined ? '' : _ref6$title;

  var skip_page_type = '',
      skip_page_name = '',
      skip_page_id = '';

  if (!link.type) {
    return {
      skip_page_type: skip_page_type,
      skip_page_name: skip_page_name,
      skip_page_id: skip_page_id
    };
  }

  switch (link.type) {
    case 'none':
      break;
    case 'product':
      skip_page_type = '商品详情页-普通商品';
      skip_page_id = link.value;
      break;
    case 'article':
      skip_page_type = '专题页';
      skip_page_id = link.value;
      break;
    case 'shop-story':
      skip_page_type = '封面故事页';
      skip_page_id = link.value;
      break;
    case 'shop':
      skip_page_type = '店铺主页';
      skip_page_id = link.value;
      break;
    case 'list':
      skip_page_type = '商品列表页-运营list';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'new':
      skip_page_type = '商品列表页-新鲜上架';
      skip_page_name = title || '';
      break;
    case 'all':
      skip_page_type = '商品列表页-全部商品';
      skip_page_name = title || '';
      break;
    case 'brand':
      skip_page_type = '商品列表页-品牌列表';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'tag':
      skip_page_type = '商品列表页-标签列表';
      skip_page_name = title || '';
      skip_page_id = link.value;
      break;
    case 'bu':
      skip_page_type = '商品列表页-BU商品列表';
      skip_page_name = title || '';

      var idArr = link.value.split("-");
      if (idArr.length) {
        skip_page_id = idArr[0] || '';
      }
      break;
    case 'category':
      var cateStrs = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs += 'categoryId=' + v + '&';
      });

      skip_page_type = '商品列表页-分类列表';
      skip_page_name = title || '';
      skip_page_id = cateStrs;
      break;
    case 'oversea':
      skip_page_type = '商品列表页-海淘列表';
      skip_page_name = title || '';
      break;
    case 'categoryOversea':
      var cateStrs1 = '';
      link.value.split(',').forEach(function (v, index) {
        cateStrs1 += 'categoryId=' + v + '&';
      });

      skip_page_type = '商品列表页-海淘分类列表';
      skip_page_name = title || '';
      skip_page_id = cateStrs1;
      break;
    case 'article-list':
      var idStrs = '';
      link.value.split(',').forEach(function (v, index) {
        idStrs += 'articleId=' + v + '&';
      });

      skip_page_type = '专题列表';
      skip_page_name = title || '';
      skip_page_id = idStrs;
      break;
    case 'lesson':
      skip_page_type = '野兽课堂列表页';
      skip_page_name = title || '';
      break;
    case 'group':
      skip_page_type = '商品详情页-团购商品';
      skip_page_id = link.value;
      break;
    case 'customization-list':
      skip_page_type = '商品列表页-定制列表';
      break;
    case 'deeplink':
      var dealLink = dealMLinkPage(link.value);
      skip_page_type = dealLink.skip_page_type;
      break;
    case 'custom':
      skip_page_type = '商品列表页-定制列表';
      break;
    case 'discount':
      skip_page_type = '商品列表页-折扣列表';
      skip_page_name = '折扣';
      break;
    case 'index':
      skip_page_type = '首页';
      break;
    case 'program':
      skip_page_type = '小程序页面';
      break;
    case 'web':
      skip_page_type = '网页';
      skip_page_name = link.value;
      break;
    case 'selfdefine':
      skip_page_type = '自定义页面';
      skip_page_name = app ? link.deeplink : link.waplink;
      break;
  }

  return {
    skip_page_type: skip_page_type,
    skip_page_id: skip_page_id,
    skip_page_name: skip_page_name
  };
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import $ from 'zepto'
// import util from 'util'

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(63);

var _from2 = _interopRequireDefault(_from);

var _getPrototypeOf = __webpack_require__(139);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(140);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(141);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.lazyload = lazyload;
exports.getDefaultImage = getDefaultImage;

var _events = __webpack_require__(147);

var _load = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import assets from 'assets'


var DEFAULT_OPITONS = {
  threshold: 400,
  attr: 'datalazy',
  isAnimation: true,
  isSlider: false,
  timeout: 1000,
  debounce: 50,
  loadFun: null

  // const defaultImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==`
};var defaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=';
var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
var windowFlag = true;

function lazyload() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  options.threshold = options.threshold || DEFAULT_OPITONS.threshold;
  options.attr = options.attr || DEFAULT_OPITONS.attr;
  options.timeout = options.timeout || DEFAULT_OPITONS.timeout;
  options.isAnimation = options.isAnimation || DEFAULT_OPITONS.isAnimation;
  options.isSlider = options.isSlider || DEFAULT_OPITONS.isSlider;
  options.debounce = options.debounce || DEFAULT_OPITONS.debounce;

  if (!options.container) {
    options.container = window;
  } else {
    windowFlag = false;
    // options.container = document.querySelector(options.container)
    options.container = container;
  }

  return new LazyImage(options);
}

function getDefaultImage() {
  return defaultImage;
}

var LazyImage = function (_EventEmitter) {
  (0, _inherits3.default)(LazyImage, _EventEmitter);

  function LazyImage(options) {
    (0, _classCallCheck3.default)(this, LazyImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyImage.__proto__ || (0, _getPrototypeOf2.default)(LazyImage)).call(this));
    // code


    _this.options = options;
    _this.nodes = [];
    if (document.body) {
      _this.bodyDom = document.body;
    }
    if (document.documentElement) {
      _this.documentDom = document.documentElement;
    }
    // this.bodyDom = document.documentElement || document.querySelector("body")
    // this._check = this._check.bind(this)
    _this._check = debounce(_this._check.bind(_this), _this.options.debounce);

    _this._bind();

    var images = null;
    try {
      // if(!selector) {
      images = document.querySelectorAll("img[datalazy]");
      // } else {
      //   images = document.querySelectorAll(selector)
      // }
    } catch (e) {}

    if (images && images.length > 0) {
      _this.add(images);
    }

    return _this;
  }

  (0, _createClass3.default)(LazyImage, [{
    key: '_bind',
    value: function _bind() {
      this.options.container.addEventListener('scroll', this._check);
      this.options.container.addEventListener('resize', this._check);
    }
  }, {
    key: 'add',
    value: function add(images) {
      var _this2 = this;

      // const eles = images
      var eles = (0, _from2.default)(images);
      // console.log(eles)
      eles.forEach(function (ele) {
        var eleNode = ele;
        // console.log(eleNode.getAttribute("defaultimg"))
        eleNode.getAttribute('src') || eleNode.setAttribute('src', eleNode.getAttribute("defaultimg") || defaultImage);
        // console.log(this.nodes)
        _this2.nodes.push(eleNode);
      });

      setTimeout(function () {
        _this2._check();
      });

      return this;
    }
  }, {
    key: '_check',
    value: function _check() {
      var _this3 = this;

      // console.log("_check function")

      clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var top = 0;
      var container = this.options.container;
      if (this.options.isSlider) {
        // top = this.options.container.height() + this.options.container.offset().top
        if (windowFlag) {
          top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop);
        } else {
          top = container.offsetHeight + container.scrollTop + container.offsetTop;
        }
      } else {
        if (windowFlag) {
          top = clientHeight + (this.bodyDom.scrollTop || this.documentDom.scrollTop);
        } else {
          if (container.offsetHeight < clientHeight) {
            top = container.offsetHeight + container.scrollTop + container.offsetTop;
          } else {
            top = clientHeight + container.scrollTop + container.offsetTop;
          }
        }
        // if(container.offsetHeight < clientHeight) {
        //   // top = this.options.container.height() + this.options.container.scrollTop()
        // } else {
        //   // top = $(window).height() + this.options.container.scrollTop()
        // }
      }

      var nodes = this.nodes;
      this.nodes = nodes.filter(function (node) {
        // console.log(node)
        if (!_this3._in_viewport(node, top)) {
          return true;
        }

        var count = _this3.listenerCount('show');
        if (count > 0) {
          _this3.emit('show', node[0]);
          return;
        }

        _this3._reveal(node);
      });
    }
  }, {
    key: '_in_viewport',
    value: function _in_viewport(node, top) {
      // console.log(node.offsetTop - this.options.threshold, "offset top")
      // console.log(top, "top")
      // return node.offset().top - this.options.threshold < top
      return node.offsetTop - this.options.threshold < top;
    }
  }, {
    key: '_reveal',
    value: function _reveal(node) {
      var _this4 = this;

      node.getAttribute('src') || node.setAttribute('src', node.getAttribute("defaultimg") || defaultImage);
      var source = node.getAttribute(this.options.attr);
      var loaded = false;
      if (source) {
        var url = '';
        var tm = setTimeout(function () {
          loaded = true;
          _this4._dealImg(node, source);
        }, this.options.timeout);

        (0, _load.load_image)(source, function (err, imgObj) {
          if (loaded) {
            return;
          } else {
            clearTimeout(tm);
          }
          if (err || !imgObj || imgObj.length == 0) {
            url = node.getAttribute("defaultimg") || defaultImage;
          } else {
            url = imgObj.src;
          }

          _this4._dealImg(node, url);
        });
      }
    }
  }, {
    key: '_dealImg',
    value: function _dealImg(node, url) {
      node.setAttribute('src', url);
      node.removeAttribute('datalazy');
      // hasClass(node, 'lazy') && removeClass(node, 'lazy')
      // hasClass(node, 'lazy-loaded') || addClass(node, 'lazy-loaded')

      if (this.options.isAnimation) {
        this._addAnimation(node);
      }
    }
  }, {
    key: '_addAnimation',
    value: function _addAnimation(node) {
      hasClass(node, 'lazy-fadeIn') || addClass(node, 'lazy-fadeIn');
    }
  }]);
  return LazyImage;
}(_events.EventEmitter);

function hasClass(ele, cls) {
  return (' ' + ele.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

function addClass(ele, cls) {
  ele.classList.add(cls);
}

function removeClass(ele, cls) {
  ele.classList.remove(cls);
}

function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;
  var later = function later() {
    var last = new Date().getTime() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    context = this;
    args = arguments;
    timestamp = new Date().getTime();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getEnv = getEnv;

var _sdk = __webpack_require__(146);

var _sdk2 = _interopRequireDefault(_sdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEnv() {
  return new _promise2.default(function (resolve, reject) {
    _sdk2.default.adapter.invoke(function () {
      resolve(_sdk2.default);
    });
  });
}

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: 'left'
    },
    zIndex: {
      default: 1001
    },
    height: {
      type: String,
      default: 'auto'
    },
    mask: {
      // type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    },
    slidecls: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isShow: false
    };
  },

  watch: {
    'show': function show(val) {
      this.showChange();
    }
  },
  created: function created() {
    this.showChange();
    // console.log(MaxZIndex.getZIndex());
  },

  computed: {
    mOpacity: function mOpacity() {
      return parseFloat(this.maskOpacity);
    },
    mfrom: function mfrom() {
      return 'beast_slide_from_' + this.from;
    }
  },
  methods: {
    showChange: function showChange() {
      var _show = this.show;
      // this.mfrom =  _show ? `` : ''
      this.isShow = _show;
    },

    // maskHide(){
    //   (this.mOpacity != 0) && this.mask && this.$emit('onHide')
    // },
    maskTap: function maskTap() {
      this.$emit('maskTap');
    }
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.isShow
    }
  }, [(_vm.mask) ? _c('masks', {
    attrs: {
      "mshow": _vm.isShow,
      "mopacity": _vm.mOpacity
    },
    on: {
      "maskTap": _vm.maskTap
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "beast_slider",
    class: [_vm.mfrom, {
      beast_slide_from_reset: _vm.isShow
    }, _vm.slidecls],
    style: ({
      'z-index': _vm.zIndex,
      height: _vm.height
    })
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _defineProperty = __webpack_require__(160);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _from = __webpack_require__(63);

var _from2 = _interopRequireDefault(_from);

var _isIterable2 = __webpack_require__(164);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(165);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*!
 * better-normal-scroll v1.13.2
 * (c) 2016-2018 ustbhuangyi
 * Released under the MIT License.
 */
(function (global, factory) {
  ( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.BScroll = factory();
})(undefined, function () {
  'use strict';

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if ((0, _isIterable3.default)(Object(arr))) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var toConsumableArray = function toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  };

  function eventMixin(BScroll) {
    BScroll.prototype.on = function (type, fn) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

      if (!this._events[type]) {
        this._events[type] = [];
      }

      this._events[type].push([fn, context]);
    };

    BScroll.prototype.once = function (type, fn) {
      var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

      function magic() {
        this.off(type, magic);

        fn.apply(context, arguments);
      }
      // To expose the corresponding function method in order to execute the off method
      magic.fn = fn;

      this.on(type, magic);
    };

    BScroll.prototype.off = function (type, fn) {
      var _events = this._events[type];
      if (!_events) {
        return;
      }

      var count = _events.length;
      while (count--) {
        if (_events[count][0] === fn || _events[count][0] && _events[count][0].fn === fn) {
          _events[count][0] = undefined;
        }
      }
    };

    BScroll.prototype.trigger = function (type) {
      var events = this._events[type];
      if (!events) {
        return;
      }

      var len = events.length;
      var eventsCopy = [].concat(toConsumableArray(events));
      for (var i = 0; i < len; i++) {
        var event = eventsCopy[i];

        var _event = slicedToArray(event, 2),
            fn = _event[0],
            context = _event[1];

        if (fn) {
          fn.apply(context, [].slice.call(arguments, 1));
        }
      }
    };
  }

  // ssr support
  var inBrowser = typeof window !== 'undefined';
  var ua = inBrowser && navigator.userAgent.toLowerCase();
  var isWeChatDevTools = ua && /wechatdevtools/.test(ua);
  var isAndroid = ua && ua.indexOf('android') > 0;

  function getNow() {
    return window.performance && window.performance.now ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
  }

  function extend(target) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    for (var i = 0; i < rest.length; i++) {
      var source = rest[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target;
  }

  function isUndef(v) {
    return v === undefined || v === null;
  }

  function getDistance(x, y) {
    return Math.sqrt(x * x + y * y);
  }

  var elementStyle = inBrowser && document.createElement('div').style;

  var vendor = function () {
    if (!inBrowser) {
      return false;
    }
    var transformNames = {
      webkit: 'webkitTransform',
      Moz: 'MozTransform',
      O: 'OTransform',
      ms: 'msTransform',
      standard: 'transform'
    };

    for (var key in transformNames) {
      if (elementStyle[transformNames[key]] !== undefined) {
        return key;
      }
    }

    return false;
  }();

  function prefixStyle(style) {
    if (vendor === false) {
      return false;
    }

    if (vendor === 'standard') {
      if (style === 'transitionEnd') {
        return 'transitionend';
      }
      return style;
    }

    return vendor + style.charAt(0).toUpperCase() + style.substr(1);
  }

  function addEvent(el, type, fn, capture) {
    el.addEventListener(type, fn, { passive: false, capture: !!capture });
  }

  function removeEvent(el, type, fn, capture) {
    el.removeEventListener(type, fn, { passive: false, capture: !!capture });
  }

  function offset(el) {
    var left = 0;
    var top = 0;

    while (el) {
      left -= el.offsetLeft;
      top -= el.offsetTop;
      el = el.offsetParent;
    }

    return {
      left: left,
      top: top
    };
  }

  function offsetToBody(el) {
    var rect = el.getBoundingClientRect();

    return {
      left: -(rect.left + window.pageXOffset),
      top: -(rect.top + window.pageYOffset)
    };
  }

  var cssVendor = vendor && vendor !== 'standard' ? '-' + vendor.toLowerCase() + '-' : '';

  var transform = prefixStyle('transform');
  var transition = prefixStyle('transition');

  var hasPerspective = inBrowser && prefixStyle('perspective') in elementStyle;
  // fix issue #361
  var hasTouch = inBrowser && ('ontouchstart' in window || isWeChatDevTools);
  var hasTransform = transform !== false;
  var hasTransition = inBrowser && transition in elementStyle;

  var style = {
    transform: transform,
    transition: transition,
    transitionTimingFunction: prefixStyle('transitionTimingFunction'),
    transitionDuration: prefixStyle('transitionDuration'),
    transitionDelay: prefixStyle('transitionDelay'),
    transformOrigin: prefixStyle('transformOrigin'),
    transitionEnd: prefixStyle('transitionEnd')
  };

  var TOUCH_EVENT = 1;
  var MOUSE_EVENT = 2;

  var eventType = {
    touchstart: TOUCH_EVENT,
    touchmove: TOUCH_EVENT,
    touchend: TOUCH_EVENT,

    mousedown: MOUSE_EVENT,
    mousemove: MOUSE_EVENT,
    mouseup: MOUSE_EVENT
  };

  function getRect(el) {
    if (el instanceof window.SVGElement) {
      var rect = el.getBoundingClientRect();
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      };
    } else {
      return {
        top: el.offsetTop,
        left: el.offsetLeft,
        width: el.offsetWidth,
        height: el.offsetHeight
      };
    }
  }

  function preventDefaultException(el, exceptions) {
    for (var i in exceptions) {
      if (exceptions[i].test(el[i])) {
        return true;
      }
    }
    return false;
  }

  function tap(e, eventName) {
    var ev = document.createEvent('Event');
    ev.initEvent(eventName, true, true);
    ev.pageX = e.pageX;
    ev.pageY = e.pageY;
    e.target.dispatchEvent(ev);
  }

  function click(e) {
    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';

    var eventSource = void 0;
    if (e.type === 'mouseup' || e.type === 'mousecancel') {
      eventSource = e;
    } else if (e.type === 'touchend' || e.type === 'touchcancel') {
      eventSource = e.changedTouches[0];
    }
    var posSrc = {};
    if (eventSource) {
      posSrc.screenX = eventSource.screenX || 0;
      posSrc.screenY = eventSource.screenY || 0;
      posSrc.clientX = eventSource.clientX || 0;
      posSrc.clientY = eventSource.clientY || 0;
    }
    var ev = void 0;
    var bubbles = true;
    var cancelable = true;
    if (typeof MouseEvent !== 'undefined') {
      try {
        ev = new MouseEvent(event, extend({
          bubbles: bubbles,
          cancelable: cancelable
        }, posSrc));
      } catch (e) {
        createEvent();
      }
    } else {
      createEvent();
    }

    function createEvent() {
      ev = document.createEvent('Event');
      ev.initEvent(event, bubbles, cancelable);
      extend(ev, posSrc);
    }

    // forwardedTouchEvent set to true in case of the conflict with fastclick
    ev.forwardedTouchEvent = true;
    ev._constructed = true;
    e.target.dispatchEvent(ev);
  }

  function dblclick(e) {
    click(e, 'dblclick');
  }

  function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  }

  function before(el, target) {
    target.parentNode.insertBefore(el, target);
  }

  function removeChild(el, child) {
    el.removeChild(child);
  }

  var DEFAULT_OPTIONS = {
    startX: 0,
    startY: 0,
    scrollX: false,
    scrollY: true,
    freeScroll: false,
    directionLockThreshold: 5,
    eventPassthrough: '',
    click: false,
    tap: false,
    /**
     * support any side
     * bounce: {
     *   top: true,
     *   bottom: true,
     *   left: true,
     *   right: true
     * }
     */
    bounce: true,
    bounceTime: 800,
    momentum: true,
    momentumLimitTime: 300,
    momentumLimitDistance: 15,
    swipeTime: 2500,
    swipeBounceTime: 500,
    deceleration: 0.0015,
    flickLimitTime: 200,
    flickLimitDistance: 100,
    resizePolling: 60,
    probeType: 0,
    preventDefault: true,
    preventDefaultException: {
      tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/
    },
    HWCompositing: true,
    useTransition: true,
    useTransform: true,
    bindToWrapper: false,
    disableMouse: hasTouch,
    disableTouch: !hasTouch,
    observeDOM: true,
    autoBlur: true,
    /**
     * for picker
     * wheel: {
     *   selectedIndex: 0,
     *   rotate: 25,
     *   adjustTime: 400
     *   wheelWrapperClass: 'wheel-scroll',
     *   wheelItemClass: 'wheel-item'
     * }
     */
    wheel: false,
    /**
     * for slide
     * snap: {
     *   loop: false,
     *   el: domEl,
     *   threshold: 0.1,
     *   stepX: 100,
     *   stepY: 100,
     *   speed: 400,
     *   easing: {
     *     style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
     *     fn: function (t) {
     *       return t * (2 - t)
     *     }
     *   }
     *   listenFlick: true
     * }
     */
    snap: false,
    /**
     * for scrollbar
     * scrollbar: {
     *   fade: true,
     *   interactive: false
     * }
     */
    scrollbar: false,
    /**
     * for pull down and refresh
     * pullDownRefresh: {
     *   threshold: 50,
     *   stop: 20
     * }
     */
    pullDownRefresh: false,
    /**
     * for pull up and load
     * pullUpLoad: {
     *   threshold: 50
     * }
     */
    pullUpLoad: false,
    /**
     * for mouse wheel
     * mouseWheel: {
     *   speed: 20,
     *   invert: false,
     *   easeTime: 300
     * }
     */
    mouseWheel: false,
    stopPropagation: false,
    /**
     * for zoom
     * zoom: {
     *   start: 1,
     *   min: 1,
     *   max: 4
     * }
     */
    zoom: false,
    /**
     * for infinity
     * infinity: {
     *   render(item, div) {
     *   },
     *   createTombstone() {
     *   },
     *   fetch(count) {
     *   }
     * }
     */
    infinity: false,
    /**
     * for double click
     * dblclick: {
     *   delay: 300
     * }
     */
    dblclick: false
  };

  function initMixin(BScroll) {
    BScroll.prototype._init = function (el, options) {
      this._handleOptions(options);

      // init private custom events
      this._events = {};

      this.x = 0;
      this.y = 0;
      this.directionX = 0;
      this.directionY = 0;

      this.setScale(1);

      this._addDOMEvents();

      this._initExtFeatures();

      this._watchTransition();

      if (this.options.observeDOM) {
        this._initDOMObserver();
      }

      if (this.options.autoBlur) {
        this._handleAutoBlur();
      }

      this.refresh();

      if (!this.options.snap) {
        this.scrollTo(this.options.startX, this.options.startY);
      }

      this.enable();
    };

    BScroll.prototype.setScale = function (scale) {
      this.lastScale = isUndef(this.scale) ? scale : this.scale;
      this.scale = scale;
    };

    BScroll.prototype._handleOptions = function (options) {
      this.options = extend({}, DEFAULT_OPTIONS, options);

      this.translateZ = this.options.HWCompositing && hasPerspective ? ' translateZ(0)' : '';

      this.options.useTransition = this.options.useTransition && hasTransition;
      this.options.useTransform = this.options.useTransform && hasTransform;

      this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

      // If you want eventPassthrough I have to lock one of the axes
      this.options.scrollX = this.options.eventPassthrough === 'horizontal' ? false : this.options.scrollX;
      this.options.scrollY = this.options.eventPassthrough === 'vertical' ? false : this.options.scrollY;

      // With eventPassthrough we also need lockDirection mechanism
      this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
      this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

      if (this.options.tap === true) {
        this.options.tap = 'tap';
      }
    };

    BScroll.prototype._addDOMEvents = function () {
      var eventOperation = addEvent;
      this._handleDOMEvents(eventOperation);
    };

    BScroll.prototype._removeDOMEvents = function () {
      var eventOperation = removeEvent;
      this._handleDOMEvents(eventOperation);
    };

    BScroll.prototype._handleDOMEvents = function (eventOperation) {
      var target = this.options.bindToWrapper ? this.wrapper : window;
      eventOperation(window, 'orientationchange', this);
      eventOperation(window, 'resize', this);

      if (this.options.click) {
        eventOperation(this.wrapper, 'click', this, true);
      }

      if (!this.options.disableMouse) {
        eventOperation(this.wrapper, 'mousedown', this);
        eventOperation(target, 'mousemove', this);
        eventOperation(target, 'mousecancel', this);
        eventOperation(target, 'mouseup', this);
      }

      if (hasTouch && !this.options.disableTouch) {
        eventOperation(this.wrapper, 'touchstart', this);
        eventOperation(target, 'touchmove', this);
        eventOperation(target, 'touchcancel', this);
        eventOperation(target, 'touchend', this);
      }

      eventOperation(this.scroller, style.transitionEnd, this);
    };

    BScroll.prototype._initExtFeatures = function () {
      if (this.options.snap) {
        this._initSnap();
      }
      if (this.options.scrollbar) {
        this._initScrollbar();
      }
      if (this.options.pullUpLoad) {
        this._initPullUp();
      }
      if (this.options.pullDownRefresh) {
        this._initPullDown();
      }
      if (this.options.wheel) {
        this._initWheel();
      }
      if (this.options.mouseWheel) {
        this._initMouseWheel();
      }
      if (this.options.zoom) {
        this._initZoom();
      }
      if (this.options.infinity) {
        this._initInfinite();
      }
    };

    BScroll.prototype._watchTransition = function () {
      if (typeof _defineProperty2.default !== 'function') {
        return;
      }
      var me = this;
      var isInTransition = false;
      var key = this.useTransition ? 'isInTransition' : 'isAnimating';
      (0, _defineProperty2.default)(this, key, {
        get: function get() {
          return isInTransition;
        },
        set: function set(newVal) {
          isInTransition = newVal;
          // fix issue #359
          var el = me.scroller.children.length ? me.scroller.children : [me.scroller];
          var pointerEvents = isInTransition && !me.pulling ? 'none' : 'auto';
          for (var i = 0; i < el.length; i++) {
            el[i].style.pointerEvents = pointerEvents;
          }
        }
      });
    };

    BScroll.prototype._handleAutoBlur = function () {
      this.on('scrollStart', function () {
        var activeElement = document.activeElement;
        if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
          activeElement.blur();
        }
      });
    };

    BScroll.prototype._initDOMObserver = function () {
      var _this = this;

      if (typeof MutationObserver !== 'undefined') {
        var timer = void 0;
        var observer = new MutationObserver(function (mutations) {
          // don't do any refresh during the transition, or outside of the boundaries
          if (_this._shouldNotRefresh()) {
            return;
          }
          var immediateRefresh = false;
          var deferredRefresh = false;
          for (var i = 0; i < mutations.length; i++) {
            var mutation = mutations[i];
            if (mutation.type !== 'attributes') {
              immediateRefresh = true;
              break;
            } else {
              if (mutation.target !== _this.scroller) {
                deferredRefresh = true;
                break;
              }
            }
          }
          if (immediateRefresh) {
            _this.refresh();
          } else if (deferredRefresh) {
            // attributes changes too often
            clearTimeout(timer);
            timer = setTimeout(function () {
              if (!_this._shouldNotRefresh()) {
                _this.refresh();
              }
            }, 60);
          }
        });
        var config = {
          attributes: true,
          childList: true,
          subtree: true
        };
        observer.observe(this.scroller, config);

        this.on('destroy', function () {
          observer.disconnect();
        });
      } else {
        this._checkDOMUpdate();
      }
    };

    BScroll.prototype._shouldNotRefresh = function () {
      var outsideBoundaries = this.x > this.minScrollX || this.x < this.maxScrollX || this.y > this.minScrollY || this.y < this.maxScrollY;

      return this.isInTransition || this.stopFromTransition || outsideBoundaries;
    };

    BScroll.prototype._checkDOMUpdate = function () {
      var scrollerRect = getRect(this.scroller);
      var oldWidth = scrollerRect.width;
      var oldHeight = scrollerRect.height;

      function check() {
        if (this.destroyed) {
          return;
        }
        scrollerRect = getRect(this.scroller);
        var newWidth = scrollerRect.width;
        var newHeight = scrollerRect.height;

        if (oldWidth !== newWidth || oldHeight !== newHeight) {
          this.refresh();
        }
        oldWidth = newWidth;
        oldHeight = newHeight;

        next.call(this);
      }

      function next() {
        var _this2 = this;

        setTimeout(function () {
          check.call(_this2);
        }, 1000);
      }

      next.call(this);
    };

    BScroll.prototype.handleEvent = function (e) {
      switch (e.type) {
        case 'touchstart':
        case 'mousedown':
          this._start(e);
          if (this.options.zoom && e.touches && e.touches.length > 1) {
            this._zoomStart(e);
          }
          break;
        case 'touchmove':
        case 'mousemove':
          if (this.options.zoom && e.touches && e.touches.length > 1) {
            this._zoom(e);
          } else {
            this._move(e);
          }
          break;
        case 'touchend':
        case 'mouseup':
        case 'touchcancel':
        case 'mousecancel':
          if (this.scaled) {
            this._zoomEnd(e);
          } else {
            this._end(e);
          }
          break;
        case 'orientationchange':
        case 'resize':
          this._resize();
          break;
        case 'transitionend':
        case 'webkitTransitionEnd':
        case 'oTransitionEnd':
        case 'MSTransitionEnd':
          this._transitionEnd(e);
          break;
        case 'click':
          if (this.enabled && !e._constructed) {
            if (!preventDefaultException(e.target, this.options.preventDefaultException)) {
              e.preventDefault();
              e.stopPropagation();
            }
          }
          break;
        case 'wheel':
        case 'DOMMouseScroll':
        case 'mousewheel':
          this._onMouseWheel(e);
          break;
      }
    };

    BScroll.prototype.refresh = function () {
      var isWrapperStatic = window.getComputedStyle(this.wrapper, null).position === 'static';
      var wrapperRect = getRect(this.wrapper);
      this.wrapperWidth = wrapperRect.width;
      this.wrapperHeight = wrapperRect.height;

      var scrollerRect = getRect(this.scroller);
      this.scrollerWidth = Math.round(scrollerRect.width * this.scale);
      this.scrollerHeight = Math.round(scrollerRect.height * this.scale);

      this.relativeX = scrollerRect.left;
      this.relativeY = scrollerRect.top;

      if (isWrapperStatic) {
        this.relativeX -= wrapperRect.left;
        this.relativeY -= wrapperRect.top;
      }

      this.minScrollX = 0;
      this.minScrollY = 0;

      var wheel = this.options.wheel;
      if (wheel) {
        this.items = this.scroller.children;
        this.options.itemHeight = this.itemHeight = this.items.length ? this.scrollerHeight / this.items.length : 0;
        if (this.selectedIndex === undefined) {
          this.selectedIndex = wheel.selectedIndex || 0;
        }
        this.options.startY = -this.selectedIndex * this.itemHeight;
        this.maxScrollX = 0;
        this.maxScrollY = -this.itemHeight * (this.items.length - 1);
      } else {
        this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
        if (!this.options.infinity) {
          this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
        }
        if (this.maxScrollX < 0) {
          this.maxScrollX -= this.relativeX;
          this.minScrollX = -this.relativeX;
        } else if (this.scale > 1) {
          this.maxScrollX = this.maxScrollX / 2 - this.relativeX;
          this.minScrollX = this.maxScrollX;
        }
        if (this.maxScrollY < 0) {
          this.maxScrollY -= this.relativeY;
          this.minScrollY = -this.relativeY;
        } else if (this.scale > 1) {
          this.maxScrollY = this.maxScrollY / 2 - this.relativeY;
          this.minScrollY = this.maxScrollY;
        }
      }

      this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < this.minScrollX;
      this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < this.minScrollY;

      if (!this.hasHorizontalScroll) {
        this.maxScrollX = this.minScrollX;
        this.scrollerWidth = this.wrapperWidth;
      }

      if (!this.hasVerticalScroll) {
        this.maxScrollY = this.minScrollY;
        this.scrollerHeight = this.wrapperHeight;
      }

      this.endTime = 0;
      this.directionX = 0;
      this.directionY = 0;
      this.wrapperOffset = offset(this.wrapper);

      this.trigger('refresh');

      !this.scaled && this.resetPosition();
    };

    BScroll.prototype.enable = function () {
      this.enabled = true;
    };

    BScroll.prototype.disable = function () {
      this.enabled = false;
    };
  }

  var ease = {
    // easeOutQuint
    swipe: {
      style: 'cubic-bezier(0.23, 1, 0.32, 1)',
      fn: function fn(t) {
        return 1 + --t * t * t * t * t;
      }
    },
    // easeOutQuard
    swipeBounce: {
      style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      fn: function fn(t) {
        return t * (2 - t);
      }
    },
    // easeOutQuart
    bounce: {
      style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
      fn: function fn(t) {
        return 1 - --t * t * t * t;
      }
    }
  };

  function momentum(current, start, time, lowerMargin, upperMargin, wrapperSize, options) {
    var distance = current - start;
    var speed = Math.abs(distance) / time;

    var deceleration = options.deceleration,
        itemHeight = options.itemHeight,
        swipeBounceTime = options.swipeBounceTime,
        wheel = options.wheel,
        swipeTime = options.swipeTime;

    var duration = swipeTime;
    var rate = wheel ? 4 : 15;

    var destination = current + speed / deceleration * (distance < 0 ? -1 : 1);

    if (wheel && itemHeight) {
      destination = Math.round(destination / itemHeight) * itemHeight;
    }

    if (destination < lowerMargin) {
      destination = wrapperSize ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - wrapperSize / rate * speed) : lowerMargin;
      duration = swipeBounceTime;
    } else if (destination > upperMargin) {
      destination = wrapperSize ? Math.min(upperMargin + wrapperSize / 4, upperMargin + wrapperSize / rate * speed) : upperMargin;
      duration = swipeBounceTime;
    }

    return {
      destination: Math.round(destination),
      duration: duration
    };
  }

  var DEFAULT_INTERVAL = 100 / 60;

  function noop() {}

  var requestAnimationFrame = function () {
    if (!inBrowser) {
      /* istanbul ignore if */
      return noop;
    }
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame ||
    // if all else fails, use setTimeout
    function (callback) {
      return window.setTimeout(callback, (callback.interval || DEFAULT_INTERVAL) / 2); // make interval as precise as possible.
    };
  }();

  var cancelAnimationFrame = function () {
    if (!inBrowser) {
      /* istanbul ignore if */
      return noop;
    }
    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || function (id) {
      window.clearTimeout(id);
    };
  }();

  var DIRECTION_UP = 1;
  var DIRECTION_DOWN = -1;
  var DIRECTION_LEFT = 1;
  var DIRECTION_RIGHT = -1;

  var PROBE_DEBOUNCE = 1;

  var PROBE_REALTIME = 3;

  function warn(msg) {
    console.error('[BScroll warn]: ' + msg);
  }

  function assert(condition, msg) {
    if (!condition) {
      throw new Error('[BScroll] ' + msg);
    }
  }

  function coreMixin(BScroll) {
    BScroll.prototype._start = function (e) {
      var _eventType = eventType[e.type];
      if (_eventType !== TOUCH_EVENT) {
        if (e.button !== 0) {
          return;
        }
      }
      if (!this.enabled || this.destroyed || this.initiated && this.initiated !== _eventType) {
        return;
      }
      this.initiated = _eventType;

      if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
        e.preventDefault();
      }
      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      this.moved = false;
      this.distX = 0;
      this.distY = 0;
      this.directionX = 0;
      this.directionY = 0;
      this.movingDirectionX = 0;
      this.movingDirectionY = 0;
      this.directionLocked = 0;

      this._transitionTime();
      this.startTime = getNow();

      if (this.options.wheel) {
        this.target = e.target;
      }

      this.stop();

      var point = e.touches ? e.touches[0] : e;

      this.startX = this.x;
      this.startY = this.y;
      this.absStartX = this.x;
      this.absStartY = this.y;
      this.pointX = point.pageX;
      this.pointY = point.pageY;

      this.trigger('beforeScrollStart');
    };

    BScroll.prototype._move = function (e) {
      if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
        return;
      }

      if (this.options.preventDefault) {
        e.preventDefault();
      }
      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      var point = e.touches ? e.touches[0] : e;
      var deltaX = point.pageX - this.pointX;
      var deltaY = point.pageY - this.pointY;

      this.pointX = point.pageX;
      this.pointY = point.pageY;

      this.distX += deltaX;
      this.distY += deltaY;

      var absDistX = Math.abs(this.distX);
      var absDistY = Math.abs(this.distY);

      var timestamp = getNow();

      // We need to move at least momentumLimitDistance pixels for the scrolling to initiate
      if (timestamp - this.endTime > this.options.momentumLimitTime && absDistY < this.options.momentumLimitDistance && absDistX < this.options.momentumLimitDistance) {
        return;
      }

      // If you are scrolling in one direction lock the other
      if (!this.directionLocked && !this.options.freeScroll) {
        if (absDistX > absDistY + this.options.directionLockThreshold) {
          this.directionLocked = 'h'; // lock horizontally
        } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
          this.directionLocked = 'v'; // lock vertically
        } else {
          this.directionLocked = 'n'; // no lock
        }
      }

      if (this.directionLocked === 'h') {
        if (this.options.eventPassthrough === 'vertical') {
          e.preventDefault();
        } else if (this.options.eventPassthrough === 'horizontal') {
          this.initiated = false;
          return;
        }
        deltaY = 0;
      } else if (this.directionLocked === 'v') {
        if (this.options.eventPassthrough === 'horizontal') {
          e.preventDefault();
        } else if (this.options.eventPassthrough === 'vertical') {
          this.initiated = false;
          return;
        }
        deltaX = 0;
      }

      deltaX = this.hasHorizontalScroll ? deltaX : 0;
      deltaY = this.hasVerticalScroll ? deltaY : 0;
      this.movingDirectionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
      this.movingDirectionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

      var newX = this.x + deltaX;
      var newY = this.y + deltaY;

      var top = false;
      var bottom = false;
      var left = false;
      var right = false;
      // Slow down or stop if outside of the boundaries
      var bounce = this.options.bounce;
      if (bounce !== false) {
        top = bounce.top === undefined ? true : bounce.top;
        bottom = bounce.bottom === undefined ? true : bounce.bottom;
        left = bounce.left === undefined ? true : bounce.left;
        right = bounce.right === undefined ? true : bounce.right;
      }
      if (newX > this.minScrollX || newX < this.maxScrollX) {
        if (newX > this.minScrollX && left || newX < this.maxScrollX && right) {
          newX = this.x + deltaX / 3;
        } else {
          newX = newX > this.minScrollX ? this.minScrollX : this.maxScrollX;
        }
      }
      if (newY > this.minScrollY || newY < this.maxScrollY) {
        if (newY > this.minScrollY && top || newY < this.maxScrollY && bottom) {
          newY = this.y + deltaY / 3;
        } else {
          newY = newY > this.minScrollY ? this.minScrollY : this.maxScrollY;
        }
      }

      if (!this.moved) {
        this.moved = true;
        this.trigger('scrollStart');
      }

      this._translate(newX, newY);

      if (timestamp - this.startTime > this.options.momentumLimitTime) {
        this.startTime = timestamp;
        this.startX = this.x;
        this.startY = this.y;

        if (this.options.probeType === PROBE_DEBOUNCE) {
          this.trigger('scroll', {
            x: this.x,
            y: this.y
          });
        }
      }

      if (this.options.probeType > PROBE_DEBOUNCE) {
        this.trigger('scroll', {
          x: this.x,
          y: this.y
        });
      }

      var scrollLeft = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft;
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      var pX = this.pointX - scrollLeft;
      var pY = this.pointY - scrollTop;

      if (pX > document.documentElement.clientWidth - this.options.momentumLimitDistance || pX < this.options.momentumLimitDistance || pY < this.options.momentumLimitDistance || pY > document.documentElement.clientHeight - this.options.momentumLimitDistance) {
        this._end(e);
      }
    };

    BScroll.prototype._end = function (e) {
      if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
        return;
      }
      this.initiated = false;

      if (this.options.preventDefault && !preventDefaultException(e.target, this.options.preventDefaultException)) {
        e.preventDefault();
      }
      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      this.trigger('touchEnd', {
        x: this.x,
        y: this.y
      });

      this.isInTransition = false;

      // ensures that the last position is rounded
      var newX = Math.round(this.x);
      var newY = Math.round(this.y);

      var deltaX = newX - this.absStartX;
      var deltaY = newY - this.absStartY;
      this.directionX = deltaX > 0 ? DIRECTION_RIGHT : deltaX < 0 ? DIRECTION_LEFT : 0;
      this.directionY = deltaY > 0 ? DIRECTION_DOWN : deltaY < 0 ? DIRECTION_UP : 0;

      // if configure pull down refresh, check it first
      if (this.options.pullDownRefresh && this._checkPullDown()) {
        return;
      }

      // check if it is a click operation
      if (this._checkClick(e)) {
        this.trigger('scrollCancel');
        return;
      }

      // reset if we are outside of the boundaries
      if (this.resetPosition(this.options.bounceTime, ease.bounce)) {
        return;
      }

      this._translate(newX, newY);

      this.endTime = getNow();
      var duration = this.endTime - this.startTime;
      var absDistX = Math.abs(newX - this.startX);
      var absDistY = Math.abs(newY - this.startY);

      // flick
      if (this._events.flick && duration < this.options.flickLimitTime && absDistX < this.options.flickLimitDistance && absDistY < this.options.flickLimitDistance) {
        this.trigger('flick');
        return;
      }

      var time = 0;
      // start momentum animation if needed
      if (this.options.momentum && duration < this.options.momentumLimitTime && (absDistY > this.options.momentumLimitDistance || absDistX > this.options.momentumLimitDistance)) {
        var top = false;
        var bottom = false;
        var left = false;
        var right = false;
        var bounce = this.options.bounce;
        if (bounce !== false) {
          top = bounce.top === undefined ? true : bounce.top;
          bottom = bounce.bottom === undefined ? true : bounce.bottom;
          left = bounce.left === undefined ? true : bounce.left;
          right = bounce.right === undefined ? true : bounce.right;
        }
        var wrapperWidth = this.directionX === DIRECTION_RIGHT && left || this.directionX === DIRECTION_LEFT && right ? this.wrapperWidth : 0;
        var wrapperHeight = this.directionY === DIRECTION_DOWN && top || this.directionY === DIRECTION_UP && bottom ? this.wrapperHeight : 0;
        var momentumX = this.hasHorizontalScroll ? momentum(this.x, this.startX, duration, this.maxScrollX, this.minScrollX, wrapperWidth, this.options) : { destination: newX, duration: 0 };
        var momentumY = this.hasVerticalScroll ? momentum(this.y, this.startY, duration, this.maxScrollY, this.minScrollY, wrapperHeight, this.options) : { destination: newY, duration: 0 };
        newX = momentumX.destination;
        newY = momentumY.destination;
        time = Math.max(momentumX.duration, momentumY.duration);
        this.isInTransition = true;
      } else {
        if (this.options.wheel) {
          newY = Math.round(newY / this.itemHeight) * this.itemHeight;
          time = this.options.wheel.adjustTime || 400;
        }
      }

      var easing = ease.swipe;
      if (this.options.snap) {
        var snap = this._nearestSnap(newX, newY);
        this.currentPage = snap;
        time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
        newX = snap.x;
        newY = snap.y;

        this.directionX = 0;
        this.directionY = 0;
        easing = this.options.snap.easing || ease.bounce;
      }

      if (newX !== this.x || newY !== this.y) {
        // change easing function when scroller goes out of the boundaries
        if (newX > this.minScrollX || newX < this.maxScrollX || newY > this.minScrollY || newY < this.maxScrollY) {
          easing = ease.swipeBounce;
        }
        this.scrollTo(newX, newY, time, easing);
        return;
      }

      if (this.options.wheel) {
        this.selectedIndex = Math.round(Math.abs(this.y / this.itemHeight));
      }
      this.trigger('scrollEnd', {
        x: this.x,
        y: this.y
      });
    };

    BScroll.prototype._checkClick = function (e) {
      // when in the process of pulling down, it should not prevent click
      var preventClick = this.stopFromTransition && !this.pulling;
      this.stopFromTransition = false;

      // we scrolled less than 15 pixels
      if (!this.moved) {
        if (this.options.wheel) {
          if (this.target && this.target.classList.contains(this.options.wheel.wheelWrapperClass)) {
            var index = Math.abs(Math.round(this.y / this.itemHeight));
            var _offset = Math.round((this.pointY + offsetToBody(this.wrapper).top - this.wrapperHeight / 2) / this.itemHeight);
            this.target = this.items[index + _offset];
          }
          this.scrollToElement(this.target, this.options.wheel.adjustTime || 400, true, true, ease.swipe);
          return true;
        } else {
          if (!preventClick) {
            var _dblclick = this.options.dblclick;
            var dblclickTrigged = false;
            if (_dblclick && this.lastClickTime) {
              var _dblclick$delay = _dblclick.delay,
                  delay = _dblclick$delay === undefined ? 300 : _dblclick$delay;

              if (getNow() - this.lastClickTime < delay) {
                dblclickTrigged = true;
                dblclick(e);
              }
            }
            if (this.options.tap) {
              tap(e, this.options.tap);
            }

            if (this.options.click && !preventDefaultException(e.target, this.options.preventDefaultException)) {
              click(e);
            }
            this.lastClickTime = dblclickTrigged ? null : getNow();
            return true;
          }
          return false;
        }
      }
      return false;
    };

    BScroll.prototype._resize = function () {
      var _this = this;

      if (!this.enabled) {
        return;
      }
      // fix a scroll problem under Android condition
      if (isAndroid) {
        this.wrapper.scrollTop = 0;
      }
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(function () {
        _this.refresh();
      }, this.options.resizePolling);
    };

    BScroll.prototype._startProbe = function () {
      cancelAnimationFrame(this.probeTimer);
      this.probeTimer = requestAnimationFrame(probe);

      var me = this;

      function probe() {
        var pos = me.getComputedPosition();
        me.trigger('scroll', pos);
        if (!me.isInTransition) {
          me.trigger('scrollEnd', pos);
          return;
        }
        me.probeTimer = requestAnimationFrame(probe);
      }
    };

    BScroll.prototype._transitionTime = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.scrollerStyle[style.transitionDuration] = time + 'ms';

      if (this.options.wheel) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].style[style.transitionDuration] = time + 'ms';
        }
      }

      if (this.indicators) {
        for (var _i = 0; _i < this.indicators.length; _i++) {
          this.indicators[_i].transitionTime(time);
        }
      }
    };

    BScroll.prototype._transitionTimingFunction = function (easing) {
      this.scrollerStyle[style.transitionTimingFunction] = easing;

      if (this.options.wheel) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].style[style.transitionTimingFunction] = easing;
        }
      }

      if (this.indicators) {
        for (var _i2 = 0; _i2 < this.indicators.length; _i2++) {
          this.indicators[_i2].transitionTimingFunction(easing);
        }
      }
    };

    BScroll.prototype._transitionEnd = function (e) {
      if (e.target !== this.scroller || !this.isInTransition) {
        return;
      }

      this._transitionTime();
      var needReset = !this.pulling || this.movingDirectionY === DIRECTION_UP;
      if (needReset && !this.resetPosition(this.options.bounceTime, ease.bounce)) {
        this.isInTransition = false;
        if (this.options.probeType !== PROBE_REALTIME) {
          this.trigger('scrollEnd', {
            x: this.x,
            y: this.y
          });
        }
      }
    };

    BScroll.prototype._translate = function (x, y, scale) {
      assert(!isUndef(x) && !isUndef(y), 'Translate x or y is null or undefined.');
      if (isUndef(scale)) {
        scale = this.scale;
      }
      if (this.options.useTransform) {
        this.scrollerStyle[style.transform] = 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')' + this.translateZ;
      } else {
        x = Math.round(x);
        y = Math.round(y);
        this.scrollerStyle.left = x + 'px';
        this.scrollerStyle.top = y + 'px';
      }

      if (this.options.wheel) {
        var _options$wheel$rotate = this.options.wheel.rotate,
            rotate = _options$wheel$rotate === undefined ? 25 : _options$wheel$rotate;

        for (var i = 0; i < this.items.length; i++) {
          var deg = rotate * (y / this.itemHeight + i);
          this.items[i].style[style.transform] = 'rotateX(' + deg + 'deg)';
        }
      }

      this.x = x;
      this.y = y;
      this.setScale(scale);

      if (this.indicators) {
        for (var _i3 = 0; _i3 < this.indicators.length; _i3++) {
          this.indicators[_i3].updatePosition();
        }
      }
    };

    BScroll.prototype._animate = function (destX, destY, duration, easingFn) {
      var me = this;
      var startX = this.x;
      var startY = this.y;
      var startScale = this.lastScale;
      var destScale = this.scale;
      var startTime = getNow();
      var destTime = startTime + duration;

      function step() {
        var now = getNow();

        if (now >= destTime) {
          me.isAnimating = false;
          me._translate(destX, destY, destScale);

          me.trigger('scroll', {
            x: me.x,
            y: me.y
          });

          if (!me.pulling && !me.resetPosition(me.options.bounceTime)) {
            me.trigger('scrollEnd', {
              x: me.x,
              y: me.y
            });
          }
          return;
        }
        now = (now - startTime) / duration;
        var easing = easingFn(now);
        var newX = (destX - startX) * easing + startX;
        var newY = (destY - startY) * easing + startY;
        var newScale = (destScale - startScale) * easing + startScale;

        me._translate(newX, newY, newScale);

        if (me.isAnimating) {
          me.animateTimer = requestAnimationFrame(step);
        }

        if (me.options.probeType === PROBE_REALTIME) {
          me.trigger('scroll', {
            x: me.x,
            y: me.y
          });
        }
      }

      this.isAnimating = true;
      cancelAnimationFrame(this.animateTimer);
      step();
    };

    BScroll.prototype.scrollBy = function (x, y) {
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

      x = this.x + x;
      y = this.y + y;

      this.scrollTo(x, y, time, easing);
    };

    BScroll.prototype.scrollTo = function (x, y) {
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ease.bounce;

      this.isInTransition = this.options.useTransition && time > 0 && (x !== this.x || y !== this.y);

      if (!time || this.options.useTransition) {
        this._transitionTimingFunction(easing.style);
        this._transitionTime(time);
        this._translate(x, y);

        if (time && this.options.probeType === PROBE_REALTIME) {
          this._startProbe();
        }

        if (!time && (x !== this.x || y !== this.y)) {
          this.trigger('scroll', {
            x: x,
            y: y
          });
          // force reflow to put everything in position
          this._reflow = document.body.offsetHeight;
          if (!this.resetPosition(this.options.bounceTime, ease.bounce)) {
            this.trigger('scrollEnd', {
              x: x,
              y: y
            });
          }
        }

        if (this.options.wheel) {
          if (y > this.minScrollY) {
            this.selectedIndex = 0;
          } else if (y < this.maxScrollY) {
            this.selectedIndex = this.items.length - 1;
          } else {
            this.selectedIndex = Math.round(Math.abs(y / this.itemHeight));
          }
        }
      } else {
        this._animate(x, y, time, easing.fn);
      }
    };

    BScroll.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
      if (!el) {
        return;
      }
      el = el.nodeType ? el : this.scroller.querySelector(el);

      if (this.options.wheel && !el.classList.contains(this.options.wheel.wheelItemClass)) {
        return;
      }

      var pos = offset(el);
      pos.left -= this.wrapperOffset.left;
      pos.top -= this.wrapperOffset.top;

      // if offsetX/Y are true we center the element to the screen
      if (offsetX === true) {
        offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
      }
      if (offsetY === true) {
        offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
      }

      pos.left -= offsetX || 0;
      pos.top -= offsetY || 0;
      pos.left = pos.left > this.minScrollX ? this.minScrollX : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
      pos.top = pos.top > this.minScrollY ? this.minScrollY : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

      if (this.options.wheel) {
        pos.top = Math.round(pos.top / this.itemHeight) * this.itemHeight;
      }

      this.scrollTo(pos.left, pos.top, time, easing);
    };

    BScroll.prototype.resetPosition = function () {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var easeing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ease.bounce;

      var x = this.x;
      var roundX = Math.round(x);
      if (!this.hasHorizontalScroll || roundX > this.minScrollX) {
        x = this.minScrollX;
      } else if (roundX < this.maxScrollX) {
        x = this.maxScrollX;
      }

      var y = this.y;
      var roundY = Math.round(y);
      if (!this.hasVerticalScroll || roundY > this.minScrollY) {
        y = this.minScrollY;
      } else if (roundY < this.maxScrollY) {
        y = this.maxScrollY;
      }

      if (x === this.x && y === this.y) {
        return false;
      }

      this.scrollTo(x, y, time, easeing);

      return true;
    };

    BScroll.prototype.getComputedPosition = function () {
      var matrix = window.getComputedStyle(this.scroller, null);
      var x = void 0;
      var y = void 0;

      if (this.options.useTransform) {
        matrix = matrix[style.transform].split(')')[0].split(', ');
        x = +(matrix[12] || matrix[4]);
        y = +(matrix[13] || matrix[5]);
      } else {
        x = +matrix.left.replace(/[^-\d.]/g, '');
        y = +matrix.top.replace(/[^-\d.]/g, '');
      }

      return {
        x: x,
        y: y
      };
    };

    BScroll.prototype.stop = function () {
      if (this.options.useTransition && this.isInTransition) {
        this.isInTransition = false;
        cancelAnimationFrame(this.probeTimer);
        var pos = this.getComputedPosition();
        this._translate(pos.x, pos.y);
        if (this.options.wheel) {
          this.target = this.items[Math.round(-pos.y / this.itemHeight)];
        } else {
          this.trigger('scrollEnd', {
            x: this.x,
            y: this.y
          });
        }
        this.stopFromTransition = true;
      } else if (!this.options.useTransition && this.isAnimating) {
        this.isAnimating = false;
        cancelAnimationFrame(this.animateTimer);
        this.trigger('scrollEnd', {
          x: this.x,
          y: this.y
        });
        this.stopFromTransition = true;
      }
    };

    BScroll.prototype.destroy = function () {
      this.destroyed = true;
      this.trigger('destroy');
      if (this.options.useTransition) {
        cancelAnimationFrame(this.probeTimer);
      } else {
        cancelAnimationFrame(this.animateTimer);
      }
      this._removeDOMEvents();
      // remove custom events
      this._events = {};
    };
  }

  function snapMixin(BScroll) {
    BScroll.prototype._initSnap = function () {
      var _this = this;

      this.currentPage = {};
      var snap = this.options.snap;

      if (snap.loop) {
        var children = this.scroller.children;
        if (children.length > 1) {
          prepend(children[children.length - 1].cloneNode(true), this.scroller);
          this.scroller.appendChild(children[1].cloneNode(true));
        } else {
          // Loop does not make any sense if there is only one child.
          snap.loop = false;
        }
      }

      var el = snap.el;
      if (typeof el === 'string') {
        el = this.scroller.querySelectorAll(el);
      }

      this.on('refresh', function () {
        _this.pages = [];

        if (!_this.wrapperWidth || !_this.wrapperHeight || !_this.scrollerWidth || !_this.scrollerHeight) {
          return;
        }

        var stepX = snap.stepX || _this.wrapperWidth;
        var stepY = snap.stepY || _this.wrapperHeight;

        var x = 0;
        var y = void 0;
        var cx = void 0;
        var cy = void 0;
        var i = 0;
        var l = void 0;
        var m = 0;
        var n = void 0;
        var rect = void 0;
        if (!el) {
          cx = Math.round(stepX / 2);
          cy = Math.round(stepY / 2);

          while (x > -_this.scrollerWidth) {
            _this.pages[i] = [];
            l = 0;
            y = 0;

            while (y > -_this.scrollerHeight) {
              _this.pages[i][l] = {
                x: Math.max(x, _this.maxScrollX),
                y: Math.max(y, _this.maxScrollY),
                width: stepX,
                height: stepY,
                cx: x - cx,
                cy: y - cy
              };

              y -= stepY;
              l++;
            }

            x -= stepX;
            i++;
          }
        } else {
          l = el.length;
          n = -1;

          for (; i < l; i++) {
            rect = getRect(el[i]);
            if (i === 0 || rect.left <= getRect(el[i - 1]).left) {
              m = 0;
              n++;
            }

            if (!_this.pages[m]) {
              _this.pages[m] = [];
            }

            x = Math.max(-rect.left, _this.maxScrollX);
            y = Math.max(-rect.top, _this.maxScrollY);
            cx = x - Math.round(rect.width / 2);
            cy = y - Math.round(rect.height / 2);

            _this.pages[m][n] = {
              x: x,
              y: y,
              width: rect.width,
              height: rect.height,
              cx: cx,
              cy: cy
            };

            if (x > _this.maxScrollX) {
              m++;
            }
          }
        }

        _this._checkSnapLoop();

        var initPageX = snap._loopX ? 1 : 0;
        var initPageY = snap._loopY ? 1 : 0;
        _this._goToPage(_this.currentPage.pageX || initPageX, _this.currentPage.pageY || initPageY, 0);

        // Update snap threshold if needed.
        var snapThreshold = snap.threshold;
        if (snapThreshold % 1 === 0) {
          _this.snapThresholdX = snapThreshold;
          _this.snapThresholdY = snapThreshold;
        } else {
          _this.snapThresholdX = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].width * snapThreshold);
          _this.snapThresholdY = Math.round(_this.pages[_this.currentPage.pageX][_this.currentPage.pageY].height * snapThreshold);
        }
      });

      this.on('scrollEnd', function () {
        if (snap.loop) {
          if (snap._loopX) {
            if (_this.currentPage.pageX === 0) {
              _this._goToPage(_this.pages.length - 2, _this.currentPage.pageY, 0);
            }
            if (_this.currentPage.pageX === _this.pages.length - 1) {
              _this._goToPage(1, _this.currentPage.pageY, 0);
            }
          } else {
            if (_this.currentPage.pageY === 0) {
              _this._goToPage(_this.currentPage.pageX, _this.pages[0].length - 2, 0);
            }
            if (_this.currentPage.pageY === _this.pages[0].length - 1) {
              _this._goToPage(_this.currentPage.pageX, 1, 0);
            }
          }
        }
      });

      if (snap.listenFlick !== false) {
        this.on('flick', function () {
          var time = snap.speed || Math.max(Math.max(Math.min(Math.abs(_this.x - _this.startX), 1000), Math.min(Math.abs(_this.y - _this.startY), 1000)), 300);

          _this._goToPage(_this.currentPage.pageX + _this.directionX, _this.currentPage.pageY + _this.directionY, time);
        });
      }

      this.on('destroy', function () {
        if (snap.loop) {
          var _children = _this.scroller.children;
          if (_children.length > 2) {
            removeChild(_this.scroller, _children[_children.length - 1]);
            removeChild(_this.scroller, _children[0]);
          }
        }
      });
    };

    BScroll.prototype._checkSnapLoop = function () {
      var snap = this.options.snap;

      if (!snap.loop || !this.pages || !this.pages.length) {
        return;
      }

      if (this.pages.length > 1) {
        snap._loopX = true;
      }
      if (this.pages[0] && this.pages[0].length > 1) {
        snap._loopY = true;
      }
      if (snap._loopX && snap._loopY) {
        warn('Loop does not support two direction at the same time.');
      }
    };

    BScroll.prototype._nearestSnap = function (x, y) {
      if (!this.pages.length) {
        return { x: 0, y: 0, pageX: 0, pageY: 0 };
      }

      var i = 0;
      // Check if we exceeded the snap threshold
      if (Math.abs(x - this.absStartX) <= this.snapThresholdX && Math.abs(y - this.absStartY) <= this.snapThresholdY) {
        return this.currentPage;
      }

      if (x > this.minScrollX) {
        x = this.minScrollX;
      } else if (x < this.maxScrollX) {
        x = this.maxScrollX;
      }

      if (y > this.minScrollY) {
        y = this.minScrollY;
      } else if (y < this.maxScrollY) {
        y = this.maxScrollY;
      }

      var l = this.pages.length;
      for (; i < l; i++) {
        if (x >= this.pages[i][0].cx) {
          x = this.pages[i][0].x;
          break;
        }
      }

      l = this.pages[i].length;

      var m = 0;
      for (; m < l; m++) {
        if (y >= this.pages[0][m].cy) {
          y = this.pages[0][m].y;
          break;
        }
      }

      if (i === this.currentPage.pageX) {
        i += this.directionX;

        if (i < 0) {
          i = 0;
        } else if (i >= this.pages.length) {
          i = this.pages.length - 1;
        }

        x = this.pages[i][0].x;
      }

      if (m === this.currentPage.pageY) {
        m += this.directionY;

        if (m < 0) {
          m = 0;
        } else if (m >= this.pages[0].length) {
          m = this.pages[0].length - 1;
        }

        y = this.pages[0][m].y;
      }

      return {
        x: x,
        y: y,
        pageX: i,
        pageY: m
      };
    };

    BScroll.prototype._goToPage = function (x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var time = arguments[2];
      var easing = arguments[3];

      var snap = this.options.snap;

      if (!snap || !this.pages || !this.pages.length) {
        return;
      }

      easing = easing || snap.easing || ease.bounce;

      if (x >= this.pages.length) {
        x = this.pages.length - 1;
      } else if (x < 0) {
        x = 0;
      }

      if (!this.pages[x]) {
        return;
      }

      if (y >= this.pages[x].length) {
        y = this.pages[x].length - 1;
      } else if (y < 0) {
        y = 0;
      }

      var posX = this.pages[x][y].x;
      var posY = this.pages[x][y].y;

      time = time === undefined ? snap.speed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

      this.currentPage = {
        x: posX,
        y: posY,
        pageX: x,
        pageY: y
      };
      this.scrollTo(posX, posY, time, easing);
    };

    BScroll.prototype.goToPage = function (x, y, time, easing) {
      var snap = this.options.snap;
      if (!snap || !this.pages || !this.pages.length) {
        return;
      }

      if (snap.loop) {
        var len = void 0;
        if (snap._loopX) {
          len = this.pages.length - 2;
          if (x >= len) {
            x = len - 1;
          } else if (x < 0) {
            x = 0;
          }
          x += 1;
        } else {
          len = this.pages[0].length - 2;
          if (y >= len) {
            y = len - 1;
          } else if (y < 0) {
            y = 0;
          }
          y += 1;
        }
      }
      this._goToPage(x, y, time, easing);
    };

    BScroll.prototype.next = function (time, easing) {
      var snap = this.options.snap;
      if (!snap) {
        return;
      }

      var x = this.currentPage.pageX;
      var y = this.currentPage.pageY;

      x++;
      if (x >= this.pages.length && this.hasVerticalScroll) {
        x = 0;
        y++;
      }

      this._goToPage(x, y, time, easing);
    };

    BScroll.prototype.prev = function (time, easing) {
      var snap = this.options.snap;
      if (!snap) {
        return;
      }

      var x = this.currentPage.pageX;
      var y = this.currentPage.pageY;

      x--;
      if (x < 0 && this.hasVerticalScroll) {
        x = 0;
        y--;
      }

      this._goToPage(x, y, time, easing);
    };

    BScroll.prototype.getCurrentPage = function () {
      var snap = this.options.snap;
      if (!snap) {
        return null;
      }

      if (snap.loop) {
        var currentPage = void 0;
        if (snap._loopX) {
          currentPage = extend({}, this.currentPage, {
            pageX: this.currentPage.pageX - 1
          });
        } else {
          currentPage = extend({}, this.currentPage, {
            pageY: this.currentPage.pageY - 1
          });
        }
        return currentPage;
      }
      return this.currentPage;
    };
  }

  function wheelMixin(BScroll) {
    BScroll.prototype.wheelTo = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.options.wheel) {
        this.y = -index * this.itemHeight;
        this.scrollTo(0, this.y);
      }
    };

    BScroll.prototype.getSelectedIndex = function () {
      return this.options.wheel && this.selectedIndex;
    };

    BScroll.prototype._initWheel = function () {
      var wheel = this.options.wheel;
      if (!wheel.wheelWrapperClass) {
        wheel.wheelWrapperClass = 'wheel-scroll';
      }
      if (!wheel.wheelItemClass) {
        wheel.wheelItemClass = 'wheel-item';
      }
      if (wheel.selectedIndex === undefined) {
        wheel.selectedIndex = 0;
        warn('wheel option selectedIndex is required!');
      }
    };
  }

  var INDICATOR_MIN_LEN = 8;

  function scrollbarMixin(BScroll) {
    BScroll.prototype._initScrollbar = function () {
      var _this = this;

      var _options$scrollbar = this.options.scrollbar,
          _options$scrollbar$fa = _options$scrollbar.fade,
          fade = _options$scrollbar$fa === undefined ? true : _options$scrollbar$fa,
          _options$scrollbar$in = _options$scrollbar.interactive,
          interactive = _options$scrollbar$in === undefined ? false : _options$scrollbar$in;

      this.indicators = [];
      var indicator = void 0;

      if (this.options.scrollX) {
        indicator = {
          el: createScrollbar('horizontal'),
          direction: 'horizontal',
          fade: fade,
          interactive: interactive
        };
        this._insertScrollBar(indicator.el);

        this.indicators.push(new Indicator(this, indicator));
      }

      if (this.options.scrollY) {
        indicator = {
          el: createScrollbar('vertical'),
          direction: 'vertical',
          fade: fade,
          interactive: interactive
        };
        this._insertScrollBar(indicator.el);
        this.indicators.push(new Indicator(this, indicator));
      }

      this.on('refresh', function () {
        for (var i = 0; i < _this.indicators.length; i++) {
          _this.indicators[i].refresh();
        }
      });

      if (fade) {
        this.on('scrollEnd', function () {
          for (var i = 0; i < _this.indicators.length; i++) {
            _this.indicators[i].fade();
          }
        });

        this.on('scrollCancel', function () {
          for (var i = 0; i < _this.indicators.length; i++) {
            _this.indicators[i].fade();
          }
        });

        this.on('scrollStart', function () {
          for (var i = 0; i < _this.indicators.length; i++) {
            _this.indicators[i].fade(true);
          }
        });

        this.on('beforeScrollStart', function () {
          for (var i = 0; i < _this.indicators.length; i++) {
            _this.indicators[i].fade(true, true);
          }
        });
      }

      this.on('destroy', function () {
        _this._removeScrollBars();
      });
    };

    BScroll.prototype._insertScrollBar = function (scrollbar) {
      this.wrapper.appendChild(scrollbar);
    };

    BScroll.prototype._removeScrollBars = function () {
      for (var i = 0; i < this.indicators.length; i++) {
        this.indicators[i].destroy();
      }
    };
  }

  function createScrollbar(direction) {
    var scrollbar = document.createElement('div');
    var indicator = document.createElement('div');

    scrollbar.style.cssText = 'position:absolute;z-index:9999;pointerEvents:none';
    indicator.style.cssText = 'box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px;';

    indicator.className = 'bscroll-indicator';

    if (direction === 'horizontal') {
      scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
      indicator.style.height = '100%';
      scrollbar.className = 'bscroll-horizontal-scrollbar';
    } else {
      scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
      indicator.style.width = '100%';
      scrollbar.className = 'bscroll-vertical-scrollbar';
    }

    scrollbar.style.cssText += ';overflow:hidden';
    scrollbar.appendChild(indicator);

    return scrollbar;
  }

  function Indicator(scroller, options) {
    this.wrapper = options.el;
    this.wrapperStyle = this.wrapper.style;
    this.indicator = this.wrapper.children[0];
    this.indicatorStyle = this.indicator.style;
    this.scroller = scroller;
    this.direction = options.direction;
    if (options.fade) {
      this.visible = 0;
      this.wrapperStyle.opacity = '0';
    } else {
      this.visible = 1;
    }

    this.sizeRatioX = 1;
    this.sizeRatioY = 1;
    this.maxPosX = 0;
    this.maxPosY = 0;
    this.x = 0;
    this.y = 0;

    if (options.interactive) {
      this._addDOMEvents();
    }
  }

  Indicator.prototype.handleEvent = function (e) {
    switch (e.type) {
      case 'touchstart':
      case 'mousedown':
        this._start(e);
        break;
      case 'touchmove':
      case 'mousemove':
        this._move(e);
        break;
      case 'touchend':
      case 'mouseup':
      case 'touchcancel':
      case 'mousecancel':
        this._end(e);
        break;
    }
  };

  Indicator.prototype.refresh = function () {
    if (this._shouldShow()) {
      this.transitionTime();
      this._calculate();
      this.updatePosition();
    }
  };

  Indicator.prototype.fade = function (visible, hold) {
    var _this2 = this;

    if (hold && !this.visible) {
      return;
    }

    var time = visible ? 250 : 500;

    visible = visible ? '1' : '0';

    this.wrapperStyle[style.transitionDuration] = time + 'ms';

    clearTimeout(this.fadeTimeout);
    this.fadeTimeout = setTimeout(function () {
      _this2.wrapperStyle.opacity = visible;
      _this2.visible = +visible;
    }, 0);
  };

  Indicator.prototype.updatePosition = function () {
    if (this.direction === 'vertical') {
      var y = Math.round(this.sizeRatioY * this.scroller.y);

      if (y < 0) {
        this.transitionTime(500);
        var height = Math.max(this.indicatorHeight + y * 3, INDICATOR_MIN_LEN);
        this.indicatorStyle.height = height + 'px';
        y = 0;
      } else if (y > this.maxPosY) {
        this.transitionTime(500);
        var _height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, INDICATOR_MIN_LEN);
        this.indicatorStyle.height = _height + 'px';
        y = this.maxPosY + this.indicatorHeight - _height;
      } else {
        this.indicatorStyle.height = this.indicatorHeight + 'px';
      }
      this.y = y;

      if (this.scroller.options.useTransform) {
        this.indicatorStyle[style.transform] = 'translateY(' + y + 'px)' + this.scroller.translateZ;
      } else {
        this.indicatorStyle.top = y + 'px';
      }
    } else {
      var x = Math.round(this.sizeRatioX * this.scroller.x);

      if (x < 0) {
        this.transitionTime(500);
        var width = Math.max(this.indicatorWidth + x * 3, INDICATOR_MIN_LEN);
        this.indicatorStyle.width = width + 'px';
        x = 0;
      } else if (x > this.maxPosX) {
        this.transitionTime(500);
        var _width = Math.max(this.indicatorWidth - (x - this.maxPosX) * 3, INDICATOR_MIN_LEN);
        this.indicatorStyle.width = _width + 'px';
        x = this.maxPosX + this.indicatorWidth - _width;
      } else {
        this.indicatorStyle.width = this.indicatorWidth + 'px';
      }

      this.x = x;

      if (this.scroller.options.useTransform) {
        this.indicatorStyle[style.transform] = 'translateX(' + x + 'px)' + this.scroller.translateZ;
      } else {
        this.indicatorStyle.left = x + 'px';
      }
    }
  };

  Indicator.prototype.transitionTime = function () {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    this.indicatorStyle[style.transitionDuration] = time + 'ms';
  };

  Indicator.prototype.transitionTimingFunction = function (easing) {
    this.indicatorStyle[style.transitionTimingFunction] = easing;
  };

  Indicator.prototype.destroy = function () {
    this._removeDOMEvents();
    this.wrapper.parentNode.removeChild(this.wrapper);
  };

  Indicator.prototype._start = function (e) {
    var point = e.touches ? e.touches[0] : e;

    e.preventDefault();
    e.stopPropagation();

    this.transitionTime();

    this.initiated = true;
    this.moved = false;
    this.lastPointX = point.pageX;
    this.lastPointY = point.pageY;

    this.startTime = getNow();

    this._handleMoveEvents(addEvent);
    this.scroller.trigger('beforeScrollStart');
  };

  Indicator.prototype._move = function (e) {
    var point = e.touches ? e.touches[0] : e;

    e.preventDefault();
    e.stopPropagation();

    if (!this.moved) {
      this.scroller.trigger('scrollStart');
    }

    this.moved = true;

    var deltaX = point.pageX - this.lastPointX;
    this.lastPointX = point.pageX;

    var deltaY = point.pageY - this.lastPointY;
    this.lastPointY = point.pageY;

    var newX = this.x + deltaX;
    var newY = this.y + deltaY;

    this._pos(newX, newY);
  };

  Indicator.prototype._end = function (e) {
    if (!this.initiated) {
      return;
    }
    this.initiated = false;

    e.preventDefault();
    e.stopPropagation();

    this._handleMoveEvents(removeEvent);

    var snapOption = this.scroller.options.snap;
    if (snapOption) {
      var speed = snapOption.speed,
          _snapOption$easing = snapOption.easing,
          easing = _snapOption$easing === undefined ? ease.bounce : _snapOption$easing;

      var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

      var time = speed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

      if (this.scroller.x !== snap.x || this.scroller.y !== snap.y) {
        this.scroller.directionX = 0;
        this.scroller.directionY = 0;
        this.scroller.currentPage = snap;
        this.scroller.scrollTo(snap.x, snap.y, time, easing);
      }
    }

    if (this.moved) {
      this.scroller.trigger('scrollEnd', {
        x: this.scroller.x,
        y: this.scroller.y
      });
    }
  };

  Indicator.prototype._pos = function (x, y) {
    if (x < 0) {
      x = 0;
    } else if (x > this.maxPosX) {
      x = this.maxPosX;
    }

    if (y < 0) {
      y = 0;
    } else if (y > this.maxPosY) {
      y = this.maxPosY;
    }

    x = Math.round(x / this.sizeRatioX);
    y = Math.round(y / this.sizeRatioY);

    this.scroller.scrollTo(x, y);
    this.scroller.trigger('scroll', {
      x: this.scroller.x,
      y: this.scroller.y
    });
  };

  Indicator.prototype._shouldShow = function () {
    if (this.direction === 'vertical' && this.scroller.hasVerticalScroll || this.direction === 'horizontal' && this.scroller.hasHorizontalScroll) {
      this.wrapper.style.display = '';
      return true;
    }
    this.wrapper.style.display = 'none';
    return false;
  };

  Indicator.prototype._calculate = function () {
    if (this.direction === 'vertical') {
      var wrapperHeight = this.wrapper.clientHeight;
      this.indicatorHeight = Math.max(Math.round(wrapperHeight * wrapperHeight / (this.scroller.scrollerHeight || wrapperHeight || 1)), INDICATOR_MIN_LEN);
      this.indicatorStyle.height = this.indicatorHeight + 'px';

      this.maxPosY = wrapperHeight - this.indicatorHeight;

      this.sizeRatioY = this.maxPosY / this.scroller.maxScrollY;
    } else {
      var wrapperWidth = this.wrapper.clientWidth;
      this.indicatorWidth = Math.max(Math.round(wrapperWidth * wrapperWidth / (this.scroller.scrollerWidth || wrapperWidth || 1)), INDICATOR_MIN_LEN);
      this.indicatorStyle.width = this.indicatorWidth + 'px';

      this.maxPosX = wrapperWidth - this.indicatorWidth;

      this.sizeRatioX = this.maxPosX / this.scroller.maxScrollX;
    }
  };

  Indicator.prototype._addDOMEvents = function () {
    var eventOperation = addEvent;
    this._handleDOMEvents(eventOperation);
  };

  Indicator.prototype._removeDOMEvents = function () {
    var eventOperation = removeEvent;
    this._handleDOMEvents(eventOperation);
    this._handleMoveEvents(eventOperation);
  };

  Indicator.prototype._handleMoveEvents = function (eventOperation) {
    if (!this.scroller.options.disableTouch) {
      eventOperation(window, 'touchmove', this);
    }
    if (!this.scroller.options.disableMouse) {
      eventOperation(window, 'mousemove', this);
    }
  };

  Indicator.prototype._handleDOMEvents = function (eventOperation) {
    if (!this.scroller.options.disableTouch) {
      eventOperation(this.indicator, 'touchstart', this);
      eventOperation(window, 'touchend', this);
    }
    if (!this.scroller.options.disableMouse) {
      eventOperation(this.indicator, 'mousedown', this);
      eventOperation(window, 'mouseup', this);
    }
  };

  function pullDownMixin(BScroll) {
    BScroll.prototype._initPullDown = function () {
      // must watch scroll in real time
      this.options.probeType = PROBE_REALTIME;
    };

    BScroll.prototype._checkPullDown = function () {
      var _options$pullDownRefr = this.options.pullDownRefresh,
          _options$pullDownRefr2 = _options$pullDownRefr.threshold,
          threshold = _options$pullDownRefr2 === undefined ? 90 : _options$pullDownRefr2,
          _options$pullDownRefr3 = _options$pullDownRefr.stop,
          stop = _options$pullDownRefr3 === undefined ? 40 : _options$pullDownRefr3;

      // check if a real pull down action

      if (this.directionY !== DIRECTION_DOWN || this.y < threshold) {
        return false;
      }

      if (!this.pulling) {
        this.pulling = true;
        this.trigger('pullingDown');
      }
      this.scrollTo(this.x, stop, this.options.bounceTime, ease.bounce);

      return this.pulling;
    };

    BScroll.prototype.finishPullDown = function () {
      this.pulling = false;
      this.resetPosition(this.options.bounceTime, ease.bounce);
    };

    BScroll.prototype.openPullDown = function () {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.options.pullDownRefresh = config;
      this._initPullDown();
    };

    BScroll.prototype.closePullDown = function () {
      this.options.pullDownRefresh = false;
    };
  }

  function pullUpMixin(BScroll) {
    BScroll.prototype._initPullUp = function () {
      // must watch scroll in real time
      this.options.probeType = PROBE_REALTIME;

      this.pullupWatching = false;
      this._watchPullUp();
    };

    BScroll.prototype._watchPullUp = function () {
      if (this.pullupWatching) {
        return;
      }
      this.pullupWatching = true;
      this.on('scroll', this._checkToEnd);
    };

    BScroll.prototype._checkToEnd = function (pos) {
      var _this = this;

      var _options$pullUpLoad$t = this.options.pullUpLoad.threshold,
          threshold = _options$pullUpLoad$t === undefined ? 0 : _options$pullUpLoad$t;

      if (this.movingDirectionY === DIRECTION_UP && pos.y <= this.maxScrollY + threshold) {
        // reset pullupWatching status after scroll end.
        this.once('scrollEnd', function () {
          _this.pullupWatching = false;
        });
        this.trigger('pullingUp');
        this.off('scroll', this._checkToEnd);
      }
    };

    BScroll.prototype.finishPullUp = function () {
      var _this2 = this;

      if (this.pullupWatching) {
        this.once('scrollEnd', function () {
          _this2._watchPullUp();
        });
      } else {
        this._watchPullUp();
      }
    };

    BScroll.prototype.openPullUp = function () {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.options.pullUpLoad = config;
      this._initPullUp();
    };

    BScroll.prototype.closePullUp = function () {
      this.options.pullUpLoad = false;
      if (!this.pullupWatching) {
        return;
      }
      this.pullupWatching = false;
      this.off('scroll', this._checkToEnd);
    };
  }

  function mouseWheelMixin(BScroll) {
    BScroll.prototype._initMouseWheel = function () {
      var _this = this;

      this._handleMouseWheelEvent(addEvent);

      this.on('destroy', function () {
        clearTimeout(_this.mouseWheelTimer);
        clearTimeout(_this.mouseWheelEndTimer);
        _this._handleMouseWheelEvent(removeEvent);
      });

      this.firstWheelOpreation = true;
    };

    BScroll.prototype._handleMouseWheelEvent = function (eventOperation) {
      eventOperation(this.wrapper, 'wheel', this);
      eventOperation(this.wrapper, 'mousewheel', this);
      eventOperation(this.wrapper, 'DOMMouseScroll', this);
    };

    BScroll.prototype._onMouseWheel = function (e) {
      var _this2 = this;

      if (!this.enabled) {
        return;
      }
      e.preventDefault();

      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      if (this.firstWheelOpreation) {
        this.trigger('scrollStart');
      }
      this.firstWheelOpreation = false;

      var _options$mouseWheel = this.options.mouseWheel,
          _options$mouseWheel$s = _options$mouseWheel.speed,
          speed = _options$mouseWheel$s === undefined ? 20 : _options$mouseWheel$s,
          _options$mouseWheel$i = _options$mouseWheel.invert,
          invert = _options$mouseWheel$i === undefined ? false : _options$mouseWheel$i,
          _options$mouseWheel$e = _options$mouseWheel.easeTime,
          easeTime = _options$mouseWheel$e === undefined ? 300 : _options$mouseWheel$e;

      clearTimeout(this.mouseWheelTimer);
      this.mouseWheelTimer = setTimeout(function () {
        if (!_this2.options.snap && !easeTime) {
          _this2.trigger('scrollEnd', {
            x: _this2.x,
            y: _this2.y
          });
        }
        _this2.firstWheelOpreation = true;
      }, 400);

      var wheelDeltaX = void 0;
      var wheelDeltaY = void 0;

      switch (true) {
        case 'deltaX' in e:
          if (e.deltaMode === 1) {
            wheelDeltaX = -e.deltaX * speed;
            wheelDeltaY = -e.deltaY * speed;
          } else {
            wheelDeltaX = -e.deltaX;
            wheelDeltaY = -e.deltaY;
          }
          break;
        case 'wheelDeltaX' in e:
          wheelDeltaX = e.wheelDeltaX / 120 * speed;
          wheelDeltaY = e.wheelDeltaY / 120 * speed;
          break;
        case 'wheelDelta' in e:
          wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * speed;
          break;
        case 'detail' in e:
          wheelDeltaX = wheelDeltaY = -e.detail / 3 * speed;
          break;
        default:
          return;
      }

      var direction = invert ? -1 : 1;
      wheelDeltaX *= direction;
      wheelDeltaY *= direction;

      if (!this.hasVerticalScroll) {
        wheelDeltaX = wheelDeltaY;
        wheelDeltaY = 0;
      }

      var newX = void 0;
      var newY = void 0;
      if (this.options.snap) {
        newX = this.currentPage.pageX;
        newY = this.currentPage.pageY;

        if (wheelDeltaX > 0) {
          newX--;
        } else if (wheelDeltaX < 0) {
          newX++;
        }

        if (wheelDeltaY > 0) {
          newY--;
        } else if (wheelDeltaY < 0) {
          newY++;
        }

        this._goToPage(newX, newY);
        return;
      }

      newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
      newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

      this.movingDirectionX = this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
      this.movingDirectionY = this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

      if (newX > this.minScrollX) {
        newX = this.minScrollX;
      } else if (newX < this.maxScrollX) {
        newX = this.maxScrollX;
      }

      if (newY > this.minScrollY) {
        newY = this.minScrollY;
      } else if (newY < this.maxScrollY) {
        newY = this.maxScrollY;
      }

      var needTriggerEnd = this.y === newY;
      this.scrollTo(newX, newY, easeTime, ease.swipe);
      this.trigger('scroll', {
        x: this.x,
        y: this.y
      });
      clearTimeout(this.mouseWheelEndTimer);
      if (needTriggerEnd) {
        this.mouseWheelEndTimer = setTimeout(function () {
          _this2.trigger('scrollEnd', {
            x: _this2.x,
            y: _this2.y
          });
        }, easeTime);
      }
    };
  }

  function zoomMixin(BScroll) {
    BScroll.prototype._initZoom = function () {
      var _options$zoom = this.options.zoom,
          _options$zoom$start = _options$zoom.start,
          start = _options$zoom$start === undefined ? 1 : _options$zoom$start,
          _options$zoom$min = _options$zoom.min,
          min = _options$zoom$min === undefined ? 1 : _options$zoom$min,
          _options$zoom$max = _options$zoom.max,
          max = _options$zoom$max === undefined ? 4 : _options$zoom$max;

      this.scale = Math.min(Math.max(start, min), max);
      this.setScale(this.scale);
      this.scrollerStyle[style.transformOrigin] = '0 0';
    };

    BScroll.prototype._zoomTo = function (scale, originX, originY, startScale) {
      this.scaled = true;

      var lastScale = scale / (startScale || this.scale);
      this.setScale(scale);

      this.refresh();

      var newX = Math.round(this.startX - (originX - this.relativeX) * (lastScale - 1));
      var newY = Math.round(this.startY - (originY - this.relativeY) * (lastScale - 1));

      if (newX > this.minScrollX) {
        newX = this.minScrollX;
      } else if (newX < this.maxScrollX) {
        newX = this.maxScrollX;
      }

      if (newY > this.minScrollY) {
        newY = this.minScrollY;
      } else if (newY < this.maxScrollY) {
        newY = this.maxScrollY;
      }

      if (this.x !== newX || this.y !== newY) {
        this.scrollTo(newX, newY, this.options.bounceTime);
      }

      this.scaled = false;
    };

    BScroll.prototype.zoomTo = function (scale, x, y) {
      var _offsetToBody = offsetToBody(this.wrapper),
          left = _offsetToBody.left,
          top = _offsetToBody.top;

      var originX = x + left - this.x;
      var originY = y + top - this.y;
      this._zoomTo(scale, originX, originY);
    };

    BScroll.prototype._zoomStart = function (e) {
      var firstFinger = e.touches[0];
      var secondFinger = e.touches[1];
      var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
      var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);

      this.startDistance = getDistance(deltaX, deltaY);
      this.startScale = this.scale;

      var _offsetToBody2 = offsetToBody(this.wrapper),
          left = _offsetToBody2.left,
          top = _offsetToBody2.top;

      this.originX = Math.abs(firstFinger.pageX + secondFinger.pageX) / 2 + left - this.x;
      this.originY = Math.abs(firstFinger.pageY + secondFinger.pageY) / 2 + top - this.y;

      this.trigger('zoomStart');
    };

    BScroll.prototype._zoom = function (e) {
      if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
        return;
      }

      if (this.options.preventDefault) {
        e.preventDefault();
      }

      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      var firstFinger = e.touches[0];
      var secondFinger = e.touches[1];
      var deltaX = Math.abs(firstFinger.pageX - secondFinger.pageX);
      var deltaY = Math.abs(firstFinger.pageY - secondFinger.pageY);
      var distance = getDistance(deltaX, deltaY);
      var scale = distance / this.startDistance * this.startScale;

      this.scaled = true;

      var _options$zoom2 = this.options.zoom,
          _options$zoom2$min = _options$zoom2.min,
          min = _options$zoom2$min === undefined ? 1 : _options$zoom2$min,
          _options$zoom2$max = _options$zoom2.max,
          max = _options$zoom2$max === undefined ? 4 : _options$zoom2$max;

      if (scale < min) {
        scale = 0.5 * min * Math.pow(2.0, scale / min);
      } else if (scale > max) {
        scale = 2.0 * max * Math.pow(0.5, max / scale);
      }

      var lastScale = scale / this.startScale;

      var x = this.startX - (this.originX - this.relativeX) * (lastScale - 1);
      var y = this.startY - (this.originY - this.relativeY) * (lastScale - 1);

      this.setScale(scale);

      this.scrollTo(x, y, 0);
    };

    BScroll.prototype._zoomEnd = function (e) {
      if (!this.enabled || this.destroyed || eventType[e.type] !== this.initiated) {
        return;
      }

      if (this.options.preventDefault) {
        e.preventDefault();
      }

      if (this.options.stopPropagation) {
        e.stopPropagation();
      }

      this.isInTransition = false;
      this.isAnimating = false;
      this.initiated = 0;

      var _options$zoom3 = this.options.zoom,
          _options$zoom3$min = _options$zoom3.min,
          min = _options$zoom3$min === undefined ? 1 : _options$zoom3$min,
          _options$zoom3$max = _options$zoom3.max,
          max = _options$zoom3$max === undefined ? 4 : _options$zoom3$max;

      var scale = this.scale > max ? max : this.scale < min ? min : this.scale;

      this._zoomTo(scale, this.originX, this.originY, this.startScale);

      this.trigger('zoomEnd');
    };
  }

  // import { ease } from '../util/ease'

  // Number of items to instantiate beyond current view in the scroll direction.
  var RUNWAY_ITEMS = 30;

  // Number of items to instantiate beyond current view in the opposite direction.
  var RUNWAY_ITEMS_OPPOSITE = 10;

  // The animation interval (in ms) for fading in content from tombstones.
  var ANIMATION_DURATION_MS = 200;

  // The number of pixels of default additional length to allow scrolling to.
  var DEFAULT_SCROLL_RUNWAY = 2000;

  function infiniteMixin(BScroll) {
    BScroll.prototype._initInfinite = function () {
      this.options.probeType = 3;
      this.maxScrollY = -DEFAULT_SCROLL_RUNWAY;
      this.infiniteScroller = new InfiniteScroller(this, this.options.infinity);
    };
  }

  function isTombstoneNode(node) {
    if (node && node.classList) {
      return node.classList.contains('tombstone');
    }
  }

  function InfiniteScroller(scroller, options) {
    var _this = this;

    this.options = options;
    assert(typeof this.options.createTombstone === 'function', 'Infinite scroll need createTombstone Function to create tombstone');

    assert(typeof this.options.fetch === 'function', 'Infinite scroll need fetch Function to fetch new data.');

    assert(typeof this.options.render === 'function', 'Infinite scroll need render Function to render each item.');

    this.firstAttachedItem = 0;
    this.lastAttachedItem = 0;

    this.anchorScrollTop = 0;
    this.anchorItem = {
      index: 0,
      offset: 0
    };
    this.tombstoneHeight = 0;
    this.tombstoneWidth = 0;
    this.tombstones = [];
    this.tombstonesAnimationHandlers = [];

    this.items = [];
    this.loadedItems = 0;
    this.requestInProgress = false;
    this.hasMore = true;

    this.scroller = scroller;
    this.wrapperEl = this.scroller.wrapper;
    this.scrollerEl = this.scroller.scroller;
    this.scroller.on('scroll', function () {
      _this.onScroll();
    });
    this.scroller.on('resize', function () {
      _this.onResize();
    });
    this.scroller.on('destroy', function () {
      _this.destroy();
    });

    // wait scroll core init
    this._onResizeHandler = setTimeout(function () {
      _this.onResize();
    });
  }

  InfiniteScroller.prototype.destroy = function () {
    var _this2 = this;

    // In extreme scene, destroy is triggered before _onResizeHandler
    clearTimeout(this._onResizeHandler);
    this.tombstonesAnimationHandlers.forEach(function (handler) {
      clearTimeout(handler);
    });
    this.tombstonesAnimationHandlers = null;
    this.items.forEach(function (item) {
      if (item.node) {
        _this2.scrollerEl.removeChild(item.node);
        item.node = null;
      }
    });
    this.scroller.infiniteScroller = null;
    this.scroller = null;
    this.wrapperEl = null;
    this.scrollerEl = null;
    this.items = null;
    this.tombstones = null;
  };

  InfiniteScroller.prototype.onScroll = function () {
    var scrollTop = -this.scroller.y;
    var delta = scrollTop - this.anchorScrollTop;
    if (scrollTop === 0) {
      this.anchorItem = {
        index: 0,
        offset: 0
      };
    } else {
      this.anchorItem = this._calculateAnchoredItem(this.anchorItem, delta);
    }

    this.anchorScrollTop = scrollTop;
    var lastScreenItem = this._calculateAnchoredItem(this.anchorItem, this.scroller.wrapperHeight);

    var start = this.anchorItem.index;
    var end = lastScreenItem.index;
    if (delta < 0) {
      start -= RUNWAY_ITEMS;
      end += RUNWAY_ITEMS_OPPOSITE;
    } else {
      start -= RUNWAY_ITEMS_OPPOSITE;
      end += RUNWAY_ITEMS;
    }
    this.fill(start, end);
    this.maybeRequestContent();
  };

  InfiniteScroller.prototype.onResize = function () {
    var tombstone = this.options.createTombstone();
    tombstone.style.position = 'absolute';
    this.scrollerEl.appendChild(tombstone);
    tombstone.style.display = '';
    this.tombstoneHeight = tombstone.offsetHeight;
    this.tombstoneWidth = tombstone.offsetWidth;
    this.scrollerEl.removeChild(tombstone);

    for (var i = 0; i < this.items.length; i++) {
      this.items[i].height = this.items[i].width = 0;
    }

    this.onScroll();
  };

  InfiniteScroller.prototype.fill = function (start, end) {
    this.firstAttachedItem = Math.max(0, start);
    if (!this.hasMore) {
      end = Math.min(end, this.items.length);
    }
    this.lastAttachedItem = end;
    this.attachContent();
  };

  InfiniteScroller.prototype.maybeRequestContent = function () {
    var _this3 = this;

    if (this.requestInProgress || !this.hasMore) {
      return;
    }
    var itemsNeeded = this.lastAttachedItem - this.loadedItems;
    if (itemsNeeded <= 0) {
      return;
    }
    this.requestInProgress = true;
    this.options.fetch(itemsNeeded).then(function (items) {
      _this3.requestInProgress = false;
      if (items) {
        _this3.addContent(items);
      } else {
        _this3.hasMore = false;
        var tombstoneLen = _this3._removeTombstones();
        var curPos = 0;
        if (_this3.anchorItem.index <= _this3.items.length) {
          curPos = _this3._fixScrollPosition();
          _this3._setupAnimations({}, curPos);
          _this3.scroller.resetPosition(_this3.scroller.options.bounceTime);
        } else {
          _this3.anchorItem.index -= tombstoneLen;
          curPos = _this3._fixScrollPosition();
          _this3._setupAnimations({}, curPos);
          _this3.scroller.stop();
          _this3.scroller.resetPosition();
          _this3.onScroll();
        }
      }
    });
  };

  InfiniteScroller.prototype.addContent = function (items) {
    for (var i = 0; i < items.length; i++) {
      if (this.items.length <= this.loadedItems) {
        this._addItem();
      }
      this.items[this.loadedItems++].data = items[i];
    }
    this.attachContent();
    this.maybeRequestContent();
  };

  InfiniteScroller.prototype.attachContent = function () {
    var unusedNodes = this._collectUnusedNodes();
    var tombstoneAnimations = this._createDOMNodes(unusedNodes);
    this._cleanupUnusedNodes(unusedNodes);
    this._cacheNodeSize();
    var curPos = this._fixScrollPosition();
    this._setupAnimations(tombstoneAnimations, curPos);
  };

  InfiniteScroller.prototype.resetMore = function () {
    this.hasMore = true;
  };

  InfiniteScroller.prototype._removeTombstones = function () {
    var markIndex = void 0;
    var tombstoneLen = 0;
    var itemLen = this.items.length;
    for (var i = 0; i < itemLen; i++) {
      var currentNode = this.items[i].node;
      var currentData = this.items[i].data;
      if ((!currentNode || isTombstoneNode(currentNode)) && !currentData) {
        // 0 should be excluded
        if (markIndex === void 0) {
          markIndex = i;
        }
        if (currentNode) {
          this.scrollerEl.removeChild(currentNode);
        }
      }
    }
    tombstoneLen = itemLen - markIndex;
    this.items.splice(markIndex);
    this.lastAttachedItem = Math.min(this.lastAttachedItem, this.items.length);
    return tombstoneLen;
  };

  InfiniteScroller.prototype._collectUnusedNodes = function () {
    var unusedNodes = [];
    for (var i = 0; i < this.items.length; i++) {
      // Skip the items which should be visible.
      if (i === this.firstAttachedItem) {
        i = this.lastAttachedItem - 1;
        continue;
      }
      var currentNode = this.items[i].node;
      if (currentNode) {
        if (isTombstoneNode(currentNode)) {
          // Cache tombstones for reuse
          this.tombstones.push(currentNode);
          this.tombstones[this.tombstones.length - 1].style.display = 'none';
        } else {
          unusedNodes.push(currentNode);
        }
      }
      this.items[i].node = null;
    }
    return unusedNodes;
  };

  InfiniteScroller.prototype._createDOMNodes = function (unusedNodes) {
    var tombstoneAnimations = {};
    for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
      while (this.items.length <= i) {
        this._addItem();
      }
      var currentNode = this.items[i].node;
      var currentData = this.items[i].data;
      if (currentNode) {
        if (isTombstoneNode(currentNode) && currentData) {
          currentNode.style.zIndex = 1;
          tombstoneAnimations[i] = [currentNode, this.items[i].top - this.anchorScrollTop];
          this.items[i].node = null;
        } else {
          continue;
        }
      }
      var node = currentData ? this.options.render(currentData, unusedNodes.pop()) : this._getTombStone();
      node.style.position = 'absolute';
      this.items[i].top = -1;
      this.scrollerEl.appendChild(node);
      this.items[i].node = node;
    }
    return tombstoneAnimations;
  };

  InfiniteScroller.prototype._cleanupUnusedNodes = function (unusedNodes) {
    while (unusedNodes.length) {
      this.scrollerEl.removeChild(unusedNodes.pop());
    }
  };

  InfiniteScroller.prototype._cacheNodeSize = function () {
    for (var i = this.firstAttachedItem; i < this.lastAttachedItem; i++) {
      var item = this.items[i];
      // Only cache the height if we have the real contents, not a placeholder.
      if (item.data && !item.height) {
        var isTombstone = isTombstoneNode(item.node);
        item.height = isTombstone ? this.tombstoneHeight : item.node.offsetHeight;
        item.width = isTombstone ? this.tombstoneWidth : item.node.offsetWidth;
      }
    }
  };

  InfiniteScroller.prototype._fixScrollPosition = function () {
    this.anchorScrollTop = 0;
    for (var _i = 0; _i < this.anchorItem.index; _i++) {
      this.anchorScrollTop += this.items[_i].height || this.tombstoneHeight;
    }
    this.anchorScrollTop += this.anchorItem.offset;

    // Position all nodes.
    var curPos = this.anchorScrollTop - this.anchorItem.offset;
    var i = this.anchorItem.index;
    while (i > this.firstAttachedItem) {
      curPos -= this.items[i - 1].height || this.tombstoneHeight;
      i--;
    }

    return curPos;
  };

  InfiniteScroller.prototype._setupAnimations = function (tombstoneAnimations, curPos) {
    var _this4 = this;

    for (var i in tombstoneAnimations) {
      var animation = tombstoneAnimations[i];
      this.items[i].node.style[style.transform] = 'translateY(' + (this.anchorScrollTop + animation[1]) + 'px) scale(' + this.tombstoneWidth / this.items[i].width + ', ' + this.tombstoneHeight / this.items[i].height + ')';
      // Call offsetTop on the nodes to be animated to force them to apply current transforms.
      /* eslint-disable no-unused-expressions */
      this.items[i].node.offsetTop;
      animation[0].offsetTop;
      this.items[i].node.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms';
    }

    for (var _i2 = this.firstAttachedItem; _i2 < this.lastAttachedItem; _i2++) {
      var _animation = tombstoneAnimations[_i2];
      if (_animation) {
        var tombstoneNode = _animation[0];
        tombstoneNode.style[style.transition] = cssVendor + 'transform ' + ANIMATION_DURATION_MS + 'ms, opacity ' + ANIMATION_DURATION_MS + 'ms';
        tombstoneNode.style[style.transform] = 'translateY(' + curPos + 'px) scale(' + this.items[_i2].width / this.tombstoneWidth + ', ' + this.items[_i2].height / this.tombstoneHeight + ')';
        tombstoneNode.style.opacity = 0;
      }
      if (curPos !== this.items[_i2].top) {
        if (!_animation) {
          this.items[_i2].node.style[style.transition] = '';
        }
        this.items[_i2].node.style[style.transform] = 'translateY(' + curPos + 'px)';
      }
      this.items[_i2].top = curPos;
      curPos += this.items[_i2].height || this.tombstoneHeight;
    }

    this.scroller.maxScrollY = -(curPos - this.scroller.wrapperHeight + (this.hasMore ? DEFAULT_SCROLL_RUNWAY : 0));

    var tombstoneAnimationsHandler = setTimeout(function () {
      for (var _i3 in tombstoneAnimations) {
        var _animation2 = tombstoneAnimations[_i3];
        _animation2[0].style.display = 'none';
        // Tombstone can be recycled now.
        _this4.tombstones.push(_animation2[0]);
      }
    }, ANIMATION_DURATION_MS);

    this.tombstonesAnimationHandlers.push(tombstoneAnimationsHandler);
  };

  InfiniteScroller.prototype._getTombStone = function () {
    var tombstone = this.tombstones.pop();
    if (tombstone) {
      tombstone.style.display = '';
      tombstone.style.opacity = 1;
      tombstone.style[style.transform] = '';
      tombstone.style[style.transition] = '';
      return tombstone;
    }
    return this.options.createTombstone();
  };

  InfiniteScroller.prototype._addItem = function () {
    this.items.push({
      data: null,
      node: null,
      height: 0,
      width: 0,
      top: 0
    });
  };

  InfiniteScroller.prototype._calculateAnchoredItem = function (initialAnchor, delta) {
    if (delta === 0) {
      return initialAnchor;
    }
    var i = initialAnchor.index;
    var tombstones = 0;

    delta += initialAnchor.offset;
    if (delta < 0) {
      while (delta < 0 && i > 0 && this.items[i - 1].height) {
        delta += this.items[i - 1].height;
        i--;
      }
      tombstones = Math.max(-i, Math.ceil(Math.min(delta, 0) / this.tombstoneHeight));
    } else {
      while (delta > 0 && i < this.items.length && this.items[i].height && this.items[i].height < delta) {
        delta -= this.items[i].height;
        i++;
      }
      if (i >= this.items.length || !this.items[i].height) {
        tombstones = Math.floor(Math.max(delta, 0) / this.tombstoneHeight);
      }
    }
    i += tombstones;
    delta -= tombstones * this.tombstoneHeight;

    return {
      index: i,
      offset: delta
    };
  };

  function BScroll(el, options) {
    this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
    if (!this.wrapper) {
      warn('Can not resolve the wrapper DOM.');
    }
    this.scroller = this.wrapper.children[0];
    if (!this.scroller) {
      warn('The wrapper need at least one child element to be scroller.');
    }
    // cache style for better performance
    this.scrollerStyle = this.scroller.style;

    this._init(el, options);
  }

  initMixin(BScroll);
  coreMixin(BScroll);
  eventMixin(BScroll);
  snapMixin(BScroll);
  wheelMixin(BScroll);
  scrollbarMixin(BScroll);
  pullDownMixin(BScroll);
  pullUpMixin(BScroll);
  mouseWheelMixin(BScroll);
  zoomMixin(BScroll);
  infiniteMixin(BScroll);

  BScroll.Version = '1.13.2';

  return BScroll;
});

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _util = __webpack_require__(68);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
//
//
//
//
//
//

exports.default = {
  name: 'beast-image',
  props: {
    src: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    },
    containerWidth: {
      type: Number,
      default: 0
    },
    clipData: [String, Object],
    lazy: {
      type: Boolean,
      default: false
    },
    defaultImage: {
      type: String,
      default: ''
    },
    timeout: {
      type: Number,
      default: 100
    },
    load: {
      type: Boolean,
      default: true
    },
    suffix: {
      type: String,
      default: ""
    },
    fixWidth: {
      type: Number,
      default: 0
    },
    radius: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      imageLoad: false,
      imageData: {},
      imageSrc: null,
      imageWidth: "",
      imageHeight: "",
      lazyImage: null
    };
  },

  computed: {
    // imgSrc () {
    //   return ensure_protocol(this.src)
    // }
  },
  watch: {
    src: function src() {
      var _this = this;

      this.$nextTick(function () {
        // console.log(this.src, "watch src")
        _this.transform();
      });
    },
    image: function image() {
      var _this2 = this;

      this.$nextTick(function () {
        // console.log(this.image, "watch image")
        _this2.transform();
      });
    }
  },
  created: function created() {
    this.transform();
  },

  methods: {
    transform: function transform() {
      if (!this.src && !this.image) {
        return;
      }
      var formatData = util.transform({
        data: this.src || this.image,
        containerWidth: this.containerWidth,
        clipData: this.clipData,
        suffix: this.suffix,
        fixWidth: this.fixWidth
      });
      formatData.src = (0, _urlUtil.ensure_protocol)(formatData.src);
      // console.log(formatData)
      if (this.lazy) {
        this.imageData = formatData;
        this.imageSrc = this.imageData.src;
        this.imageWidth = this.imageData.width;
        this.imageHeight = this.imageData.height;
        // console.log(this.defaultImage, "defaultImage")
        if (this.defaultImage) {
          this.lazyImage = (0, _urlUtil.ensure_protocol)(this.defaultImage);
        }
      } else {
        var dataFlag = true;
        this.getImage(formatData, dataFlag);
      }
    },
    getImage: function getImage(formatImage, dataFlag) {
      var _this3 = this;

      // console.log("getImage")
      // console.log(formatImage)
      if (!this.load) {
        this.imageData = formatImage;
        this.setImage();
        this.imageLoad = true;
        return;
      }
      var tm = setTimeout(function () {
        // console.log("timeout")
        if (dataFlag) {
          _this3.imageData = formatImage;
          _this3.setImage();
          // this.imageSrc = this.imageData.src
          // this.imageWidth = this.imageData.width
          // this.imageHeight = this.imageData.height
        }
        _this3.imageLoad = true;
      }, this.timeout);
      this.loadImage(formatImage.src, function (err, imgObj) {
        if (_this3.imageLoad) {
          return;
        } else {
          clearTimeout(tm);
        }
        var src = formatImage.src;
        if (err || !imgObj) {
          return;
          // src = imgObj.src
        }
        if (dataFlag) {
          _this3.imageData = {
            src: imgObj.src,
            width: formatImage.width,
            height: formatImage.height
          };
          _this3.setImage();
          // this.imageSrc = this.imageData.src
          // this.imageWidth = this.imageData.width
          // this.imageHeight = this.imageData.height
        }
        _this3.imageLoad = true;
      });
    },
    setImage: function setImage() {
      this.imageSrc = this.imageData.src;
      this.imageWidth = this.imageData.width;
      this.imageHeight = this.imageData.height;
    },
    loadImage: function loadImage(src, callback) {
      // console.log("loadImage")
      var image = new Image();
      var doned = void 0;

      function done(err) {
        if (doned) {
          return;
        }
        doned = true;
        image.onload = image.onerror = image.onabort = null;

        if (err) {
          return callback(err);
        }

        var height = image.height,
            width = image.width,
            src = image.src;

        callback(null, {
          height: height,
          width: width,
          src: src
        });
      }

      image.onload = function () {
        done();
      };

      image.onabort = function () {
        done('abort');
      };

      image.onerror = function () {
        done('error');
      };

      image.src = src;
    }
  }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = transform;
exports.formatZoom = formatZoom;
exports.formatStuff = formatStuff;

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLIP_MAP = {
  'product': {
    'width': 690,
    'height': 721
  },
  'simple-product': {
    'width': 330,
    'height': 345
  },
  'pack': {
    'width': 170,
    'height': 178
  },
  'addible-pack': {
    'width': 100,
    'height': 104
  },
  'package': {
    'width': 130,
    'height': 136
  }
};

var defaultImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII=';

var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

function transform(_ref) {
  var data = _ref.data,
      containerWidth = _ref.containerWidth,
      clipData = _ref.clipData,
      suffix = _ref.suffix,
      fixWidth = _ref.fixWidth;

  if (!data) {
    return {};
  }
  if (typeof data === 'string') {
    return {
      src: formatStuff({
        data: data,
        suffix: suffix,
        fixWidth: fixWidth
      }),
      width: "",
      height: ""
    };
  }

  var formatData = formatData = formatZoom(data.width, data.height, containerWidth);
  var url = formatStuff({
    data: data,
    formatData: formatData,
    clipData: clipData,
    suffix: suffix,
    fixWidth: fixWidth
  });
  formatData.src = url;
  return formatData;
}

function formatZoom(width, height, containerWidth) {
  if (!width || !height) {
    return {};
  }

  var zoomWidth = containerWidth ? containerWidth : clientWidth;
  var zoomHeight = parseFloat(zoomWidth / width * height);

  return {
    width: zoomWidth,
    height: zoomHeight
  };
}

function formatStuff(_ref2) {
  var data = _ref2.data,
      formatData = _ref2.formatData,
      clipData = _ref2.clipData,
      suffix = _ref2.suffix,
      fixWidth = _ref2.fixWidth;

  if (!data) {
    return "";
  }

  var url = '';
  var width = '';
  var height = '';

  if (typeof data === 'string') {
    url = decodeURIComponent(data);
  } else {
    url = decodeURIComponent(data.url || data.src);
    width = data.width;
    height = data.height;
  }

  var stuffIndex = url.lastIndexOf('.');
  var stuffMidIndex = url.lastIndexOf('@');
  var stuffAdditionIndex = url.lastIndexOf('|');
  var urlLen = url.length;

  if (!~stuffIndex) {
    return url;
  }

  var oldStuff = '';
  if (suffix) {
    oldStuff = '.' + suffix;
  } else {
    if (~stuffAdditionIndex) {
      oldStuff = url.substring(stuffIndex, stuffAdditionIndex);
    } else {
      oldStuff = url.substring(stuffIndex);
    }
    oldStuff = oldStuff.toLowerCase();
  }
  if (oldStuff !== ".jpg" && oldStuff !== ".jpeg" && oldStuff !== ".png" && oldStuff !== ".webp" && oldStuff !== ".gif") {
    return url;
  }

  var stuff = '.webp';
  var newUrl = url;
  if (_browser2.default.ios() || !/i(?:pod|phone|pad)|android|micromessenger/i.test(navigator.userAgent)) {
    //webview ios || pc
    stuff = oldStuff === '.webp' ? '.jpg' : oldStuff;
  }

  var clipSize = {};

  if (clipData) {
    //'product' {'type':'product','width':'','height':''}
    if (typeof clipData === 'string') {
      if (CLIP_MAP[clipData]) {
        clipSize = CLIP_MAP[clipData];
      }
    } else {
      if (clipData['type'] && CLIP_MAP[clipData['type']]) {
        clipSize = CLIP_MAP[clipData['type']];
      } else {
        clipSize['width'] = clipData['width'];
        clipSize['height'] = clipData['height'];
      }
    }
  }

  if (clipSize['width'] && clipSize['height'] && !~stuffMidIndex) {
    newUrl = url + ('@4e_0o_0l_' + clipSize['height'] + 'h_' + clipSize['width'] + 'w_90q') + stuff;
    return newUrl;
  }

  if (!~stuffMidIndex || stuffMidIndex > stuffIndex) {
    // no @
    var formatObj = formatRangeSize(formatData);
    newUrl = url + formatRangeStuff({
      width: width,
      formatObj: formatObj,
      fixWidth: fixWidth
    });
    return newUrl;
  }

  //has @
  var stuffMidStr = url.substring(stuffMidIndex, stuffIndex);
  var stuffAdditionStr = '';
  if (~stuffAdditionIndex && stuffAdditionIndex > stuffMidIndex) {
    //has |
    stuffAdditionStr = url.substring(stuffAdditionIndex);
  }

  if (width && height) {
    // const whObj = this._formatStuffZoom(width, height)
    // stuffMidStr = `@4e_0o_0l_${whObj.height}h_${whObj.width}w_90q`
    var _formatObj = formatRangeSize(formatData);
    stuffMidStr = formatRangeStuff({
      width: width,
      formatObj: _formatObj,
      stuffMidStr: stuffMidStr,
      fixWidth: fixWidth
    });
  }
  newUrl = url.substring(0, stuffMidIndex) + stuffMidStr + stuff + stuffAdditionStr;

  return newUrl;
}

function formatRangeSize(formatData) {
  return {
    'width': 750
  };
}

function formatRangeStuff(_ref3) {
  var width = _ref3.width,
      formatObj = _ref3.formatObj,
      stuffMidStr = _ref3.stuffMidStr,
      fixWidth = _ref3.fixWidth;

  var midStuff = '';
  if (fixWidth) {
    // midStuff =  `@0o_0l_${fixWidth}w_90q`
    midStuff = '?x-oss-process=image/resize,w_' + fixWidth + '/quality,q_90';
  } else {
    if (width && width >= formatObj.width) {
      midStuff = '?x-oss-process=image/resize,w_' + formatObj.width + '/quality,q_90';
    } else {
      if (stuffMidStr) {
        midStuff = stuffMidStr;
      } else {
        midStuff = '?x-oss-process=image/quality,q_90';
      }
    }
  }
  return midStuff;
}

// export DEFAULT_IMAGE = defaultImage

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lazy) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "defaultimg": _vm.lazyImage,
      "datalazy": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : (!_vm.lazy && _vm.imageLoad) ? _c('img', {
    style: ({
      'border-radius': ((_vm.radius || 0) + "px")
    }),
    attrs: {
      "src": _vm.imageSrc,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: 'price',
  props: ['data', 'single', 'bit'],
  data: function data() {
    return {};
  },

  computed: {
    formatedPrice: function formatedPrice() {
      return this.formatPrice(this.data);
    }
  },
  methods: {
    formatPrice: function formatPrice(price) {
      var origin = price;
      var sign = '';

      if (price < 0) {
        price = Math.abs(price);
        sign = '-';
      }

      var int_number = (price * 100).toFixed(0);
      var decimal = String(int_number % 100);
      var int = String(parseInt(Number(price)));

      // 0.03 -> 3 -> 03
      if (decimal.length === 1) {
        decimal = '0' + decimal;
      }

      if (int.length > 3) {
        var remain = 3 - int.length % 3;

        switch (remain) {
          case 1:
            int = '0' + int;
            break;
          case 2:
            int = '00' + int;
            break;
        }

        var matches = int.match(/.{3}/g);

        if (remain !== 3) {
          matches[0] = matches[0].substring(remain);
        }

        int = matches.join(',');
      }

      return {
        int: int,
        decimal: this.single === 'false' ? decimal : decimal.substring(0, this.bit || 1),
        origin: origin,
        sign: sign,
        html: '<span class="sign">' + sign + '</span><span class="symbol">&yen;</span><span class="int">' + int + '</span><span class="decimal">.' + decimal + '</span>'
      };
    }
  }

};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sign"
  }, [_vm._v(_vm._s(_vm.formatedPrice.sign))]), _c('span', {
    staticClass: "symbol"
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.formatedPrice.int))]), _vm._v("."), _c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.formatedPrice.decimal))])])
},staticRenderFns: []}

/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _select = __webpack_require__(75);

var _select2 = _interopRequireDefault(_select);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

var handler = function handler(e) {
  e.preventDefault();
};
exports.default = {
  components: {
    BeastSelect: _select2.default,
    Slide: _slide2.default
  },
  data: function data() {
    return {
      show: false
    };
  },

  props: {
    list: Array
  },
  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    },
    confirm: function confirm(data) {
      this.$emit('on-confirm', data);
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$el.addEventListener('touchmove', handler, false);
      } else {
        this.$el.removeEventListener('touchmove', handler, false);
      }
    }
  }
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _item = __webpack_require__(78);

var _item2 = _interopRequireDefault(_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Item: _item2.default
  },
  methods: {
    change: function change(index) {
      this.index = index;
    },
    cancel: function cancel() {
      // this.$el.removeEventListener('touchmove', handler, false)
      this.$emit('on-cancel');
    },
    confirm: function confirm() {
      // this.$el.removeEventListener('touchmove', handler, false)
      this.$emit('on-confirm', this.index);
    }
  },
  // watch:{

  // },
  // mounted: function(){
  //   this.$el.addEventListener('touchmove', handler, false)
  // },
  props: {
    list: Array
  },
  data: function data() {
    return {
      index: 0,
      show: true
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _betterScroll = __webpack_require__(64);

var _betterScroll2 = _interopRequireDefault(_betterScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollOptions = {
  wheel: {
    selectedIndex: 0
    /** 默认值就是下面配置的两个，为了展示二者的作用，这里再配置一下 */
    // wheelWrapperClass: 'wheel-scroll',
    // wheelItemClass: 'wheel-item'
  },
  probeType: 3
}; //
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    list: Array,
    column: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentShow: function currentShow() {
      return this.show;
    }
  },
  watch: {
    show: function show(val) {
      // if(this.scroll){
      //   return
      // }
      // this._index =0
      // let _warp = this.$el.querySelector(".scroll-warp")
      // let defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight
      // this.scroll = new IScroll(_warp, scrollOptions )
      // let _this = this
      // this.scroll.on('scrollEnd', function(){
      //   let _y = this.y
      //   let index = parseInt(Math.abs(_y) / defaultHeight)
      //   if(_this._index !== index){
      //     _this._index = index
      //     _this.$emit("on-change" , index , _this.column)
      //   }
      // });
    },
    list: function list(val) {
      if (!this.scroll) {
        this._index = 0;
        var _warp = this.$el.querySelector(".scroll-warp");
        var defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight;
        this.scroll = new _betterScroll2.default(_warp, scrollOptions);
        var _this = this;
        this.scroll.on('scrollEnd', function () {
          var _y = this.y;
          var index = parseInt(Math.abs(_y) / defaultHeight);
          if (_this._index !== index) {
            _this._index = index;
            _this.$emit("on-change", index);
          }
        });
      }
      this.$nextTick(function () {
        var _scroll = this.scroll;
        var _column = this.column;
        setTimeout(function () {
          _scroll.refresh();
          if (_column > 0) {
            _scroll.scrollTo(0, 0);
          }
        }, 100);
      });
    }
  }
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-item-warp"
  }, [_c('div', {
    staticClass: "scroll-warp"
  }, [_c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-warp"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "fl",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', [_vm._v("请选择")]), _vm._v(" "), _c('div', {
    staticClass: "fr",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "select-warp"
  }, [_c('div', {
    staticClass: "indicator"
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.list,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('slide', {
    attrs: {
      "from": "bottom",
      "show": _vm.show
    }
  }, [_c('beast-select', {
    attrs: {
      "list": _vm.list
    },
    on: {
      "on-cancel": _vm.cancel,
      "on-confirm": _vm.confirm
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__(85);

var _index2 = _interopRequireDefault(_index);

var _validate = __webpack_require__(106);

var _validate2 = _interopRequireDefault(_validate);

var _register = __webpack_require__(122);

var _register2 = _interopRequireDefault(_register);

var _browser = __webpack_require__(1);

var _api = __webpack_require__(134);

var _api2 = _interopRequireDefault(_api);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0,
    $validatevm = void 0,
    $registervm = void 0,
    login_resolve = void 0,
    login_reject = void 0,
    validate_resolve = void 0,
    validate_reject = void 0,
    register_resolve = void 0,
    register_reject = void 0;

(function () {
  function install(Vue) {
    var login = function login() {
      if (!$vm) {
        var Login = Vue.extend(_index2.default);
        $vm = new Login({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      $vm.$on('login-cancel', function () {
        $vm.show = false;
        var error = new Error('cancel login');
        error.code = 'abort'.toUpperCase();
        error.message = 'cancel login';
        login_reject(error);
      });

      $vm.$on('login-success', function (member) {
        if (!member.mobile) {
          this.$verifiedMobile().then(function () {
            $vm.show = false;
            login_resolve({
              logged: true
            });
          }).catch(function () {
            var error = new Error('cancel Validate');
            error.code = 'abort'.toUpperCase();
            error.message = 'cancel Validate';
            login_reject(error);
          });
        } else {
          $vm.show = false;
          login_resolve({
            logged: true,
            member: member
          });
        }
      });
      $vm.$on('to-register', function (member) {
        this.$register().then(function () {
          $vm.show = false;
          login_resolve({
            logged: true,
            member: member
          });
        }).catch(function () {});
      });
      setTimeout(function () {
        $vm.show = true;
      }, 20);
      return new _promise2.default(function (resolve, reject) {
        login_resolve = resolve;
        login_reject = reject;
      });
    };

    var register = function register() {
      if (!$registervm) {
        var Register = Vue.extend(_register2.default);
        $registervm = new Register({
          el: document.createElement('div')
        });
        document.body.appendChild($registervm.$el);
      }

      $registervm.$on('register-cancel', function () {
        $registervm.show = false;
        var error = new Error('cancel Register');
        error.code = 'abort'.toUpperCase();
        error.message = 'cancel Register';
        register_reject(error);
      });
      $registervm.$on('register-success', function () {
        $registervm.show = false;
        register_resolve({
          logged: true
        });
      });
      $registervm.$on('to-login', function () {
        $registervm.show = false;
        var error = new Error('to Login');
        error.code = 'abort'.toUpperCase();
        error.message = 'to Login';
        register_reject(error);
      });
      setTimeout(function () {
        $registervm.show = true;
      }, 20);
      return new _promise2.default(function (resolve, reject) {
        register_resolve = resolve;
        register_reject = reject;
      });
    };

    var verifiedMobile = function verifiedMobile() {
      if (!$validatevm) {
        var Validate = Vue.extend(_validate2.default);
        $validatevm = new Validate({
          el: document.createElement('div')
        });
        document.body.appendChild($validatevm.$el);
      }

      $validatevm.$on('validate-cancel', function () {
        $validatevm.show = false;
        var error = new Error('cancel Validate');
        error.code = 'abort'.toUpperCase();
        error.message = 'cancel Validate';
        validate_reject(error);
      });
      $validatevm.$on('validate-success', function () {
        $validatevm.show = false;
        validate_resolve({
          logged: true
        });
      });
      setTimeout(function () {
        $validatevm.show = true;
      }, 20);

      return new _promise2.default(function (resolve, reject) {
        validate_resolve = resolve;
        validate_reject = reject;
      });
    };

    var ensureLogged = function ensureLogged() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$event = _ref.event,
          event = _ref$event === undefined ? '' : _ref$event;

      if ((0, _browser.app)()) {
        return _bridge2.default.ensureLogged();
      }
      return _api2.default.member().then(function (_ref2) {
        var data = _ref2.data;

        if (!data.mobile) {
          return _this.$verifiedMobile().then(function () {
            return _api2.default.member().then(function (_ref3) {
              var data = _ref3.data;

              return _promise2.default.resolve({
                alreadyLogged: true,
                member: data
              });
            });
          }).catch(function (data) {
            return _promise2.default.reject(data);
          });
        }
        window.sessionStorage.setItem('_b_m', (0, _stringify2.default)(data));
        return _promise2.default.resolve({
          alreadyLogged: true,
          member: data
        });
      }).catch(function (data) {
        var code = data.code;
        if (code == '401') {
          if ((0, _browser.weixin)()) {
            return _this.$verifiedMobile().then(function () {
              return _api2.default.member().then(function (_ref4) {
                var data = _ref4.data;

                return _promise2.default.resolve({
                  alreadyLogged: true,
                  member: data
                });
              });
            }).catch(function (data) {
              return _promise2.default.reject(data);
            });
          }

          // if (weixin()) {
          //   // window.location.reload()
          //   this.$verifiedMobile()
          //     .then(() => {
          //        api.member().then(({ data }) => {
          //          return Promise.resolve({
          //            alreadyLogged: true,
          //            member: data,
          //          });
          //        });
          //     })
          //     .catch((data) => {
          //       return Promise.reject(data)
          //     })
          // }

          if (event) {
            sa.registerButtonClick(event);
          }

          return _this.$login();
        }
        if (code == '4001') {
          return _this.$verifiedMobile().then(function () {
            return _api2.default.member().then(function (_ref5) {
              var data = _ref5.data;

              return _promise2.default.resolve({
                alreadyLogged: true,
                member: data
              });
            });
          }).catch(function (data) {
            return _promise2.default.reject(data);
          });
        }
        // this.$alert("系统异常")
        // const error = new Error('sysErr')
        // error.code = 'abort'.toUpperCase()
        // error.message = 'sysErr'
        return _promise2.default.reject(data);
      });
    };

    Vue.mixin({
      created: function created() {
        this.$login = login;
        this.$ensureLogged = ensureLogged;
        this.$verifiedMobile = verifiedMobile;
        this.$register = register;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(83);

var _index2 = _interopRequireDefault(_index);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Login: _index2.default,
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onLogin: function onLogin(member) {
      this.$emit("login-success", member);
    },
    onResister: function onResister(member) {
      this.$emit("to-register");
    },
    onCancel: function onCancel() {
      this.$emit("login-cancel");
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _select = __webpack_require__(18);

var _select2 = _interopRequireDefault(_select);

var _passLogin = __webpack_require__(89);

var _passLogin2 = _interopRequireDefault(_passLogin);

var _country2 = __webpack_require__(19);

var _country3 = _interopRequireDefault(_country2);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIphoneX() {
  return (/iphone/gi.test(navigator.userAgent) && screen.height >= 812
  );
} //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_select2.default);

var timeDown = null;

exports.default = {
  components: {
    PassLogin: _passLogin2.default
  },

  props: {
    showClose: {
      default: true
    }
  },

  data: function data() {
    return {
      phone: '',
      captcha: '',
      showPass: false,
      smsCode: '',
      countryIndex: 0,
      imgCode: null,
      verifyType: 'SMS_LOGIN',
      smsSended: false,
      timeDownText: '60秒后获取',
      errmsg: '',
      fixed: false,
      checkRule: false,
      isIphoneX: isIphoneX()
    };
  },


  computed: {
    country: function country() {
      return _country3.default[this.countryIndex];
    },
    realPhone: function realPhone() {
      return this.country.country_code + '-' + this.phone;
    },
    enableLogin: function enableLogin() {
      return this.phone && this.smsCode;
    }
  },

  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      this.getCaptcha();
    },
    login: function login() {
      var _this = this;

      var phone = this.phone,
          realPhone = this.realPhone,
          smsCode = this.smsCode,
          verifyType = this.verifyType,
          checkRule = this.checkRule;


      if (!this.enableLogin) return;
      this.errmsg = '';

      if (!checkRule) {
        this.errmsg = '请先勾选同意《野兽派服务条款》和《隐私政策》';
        return;
      }

      if (phone.length != 11) {
        this.errmsg = '请输入正确的手机号';
        return;
      }

      if (this.smsCode == '') {
        this.errmsg = '请输短信验证码';
        return;
      }

      var authData = {
        principal: realPhone,
        credential: smsCode,
        authType: verifyType
      };

      _api2.default.login(authData).then(function (_ref) {
        var data = _ref.data;

        if (data.member.enroll) {
          try {
            TDH5SDK.account.register(data.member.id);
          } catch (e) {}
        }
        if (data.toast) {
          _this.$toast(data.toast).then(function () {
            _this.$emit('login', data.member);
          });
        } else {
          _this.$emit('login', data.member);
        }
      }).catch(function (err) {
        _this.errmsg = err.message;
      });
    },
    passLogin: function passLogin(data) {
      // console.log('1111111')
      // console.log(data)
      this.$emit('login', data);
    },
    getSms: function getSms() {
      var _this2 = this;

      var phone = this.phone,
          realPhone = this.realPhone,
          captcha = this.captcha,
          verifyType = this.verifyType,
          country = this.country,
          smsSended = this.smsSended;


      this.errmsg = '';

      if (smsSended) return;

      if (phone.length != 11) {
        this.errmsg = '请输入正确的手机号';
        return;
      }

      if (this.captcha == '') {
        this.errmsg = '请输入图形验证码';
        return;
      }
      sa.track('GetCode', {
        service_type: '快捷登录注册'
      });
      _api2.default.sms(realPhone, captcha, verifyType).then(function (_ref2) {
        var data = _ref2.data;

        _this2.smsSended = true;
        _this2.startTimeDown();
        // this.getCaptcha()
      }).catch(function (err) {
        _this2.errmsg = err.message;
      });
    },
    startTimeDown: function startTimeDown() {
      var _this3 = this;

      if (timeDown) {
        clearInterval(timeDown);
      }

      var num = 60;

      timeDown = setInterval(function () {
        if (num === 0) {
          _this3.smsSended = false;
          clearInterval(timeDown);
          return;
        }

        num--;
        _this3.timeDownText = num + '\u79D2\u540E\u83B7\u53D6';
      }, 1000);
    },
    getCaptcha: function getCaptcha() {
      var _timestamp = new Date().getTime();

      this.imgCode = "https://api.thebeastshop.com" + '/app/captcha?_timestamp=' + _timestamp;
    },


    close: function close() {
      this.$emit('cancel');
    },

    delSmsCode: function delSmsCode() {
      this.smsCode = '';
    },
    selectCountry: function selectCountry() {
      var _this4 = this;

      // track({
      //   name: 'areaCode'
      // })

      this.$select(_country3.default.map(function (item) {
        return item.country_name_cn;
      })).then(function (data) {
        _this4.countryIndex = data;
      }).catch(function () {
        // console.log('select-cancel');
      });
    },
    showPassLogin: function showPassLogin() {
      this.showPass = !this.showPass;
    },
    blur: function blur() {
      this.fixed = false;
    },
    focus: function focus() {
      this.fixed = true;
    }
  }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _country2 = __webpack_require__(19);

var _country3 = _interopRequireDefault(_country2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _select = __webpack_require__(18);

var _select2 = _interopRequireDefault(_select);

var _forget = __webpack_require__(92);

var _forget2 = _interopRequireDefault(_forget);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_select2.default);
exports.default = {
  components: {
    Forget: _forget2.default
  },
  data: function data() {
    return {
      loginType: 'mobile',
      countryIndex: 0,
      error: '',
      mobile: '',
      email: '',
      password: '',
      forgetShow: false,
      fixed: false
    };
  },

  props: {
    showClose: {
      default: true
    }
  },
  computed: {
    country: function country() {
      return _country3.default[this.countryIndex];
    }
  },
  methods: {
    changeLoginType: function changeLoginType(type) {
      (0, _track2.default)({
        name: 'login-' + type
      });
      this.loginType = type;
      this.password = '';
      // console.log(type);
    },
    selectCountry: function selectCountry() {
      var _this = this;

      (0, _track2.default)({
        name: 'areaCode'
      });
      this.$select(_country3.default.map(function (item) {
        return item.country_name_cn;
      })).then(function (data) {
        _this.countryIndex = data;
      }).catch(function () {
        // console.log('select-cancel');
      });
    },
    close: function close() {
      (0, _track2.default)({
        name: 'close'
      });
      this.$emit('cancel');
    },
    register: function register() {
      (0, _track2.default)({
        name: 'login-register'
      });
      this.$emit('register');
    },
    forget: function forget() {
      (0, _track2.default)({
        name: 'login-forget'
      });
      this.forgetShow = true;
    },
    forgetClose: function forgetClose() {
      this.forgetShow = false;
    },
    delPass: function delPass() {
      this.password = '';
    },

    login: function login() {
      var _this2 = this;

      (0, _track2.default)({
        name: 'login-login'
      });
      var _json = {
        principal: '',
        credential: '',
        authType: this.loginType.toUpperCase()
      };
      if (this.loginType == 'mobile') {
        if (this.mobile.length != 11) {
          this.$alert("请输入正确的手机号");
          return;
        }
        _json.principal = this.country.country_code + '-' + this.mobile;
      } else {
        if (this.email == '') {
          this.$alert("请输入邮箱");
          return;
        }
        _json.principal = this.email;
      }
      if (this.password == '') {
        this.$alert("请输入密码");
        return;
      }
      _json.credential = this.password;
      _api2.default.login(_json).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        _this2.$emit('login', data.member);
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this2.$alert(message);
        (0, _track2.default)({
          name: 'login-failed',
          attrs: {
            message: message
          }
        });
      });
    },

    blur: function blur() {
      this.fixed = false;
    },
    focus: function focus() {
      this.fixed = true;
    }
  }
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _country2 = __webpack_require__(19);

var _country3 = _interopRequireDefault(_country2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

var _forgetSuccess = __webpack_require__(98);

var _forgetSuccess2 = _interopRequireDefault(_forgetSuccess);

var _select = __webpack_require__(18);

var _select2 = _interopRequireDefault(_select);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var timeDown = null;

_vue2.default.use(_select2.default);
exports.default = {
  components: {
    Slide: _slide2.default,
    forgetSuccess: _forgetSuccess2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {
      loginType: 'mobile',
      countryIndex: 0,
      stepSmsCode: false,
      error: '',
      mobile: '',
      email: '',
      codeEnd: 0,
      captchaCode: '',
      mobileCode: '',
      password: '',
      phoneText: '',
      showPassword: false,
      codeTime: new Date().getTime(),
      successShow: false,
      timeDownText: '60秒后获取',
      smsSended: false,
      imgCode: '',
      errmsg: ''
    };
  },

  props: {
    showClose: {
      default: true
    },
    forgetShow: {
      default: false
    }
  },
  computed: {
    country: function country() {
      return _country3.default[this.countryIndex];
    },
    phone_code_text: function phone_code_text() {
      return this.codeEnd === 0 ? '获取验证码' : '\u91CD\u65B0\u83B7\u53D6(' + this.codeEnd + ')';
    },
    captchaCodeSrc: function captchaCodeSrc() {
      return "https://api.thebeastshop.com" + '/app/captcha?_timestamp=' + this.codeTime;
    }
  },
  methods: {
    changeCode: function changeCode() {
      (0, _track2.default)({
        name: 'graphicCode'
      });
      this.codeTime = new Date().getTime();
    },

    changeLoginType: function changeLoginType(type) {
      (0, _track2.default)({
        name: 'login-' + type
      });
      this.errmsg = '';
      this.loginType = type;
      this.password = '';
      this.captchaCode = '';
      this.mobileCode = '';
      this.changeCode();
    },

    validCpatchaCodeSrc: function validCpatchaCodeSrc() {
      var _this = this;

      if (this.smsSended) return;
      this.errmsg = '';

      if (this.mobile.length != 11) {
        this.errmsg = '请输入正确的手机号';
        return;
      }

      if (this.captchaCode == '') {
        this.errmsg = '请输入图形验证码';
        return;
      }

      _api2.default.sms(this.mobile, this.captchaCode, 'RETRIEVE_PASSWORD').then(function (data) {

        var personMobile = _this.mobile.slice(0, 3) + '*****' + _this.mobile.slice(9, 10);

        _this.phoneText = '\u5DF2\u5411' + personMobile + '\u53D1\u9001\u9A8C\u8BC1\u7801';
        _this.stepSmsCode = true;

        _this.startTimeDown();
      }).catch(function (_ref) {
        var code = _ref.code,
            message = _ref.message;

        _this.errmsg = message;
      });
    },
    resetPass: function resetPass() {
      this.changePassword();
    },


    sendCode: function sendCode() {
      var _this2 = this;

      (0, _track2.default)({
        name: 'verificationCode'
      });
      this.errmsg = '';
      if (this.codeEnd > 0) {
        return false;
      }
      if (this.mobile.length != 11) {
        this.errmsg = '请输入正确的手机号';
        return;
      }
      if (this.captchaCode == '') {
        this.errmsg = '请输入图形验证码';
        return;
      }
      sa.track('GetCode', {
        service_type: '找回密码'
      });
      _api2.default.sms(this.mobile, this.captchaCode).then(function (data) {
        _this2.codeEnd = 60;
        _this2.countDown();
      }).catch(function (_ref2) {
        var code = _ref2.code,
            message = _ref2.message;

        _this2.errmsg = message;
      });
    },
    selectCountry: function selectCountry() {
      var _this3 = this;

      (0, _track2.default)({
        name: 'areaCode'
      });
      this.$select(_country3.default.map(function (item) {
        return item.country_name_cn;
      })).then(function (data) {
        _this3.countryIndex = data;
      }).catch(function () {
        // console.log('select-cancel');
      });
    },

    startTimeDown: function startTimeDown() {
      var _this4 = this;

      if (timeDown) {
        clearInterval(timeDown);
      }

      var num = 60;

      timeDown = setInterval(function () {
        if (num === 0) {
          _this4.smsSended = false;
          clearInterval(timeDown);
          return;
        }
        _this4.smsSended = true;

        num--;
        _this4.timeDownText = num + '\u79D2\u540E\u83B7\u53D6';
      }, 1000);
    },


    close: function close() {
      this.$emit('cancel');
    },
    success: function success() {
      this.successShow = false;
      this.$emit('forget');
    },
    changePassword: function changePassword() {
      var _this5 = this;

      this.errmsg = '';
      if (this.mobile.length != 11) {
        this.errmsg = '请输入正确的手机号';
        return;
      }
      if (this.mobileCode == '') {
        this.errmsg = '请输入短信验证码';
        return;
      }
      var password_reg = /^[a-z0-9]{6,16}$/i;
      if (!password_reg.test(this.password)) {
        this.errmsg = '密码必须为6-16位数字或字母';
        return;
      }

      _api2.default.modification(this.mobile, this.password, this.mobileCode).then(function (data) {
        _this5.successShow = true;
      }).catch(function (_ref3) {
        var code = _ref3.code,
            message = _ref3.message;

        _this5.errmsg = message;
      });
    }
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(16);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var handler = function handler(e) {
  e.preventDefault();
  // e.stopPropagation()
};
var passiveSupported = false;

try {
  var options = Object.defineProperty({}, "passive", {
    get: function get() {
      passiveSupported = true;
    }
  });
} catch (err) {}

exports.default = {
  components: {
    Masks: _index2.default,
    MaxZIndex: _index4.default
  },
  props: {
    mshow: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'beast-mask'
    },
    // maskStyle: {
    //   type: String,
    //   default: 'beast__mask'
    // },
    dialogTransition: {
      type: String,
      default: 'beast-dialog-login'
    },
    dialogStyle: {
      type: String,
      default: 'beast__dialog-m'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskTouchHide: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    },
    maskOpacity: {
      // type: Number,
      default: 0.4
    }
  },

  created: function created() {
    if (typeof this.mshow !== 'undefined') {
      this.currentValue = this.mshow;
    }
  },
  data: function data() {
    return {
      currentValue: false,
      top: 0,
      relative: false
    };
  },


  computed: {
    mOpacity: function mOpacity() {
      return this.mask ? parseFloat(this.maskOpacity) : 0;
    },
    whight: function whight() {
      return 'height:' + document.documentElement.clientHeight + 'px;';
    }
  },

  watch: {
    mshow: function mshow(val) {
      if (val) {
        console.log(this.$el);
        var _top = document.documentElement.scrollTop || document.body.scrollTop;
        // this.top = _top + document.documentElement.clientHeight
        this.top = _top;
        this.$el.addEventListener('touchmove', handler, false);
      } else {
        this.$el.removeEventListener('touchmove', handler, false);
      }
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      val || this.$emit('mask-hide');
    }
  },
  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    },
    maskHide: function maskHide() {
      this.mask && this.maskTouchHide && (this.currentValue = false);
    }
  }
};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('max-z-index', {
    attrs: {
      "show": _vm.currentValue,
      "relative": _vm.relative
    }
  }, [_c('div', {
    staticStyle: {
      "touch-action": "none"
    },
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('masks', {
    attrs: {
      "mshow": _vm.currentValue,
      "mopacity": _vm.mOpacity
    },
    on: {
      "onHide": _vm.maskHide
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogStyle,
    staticStyle: {
      "z-index": "2002"
    },
    style: ({
      whight: _vm.whight,
      top: '0px'
    })
  }, [_vm._t("default")], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {};
  },

  props: {
    showClose: {
      default: true
    },
    successShow: {
      default: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('cancel');
    }
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mshow": _vm.successShow
    }
  }, [_c('div', {
    staticClass: "beast-login-warp forget"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("密码修改成功")])]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "forget-tips"
  }, [_c('p', [_vm._v("你的账号密码已修改成功")]), _vm._v(" "), _c('p', [_vm._v("点击确定后重新登录")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn-success",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      确定\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "beast-login-warp login"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/icon-back.png"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('p', {
    staticClass: "tit-phone"
  }, [_vm._v(_vm._s(_vm.phoneText))])]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.stepSmsCode),
      expression: "!stepSmsCode"
    }],
    staticClass: "type"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-warp"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginType == 'mobile'),
      expression: "loginType=='mobile'"
    }]
  }, [(!_vm.stepSmsCode) ? [_c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-area",
    on: {
      "click": _vm.selectCountry
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.country.country_code) + "\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "split"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    attrs: {
      "placeholder": "图片验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-code",
    on: {
      "click": _vm.changeCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchaCodeSrc
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "err-message"
  }, [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn-forget",
    on: {
      "click": _vm.validCpatchaCodeSrc
    }
  }, [_vm._v("\n                下一步\n              ")])] : [_c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileCode),
      expression: "mobileCode"
    }],
    attrs: {
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.mobileCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tel-code",
    class: {
      enabled: !_vm.smsSended
    },
    on: {
      "click": _vm.validCpatchaCodeSrc
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.smsSended ? _vm.timeDownText : '获取验证码') + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "placeholder": "设置新密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "err-message"
  }, [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn-forget",
    on: {
      "click": _vm.resetPass
    }
  }, [_vm._v("\n                下一步\n              ")])]], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginType == 'email'),
      expression: "loginType=='email'"
    }]
  }, [_c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    attrs: {
      "placeholder": "图片验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-code",
    on: {
      "click": _vm.changeCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchaCodeSrc
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "err-message"
  }, [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn-forget"
  }, [_vm._v("\n              下一步\n            ")])])])])])]), _vm._v(" "), _c('forget-success', {
    attrs: {
      "successShow": _vm.successShow
    },
    on: {
      "cancel": _vm.success
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pass-login-wrap",
    class: {
      fixed: _vm.fixed
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.forgetShow),
      expression: "!forgetShow"
    }],
    staticClass: "beast-login-warp login pass-login"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/icon-back.png"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-main pass-login"
  }, [_c('div', {
    staticClass: "type"
  }, [_c('div', {
    staticClass: "item",
    class: {
      active: _vm.loginType == 'mobile'
    },
    on: {
      "click": function($event) {
        return _vm.changeLoginType('mobile')
      }
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      active: _vm.loginType == 'email'
    },
    on: {
      "click": function($event) {
        return _vm.changeLoginType('email')
      }
    }
  }, [_vm._v("邮箱")])]), _vm._v(" "), _c('div', {
    staticClass: "input-warp"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginType == 'mobile'),
      expression: "loginType=='mobile'"
    }]
  }, [_c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-area",
    on: {
      "click": _vm.selectCountry
    }
  }, [_vm._v("\n                " + _vm._s(_vm.country.country_code) + "\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "split"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginType == 'email'),
      expression: "loginType=='email'"
    }]
  }, [_c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-del",
    on: {
      "click": _vm.delPass
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-tips"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('span', {
    staticClass: "to-forget",
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn-wrap"
  }, [_c('div', {
    staticClass: "login-btn-pass",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n        登录\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "login-others pass-login"
  }, [_c('div', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("快捷登录注册")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.forgetShow) ? _c('forget', {
    on: {
      "forget": _vm.forgetClose,
      "cancel": _vm.forgetClose
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-head pass-login"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("密码登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/login/login-bg.png"
    }
  })])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap",
    class: {
      fixed: _vm.fixed
    }
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/icon-back.png"
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tit",
    class: {
      'show-close': _vm.showClose
    }
  }, [_vm._v("快捷注册登录")]), _vm._v(" "), _c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "area",
    on: {
      "click": _vm.selectCountry
    }
  }, [_vm._v(_vm._s(_vm.country.country_code))]), _vm._v(" "), _c('i', {
    staticClass: "split"
  }), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    attrs: {
      "placeholder": "图片验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img-code",
    on: {
      "click": _vm.getCaptcha
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgCode
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.smsCode),
      expression: "smsCode"
    }],
    staticClass: "input-del",
    on: {
      "click": _vm.delSmsCode
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smsCode),
      expression: "smsCode"
    }],
    attrs: {
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.smsCode)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.smsCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tel-code",
    class: {
      enabled: !_vm.smsSended && (_vm.phone && _vm.phone.length == 11 && _vm.captcha)
    },
    on: {
      "click": _vm.getSms
    }
  }, [_vm._v("\n        " + _vm._s(_vm.smsSended ? _vm.timeDownText : '获取验证码') + "\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "err-msg"
  }, [_vm._v(_vm._s(_vm.errmsg))]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      enabled: _vm.enableLogin
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "login-other"
  }, [_c('div', {
    on: {
      "click": _vm.showPassLogin
    }
  }, [_vm._v("密码登录")])]), _vm._v(" "), (!_vm.showPass) ? _c('div', {
    staticClass: "footer",
    class: {
      fixed: _vm.fixed
    }
  }, [_c('div', {
    staticClass: "rules"
  }, [_c('div', {
    staticClass: "checkbox",
    class: {
      checked: _vm.checkRule
    },
    on: {
      "click": function($event) {
        _vm.checkRule = !_vm.checkRule
      }
    }
  }), _vm._v("我已阅读并同意"), _c('a', {
    attrs: {
      "href": "https://m.thebeastshop.com/eula"
    }
  }, [_vm._v("《野兽派服务条款》")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": "https://m.thebeastshop.com/rule"
    }
  }, [_vm._v("《隐私政策》")])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.showPass) ? _c('pass-login', {
    on: {
      "cancel": _vm.showPassLogin,
      "login": _vm.passLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/login/login-bg.png"
    }
  })])
}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mshow": _vm.show
    }
  }, [_c('login', {
    on: {
      "login": _vm.onLogin,
      "cancel": _vm.onCancel,
      "register": _vm.onResister
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validate = __webpack_require__(108);

var _validate2 = _interopRequireDefault(_validate);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Validate: _validate2.default,
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onVerified: function onVerified() {
      this.$emit("validate-success");
    },
    onCancel: function onCancel() {
      this.$emit("validate-cancel");
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _country2 = __webpack_require__(19);

var _country3 = _interopRequireDefault(_country2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__(111);

var _merge2 = _interopRequireDefault(_merge);

var _select = __webpack_require__(18);

var _select2 = _interopRequireDefault(_select);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _countDown = null; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_select2.default);
exports.default = {
  components: {
    Merge: _merge2.default
  },
  data: function data() {
    return {
      countryIndex: 0,
      error: '',
      mobile: '',
      codeEnd: 0,
      captchaCode: '',
      mobileCode: '',
      password: null,
      needPassword: false,
      codeTime: new Date().getTime(),
      mergeShow: false,
      mergeData: {},
      fixed: false,
      checkRule: false
    };
  },

  props: {
    showClose: {
      default: true
    }
  },
  computed: {
    country: function country() {
      return _country3.default[this.countryIndex];
    },
    phone_code_text: function phone_code_text() {
      return this.codeEnd === 0 ? '获取验证码' : '\u91CD\u65B0\u83B7\u53D6(' + this.codeEnd + ')';
    },
    captchaCodeSrc: function captchaCodeSrc() {
      return "https://api.thebeastshop.com" + '/app/captcha?_timestamp=' + this.codeTime;
    }
  },
  methods: {
    changeCode: function changeCode() {
      this.codeTime = new Date().getTime();
    },
    countDown: function countDown() {
      if (this.codeEnd === 0) {
        clearTimeout(_countDown);
      } else {
        this.codeEnd--;
        var that = this;
        _countDown = setTimeout(function () {
          that.countDown();
        }, 1000);
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      if (this.codeEnd > 0) {
        return false;
      }
      if (this.mobile.length != 11) {
        this.$alert("请输入正确的手机号");
        return;
      }
      if (this.captchaCode == '') {
        this.$alert("请输入图形验证码");
        return;
      }
      if (!this.checkRule) {
        this.$alert('请先勾选同意《野兽派服务条款》和《隐私政策》');
        return;
      }
      _api2.default.sms(this.mobile, this.captchaCode).then(function (data) {
        _api2.default.checkVerifiedMobile(_this.mobile).then(function (_ref) {
          var code = _ref.code,
              data = _ref.data;

          _this.needPassword = data.needPassword;
        }).catch(function (err) {});
        _this.codeEnd = 60;
        _this.countDown();
      }).catch(function (_ref2) {
        var code = _ref2.code,
            message = _ref2.message;

        _this.$alert(message);
      });
    },
    selectCountry: function selectCountry() {
      var _this2 = this;

      this.$select(_country3.default.map(function (item) {
        return item.country_name_cn;
      })).then(function (data) {
        _this2.countryIndex = data;
      }).catch(function () {});
    },
    close: function close() {
      this.$emit('cancel');
    },
    merge: function merge() {
      this.$emit('verified');
    },
    mergeClose: function mergeClose() {
      this.mergeShow = false;
    },
    blur: function blur() {
      this.fixed = false;
    },
    focus: function focus() {
      this.fixed = true;
    },

    validate: function validate() {
      var _this3 = this;

      // this.mergeData = {"primary":{"id":"79160ee2-fc0d-42ae-a992-3d6d67d4c3d5","member":{"id":"M802060307","memberId":2060307,"createTime":1528169988000,"profile":{"nickName":"顺子","avatarUrl":"\"http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoEGRPUt3jYaMRMAGbaSrxnXxPeCBHcbBVe4fdBDxpP6wq8TsDrysR7ILw1egOmrTnjKUGJ3KakWw/132\"","title":{"id":4,"name":"保密"},"birthday":null,"birthdayEditable":true,"birthdayBenefit":null},"mobileAreaCode":"+86","mobile":null,"level":{"id":-1,"name":"注册用户","avatarUrl":"http://img.thebeastshop.com/member/privilege/level-icon/level-zero.jpg"},"point":0.00,"loginMethods":[{"type":"WEIXIN_APP","principal":"ojX3VjsomvGkiYeVHH0reD_qzcdU","unionId":"oEI3GwB3UAtCsVA6qht_Dbfac3tM","mobileAreaCode":"+86"}]}},"subtle":{"id":"14aa3d67-dea9-4060-bb75-dbfb308508d4","member":{"id":"M802060306","memberId":2060306,"createTime":1528169453000,"profile":{"nickName":"顺子","avatarUrl":"\"http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eoEGRPUt3jYaMRMAGbaSrxnXxPeCBHcbBVe4fdBDxpP6wq8TsDrysR7ILw1egOmrTnjKUGJ3KakWw/132\"","title":{"id":4,"name":"保密"},"birthday":null,"birthdayEditable":true,"birthdayBenefit":null},"mobileAreaCode":"+86","mobile":"15618332825","level":{"id":-1,"name":"注册用户","avatarUrl":"http://img.thebeastshop.com/member/privilege/level-icon/level-zero.jpg"},"point":0.00,"loginMethods":[{"type":"MOBILE","principal":"15618332825","unionId":null,"mobileAreaCode":"+86"}]}},"attention":"合并账号将会把以上所列账号的会员积分、收货地址和订单等信息合并至本账号。请在合并账号前确定以上所列账号是否为自己的账号，合并流程不可逆。","mergeable":true}
      // this.mergeShow = true
      // return
      if (!this.checkRule) {
        this.$alert('请先勾选同意《野兽派服务条款》和《隐私政策》');
        return;
      }
      if (this.mobile.length != 11) {
        this.$alert("请输入正确的手机号");
        return;
      }
      if (this.mobileCode == '') {
        this.$alert("请输入短信验证码");
        return;
      }
      var password_reg = /^[a-z0-9]{6,16}$/i;
      if (this.needPassword && !password_reg.test(this.password)) {
        this.$alert("密码必须为6-16位数字或字母");
        return;
      }
      _api2.default.verifiedMobile(this.mobile, this.mobileCode, this.password).then(function (_ref3) {
        var data = _ref3.data;

        if (data.primary.member.enroll) {
          try {
            TDH5SDK.account.register(data.primary.member.id);
          } catch (e) {}
        }
        if (data.toast) {
          _this3.$toast(data.toast).then(function () {
            if (data.subtle) {
              _this3.mergeData = data;
              _this3.mergeShow = true;
            } else {
              _this3.$emit('verified');
            }
          });
        } else {
          if (data.subtle) {
            _this3.mergeData = data;
            _this3.mergeShow = true;
          } else {

            _this3.$emit('verified');
          }
        }
      }).catch(function (_ref4) {
        var code = _ref4.code,
            message = _ref4.message;

        _this3.$alert(message);
      });
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _index = __webpack_require__(11);

var _index2 = _interopRequireDefault(_index);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

var _mergeRule = __webpack_require__(114);

var _mergeRule2 = _interopRequireDefault(_mergeRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var path = 'http://img.thebeastshop.com/app/benefit/';
var levelImage = [path + 'level-zero.jpg', path + 'level-one.jpg', path + 'level-two.jpg', path + 'level-three.jpg', path + 'level-four.jpg'];
exports.default = {
  components: {
    Slide: _slide2.default,
    MergeRule: _mergeRule2.default,
    BDialog: _index2.default
  },
  data: function data() {
    return {
      mergeRuleShow: false
    };
  },

  props: {
    mergeShow: {
      default: true
    },
    mergeData: {
      mergeable: false
    },
    phone: ''
  },
  computed: {
    headImg: function headImg() {
      return this.member.profile.avatarUrl || levelImage[this.member.level.id + 1];
    },
    member: function member() {
      return this.mergeData.subtle ? this.mergeData.subtle.member : null;
    }
  },
  methods: {
    rule: function rule() {
      this.mergeRuleShow = true;
    },
    ruleClose: function ruleClose() {
      this.mergeRuleShow = false;
    },
    close: function close() {
      this.$emit('cancel');
    },
    merge: function merge() {
      var _this = this;

      if (this.mergeData.mergeable && this.mergeData.subtle) {
        _api2.default.merge(this.mergeData.subtle.id).then(function () {
          _this.$toast("你的账号已合并").then(function () {
            _this.$emit('merge');
          });
        }).catch(function (_ref) {
          var code = _ref.code,
              message = _ref.message;

          _this.$toast(message);
        });
      }
    }
  }
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {};
  },

  props: {
    mergeRuleShow: {
      default: true
    }
  },
  methods: {
    close: function close() {
      this.$emit('cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-dialog', {
    attrs: {
      "mshow": _vm.mergeRuleShow,
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "beast-login-warp merge"
  }, [_c('div', {
    staticClass: "merge-main"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("相关说明")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "merge-rule"
  }, [_c('div', [_c('p', [_vm._v("Q：账户合并会牵涉哪些项目合并？")]), _vm._v(" "), _c('p', [_vm._v("A：会员的基础信息、等级信息、所有历史订单以及账户内所有的会员福利等，合并流程不可逆。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：生日信息的合并方法？")]), _vm._v(" "), _c('p', [_vm._v("A：会以当前登录账号为准；若当前账户生日为空，则取子账号生日。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：合并后的会员等级怎么计算？")]), _vm._v(" "), _c('p', [_vm._v("A：会员等级和有效期会取多个账户中等级较高的一个。如果合并后，12个月的总消费满足升级条件，会在次日统一升级。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：会员账户内的优惠券，以及相关权益如何合并？")]), _vm._v(" "), _c('p', [_vm._v("A：已领取的所有优惠券和权益都会进行合并；可在个人中心内查看并使用。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：账户内还有未领取的会员礼包？")]), _vm._v(" "), _c('p', [_vm._v("A：如果还有未领取的会员礼包，我们会将礼包统一发放至您当前登录账户中。")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Q：被合并的账户不是我的？")]), _vm._v(" "), _c('p', [_vm._v("A：可以通过在线客服反映，我们会尽快核实并处理。")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('slide', {
    attrs: {
      "from": "bottom",
      "show": _vm.mergeShow,
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "beast-login-warp merge"
  }, [_c('div', {
    staticClass: "merge-main"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rule",
    attrs: {
      "src": __webpack_require__(119)
    },
    on: {
      "click": _vm.rule
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "merge-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.phone) + "已被以下账号作为登录手机号")]), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('p', [_vm._v("请确认是否合并账号")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "merge-member"
  }, [_c('div', {
    staticClass: "header-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "member-content"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.member.profile.nickName || _vm.phone))]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.member.level.name))]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v("积分" + _vm._s(_vm.member.point))])])])]), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "merge-tips"
  }, [_vm._v("\n            " + _vm._s(_vm.mergeData.attention) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "merge-btn-list"
  }, [(!_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "login-btn bottom",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n            换个手机号验证\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "login-btn bottom",
    on: {
      "click": _vm.merge
    }
  }, [_vm._v("\n            是我的账号，确认合并\n          ")]) : _vm._e(), _vm._v(" "), (_vm.mergeData.mergeable) ? _c('div', {
    staticClass: "merge-not-btn bottom",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n            不是我的账号，换个手机号验证\n          ")]) : _vm._e()])])])]), _vm._v(" "), _c('merge-rule', {
    attrs: {
      "mergeRuleShow": _vm.mergeRuleShow
    },
    on: {
      "cancel": _vm.ruleClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-login-warp validate",
    class: {
      fixed: _vm.fixed
    }
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "input-warp"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', [_c('div', {
    staticClass: "input-row",
    on: {
      "click": _vm.selectCountry
    }
  }, [_c('div', {
    staticClass: "phone-area"
  }, [_vm._v("\n              " + _vm._s(_vm.country.country_code) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "phone-select"
  }, [_vm._v("\n              " + _vm._s(_vm.country.country_name_cn) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone-code-img",
    on: {
      "click": _vm.changeCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchaCodeSrc
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileCode),
      expression: "mobileCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.mobileCode)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone-code-text",
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("\n              " + _vm._s(_vm.phone_code_text) + "\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needPassword),
      expression: "needPassword"
    }],
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "设置密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.blur,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon show-password"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "rules"
  }, [_c('div', {
    staticClass: "checkbox",
    class: {
      checked: _vm.checkRule
    },
    on: {
      "click": function($event) {
        _vm.checkRule = !_vm.checkRule
      }
    }
  }), _vm._v("我已阅读并同意"), _c('a', {
    attrs: {
      "href": "https://m.thebeastshop.com/eula"
    }
  }, [_vm._v("《野兽派服务条款》")]), _vm._v("和"), _c('a', {
    attrs: {
      "href": "https://m.thebeastshop.com/rule"
    }
  }, [_vm._v("《隐私政策》")])]), _vm._v(" "), _c('div', {
    staticClass: "login-tips"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.validate
    }
  }, [_vm._v("\n    完成登录\n  ")]), _vm._v(" "), _c('merge', {
    attrs: {
      "mergeShow": _vm.mergeShow,
      "phone": _vm.mobile,
      "mergeData": _vm.mergeData
    },
    on: {
      "merge": _vm.merge,
      "cancel": _vm.mergeClose
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("为了你的账号安全，请验证手机")])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mshow": _vm.show
    }
  }, [_c('validate', {
    on: {
      "verified": _vm.onVerified,
      "cancel": _vm.onCancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _register = __webpack_require__(124);

var _register2 = _interopRequireDefault(_register);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Register: _register2.default,
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onRegister: function onRegister() {
      this.$emit("register-success");
    },
    onCancel: function onCancel() {
      this.$emit("register-cancel");
    },
    onLogin: function onLogin() {
      this.$emit("to-login");
    }
  }
}; //
//
//
//
//
//

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _country2 = __webpack_require__(19);

var _country3 = _interopRequireDefault(_country2);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _select = __webpack_require__(18);

var _select2 = _interopRequireDefault(_select);

var _registerSuccess = __webpack_require__(127);

var _registerSuccess2 = _interopRequireDefault(_registerSuccess);

var _api = __webpack_require__(13);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _countDown = null;
_vue2.default.use(_select2.default);
exports.default = {
  components: {
    RegisterSuccess: _registerSuccess2.default
  },
  data: function data() {
    return {
      countryIndex: 0,
      error: '',
      mobile: '',
      codeEnd: 0,
      captchaCode: '',
      mobileCode: '',
      password: '',
      showPassword: false,
      codeTime: new Date().getTime(),
      successShow: false
    };
  },

  props: {
    showClose: {
      default: true
    }
  },
  computed: {
    country: function country() {
      return _country3.default[this.countryIndex];
    },
    phone_code_text: function phone_code_text() {
      return this.codeEnd === 0 ? '获取验证码' : '\u91CD\u65B0\u83B7\u53D6(' + this.codeEnd + ')';
    },
    captchaCodeSrc: function captchaCodeSrc() {
      return "https://api.thebeastshop.com" + '/app/captcha?_timestamp=' + this.codeTime;
    }
  },
  methods: {
    changeCode: function changeCode() {
      this.codeTime = new Date().getTime();
    },
    countDown: function countDown() {
      if (this.codeEnd === 0) {
        clearTimeout(_countDown);
      } else {
        this.codeEnd--;
        var that = this;
        _countDown = setTimeout(function () {
          that.countDown();
        }, 1000);
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      (0, _track2.default)({
        name: 'verificationCode'
      });
      if (this.codeEnd > 0) {
        return false;
      }
      if (this.mobile.length != 11) {
        this.$alert("请输入正确的手机号");
        return;
      }
      if (this.captchaCode == '') {
        this.$alert("请输入图形验证码");
        return;
      }
      sa.track('GetCode', {
        service_type: '快捷登录注册'
      });
      _api2.default.sms(this.mobile, this.captchaCode).then(function (data) {
        _this.codeEnd = 60;
        _this.countDown();
      }).catch(function (_ref) {
        // this.$alert(message)

        var code = _ref.code,
            message = _ref.message;
      });
    },
    selectCountry: function selectCountry() {
      var _this2 = this;

      (0, _track2.default)({
        name: 'areaCode'
      });
      this.$select(_country3.default.map(function (item) {
        return item.country_name_cn;
      })).then(function (data) {
        _this2.countryIndex = data;
      }).catch(function () {
        // console.log('select-cancel');
      });
    },
    close: function close() {
      (0, _track2.default)({
        name: 'close'
      });
      this.clean();
      this.$emit('cancel');
    },
    login: function login() {
      (0, _track2.default)({
        name: 'register-login'
      });
      this.clean();
      this.$emit('login');
    },
    success: function success() {
      this.successShow = false;
      this.clean();
      this.$emit('register');
    },
    clean: function clean() {
      this.error = '';
      this.mobile = '';
      this.codeEnd = 0;
      clearTimeout(_countDown);
      this.captchaCode = '';
      this.mobileCode = '';
      this.password = '';
      this.showPassword = false;
      this.successShow = false;
    },
    register: function register() {
      var _this3 = this;

      (0, _track2.default)({
        name: 'register-register'
      });
      // this.successShow = true
      if (this.mobile.length != 11) {
        this.$alert("请输入正确的手机号");
        return;
      }
      if (this.mobileCode == '') {
        this.$alert("请输入短信验证码");
        return;
      }
      var password_reg = /^[a-z0-9]{6,16}$/i;
      if (!password_reg.test(this.password)) {
        this.$alert("密码必须为6-16位数字或字母");
        return;
      }
      _api2.default.register(this.mobile, this.password, this.mobileCode).then(function (data) {
        _this3.successShow = true;
        _this3.$alert('\u6CE8\u518C\u6210\u529F').then(function () {
          _this3.$emit('register');
        });
      }).catch(function (_ref2) {
        var code = _ref2.code,
            message = _ref2.message;

        (0, _track2.default)({
          name: 'register-failed',
          attrs: {
            message: message
          }
        });
        _this3.$alert(message);
      });
    }
  }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _loginDialog = __webpack_require__(12);

var _loginDialog2 = _interopRequireDefault(_loginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Slide: _slide2.default,
    BDialog: _loginDialog2.default
  },
  data: function data() {
    return {};
  },

  props: {
    showClose: {
      default: true
    },
    successShow: {
      default: false
    }
  },
  methods: {
    close: function close() {
      this.$emit('cancel');
    }
  }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "m-show": _vm.successShow
    }
  }, [_c('div', {
    staticClass: "beast-login-warp register"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-head"
  }, [_c('p', {
    staticClass: "r-success-title"
  }, [_vm._v("注册成功")]), _vm._v(" "), _c('p', {
    staticClass: "r-success-tips"
  }, [_vm._v("你获得了BEAST 野兽派的居民证！")])]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "forget-tips"
  }, [_c('img', {
    staticClass: "passport",
    attrs: {
      "src": __webpack_require__(131),
      "height": "752",
      "width": "576",
      "alt": ""
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "s/img/passport.166a371.png";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-login-warp register"
  }, [(_vm.showClose) ? _c('img', {
    staticClass: "close",
    attrs: {
      "src": __webpack_require__(14)
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "input-warp"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', [_c('div', {
    staticClass: "input-row",
    on: {
      "click": _vm.selectCountry
    }
  }, [_c('div', {
    staticClass: "phone-area"
  }, [_vm._v("\n              " + _vm._s(_vm.country.country_code) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "phone-select"
  }, [_vm._v("\n              " + _vm._s(_vm.country.country_name_cn) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captchaCode),
      expression: "captchaCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captchaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captchaCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone-code-img",
    on: {
      "click": _vm.changeCode
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captchaCodeSrc
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "phone-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobileCode),
      expression: "mobileCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.mobileCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobileCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "phone-code-text",
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v("\n              " + _vm._s(_vm.phone_code_text) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon show-password"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "login-tips"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n    注册\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "to-login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n    已经是会员？去登录>\n  ")]), _vm._v(" "), _c('register-success', {
    attrs: {
      "successShow": _vm.successShow
    },
    on: {
      "cancel": _vm.success
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-head"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/static/login/login-logo.png"
    }
  }), _vm._v(">\n    "), _c('p', {
    staticClass: "title"
  }, [_vm._v("注册成为野兽派新会员")])])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dialog', {
    attrs: {
      "mshow": _vm.show
    }
  }, [_c('register', {
    on: {
      "register": _vm.onRegister,
      "cancel": _vm.onCancel,
      "login": _vm.onLogin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  member: function member() {
    return (0, _axiosMock2.default)({
      url: '/app/member'
    });
  }
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(235);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _route;

exports.getLink = getLink;

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// beastapp://entry?
// beastapp://search?
// beastapp://store/shopId

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = (_route = {
  'index': '/',
  'shop': '/shop?shopId=',
  'store': '/shop?shopId=',
  'brand': '/product/list?',
  'cate': '/product/list?',
  'search': '/product/list?',
  'retail': '/retail?',
  'article': '/article?articleId=',
  'customization-list': '/customization/list?',
  'big-furniture-tips': '/furniture/tips?',
  'shop-story': '/shop/story?',
  'group-purchase': '/group/purchase?',
  'points-benefit': '/points/benefit?',
  'points-mall': '/member/day/points?',
  'category': '/category?'
}, (0, _defineProperty3.default)(_route, 'store', '/store?'), (0, _defineProperty3.default)(_route, 'cart', '/cart?'), (0, _defineProperty3.default)(_route, 'member', '/my?'), _route);

var params = {
  'brand': 'brandId'
};

function getLink(link) {
  console.log(link);
  if (link === 'beastapp://index') {
    link = '/';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  console.log(que, "que");
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use strcit';

// const async = require('async')

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load_image = load_image;
function NOOP() {}

// export function load_images (src, callback = NOOP) {
//   src = util.isArray(src)
//     ? src
//     : [src]

//   const tasks = src.map((src) => {
//     return (done) => {
//       load_one_image(src, done)
//     }
//   })

//   async.parallel(tasks, callback)
// }


function load_image(src, callback) {
  var image = new Image();
  var doned = void 0;

  function done(err) {
    if (doned) {
      return;
    }
    doned = true;
    image.onload = image.onerror = image.onabort = null;

    if (err) {
      return callback(err);
    }

    var height = image.height,
        width = image.width,
        src = image.src;


    callback(null, {
      height: height,
      width: width,
      src: src
    });
  }

  image.onload = function () {
    done();
  };

  image.onabort = function () {
    done('abort');
  };

  image.onerror = function () {
    done('error');
  };

  image.src = src;
}

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getMiniEnv = getMiniEnv;
exports.navigateToMini = navigateToMini;
exports.postMessageToMini = postMessageToMini;

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _wx$miniProgram = wx.miniProgram,
    getEnv = _wx$miniProgram.getEnv,
    navigateBack = _wx$miniProgram.navigateBack,
    navigateTo = _wx$miniProgram.navigateTo,
    postMessage = _wx$miniProgram.postMessage,
    reLaunch = _wx$miniProgram.reLaunch,
    redirectTo = _wx$miniProgram.redirectTo,
    switchTab = _wx$miniProgram.switchTab;
function getMiniEnv() {
  return new _promise2.default(function (resolve, reject) {
    if (_browser2.default.weixin()) {
      getEnv(function (res) {
        resolve(res.miniprogram);
      });
    } else {
      resolve(false);
    }
  });
}

function navigateToMini(_ref) {
  var url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'navigate' : _ref$type;

  open({
    url: url,
    type: type
  });
}

function postMessageToMini(postData) {
  postMessage(postData);
}

var METHOD_MAP = {
  navigate: {
    delta: 1,
    method: 'navigateTo'
  },
  redirect: {
    delta: 0,
    method: 'redirectTo'
  },
  tab: {
    delta: 0,
    method: 'switchTab'
  }
};

var stack_await_resolves = [];

var stack_has_data = [];
var stack_data = [];

var stack_has_data_left = [];
var stack_data_left = [];
var stack_last_action = [];

function open(_ref2, i) {
  var url = _ref2.url,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'navigate' : _ref2$type,
      data = _ref2.data;

  var _ref3 = METHOD_MAP[type] || {},
      method = _ref3.method,
      delta = _ref3.delta;

  if (!method) {
    return _promise2.default.reject('unsupported open type "' + type + '"');
  }

  if (data !== undefined) {
    stack_has_data[i] = true;
    stack_data[i] = data;
  }

  stack_last_action[i + delta] = type;

  return new _promise2.default(function (resolve, reject) {
    stack_await_resolves[i] = resolve;

    wx.miniProgram[method]({
      url: url,
      fail: function fail(e) {
        clean(i);
        reject(e);
      }
    });
  });
}

function resolve_data(index) {
  var child_index = index + 1;
  var data_left = stack_has_data_left[child_index] ? stack_data_left[child_index] : undefined;

  clean_left(child_index);

  var resolve = stack_await_resolves[index];
  delete stack_await_resolves[index];

  if (!resolve) {
    return;
  }

  data_left === undefined ? resolve() : resolve(data_left);
}

function clean(i) {
  delete stack_await_resolves[i];
  clean_data(i);
}

function clean_data(i) {
  delete stack_has_data[i];
  delete stack_data[i];
}

function clean_left(i) {
  delete stack_has_data_left[i];
  delete stack_has_data[i];
}

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformMiniLink = transformMiniLink;

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i;

var route = {
  'index': '/pages/index/index',
  // 'shop': '/shop?shopId=',
  'brand': '/pages/list/index?',
  'cate': '/pages/list/index?',
  'search': '/pages/list/index?',
  // 'retail': '/retail?',
  'product': '/pages/product/detail/detail?code=',
  'article': '/pages/article/index?articleId=',
  // 'customization-list': `/customization/list?`,
  // 'big-furniture-tips': '/furniture/tips?',
  // 'shop-story': '/shop/story?',
  'group-purchase': '/pages/group-purchase/index?',
  'points-benefit': '/pages-two/points-benefit/index?',
  'points-mall': '/pages-two/points-list/index?',
  'points-list': '/pages-two/points-list/index?',
  'points-coupon': '/pages-two/points-coupon/index?',
  'points-detail': '/pages-two/points-product/detail/detail?productCode=',
  'category': '/pages/category/index?',
  'store': '/pages/store/index?',
  'cart': '/pages/cart/cart?',
  'member': '/pages/my/member?',
  'my': '/pages/my/member?',
  'member-speed': '/member/speed?',
  'flower-list': '/flower/list?'
};

var params = {
  'brand': 'brandId'
};

function transformMiniLink(_ref) {
  var _ref$link = _ref.link,
      link = _ref$link === undefined ? {} : _ref$link,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title;

  if (!link.type) {
    return '';
  }
  var url = "";
  var tabFlag = false;
  title = encodeURIComponent(title);
  switch (link.type) {
    case 'none':
      return '';
      break;
    case 'product':
      url = '/pages/product/detail/detail?code=' + link.value;
      break;
    case 'article':
      url = '/pages/article/index?articleId=' + link.value;
      break;
    case 'list':
      url = '/pages/list/index?listId=' + link.value + '&title=' + title;
      break;
    case 'new':
      url = '/pages/list/index?new=1&title=' + title;
      break;
    case 'all':
      url = '/pages/list/index?title=' + title;
      break;
    case 'oversea':
      url = '/pages/list/index?overseasOnly=true';
      break;
    case 'brand':
      url = '/pages/list/index?brandId=' + link.value + '&title=' + title;
      break;
    case 'tag':
      url = '/pages/list/index?labelId=' + link.value + '&title=' + title;
      break;
    case 'category':
      url = '/pages/list/index?categoryId=' + link.value;
      break;
    case 'discount':
      url = '/pages/list/index?param=discount&title=' + encodeURIComponent('折扣');
      break;
    case 'campaign':
      url = '/pages/list/index?campaignCode=' + link.value + '&title=' + title;
      break;
    case 'shop-story':
      url = '/pages/shop-story/index?shopId=' + link.value;
      break;
    case 'group':
      url = '/pages/group-purchase/index?productId=' + link.value;
      break;
    case 'bu':
      var query = "";
      var idArr = link.value.split("-");
      if (!idArr.length) {
        return;
      }
      if (idArr.length === 2 && idArr[1]) {
        query = 'buId=' + idArr[0] + '&categoryId=' + idArr[1] + '&title=' + title;
      } else {
        query = 'buId=' + idArr[0] + '&title=' + title;
      }

      url = '/pages/list/index?' + query;
      break;
    case 'program':
      url = link.value;
      tabFlag = formatProgramLink(url);
      break;
    case 'deeplink':
      // url = dealMLink(link.value)
      // tabFlag = formatProgramLink(url)
      url = link.value; //如果是/pages页面 要么直接跳转 要么小程序打开
      tabFlag = formatProgramLink(url);
      if (/^http/.test(url)) {
        // webview
        url = '/pages/web/index?url=' + btoa(encodeURIComponent(url));
      } else if (/^beastapp/.test(url)) {
        // webview
        // console.log(url, '#########')
        url = dealMLink(url);
        tabFlag = formatProgramLink(url);
      }
      break;
    case 'selfdefine':
      url = link.weapp;
      tabFlag = formatProgramLink(url);
      break;
  }

  console.log(url);
  if (tabFlag) {
    return {
      url: url,
      type: 'tab'
    };
  } else {
    return {
      url: url
    };
  }
}

function formatProgramLink(link) {
  if (!link) {
    return '';
  }

  var path = ["pages/index/index", "pages/category-v2/index", "pages/store/index", "pages/cart/cart", "pages/my/member/index", "pages/funny/index"];

  var tabFlag = false;
  path.some(function (p) {
    if (link.indexOf(p) !== -1) {
      //存在
      tabFlag = true;
    }
  });

  return tabFlag;

  // const FileSystemManager = wx.getFileSystemManager()
  // FileSystemManager.readFile({
  //   // filePath: '../app.json',
  //   filePath: wx.env.USER_DATA_PATH + '/app.json',
  //   success: function(res) {
  //     console.log(res, "**************")
  //   },
  //   fail: function(fail) {
  //     console.log(fail, "%%%%%%%%%%%%")
  //   }
  // })

}

function dealMLink(link) {
  console.log(link);
  if (link === 'beastapp://index') {
    link = '/pages/index/index';
  } else if (link === 'beastapp://my') {
    link = '/pages/my/member/index';
  } else {
    link = splitQue(link);
  }

  return link;
}

function splitQue(query) {
  var que = REG.exec(query);
  var type = que[1];
  var search = que[2];
  var name = '';
  // entry
  if (type === 'entry') {
    type = _queryString2.default.parse(search).name;
  }

  if (type && search) {
    que = matchQue(type, search);
  }

  return que;
}

function matchQue(type, query) {
  var que = '';
  type = type.split('/');

  var path = route[type[0]];
  var pid = params[type[0]];

  if (path) {
    que = type[1] && pid ? '' + path + pid + '=' + type[1] + '&' + query : pid ? '' + path + pid + '=' + query : '' + path + query;
  } else {
    que = '/' + type[0].replace('-', '/');
  }

  return que;
}

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getConfig = getConfig;
exports.getMember = getMember;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getConfig() {
  return (0, _axiosMock2.default)({
    url: '/app/index/classifyData'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

function getMember() {
  return (0, _axiosMock2.default)({
    url: '/app/member',
    method: 'GET'
  }).then(function (_ref2) {
    var code = _ref2.code,
        data = _ref2.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getFilter = getFilter;
exports.getMember = getMember;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFilter(query) {
  return (0, _axiosMock2.default)({
    url: '/app/search/filter?' + query
  });
}

function getMember() {
  return (0, _axiosMock2.default)({
    url: '/app/member',
    method: 'GET'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(152);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    config: Object,
    showSinglePaginate: {
      default: false
    },
    paginateCls: {
      default: null
    },
    scrollbarCls: {
      type: Object,
      default: null
    },
    showPaginate: {
      type: Boolean,
      default: true
    },
    showScrollbar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // showPaginate: true
    };
  },
  mounted: function mounted() {
    this.swiper = new _index2.default(this.$el, this.config);
    this.$emit('swiper', this.getInstance());

    // const bullets = document.querySelectorAll('.swiper-pagination-bullet')
    // console.log(bullets, bullets.length, "swiper bullets")
    // if (!this.showSinglePaginate && bullets.length === 1) {
    //   this.showPaginate = false
    // }
  },

  methods: {
    getInstance: function getInstance() {
      // return this.swiper
      return this['swiper' + this.guid];
    }
  }
}; //
//
//
//
//
//
//
//
//
//

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _create = __webpack_require__(220);

var _create2 = _interopRequireDefault(_create);

var _defineProperties = __webpack_require__(221);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _getOwnPropertyDescriptor = __webpack_require__(222);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Swiper 4.4.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2018 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 19, 2018
 */
!function (e, t) {
    "object" == ( false ? "undefined" : (0, _typeof3.default)(exports)) && "undefined" != typeof module ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e.Swiper = t();
}(undefined, function () {
    "use strict";

    var f = "undefined" == typeof document ? {
        body: {},
        addEventListener: function addEventListener() {},
        removeEventListener: function removeEventListener() {},
        activeElement: {
            blur: function blur() {},
            nodeName: ""
        },
        querySelector: function querySelector() {
            return null;
        },
        querySelectorAll: function querySelectorAll() {
            return [];
        },
        getElementById: function getElementById() {
            return null;
        },
        createEvent: function createEvent() {
            return {
                initEvent: function initEvent() {}
            };
        },
        createElement: function createElement() {
            return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function setAttribute() {},
                getElementsByTagName: function getElementsByTagName() {
                    return [];
                }
            };
        },
        location: {
            hash: ""
        }
    } : document,
        J = "undefined" == typeof window ? {
        document: f,
        navigator: {
            userAgent: ""
        },
        location: {},
        history: {},
        CustomEvent: function CustomEvent() {
            return this;
        },
        addEventListener: function addEventListener() {},
        removeEventListener: function removeEventListener() {},
        getComputedStyle: function getComputedStyle() {
            return {
                getPropertyValue: function getPropertyValue() {
                    return "";
                }
            };
        },
        Image: function Image() {},
        Date: function Date() {},
        screen: {},
        setTimeout: function setTimeout() {},
        clearTimeout: function clearTimeout() {}
    } : window,
        l = function l(e) {
        for (var t = 0; t < e.length; t += 1) {
            this[t] = e[t];
        }return this.length = e.length, this;
    };
    function L(e, t) {
        var a = [],
            i = 0;
        if (e && !t && e instanceof l) return e;
        if (e) if ("string" == typeof e) {
            var s,
                r,
                n = e.trim();
            if (0 <= n.indexOf("<") && 0 <= n.indexOf(">")) {
                var o = "div";
                for (0 === n.indexOf("<li") && (o = "ul"), 0 === n.indexOf("<tr") && (o = "tbody"), 0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"), 0 === n.indexOf("<tbody") && (o = "table"), 0 === n.indexOf("<option") && (o = "select"), (r = f.createElement(o)).innerHTML = n, i = 0; i < r.childNodes.length; i += 1) {
                    a.push(r.childNodes[i]);
                }
            } else for (s = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || f).querySelectorAll(e.trim()) : [f.getElementById(e.trim().split("#")[1])], i = 0; i < s.length; i += 1) {
                s[i] && a.push(s[i]);
            }
        } else if (e.nodeType || e === J || e === f) a.push(e);else if (0 < e.length && e[0].nodeType) for (i = 0; i < e.length; i += 1) {
            a.push(e[i]);
        }return new l(a);
    }
    function r(e) {
        for (var t = [], a = 0; a < e.length; a += 1) {
            -1 === t.indexOf(e[a]) && t.push(e[a]);
        }return t;
    }
    L.fn = l.prototype, L.Class = l, L.Dom7 = l;
    var t = {
        addClass: function addClass(e) {
            if (void 0 === e) return this;
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[a]);
                }
            }return this;
        },
        removeClass: function removeClass(e) {
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[a]);
                }
            }return this;
        },
        hasClass: function hasClass(e) {
            return !!this[0] && this[0].classList.contains(e);
        },
        toggleClass: function toggleClass(e) {
            for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
                for (var i = 0; i < this.length; i += 1) {
                    void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[a]);
                }
            }return this;
        },
        attr: function attr(e, t) {
            var a = arguments;
            if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
            for (var i = 0; i < this.length; i += 1) {
                if (2 === a.length) this[i].setAttribute(e, t);else for (var s in e) {
                    this[i][s] = e[s], this[i].setAttribute(s, e[s]);
                }
            }return this;
        },
        removeAttr: function removeAttr(e) {
            for (var t = 0; t < this.length; t += 1) {
                this[t].removeAttribute(e);
            }return this;
        },
        data: function data(e, t) {
            var a;
            if (void 0 !== t) {
                for (var i = 0; i < this.length; i += 1) {
                    (a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), a.dom7ElementDataStorage[e] = t;
                }return this;
            }
            if (a = this[0]) {
                if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
                var s = a.getAttribute("data-" + e);
                return s || void 0;
            }
        },
        transform: function transform(e) {
            for (var t = 0; t < this.length; t += 1) {
                var a = this[t].style;
                a.webkitTransform = e, a.transform = e;
            }
            return this;
        },
        transition: function transition(e) {
            "string" != typeof e && (e += "ms");
            for (var t = 0; t < this.length; t += 1) {
                var a = this[t].style;
                a.webkitTransitionDuration = e, a.transitionDuration = e;
            }
            return this;
        },
        on: function on() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }var i = t[0],
                r = t[1],
                n = t[2],
                s = t[3];
            function o(e) {
                var t = e.target;
                if (t) {
                    var a = e.target.dom7EventData || [];
                    if (a.indexOf(e) < 0 && a.unshift(e), L(t).is(r)) n.apply(t, a);else for (var i = L(t).parents(), s = 0; s < i.length; s += 1) {
                        L(i[s]).is(r) && n.apply(i[s], a);
                    }
                }
            }
            function l(e) {
                var t = e && e.target && e.target.dom7EventData || [];
                t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
            }
            "function" == typeof t[1] && (i = (e = t)[0], n = e[1], s = e[2], r = void 0), s || (s = !1);
            for (var d, p = i.split(" "), c = 0; c < this.length; c += 1) {
                var u = this[c];
                if (r) for (d = 0; d < p.length; d += 1) {
                    var h = p[d];
                    u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []), u.dom7LiveListeners[h].push({
                        listener: n,
                        proxyListener: o
                    }), u.addEventListener(h, o, s);
                } else for (d = 0; d < p.length; d += 1) {
                    var v = p[d];
                    u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({
                        listener: n,
                        proxyListener: l
                    }), u.addEventListener(v, l, s);
                }
            }
            return this;
        },
        off: function off() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }var i = t[0],
                s = t[1],
                r = t[2],
                n = t[3];
            "function" == typeof t[1] && (i = (e = t)[0], r = e[1], n = e[2], s = void 0), n || (n = !1);
            for (var o = i.split(" "), l = 0; l < o.length; l += 1) {
                for (var d = o[l], p = 0; p < this.length; p += 1) {
                    var c = this[p],
                        u = void 0;
                    if (!s && c.dom7Listeners ? u = c.dom7Listeners[d] : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]), u && u.length) for (var h = u.length - 1; 0 <= h; h -= 1) {
                        var v = u[h];
                        r && v.listener === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r || (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1));
                    }
                }
            }return this;
        },
        trigger: function trigger() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }for (var a = e[0].split(" "), i = e[1], s = 0; s < a.length; s += 1) {
                for (var r = a[s], n = 0; n < this.length; n += 1) {
                    var o = this[n],
                        l = void 0;
                    try {
                        l = new J.CustomEvent(r, {
                            detail: i,
                            bubbles: !0,
                            cancelable: !0
                        });
                    } catch (e) {
                        (l = f.createEvent("Event")).initEvent(r, !0, !0), l.detail = i;
                    }
                    o.dom7EventData = e.filter(function (e, t) {
                        return 0 < t;
                    }), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData;
                }
            }return this;
        },
        transitionEnd: function transitionEnd(t) {
            var a,
                i = ["webkitTransitionEnd", "transitionend"],
                s = this;
            function r(e) {
                if (e.target === this) for (t.call(this, e), a = 0; a < i.length; a += 1) {
                    s.off(i[a], r);
                }
            }
            if (t) for (a = 0; a < i.length; a += 1) {
                s.on(i[a], r);
            }return this;
        },
        outerWidth: function outerWidth(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
                }
                return this[0].offsetWidth;
            }
            return null;
        },
        outerHeight: function outerHeight(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
                }
                return this[0].offsetHeight;
            }
            return null;
        },
        offset: function offset() {
            if (0 < this.length) {
                var e = this[0],
                    t = e.getBoundingClientRect(),
                    a = f.body,
                    i = e.clientTop || a.clientTop || 0,
                    s = e.clientLeft || a.clientLeft || 0,
                    r = e === J ? J.scrollY : e.scrollTop,
                    n = e === J ? J.scrollX : e.scrollLeft;
                return {
                    top: t.top + r - i,
                    left: t.left + n - s
                };
            }
            return null;
        },
        css: function css(e, t) {
            var a;
            if (1 === arguments.length) {
                if ("string" != typeof e) {
                    for (a = 0; a < this.length; a += 1) {
                        for (var i in e) {
                            this[a].style[i] = e[i];
                        }
                    }return this;
                }
                if (this[0]) return J.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 === arguments.length && "string" == typeof e) {
                for (a = 0; a < this.length; a += 1) {
                    this[a].style[e] = t;
                }return this;
            }
            return this;
        },
        each: function each(e) {
            if (!e) return this;
            for (var t = 0; t < this.length; t += 1) {
                if (!1 === e.call(this[t], t, this[t])) return this;
            }return this;
        },
        html: function html(e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for (var t = 0; t < this.length; t += 1) {
                this[t].innerHTML = e;
            }return this;
        },
        text: function text(e) {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1) {
                this[t].textContent = e;
            }return this;
        },
        is: function is(e) {
            var t,
                a,
                i = this[0];
            if (!i || void 0 === e) return !1;
            if ("string" == typeof e) {
                if (i.matches) return i.matches(e);
                if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
                if (i.msMatchesSelector) return i.msMatchesSelector(e);
                for (t = L(e), a = 0; a < t.length; a += 1) {
                    if (t[a] === i) return !0;
                }return !1;
            }
            if (e === f) return i === f;
            if (e === J) return i === J;
            if (e.nodeType || e instanceof l) {
                for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1) {
                    if (t[a] === i) return !0;
                }return !1;
            }
            return !1;
        },
        index: function index() {
            var e,
                t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling);) {
                    1 === t.nodeType && (e += 1);
                }return e;
            }
        },
        eq: function eq(e) {
            if (void 0 === e) return this;
            var t,
                a = this.length;
            return new l(a - 1 < e ? [] : e < 0 ? (t = a + e) < 0 ? [] : [this[t]] : [this[e]]);
        },
        append: function append() {
            for (var e, t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }for (var i = 0; i < t.length; i += 1) {
                e = t[i];
                for (var s = 0; s < this.length; s += 1) {
                    if ("string" == typeof e) {
                        var r = f.createElement("div");
                        for (r.innerHTML = e; r.firstChild;) {
                            this[s].appendChild(r.firstChild);
                        }
                    } else if (e instanceof l) for (var n = 0; n < e.length; n += 1) {
                        this[s].appendChild(e[n]);
                    } else this[s].appendChild(e);
                }
            }
            return this;
        },
        prepend: function prepend(e) {
            var t, a;
            for (t = 0; t < this.length; t += 1) {
                if ("string" == typeof e) {
                    var i = f.createElement("div");
                    for (i.innerHTML = e, a = i.childNodes.length - 1; 0 <= a; a -= 1) {
                        this[t].insertBefore(i.childNodes[a], this[t].childNodes[0]);
                    }
                } else if (e instanceof l) for (a = 0; a < e.length; a += 1) {
                    this[t].insertBefore(e[a], this[t].childNodes[0]);
                } else this[t].insertBefore(e, this[t].childNodes[0]);
            }return this;
        },
        next: function next(e) {
            return 0 < this.length ? e ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(e) ? new l([this[0].nextElementSibling]) : new l([]) : this[0].nextElementSibling ? new l([this[0].nextElementSibling]) : new l([]) : new l([]);
        },
        nextAll: function nextAll(e) {
            var t = [],
                a = this[0];
            if (!a) return new l([]);
            for (; a.nextElementSibling;) {
                var i = a.nextElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        prev: function prev(e) {
            if (0 < this.length) {
                var t = this[0];
                return e ? t.previousElementSibling && L(t.previousElementSibling).is(e) ? new l([t.previousElementSibling]) : new l([]) : t.previousElementSibling ? new l([t.previousElementSibling]) : new l([]);
            }
            return new l([]);
        },
        prevAll: function prevAll(e) {
            var t = [],
                a = this[0];
            if (!a) return new l([]);
            for (; a.previousElementSibling;) {
                var i = a.previousElementSibling;
                e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
            }
            return new l(t);
        },
        parent: function parent(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                null !== this[a].parentNode && (e ? L(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
            }return L(r(t));
        },
        parents: function parents(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].parentNode; i;) {
                    e ? L(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
                }
            }return L(r(t));
        },
        closest: function closest(e) {
            var t = this;
            return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function find(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].querySelectorAll(e), s = 0; s < i.length; s += 1) {
                    t.push(i[s]);
                }
            }return new l(t);
        },
        children: function children(e) {
            for (var t = [], a = 0; a < this.length; a += 1) {
                for (var i = this[a].childNodes, s = 0; s < i.length; s += 1) {
                    e ? 1 === i[s].nodeType && L(i[s]).is(e) && t.push(i[s]) : 1 === i[s].nodeType && t.push(i[s]);
                }
            }return new l(r(t));
        },
        remove: function remove() {
            for (var e = 0; e < this.length; e += 1) {
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            }return this;
        },
        add: function add() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }var a, i;
            for (a = 0; a < e.length; a += 1) {
                var s = L(e[a]);
                for (i = 0; i < s.length; i += 1) {
                    this[this.length] = s[i], this.length += 1;
                }
            }
            return this;
        },
        styles: function styles() {
            return this[0] ? J.getComputedStyle(this[0], null) : {};
        }
    };
    (0, _keys2.default)(t).forEach(function (e) {
        L.fn[e] = t[e];
    });
    var e,
        a,
        i,
        ee = {
        deleteProps: function deleteProps(e) {
            var t = e;
            (0, _keys2.default)(t).forEach(function (e) {
                try {
                    t[e] = null;
                } catch (e) {}
                try {
                    delete t[e];
                } catch (e) {}
            });
        },
        nextTick: function nextTick(e, t) {
            return void 0 === t && (t = 0), setTimeout(e, t);
        },
        now: function now() {
            return Date.now();
        },
        getTranslate: function getTranslate(e, t) {
            var a, i, s;
            void 0 === t && (t = "x");
            var r = J.getComputedStyle(e, null);
            return J.WebKitCSSMatrix ? (6 < (i = r.transform || r.webkitTransform).split(",").length && (i = i.split(", ").map(function (e) {
                return e.replace(",", ".");
            }).join(", ")), s = new J.WebKitCSSMatrix("none" === i ? "" : i)) : a = (s = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (i = J.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), "y" === t && (i = J.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
        },
        parseUrlQuery: function parseUrlQuery(e) {
            var t,
                a,
                i,
                s,
                r = {},
                n = e || J.location.href;
            if ("string" == typeof n && n.length) for (s = (a = (n = -1 < n.indexOf("?") ? n.replace(/\S*\?/, "") : "").split("&").filter(function (e) {
                return "" !== e;
            })).length, t = 0; t < s; t += 1) {
                i = a[t].replace(/#\S+/g, "").split("="), r[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "";
            }return r;
        },
        isObject: function isObject(e) {
            return "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && null !== e && e.constructor && e.constructor === Object;
        },
        extend: function extend() {
            for (var e = [], t = arguments.length; t--;) {
                e[t] = arguments[t];
            }for (var a = Object(e[0]), i = 1; i < e.length; i += 1) {
                var s = e[i];
                if (null != s) for (var r = (0, _keys2.default)(Object(s)), n = 0, o = r.length; n < o; n += 1) {
                    var l = r[n],
                        d = (0, _getOwnPropertyDescriptor2.default)(s, l);
                    void 0 !== d && d.enumerable && (ee.isObject(a[l]) && ee.isObject(s[l]) ? ee.extend(a[l], s[l]) : !ee.isObject(a[l]) && ee.isObject(s[l]) ? (a[l] = {}, ee.extend(a[l], s[l])) : a[l] = s[l]);
                }
            }
            return a;
        }
    },
        te = (i = f.createElement("div"), {
        touch: J.Modernizr && !0 === J.Modernizr.touch || !!(0 < J.navigator.maxTouchPoints || "ontouchstart" in J || J.DocumentTouch && f instanceof J.DocumentTouch),
        pointerEvents: !!(J.navigator.pointerEnabled || J.PointerEvent || "maxTouchPoints" in J.navigator),
        prefixedPointerEvents: !!J.navigator.msPointerEnabled,
        transition: (a = i.style, "transition" in a || "webkitTransition" in a || "MozTransition" in a),
        transforms3d: J.Modernizr && !0 === J.Modernizr.csstransforms3d || (e = i.style, "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e),
        flexbox: function () {
            for (var e = i.style, t = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), a = 0; a < t.length; a += 1) {
                if (t[a] in e) return !0;
            }return !1;
        }(),
        observer: "MutationObserver" in J || "WebkitMutationObserver" in J,
        passiveListener: function () {
            var e = !1;
            try {
                var t = Object.defineProperty({}, "passive", {
                    get: function get() {
                        e = !0;
                    }
                });
                J.addEventListener("testPassiveListener", null, t);
            } catch (e) {}
            return e;
        }(),
        gestures: "ongesturestart" in J
    }),
        s = function s(e) {
        void 0 === e && (e = {});
        var t = this;
        t.params = e, t.eventsListeners = {}, t.params && t.params.on && (0, _keys2.default)(t.params.on).forEach(function (e) {
            t.on(e, t.params.on[e]);
        });
    },
        n = {
        components: {
            configurable: !0
        }
    };
    s.prototype.on = function (e, t, a) {
        var i = this;
        if ("function" != typeof t) return i;
        var s = a ? "unshift" : "push";
        return e.split(" ").forEach(function (e) {
            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
        }), i;
    }, s.prototype.once = function (i, s, e) {
        var r = this;
        if ("function" != typeof s) return r;
        return r.on(i, function e() {
            for (var t = [], a = arguments.length; a--;) {
                t[a] = arguments[a];
            }s.apply(r, t), r.off(i, e);
        }, e);
    }, s.prototype.off = function (e, i) {
        var s = this;
        return s.eventsListeners && e.split(" ").forEach(function (a) {
            void 0 === i ? s.eventsListeners[a] = [] : s.eventsListeners[a] && s.eventsListeners[a].length && s.eventsListeners[a].forEach(function (e, t) {
                e === i && s.eventsListeners[a].splice(t, 1);
            });
        }), s;
    }, s.prototype.emit = function () {
        for (var e = [], t = arguments.length; t--;) {
            e[t] = arguments[t];
        }var a,
            i,
            s,
            r = this;
        return r.eventsListeners && ("string" == typeof e[0] || Array.isArray(e[0]) ? (a = e[0], i = e.slice(1, e.length), s = r) : (a = e[0].events, i = e[0].data, s = e[0].context || r), (Array.isArray(a) ? a : a.split(" ")).forEach(function (e) {
            if (r.eventsListeners && r.eventsListeners[e]) {
                var t = [];
                r.eventsListeners[e].forEach(function (e) {
                    t.push(e);
                }), t.forEach(function (e) {
                    e.apply(s, i);
                });
            }
        })), r;
    }, s.prototype.useModulesParams = function (a) {
        var i = this;
        i.modules && (0, _keys2.default)(i.modules).forEach(function (e) {
            var t = i.modules[e];
            t.params && ee.extend(a, t.params);
        });
    }, s.prototype.useModules = function (i) {
        void 0 === i && (i = {});
        var s = this;
        s.modules && (0, _keys2.default)(s.modules).forEach(function (e) {
            var a = s.modules[e],
                t = i[e] || {};
            a.instance && (0, _keys2.default)(a.instance).forEach(function (e) {
                var t = a.instance[e];
                s[e] = "function" == typeof t ? t.bind(s) : t;
            }), a.on && s.on && (0, _keys2.default)(a.on).forEach(function (e) {
                s.on(e, a.on[e]);
            }), a.create && a.create.bind(s)(t);
        });
    }, n.components.set = function (e) {
        this.use && this.use(e);
    }, s.installModule = function (t) {
        for (var e = [], a = arguments.length - 1; 0 < a--;) {
            e[a] = arguments[a + 1];
        }var i = this;
        i.prototype.modules || (i.prototype.modules = {});
        var s = t.name || (0, _keys2.default)(i.prototype.modules).length + "_" + ee.now();
        return (i.prototype.modules[s] = t).proto && (0, _keys2.default)(t.proto).forEach(function (e) {
            i.prototype[e] = t.proto[e];
        }), t.static && (0, _keys2.default)(t.static).forEach(function (e) {
            i[e] = t.static[e];
        }), t.install && t.install.apply(i, e), i;
    }, s.use = function (e) {
        for (var t = [], a = arguments.length - 1; 0 < a--;) {
            t[a] = arguments[a + 1];
        }var i = this;
        return Array.isArray(e) ? (e.forEach(function (e) {
            return i.installModule(e);
        }), i) : i.installModule.apply(i, [e].concat(t));
    }, (0, _defineProperties2.default)(s, n);
    var o = {
        updateSize: function updateSize() {
            var e,
                t,
                a = this,
                i = a.$el;
            e = void 0 !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), t = t - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), ee.extend(a, {
                width: e,
                height: t,
                size: a.isHorizontal() ? e : t
            }));
        },
        updateSlides: function updateSlides() {
            var e = this,
                t = e.params,
                a = e.$wrapperEl,
                i = e.size,
                s = e.rtlTranslate,
                r = e.wrongRTL,
                n = e.virtual && t.virtual.enabled,
                o = n ? e.virtual.slides.length : e.slides.length,
                l = a.children("." + e.params.slideClass),
                d = n ? e.virtual.slides.length : l.length,
                p = [],
                c = [],
                u = [],
                h = t.slidesOffsetBefore;
            "function" == typeof h && (h = t.slidesOffsetBefore.call(e));
            var v = t.slidesOffsetAfter;
            "function" == typeof v && (v = t.slidesOffsetAfter.call(e));
            var f = e.snapGrid.length,
                m = e.snapGrid.length,
                g = t.spaceBetween,
                b = -h,
                w = 0,
                y = 0;
            if (void 0 !== i) {
                var x, T;
                "string" == typeof g && 0 <= g.indexOf("%") && (g = parseFloat(g.replace("%", "")) / 100 * i), e.virtualSize = -g, s ? l.css({
                    marginLeft: "",
                    marginTop: ""
                }) : l.css({
                    marginRight: "",
                    marginBottom: ""
                }), 1 < t.slidesPerColumn && (x = Math.floor(d / t.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
                for (var E, S = t.slidesPerColumn, C = x / S, M = Math.floor(d / t.slidesPerColumn), k = 0; k < d; k += 1) {
                    T = 0;
                    var P = l.eq(k);
                    if (1 < t.slidesPerColumn) {
                        var z = void 0,
                            $ = void 0,
                            L = void 0;
                        "column" === t.slidesPerColumnFill ? (L = k - ($ = Math.floor(k / S)) * S, (M < $ || $ === M && L === S - 1) && S <= (L += 1) && (L = 0, $ += 1), z = $ + L * x / S, P.css({
                            "-webkit-box-ordinal-group": z,
                            "-moz-box-ordinal-group": z,
                            "-ms-flex-order": z,
                            "-webkit-order": z,
                            order: z
                        })) : $ = k - (L = Math.floor(k / C)) * C, P.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== L && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", $).attr("data-swiper-row", L);
                    }
                    if ("none" !== P.css("display")) {
                        if ("auto" === t.slidesPerView) {
                            var I = J.getComputedStyle(P[0], null),
                                D = P[0].style.transform,
                                O = P[0].style.webkitTransform;
                            if (D && (P[0].style.transform = "none"), O && (P[0].style.webkitTransform = "none"), t.roundLengths) T = e.isHorizontal() ? P.outerWidth(!0) : P.outerHeight(!0);else if (e.isHorizontal()) {
                                var A = parseFloat(I.getPropertyValue("width")),
                                    N = parseFloat(I.getPropertyValue("padding-left")),
                                    H = parseFloat(I.getPropertyValue("padding-right")),
                                    G = parseFloat(I.getPropertyValue("margin-left")),
                                    B = parseFloat(I.getPropertyValue("margin-right")),
                                    X = I.getPropertyValue("box-sizing");
                                T = X && "border-box" === X ? A + G + B : A + N + H + G + B;
                            } else {
                                var Y = parseFloat(I.getPropertyValue("height")),
                                    V = parseFloat(I.getPropertyValue("padding-top")),
                                    F = parseFloat(I.getPropertyValue("padding-bottom")),
                                    R = parseFloat(I.getPropertyValue("margin-top")),
                                    q = parseFloat(I.getPropertyValue("margin-bottom")),
                                    W = I.getPropertyValue("box-sizing");
                                T = W && "border-box" === W ? Y + R + q : Y + V + F + R + q;
                            }
                            D && (P[0].style.transform = D), O && (P[0].style.webkitTransform = O), t.roundLengths && (T = Math.floor(T));
                        } else T = (i - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), l[k] && (e.isHorizontal() ? l[k].style.width = T + "px" : l[k].style.height = T + "px");
                        l[k] && (l[k].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + g, 0 === w && 0 !== k && (b = b - i / 2 - g), 0 === k && (b = b - i / 2 - g), Math.abs(b) < .001 && (b = 0), t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b)) : (t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b), b = b + T + g), e.virtualSize += T + g, w = T, y += 1;
                    }
                }
                if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && r && ("slide" === t.effect || "coverflow" === t.effect) && a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }), te.flexbox && !t.setWrapperSize || (e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + "px"
                })), 1 < t.slidesPerColumn && (e.virtualSize = (T + t.spaceBetween) * x, e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween, e.isHorizontal() ? a.css({
                    width: e.virtualSize + t.spaceBetween + "px"
                }) : a.css({
                    height: e.virtualSize + t.spaceBetween + "px"
                }), t.centeredSlides)) {
                    E = [];
                    for (var j = 0; j < p.length; j += 1) {
                        var U = p[j];
                        t.roundLengths && (U = Math.floor(U)), p[j] < e.virtualSize + p[0] && E.push(U);
                    }
                    p = E;
                }
                if (!t.centeredSlides) {
                    E = [];
                    for (var K = 0; K < p.length; K += 1) {
                        var _ = p[K];
                        t.roundLengths && (_ = Math.floor(_)), p[K] <= e.virtualSize - i && E.push(_);
                    }
                    p = E, 1 < Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) && p.push(e.virtualSize - i);
                }
                if (0 === p.length && (p = [0]), 0 !== t.spaceBetween && (e.isHorizontal() ? s ? l.css({
                    marginLeft: g + "px"
                }) : l.css({
                    marginRight: g + "px"
                }) : l.css({
                    marginBottom: g + "px"
                })), t.centerInsufficientSlides) {
                    var Z = 0;
                    if (u.forEach(function (e) {
                        Z += e + (t.spaceBetween ? t.spaceBetween : 0);
                    }), (Z -= t.spaceBetween) < i) {
                        var Q = (i - Z) / 2;
                        p.forEach(function (e, t) {
                            p[t] = e - Q;
                        }), c.forEach(function (e, t) {
                            c[t] = e + Q;
                        });
                    }
                }
                ee.extend(e, {
                    slides: l,
                    snapGrid: p,
                    slidesGrid: c,
                    slidesSizesGrid: u
                }), d !== o && e.emit("slidesLengthChange"), p.length !== f && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), c.length !== m && e.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
            }
        },
        updateAutoHeight: function updateAutoHeight(e) {
            var t,
                a = this,
                i = [],
                s = 0;
            if ("number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed), "auto" !== a.params.slidesPerView && 1 < a.params.slidesPerView) for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
                var r = a.activeIndex + t;
                if (r > a.slides.length) break;
                i.push(a.slides.eq(r)[0]);
            } else i.push(a.slides.eq(a.activeIndex)[0]);
            for (t = 0; t < i.length; t += 1) {
                if (void 0 !== i[t]) {
                    var n = i[t].offsetHeight;
                    s = s < n ? n : s;
                }
            }s && a.$wrapperEl.css("height", s + "px");
        },
        updateSlidesOffset: function updateSlidesOffset() {
            for (var e = this.slides, t = 0; t < e.length; t += 1) {
                e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
            }
        },
        updateSlidesProgress: function updateSlidesProgress(e) {
            void 0 === e && (e = this && this.translate || 0);
            var t = this,
                a = t.params,
                i = t.slides,
                s = t.rtlTranslate;
            if (0 !== i.length) {
                void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                var r = -e;
                s && (r = e), i.removeClass(a.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
                for (var n = 0; n < i.length; n += 1) {
                    var o = i[n],
                        l = (r + (a.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + a.spaceBetween);
                    if (a.watchSlidesVisibility) {
                        var d = -(r - o.swiperSlideOffset),
                            p = d + t.slidesSizesGrid[n];
                        (0 <= d && d < t.size || 0 < p && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(n), i.eq(n).addClass(a.slideVisibleClass));
                    }
                    o.progress = s ? -l : l;
                }
                t.visibleSlides = L(t.visibleSlides);
            }
        },
        updateProgress: function updateProgress(e) {
            void 0 === e && (e = this && this.translate || 0);
            var t = this,
                a = t.params,
                i = t.maxTranslate() - t.minTranslate(),
                s = t.progress,
                r = t.isBeginning,
                n = t.isEnd,
                o = r,
                l = n;
            0 === i ? n = r = !(s = 0) : (r = (s = (e - t.minTranslate()) / i) <= 0, n = 1 <= s), ee.extend(t, {
                progress: s,
                isBeginning: r,
                isEnd: n
            }), (a.watchSlidesProgress || a.watchSlidesVisibility) && t.updateSlidesProgress(e), r && !o && t.emit("reachBeginning toEdge"), n && !l && t.emit("reachEnd toEdge"), (o && !r || l && !n) && t.emit("fromEdge"), t.emit("progress", s);
        },
        updateSlidesClasses: function updateSlidesClasses() {
            var e,
                t = this,
                a = t.slides,
                i = t.params,
                s = t.$wrapperEl,
                r = t.activeIndex,
                n = t.realIndex,
                o = t.virtual && i.virtual.enabled;
            a.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (e = o ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
            var l = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
            i.loop && 0 === l.length && (l = a.eq(0)).addClass(i.slideNextClass);
            var d = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
            i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass));
        },
        updateActiveIndex: function updateActiveIndex(e) {
            var t,
                a = this,
                i = a.rtlTranslate ? a.translate : -a.translate,
                s = a.slidesGrid,
                r = a.snapGrid,
                n = a.params,
                o = a.activeIndex,
                l = a.realIndex,
                d = a.snapIndex,
                p = e;
            if (void 0 === p) {
                for (var c = 0; c < s.length; c += 1) {
                    void 0 !== s[c + 1] ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2 ? p = c : i >= s[c] && i < s[c + 1] && (p = c + 1) : i >= s[c] && (p = c);
                }n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
            }
            if ((t = 0 <= r.indexOf(i) ? r.indexOf(i) : Math.floor(p / n.slidesPerGroup)) >= r.length && (t = r.length - 1), p !== o) {
                var u = parseInt(a.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
                ee.extend(a, {
                    snapIndex: t,
                    realIndex: u,
                    previousIndex: o,
                    activeIndex: p
                }), a.emit("activeIndexChange"), a.emit("snapIndexChange"), l !== u && a.emit("realIndexChange"), a.emit("slideChange");
            } else t !== d && (a.snapIndex = t, a.emit("snapIndexChange"));
        },
        updateClickedSlide: function updateClickedSlide(e) {
            var t = this,
                a = t.params,
                i = L(e.target).closest("." + a.slideClass)[0],
                s = !1;
            if (i) for (var r = 0; r < t.slides.length; r += 1) {
                t.slides[r] === i && (s = !0);
            }if (!i || !s) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
            t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10) : t.clickedIndex = L(i).index(), a.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
        }
    };
    var d = {
        getTranslate: function getTranslate(e) {
            void 0 === e && (e = this.isHorizontal() ? "x" : "y");
            var t = this.params,
                a = this.rtlTranslate,
                i = this.translate,
                s = this.$wrapperEl;
            if (t.virtualTranslate) return a ? -i : i;
            var r = ee.getTranslate(s[0], e);
            return a && (r = -r), r || 0;
        },
        setTranslate: function setTranslate(e, t) {
            var a = this,
                i = a.rtlTranslate,
                s = a.params,
                r = a.$wrapperEl,
                n = a.progress,
                o = 0,
                l = 0;
            a.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.virtualTranslate || (te.transforms3d ? r.transform("translate3d(" + o + "px, " + l + "px, 0px)") : r.transform("translate(" + o + "px, " + l + "px)")), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : l;
            var d = a.maxTranslate() - a.minTranslate();
            (0 === d ? 0 : (e - a.minTranslate()) / d) !== n && a.updateProgress(e), a.emit("setTranslate", a.translate, t);
        },
        minTranslate: function minTranslate() {
            return -this.snapGrid[0];
        },
        maxTranslate: function maxTranslate() {
            return -this.snapGrid[this.snapGrid.length - 1];
        }
    };
    var p = {
        setTransition: function setTransition(e, t) {
            this.$wrapperEl.transition(e), this.emit("setTransition", e, t);
        },
        transitionStart: function transitionStart(e, t) {
            void 0 === e && (e = !0);
            var a = this,
                i = a.activeIndex,
                s = a.params,
                r = a.previousIndex;
            s.autoHeight && a.updateAutoHeight();
            var n = t;
            if (n || (n = r < i ? "next" : i < r ? "prev" : "reset"), a.emit("transitionStart"), e && i !== r) {
                if ("reset" === n) return void a.emit("slideResetTransitionStart");
                a.emit("slideChangeTransitionStart"), "next" === n ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart");
            }
        },
        transitionEnd: function transitionEnd(e, t) {
            void 0 === e && (e = !0);
            var a = this,
                i = a.activeIndex,
                s = a.previousIndex;
            a.animating = !1, a.setTransition(0);
            var r = t;
            if (r || (r = s < i ? "next" : i < s ? "prev" : "reset"), a.emit("transitionEnd"), e && i !== s) {
                if ("reset" === r) return void a.emit("slideResetTransitionEnd");
                a.emit("slideChangeTransitionEnd"), "next" === r ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd");
            }
        }
    };
    var c = {
        slideTo: function slideTo(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = this,
                r = e;
            r < 0 && (r = 0);
            var n = s.params,
                o = s.snapGrid,
                l = s.slidesGrid,
                d = s.previousIndex,
                p = s.activeIndex,
                c = s.rtlTranslate;
            if (s.animating && n.preventInteractionOnTransition) return !1;
            var u = Math.floor(r / n.slidesPerGroup);
            u >= o.length && (u = o.length - 1), (p || n.initialSlide || 0) === (d || 0) && a && s.emit("beforeSlideChangeStart");
            var h,
                v = -o[u];
            if (s.updateProgress(v), n.normalizeSlideIndex) for (var f = 0; f < l.length; f += 1) {
                -Math.floor(100 * v) >= Math.floor(100 * l[f]) && (r = f);
            }if (s.initialized && r !== p) {
                if (!s.allowSlideNext && v < s.translate && v < s.minTranslate()) return !1;
                if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (p || 0) !== r) return !1;
            }
            return h = p < r ? "next" : r < p ? "prev" : "reset", c && -v === s.translate || !c && v === s.translate ? (s.updateActiveIndex(r), n.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== n.effect && s.setTranslate(v), "reset" !== h && (s.transitionStart(a, h), s.transitionEnd(a, h)), !1) : (0 !== t && te.transition ? (s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function (e) {
                s && !s.destroyed && e.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(a, h));
            }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.transitionEnd(a, h)), !0);
        },
        slideToLoop: function slideToLoop(e, t, a, i) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
            var s = e;
            return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, a, i);
        },
        slideNext: function slideNext(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.params,
                r = i.animating;
            return s.loop ? !r && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)) : i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a);
        },
        slidePrev: function slidePrev(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.params,
                r = i.animating,
                n = i.snapGrid,
                o = i.slidesGrid,
                l = i.rtlTranslate;
            if (s.loop) {
                if (r) return !1;
                i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
            }
            function d(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var p,
                c = d(l ? i.translate : -i.translate),
                u = n.map(function (e) {
                return d(e);
            }),
                h = (o.map(function (e) {
                return d(e);
            }), n[u.indexOf(c)], n[u.indexOf(c) - 1]);
            return void 0 !== h && (p = o.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a);
        },
        slideReset: function slideReset(e, t, a) {
            return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a);
        },
        slideToClosest: function slideToClosest(e, t, a) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var i = this,
                s = i.activeIndex,
                r = Math.floor(s / i.params.slidesPerGroup);
            if (r < i.snapGrid.length - 1) {
                var n = i.rtlTranslate ? i.translate : -i.translate,
                    o = i.snapGrid[r];
                (i.snapGrid[r + 1] - o) / 2 < n - o && (s = i.params.slidesPerGroup);
            }
            return i.slideTo(s, e, t, a);
        },
        slideToClickedSlide: function slideToClickedSlide() {
            var e,
                t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = "auto" === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView,
                r = t.clickedIndex;
            if (a.loop) {
                if (t.animating) return;
                e = parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
                    t.slideTo(r);
                })) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
                    t.slideTo(r);
                })) : t.slideTo(r);
            } else t.slideTo(r);
        }
    };
    var u = {
        loopCreate: function loopCreate() {
            var i = this,
                e = i.params,
                t = i.$wrapperEl;
            t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove();
            var s = t.children("." + e.slideClass);
            if (e.loopFillGroupWithBlank) {
                var a = e.slidesPerGroup - s.length % e.slidesPerGroup;
                if (a !== e.slidesPerGroup) {
                    for (var r = 0; r < a; r += 1) {
                        var n = L(f.createElement("div")).addClass(e.slideClass + " " + e.slideBlankClass);
                        t.append(n);
                    }
                    s = t.children("." + e.slideClass);
                }
            }
            "auto" !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), i.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), i.loopedSlides += e.loopAdditionalSlides, i.loopedSlides > s.length && (i.loopedSlides = s.length);
            var o = [],
                l = [];
            s.each(function (e, t) {
                var a = L(t);
                e < i.loopedSlides && l.push(t), e < s.length && e >= s.length - i.loopedSlides && o.push(t), a.attr("data-swiper-slide-index", e);
            });
            for (var d = 0; d < l.length; d += 1) {
                t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
            }for (var p = o.length - 1; 0 <= p; p -= 1) {
                t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass));
            }
        },
        loopFix: function loopFix() {
            var e,
                t = this,
                a = t.params,
                i = t.activeIndex,
                s = t.slides,
                r = t.loopedSlides,
                n = t.allowSlidePrev,
                o = t.allowSlideNext,
                l = t.snapGrid,
                d = t.rtlTranslate;
            t.allowSlidePrev = !0, t.allowSlideNext = !0;
            var p = -l[i] - t.getTranslate();
            i < r ? (e = s.length - 3 * r + i, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p)) : ("auto" === a.slidesPerView && 2 * r <= i || i >= s.length - r) && (e = -s.length + i + r, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p));
            t.allowSlidePrev = n, t.allowSlideNext = o;
        },
        loopDestroy: function loopDestroy() {
            var e = this.$wrapperEl,
                t = this.params,
                a = this.slides;
            e.children("." + t.slideClass + "." + t.slideDuplicateClass + ",." + t.slideClass + "." + t.slideBlankClass).remove(), a.removeAttr("data-swiper-slide-index");
        }
    };
    var h = {
        setGrabCursor: function setGrabCursor(e) {
            if (!(te.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)) {
                var t = this.el;
                t.style.cursor = "move", t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", t.style.cursor = e ? "-moz-grabbin" : "-moz-grab", t.style.cursor = e ? "grabbing" : "grab";
            }
        },
        unsetGrabCursor: function unsetGrabCursor() {
            te.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "");
        }
    };
    var v = {
        appendSlide: function appendSlide(e) {
            var t = this,
                a = t.$wrapperEl,
                i = t.params;
            if (i.loop && t.loopDestroy(), "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) for (var s = 0; s < e.length; s += 1) {
                e[s] && a.append(e[s]);
            } else a.append(e);
            i.loop && t.loopCreate(), i.observer && te.observer || t.update();
        },
        prependSlide: function prependSlide(e) {
            var t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = t.activeIndex;
            a.loop && t.loopDestroy();
            var r = s + 1;
            if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) {
                for (var n = 0; n < e.length; n += 1) {
                    e[n] && i.prepend(e[n]);
                }r = s + e.length;
            } else i.prepend(e);
            a.loop && t.loopCreate(), a.observer && te.observer || t.update(), t.slideTo(r, 0, !1);
        },
        addSlide: function addSlide(e, t) {
            var a = this,
                i = a.$wrapperEl,
                s = a.params,
                r = a.activeIndex;
            s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children("." + s.slideClass));
            var n = a.slides.length;
            if (e <= 0) a.prependSlide(t);else if (n <= e) a.appendSlide(t);else {
                for (var o = e < r ? r + 1 : r, l = [], d = n - 1; e <= d; d -= 1) {
                    var p = a.slides.eq(d);
                    p.remove(), l.unshift(p);
                }
                if ("object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && "length" in t) {
                    for (var c = 0; c < t.length; c += 1) {
                        t[c] && i.append(t[c]);
                    }o = e < r ? r + t.length : r;
                } else i.append(t);
                for (var u = 0; u < l.length; u += 1) {
                    i.append(l[u]);
                }s.loop && a.loopCreate(), s.observer && te.observer || a.update(), s.loop ? a.slideTo(o + a.loopedSlides, 0, !1) : a.slideTo(o, 0, !1);
            }
        },
        removeSlide: function removeSlide(e) {
            var t = this,
                a = t.params,
                i = t.$wrapperEl,
                s = t.activeIndex;
            a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children("." + a.slideClass));
            var r,
                n = s;
            if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && "length" in e) {
                for (var o = 0; o < e.length; o += 1) {
                    r = e[o], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
                }n = Math.max(n, 0);
            } else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);
            a.loop && t.loopCreate(), a.observer && te.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
        },
        removeAllSlides: function removeAllSlides() {
            for (var e = [], t = 0; t < this.slides.length; t += 1) {
                e.push(t);
            }this.removeSlide(e);
        }
    },
        m = function () {
        var e = J.navigator.userAgent,
            t = {
            ios: !1,
            android: !1,
            androidChrome: !1,
            desktop: !1,
            windows: !1,
            iphone: !1,
            ipod: !1,
            ipad: !1,
            cordova: J.cordova || J.phonegap,
            phonegap: J.cordova || J.phonegap
        },
            a = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
            i = e.match(/(Android);?[\s\/]+([\d.]+)?/),
            s = e.match(/(iPad).*OS\s([\d_]+)/),
            r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
            n = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
        if (a && (t.os = "windows", t.osVersion = a[2], t.windows = !0), i && !a && (t.os = "android", t.osVersion = i[2], t.android = !0, t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome")), (s || n || r) && (t.os = "ios", t.ios = !0), n && !r && (t.osVersion = n[2].replace(/_/g, "."), t.iphone = !0), s && (t.osVersion = s[2].replace(/_/g, "."), t.ipad = !0), r && (t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, t.iphone = !0), t.ios && t.osVersion && 0 <= e.indexOf("Version/") && "10" === t.osVersion.split(".")[0] && (t.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]), t.desktop = !(t.os || t.android || t.webView), t.webView = (n || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i), t.os && "ios" === t.os) {
            var o = t.osVersion.split("."),
                l = f.querySelector('meta[name="viewport"]');
            t.minimalUi = !t.webView && (r || n) && (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) && l && 0 <= l.getAttribute("content").indexOf("minimal-ui");
        }
        return t.pixelRatio = J.devicePixelRatio || 1, t;
    }();
    function g() {
        var e = this,
            t = e.params,
            a = e.el;
        if (!a || 0 !== a.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var i = e.allowSlideNext,
                s = e.allowSlidePrev,
                r = e.snapGrid;
            if (e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), t.freeMode) {
                var n = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight && e.updateAutoHeight();
            } else e.updateSlidesClasses(), ("auto" === t.slidesPerView || 1 < t.slidesPerView) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
            e.allowSlidePrev = s, e.allowSlideNext = i, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
        }
    }
    var b = {
        attachEvents: function attachEvents() {
            var e = this,
                t = e.params,
                a = e.touchEvents,
                i = e.el,
                s = e.wrapperEl;
            e.onTouchStart = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches;
                if (!t.animating || !i.preventInteractionOnTransition) {
                    var r = e;
                    if (r.originalEvent && (r = r.originalEvent), a.isTouchEvent = "touchstart" === r.type, (a.isTouchEvent || !("which" in r) || 3 !== r.which) && !(!a.isTouchEvent && "button" in r && 0 < r.button || a.isTouched && a.isMoved)) if (i.noSwiping && L(r.target).closest(i.noSwipingSelector ? i.noSwipingSelector : "." + i.noSwipingClass)[0]) t.allowClick = !0;else if (!i.swipeHandler || L(r).closest(i.swipeHandler)[0]) {
                        s.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, s.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
                        var n = s.currentX,
                            o = s.currentY,
                            l = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
                            d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
                        if (!l || !(n <= d || n >= J.screen.width - d)) {
                            if (ee.extend(a, {
                                isTouched: !0,
                                isMoved: !1,
                                allowTouchCallbacks: !0,
                                isScrolling: void 0,
                                startMoving: void 0
                            }), s.startX = n, s.startY = o, a.touchStartTime = ee.now(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, 0 < i.threshold && (a.allowThresholdMove = !1), "touchstart" !== r.type) {
                                var p = !0;
                                L(r.target).is(a.formElements) && (p = !1), f.activeElement && L(f.activeElement).is(a.formElements) && f.activeElement !== r.target && f.activeElement.blur();
                                var c = p && t.allowTouchMove && i.touchStartPreventDefault;
                                (i.touchStartForcePreventDefault || c) && r.preventDefault();
                            }
                            t.emit("touchStart", r);
                        }
                    }
                }
            }.bind(e), e.onTouchMove = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches,
                    r = t.rtlTranslate,
                    n = e;
                if (n.originalEvent && (n = n.originalEvent), a.isTouched) {
                    if (!a.isTouchEvent || "mousemove" !== n.type) {
                        var o = "touchmove" === n.type ? n.targetTouches[0].pageX : n.pageX,
                            l = "touchmove" === n.type ? n.targetTouches[0].pageY : n.pageY;
                        if (n.preventedByNestedSwiper) return s.startX = o, void (s.startY = l);
                        if (!t.allowTouchMove) return t.allowClick = !1, void (a.isTouched && (ee.extend(s, {
                            startX: o,
                            startY: l,
                            currentX: o,
                            currentY: l
                        }), a.touchStartTime = ee.now()));
                        if (a.isTouchEvent && i.touchReleaseOnEdges && !i.loop) if (t.isVertical()) {
                            if (l < s.startY && t.translate <= t.maxTranslate() || l > s.startY && t.translate >= t.minTranslate()) return a.isTouched = !1, void (a.isMoved = !1);
                        } else if (o < s.startX && t.translate <= t.maxTranslate() || o > s.startX && t.translate >= t.minTranslate()) return;
                        if (a.isTouchEvent && f.activeElement && n.target === f.activeElement && L(n.target).is(a.formElements)) return a.isMoved = !0, void (t.allowClick = !1);
                        if (a.allowTouchCallbacks && t.emit("touchMove", n), !(n.targetTouches && 1 < n.targetTouches.length)) {
                            s.currentX = o, s.currentY = l;
                            var d,
                                p = s.currentX - s.startX,
                                c = s.currentY - s.startY;
                            if (!(t.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(c, 2)) < t.params.threshold)) if (void 0 === a.isScrolling && (t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? a.isScrolling = !1 : 25 <= p * p + c * c && (d = 180 * Math.atan2(Math.abs(c), Math.abs(p)) / Math.PI, a.isScrolling = t.isHorizontal() ? d > i.touchAngle : 90 - d > i.touchAngle)), a.isScrolling && t.emit("touchMoveOpposite", n), void 0 === a.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;else if (a.startMoving) {
                                t.allowClick = !1, n.preventDefault(), i.touchMoveStopPropagation && !i.nested && n.stopPropagation(), a.isMoved || (i.loop && t.loopFix(), a.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), a.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit("sliderFirstMove", n)), t.emit("sliderMove", n), a.isMoved = !0;
                                var u = t.isHorizontal() ? p : c;
                                s.diff = u, u *= i.touchRatio, r && (u = -u), t.swipeDirection = 0 < u ? "prev" : "next", a.currentTranslate = u + a.startTranslate;
                                var h = !0,
                                    v = i.resistanceRatio;
                                if (i.touchReleaseOnEdges && (v = 0), 0 < u && a.currentTranslate > t.minTranslate() ? (h = !1, i.resistance && (a.currentTranslate = t.minTranslate() - 1 + Math.pow(-t.minTranslate() + a.startTranslate + u, v))) : u < 0 && a.currentTranslate < t.maxTranslate() && (h = !1, i.resistance && (a.currentTranslate = t.maxTranslate() + 1 - Math.pow(t.maxTranslate() - a.startTranslate - u, v))), h && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && "next" === t.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !t.allowSlidePrev && "prev" === t.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), 0 < i.threshold) {
                                    if (!(Math.abs(u) > i.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
                                    if (!a.allowThresholdMove) return a.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, a.currentTranslate = a.startTranslate, void (s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY);
                                }
                                i.followFinger && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()), i.freeMode && (0 === a.velocities.length && a.velocities.push({
                                    position: s[t.isHorizontal() ? "startX" : "startY"],
                                    time: a.touchStartTime
                                }), a.velocities.push({
                                    position: s[t.isHorizontal() ? "currentX" : "currentY"],
                                    time: ee.now()
                                })), t.updateProgress(a.currentTranslate), t.setTranslate(a.currentTranslate));
                            }
                        }
                    }
                } else a.startMoving && a.isScrolling && t.emit("touchMoveOpposite", n);
            }.bind(e), e.onTouchEnd = function (e) {
                var t = this,
                    a = t.touchEventsData,
                    i = t.params,
                    s = t.touches,
                    r = t.rtlTranslate,
                    n = t.$wrapperEl,
                    o = t.slidesGrid,
                    l = t.snapGrid,
                    d = e;
                if (d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && t.emit("touchEnd", d), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
                i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
                var p,
                    c = ee.now(),
                    u = c - a.touchStartTime;
                if (t.allowClick && (t.updateClickedSlide(d), t.emit("tap", d), u < 300 && 300 < c - a.lastClickTime && (a.clickTimeout && clearTimeout(a.clickTimeout), a.clickTimeout = ee.nextTick(function () {
                    t && !t.destroyed && t.emit("click", d);
                }, 300)), u < 300 && c - a.lastClickTime < 300 && (a.clickTimeout && clearTimeout(a.clickTimeout), t.emit("doubleTap", d))), a.lastClickTime = ee.now(), ee.nextTick(function () {
                    t.destroyed || (t.allowClick = !0);
                }), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);
                if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, i.freeMode) {
                    if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
                    if (p > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
                    if (i.freeModeMomentum) {
                        if (1 < a.velocities.length) {
                            var h = a.velocities.pop(),
                                v = a.velocities.pop(),
                                f = h.position - v.position,
                                m = h.time - v.time;
                            t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (150 < m || 300 < ee.now() - h.time) && (t.velocity = 0);
                        } else t.velocity = 0;
                        t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;
                        var g = 1e3 * i.freeModeMomentumRatio,
                            b = t.velocity * g,
                            w = t.translate + b;
                        r && (w = -w);
                        var y,
                            x,
                            T = !1,
                            E = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
                        if (w < t.maxTranslate()) i.freeModeMomentumBounce ? (w + t.maxTranslate() < -E && (w = t.maxTranslate() - E), y = t.maxTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.maxTranslate(), i.loop && i.centeredSlides && (x = !0);else if (w > t.minTranslate()) i.freeModeMomentumBounce ? (w - t.minTranslate() > E && (w = t.minTranslate() + E), y = t.minTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.minTranslate(), i.loop && i.centeredSlides && (x = !0);else if (i.freeModeSticky) {
                            for (var S, C = 0; C < l.length; C += 1) {
                                if (l[C] > -w) {
                                    S = C;
                                    break;
                                }
                            }w = -(w = Math.abs(l[S] - w) < Math.abs(l[S - 1] - w) || "next" === t.swipeDirection ? l[S] : l[S - 1]);
                        }
                        if (x && t.once("transitionEnd", function () {
                            t.loopFix();
                        }), 0 !== t.velocity) g = r ? Math.abs((-w - t.translate) / t.velocity) : Math.abs((w - t.translate) / t.velocity);else if (i.freeModeSticky) return void t.slideToClosest();
                        i.freeModeMomentumBounce && T ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function () {
                            t && !t.destroyed && a.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(i.speed), t.setTranslate(y), n.transitionEnd(function () {
                                t && !t.destroyed && t.transitionEnd();
                            }));
                        })) : t.velocity ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function () {
                            t && !t.destroyed && t.transitionEnd();
                        }))) : t.updateProgress(w), t.updateActiveIndex(), t.updateSlidesClasses();
                    } else if (i.freeModeSticky) return void t.slideToClosest();
                    (!i.freeModeMomentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                } else {
                    for (var M = 0, k = t.slidesSizesGrid[0], P = 0; P < o.length; P += i.slidesPerGroup) {
                        void 0 !== o[P + i.slidesPerGroup] ? p >= o[P] && p < o[P + i.slidesPerGroup] && (k = o[(M = P) + i.slidesPerGroup] - o[P]) : p >= o[P] && (M = P, k = o[o.length - 1] - o[o.length - 2]);
                    }var z = (p - o[M]) / k;
                    if (u > i.longSwipesMs) {
                        if (!i.longSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && (z >= i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M)), "prev" === t.swipeDirection && (z > 1 - i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M));
                    } else {
                        if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
                        "next" === t.swipeDirection && t.slideTo(M + i.slidesPerGroup), "prev" === t.swipeDirection && t.slideTo(M);
                    }
                }
            }.bind(e), e.onClick = function (e) {
                this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
            }.bind(e);
            var r = "container" === t.touchEventsTarget ? i : s,
                n = !!t.nested;
            if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
                if (te.touch) {
                    var o = !("touchstart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    r.addEventListener(a.start, e.onTouchStart, o), r.addEventListener(a.move, e.onTouchMove, te.passiveListener ? {
                        passive: !1,
                        capture: n
                    } : n), r.addEventListener(a.end, e.onTouchEnd, o);
                }
                (t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !te.touch && m.ios) && (r.addEventListener("mousedown", e.onTouchStart, !1), f.addEventListener("mousemove", e.onTouchMove, n), f.addEventListener("mouseup", e.onTouchEnd, !1));
            } else r.addEventListener(a.start, e.onTouchStart, !1), f.addEventListener(a.move, e.onTouchMove, n), f.addEventListener(a.end, e.onTouchEnd, !1);
            (t.preventClicks || t.preventClicksPropagation) && r.addEventListener("click", e.onClick, !0), e.on(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g, !0);
        },
        detachEvents: function detachEvents() {
            var e = this,
                t = e.params,
                a = e.touchEvents,
                i = e.el,
                s = e.wrapperEl,
                r = "container" === t.touchEventsTarget ? i : s,
                n = !!t.nested;
            if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
                if (te.touch) {
                    var o = !("onTouchStart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
                        passive: !0,
                        capture: !1
                    };
                    r.removeEventListener(a.start, e.onTouchStart, o), r.removeEventListener(a.move, e.onTouchMove, n), r.removeEventListener(a.end, e.onTouchEnd, o);
                }
                (t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !te.touch && m.ios) && (r.removeEventListener("mousedown", e.onTouchStart, !1), f.removeEventListener("mousemove", e.onTouchMove, n), f.removeEventListener("mouseup", e.onTouchEnd, !1));
            } else r.removeEventListener(a.start, e.onTouchStart, !1), f.removeEventListener(a.move, e.onTouchMove, n), f.removeEventListener(a.end, e.onTouchEnd, !1);
            (t.preventClicks || t.preventClicksPropagation) && r.removeEventListener("click", e.onClick, !0), e.off(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g);
        }
    };
    var w,
        y = {
        setBreakpoint: function setBreakpoint() {
            var e = this,
                t = e.activeIndex,
                a = e.initialized,
                i = e.loopedSlides;
            void 0 === i && (i = 0);
            var s = e.params,
                r = s.breakpoints;
            if (r && (!r || 0 !== (0, _keys2.default)(r).length)) {
                var n = e.getBreakpoint(r);
                if (n && e.currentBreakpoint !== n) {
                    var o = n in r ? r[n] : void 0;
                    o && ["slidesPerView", "spaceBetween", "slidesPerGroup"].forEach(function (e) {
                        var t = o[e];
                        void 0 !== t && (o[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto");
                    });
                    var l = o || e.originalParams,
                        d = s.loop && l.slidesPerView !== s.slidesPerView;
                    ee.extend(e.params, l), ee.extend(e, {
                        allowTouchMove: e.params.allowTouchMove,
                        allowSlideNext: e.params.allowSlideNext,
                        allowSlidePrev: e.params.allowSlidePrev
                    }), e.currentBreakpoint = n, d && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", l);
                }
            }
        },
        getBreakpoint: function getBreakpoint(e) {
            if (e) {
                var t = !1,
                    a = [];
                (0, _keys2.default)(e).forEach(function (e) {
                    a.push(e);
                }), a.sort(function (e, t) {
                    return parseInt(e, 10) - parseInt(t, 10);
                });
                for (var i = 0; i < a.length; i += 1) {
                    var s = a[i];
                    this.params.breakpointsInverse ? s <= J.innerWidth && (t = s) : s >= J.innerWidth && !t && (t = s);
                }
                return t || "max";
            }
        }
    },
        I = {
        isIE: !!J.navigator.userAgent.match(/Trident/g) || !!J.navigator.userAgent.match(/MSIE/g),
        isEdge: !!J.navigator.userAgent.match(/Edge/g),
        isSafari: (w = J.navigator.userAgent.toLowerCase(), 0 <= w.indexOf("safari") && w.indexOf("chrome") < 0 && w.indexOf("android") < 0),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(J.navigator.userAgent)
    };
    var x = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        preventInteractionOnTransition: !1,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: .02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsInverse: !1,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        centeredSlides: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: .5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !0,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: .85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0
    },
        T = {
        update: o,
        translate: d,
        transition: p,
        slide: c,
        loop: u,
        grabCursor: h,
        manipulation: v,
        events: b,
        breakpoints: y,
        checkOverflow: {
            checkOverflow: function checkOverflow() {
                var e = this,
                    t = e.isLocked;
                e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), t && t !== e.isLocked && (e.isEnd = !1, e.navigation.update());
            }
        },
        classes: {
            addClasses: function addClasses() {
                var t = this.classNames,
                    a = this.params,
                    e = this.rtl,
                    i = this.$el,
                    s = [];
                s.push(a.direction), a.freeMode && s.push("free-mode"), te.flexbox || s.push("no-flexbox"), a.autoHeight && s.push("autoheight"), e && s.push("rtl"), 1 < a.slidesPerColumn && s.push("multirow"), m.android && s.push("android"), m.ios && s.push("ios"), (I.isIE || I.isEdge) && (te.pointerEvents || te.prefixedPointerEvents) && s.push("wp8-" + a.direction), s.forEach(function (e) {
                    t.push(a.containerModifierClass + e);
                }), i.addClass(t.join(" "));
            },
            removeClasses: function removeClasses() {
                var e = this.$el,
                    t = this.classNames;
                e.removeClass(t.join(" "));
            }
        },
        images: {
            loadImage: function loadImage(e, t, a, i, s, r) {
                var n;
                function o() {
                    r && r();
                }
                e.complete && s ? o() : t ? ((n = new J.Image()).onload = o, n.onerror = o, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : o();
            },
            preloadImages: function preloadImages() {
                var e = this;
                function t() {
                    null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
                }
                e.imagesToLoad = e.$el.find("img");
                for (var a = 0; a < e.imagesToLoad.length; a += 1) {
                    var i = e.imagesToLoad[a];
                    e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
                }
            }
        }
    },
        E = {},
        S = function (u) {
        function h() {
            for (var e, t, s, a = [], i = arguments.length; i--;) {
                a[i] = arguments[i];
            }1 === a.length && a[0].constructor && a[0].constructor === Object ? s = a[0] : (t = (e = a)[0], s = e[1]), s || (s = {}), s = ee.extend({}, s), t && !s.el && (s.el = t), u.call(this, s), (0, _keys2.default)(T).forEach(function (t) {
                (0, _keys2.default)(T[t]).forEach(function (e) {
                    h.prototype[e] || (h.prototype[e] = T[t][e]);
                });
            });
            var r = this;
            void 0 === r.modules && (r.modules = {}), (0, _keys2.default)(r.modules).forEach(function (e) {
                var t = r.modules[e];
                if (t.params) {
                    var a = (0, _keys2.default)(t.params)[0],
                        i = t.params[a];
                    if ("object" != (typeof i === "undefined" ? "undefined" : (0, _typeof3.default)(i)) || null === i) return;
                    if (!(a in s && "enabled" in i)) return;
                    !0 === s[a] && (s[a] = {
                        enabled: !0
                    }), "object" != (0, _typeof3.default)(s[a]) || "enabled" in s[a] || (s[a].enabled = !0), s[a] || (s[a] = {
                        enabled: !1
                    });
                }
            });
            var n = ee.extend({}, x);
            r.useModulesParams(n), r.params = ee.extend({}, n, E, s), r.originalParams = ee.extend({}, r.params), r.passedParams = ee.extend({}, s);
            var o = (r.$ = L)(r.params.el);
            if (t = o[0]) {
                if (1 < o.length) {
                    var l = [];
                    return o.each(function (e, t) {
                        var a = ee.extend({}, s, {
                            el: t
                        });
                        l.push(new h(a));
                    }), l;
                }
                t.swiper = r, o.data("swiper", r);
                var d,
                    p,
                    c = o.children("." + r.params.wrapperClass);
                return ee.extend(r, {
                    $el: o,
                    el: t,
                    $wrapperEl: c,
                    wrapperEl: c[0],
                    classNames: [],
                    slides: L(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: function isHorizontal() {
                        return "horizontal" === r.params.direction;
                    },
                    isVertical: function isVertical() {
                        return "vertical" === r.params.direction;
                    },
                    rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
                    rtlTranslate: "horizontal" === r.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
                    wrongRTL: "-webkit-box" === c.css("display"),
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEvents: (d = ["touchstart", "touchmove", "touchend"], p = ["mousedown", "mousemove", "mouseup"], te.pointerEvents ? p = ["pointerdown", "pointermove", "pointerup"] : te.prefixedPointerEvents && (p = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), r.touchEventsTouch = {
                        start: d[0],
                        move: d[1],
                        end: d[2]
                    }, r.touchEventsDesktop = {
                        start: p[0],
                        move: p[1],
                        end: p[2]
                    }, te.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop),
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        formElements: "input, select, option, textarea, button, video",
                        lastClickTime: ee.now(),
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        isTouchEvent: void 0,
                        startMoving: void 0
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), r.useModules(), r.params.init && r.init(), r;
            }
        }
        u && (h.__proto__ = u);
        var e = {
            extendedDefaults: {
                configurable: !0
            },
            defaults: {
                configurable: !0
            },
            Class: {
                configurable: !0
            },
            $: {
                configurable: !0
            }
        };
        return ((h.prototype = (0, _create2.default)(u && u.prototype)).constructor = h).prototype.slidesPerViewDynamic = function () {
            var e = this,
                t = e.params,
                a = e.slides,
                i = e.slidesGrid,
                s = e.size,
                r = e.activeIndex,
                n = 1;
            if (t.centeredSlides) {
                for (var o, l = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1) {
                    a[d] && !o && (n += 1, s < (l += a[d].swiperSlideSize) && (o = !0));
                }for (var p = r - 1; 0 <= p; p -= 1) {
                    a[p] && !o && (n += 1, s < (l += a[p].swiperSlideSize) && (o = !0));
                }
            } else for (var c = r + 1; c < a.length; c += 1) {
                i[c] - i[r] < s && (n += 1);
            }return n;
        }, h.prototype.update = function () {
            var a = this;
            if (a && !a.destroyed) {
                var e = a.snapGrid,
                    t = a.params;
                t.breakpoints && a.setBreakpoint(), a.updateSize(), a.updateSlides(), a.updateProgress(), a.updateSlidesClasses(), a.params.freeMode ? (i(), a.params.autoHeight && a.updateAutoHeight()) : (("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0)) || i(), t.watchOverflow && e !== a.snapGrid && a.checkOverflow(), a.emit("update");
            }
            function i() {
                var e = a.rtlTranslate ? -1 * a.translate : a.translate,
                    t = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
                a.setTranslate(t), a.updateActiveIndex(), a.updateSlidesClasses();
            }
        }, h.prototype.init = function () {
            var e = this;
            e.initialized || (e.emit("beforeInit"), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit), e.attachEvents(), e.initialized = !0, e.emit("init"));
        }, h.prototype.destroy = function (e, t) {
            void 0 === e && (e = !0), void 0 === t && (t = !0);
            var a = this,
                i = a.params,
                s = a.$el,
                r = a.$wrapperEl,
                n = a.slides;
            return void 0 === a.params || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), i.loop && a.loopDestroy(), t && (a.removeClasses(), s.removeAttr("style"), r.removeAttr("style"), n && n.length && n.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), a.emit("destroy"), (0, _keys2.default)(a.eventsListeners).forEach(function (e) {
                a.off(e);
            }), !1 !== e && (a.$el[0].swiper = null, a.$el.data("swiper", null), ee.deleteProps(a)), a.destroyed = !0), null;
        }, h.extendDefaults = function (e) {
            ee.extend(E, e);
        }, e.extendedDefaults.get = function () {
            return E;
        }, e.defaults.get = function () {
            return x;
        }, e.Class.get = function () {
            return u;
        }, e.$.get = function () {
            return L;
        }, (0, _defineProperties2.default)(h, e), h;
    }(s),
        C = {
        name: "device",
        proto: {
            device: m
        },
        static: {
            device: m
        }
    },
        M = {
        name: "support",
        proto: {
            support: te
        },
        static: {
            support: te
        }
    },
        k = {
        name: "browser",
        proto: {
            browser: I
        },
        static: {
            browser: I
        }
    },
        P = {
        name: "resize",
        create: function create() {
            var e = this;
            ee.extend(e, {
                resize: {
                    resizeHandler: function resizeHandler() {
                        e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
                    },
                    orientationChangeHandler: function orientationChangeHandler() {
                        e && !e.destroyed && e.initialized && e.emit("orientationchange");
                    }
                }
            });
        },
        on: {
            init: function init() {
                J.addEventListener("resize", this.resize.resizeHandler), J.addEventListener("orientationchange", this.resize.orientationChangeHandler);
            },
            destroy: function destroy() {
                J.removeEventListener("resize", this.resize.resizeHandler), J.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
            }
        }
    },
        z = {
        func: J.MutationObserver || J.WebkitMutationObserver,
        attach: function attach(e, t) {
            void 0 === t && (t = {});
            var a = this,
                i = new z.func(function (e) {
                if (1 !== e.length) {
                    var t = function t() {
                        a.emit("observerUpdate", e[0]);
                    };
                    J.requestAnimationFrame ? J.requestAnimationFrame(t) : J.setTimeout(t, 0);
                } else a.emit("observerUpdate", e[0]);
            });
            i.observe(e, {
                attributes: void 0 === t.attributes || t.attributes,
                childList: void 0 === t.childList || t.childList,
                characterData: void 0 === t.characterData || t.characterData
            }), a.observer.observers.push(i);
        },
        init: function init() {
            var e = this;
            if (te.observer && e.params.observer) {
                if (e.params.observeParents) for (var t = e.$el.parents(), a = 0; a < t.length; a += 1) {
                    e.observer.attach(t[a]);
                }e.observer.attach(e.$el[0], {
                    childList: e.params.observeSlideChildren
                }), e.observer.attach(e.$wrapperEl[0], {
                    attributes: !1
                });
            }
        },
        destroy: function destroy() {
            this.observer.observers.forEach(function (e) {
                e.disconnect();
            }), this.observer.observers = [];
        }
    },
        $ = {
        name: "observer",
        params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1
        },
        create: function create() {
            ee.extend(this, {
                observer: {
                    init: z.init.bind(this),
                    attach: z.attach.bind(this),
                    destroy: z.destroy.bind(this),
                    observers: []
                }
            });
        },
        on: {
            init: function init() {
                this.observer.init();
            },
            destroy: function destroy() {
                this.observer.destroy();
            }
        }
    },
        D = {
        update: function update(e) {
            var t = this,
                a = t.params,
                i = a.slidesPerView,
                s = a.slidesPerGroup,
                r = a.centeredSlides,
                n = t.params.virtual,
                o = n.addSlidesBefore,
                l = n.addSlidesAfter,
                d = t.virtual,
                p = d.from,
                c = d.to,
                u = d.slides,
                h = d.slidesGrid,
                v = d.renderSlide,
                f = d.offset;
            t.updateActiveIndex();
            var m,
                g,
                b,
                w = t.activeIndex || 0;
            m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", r ? (g = Math.floor(i / 2) + s + o, b = Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o, b = s + l);
            var y = Math.max((w || 0) - b, 0),
                x = Math.min((w || 0) + g, u.length - 1),
                T = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);
            function E() {
                t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
            }
            if (ee.extend(t.virtual, {
                from: y,
                to: x,
                offset: T,
                slidesGrid: t.slidesGrid
            }), p === y && c === x && !e) return t.slidesGrid !== h && T !== f && t.slides.css(m, T + "px"), void t.updateProgress();
            if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
                offset: T,
                from: y,
                to: x,
                slides: function () {
                    for (var e = [], t = y; t <= x; t += 1) {
                        e.push(u[t]);
                    }return e;
                }()
            }), void E();
            var S = [],
                C = [];
            if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();else for (var M = p; M <= c; M += 1) {
                (M < y || x < M) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + M + '"]').remove();
            }for (var k = 0; k < u.length; k += 1) {
                y <= k && k <= x && (void 0 === c || e ? C.push(k) : (c < k && C.push(k), k < p && S.push(k)));
            }C.forEach(function (e) {
                t.$wrapperEl.append(v(u[e], e));
            }), S.sort(function (e, t) {
                return t - e;
            }).forEach(function (e) {
                t.$wrapperEl.prepend(v(u[e], e));
            }), t.$wrapperEl.children(".swiper-slide").css(m, T + "px"), E();
        },
        renderSlide: function renderSlide(e, t) {
            var a = this,
                i = a.params.virtual;
            if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
            var s = i.renderSlide ? L(i.renderSlide.call(a, e, t)) : L('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>");
            return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t), i.cache && (a.virtual.cache[t] = s), s;
        },
        appendSlide: function appendSlide(e) {
            this.virtual.slides.push(e), this.virtual.update(!0);
        },
        prependSlide: function prependSlide(e) {
            var t = this;
            if (t.virtual.slides.unshift(e), t.params.virtual.cache) {
                var a = t.virtual.cache,
                    i = {};
                (0, _keys2.default)(a).forEach(function (e) {
                    i[e + 1] = a[e];
                }), t.virtual.cache = i;
            }
            t.virtual.update(!0), t.slideNext(0);
        }
    },
        O = {
        name: "virtual",
        params: {
            virtual: {
                enabled: !1,
                slides: [],
                cache: !0,
                renderSlide: null,
                renderExternal: null,
                addSlidesBefore: 0,
                addSlidesAfter: 0
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                virtual: {
                    update: D.update.bind(e),
                    appendSlide: D.appendSlide.bind(e),
                    prependSlide: D.prependSlide.bind(e),
                    renderSlide: D.renderSlide.bind(e),
                    slides: e.params.virtual.slides,
                    cache: {}
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if (e.params.virtual.enabled) {
                    e.classNames.push(e.params.containerModifierClass + "virtual");
                    var t = {
                        watchSlidesProgress: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
                }
            },
            setTranslate: function setTranslate() {
                this.params.virtual.enabled && this.virtual.update();
            }
        }
    },
        A = {
        handle: function handle(e) {
            var t = this,
                a = t.rtlTranslate,
                i = e;
            i.originalEvent && (i = i.originalEvent);
            var s = i.keyCode || i.charCode;
            if (!t.allowSlideNext && (t.isHorizontal() && 39 === s || t.isVertical() && 40 === s)) return !1;
            if (!t.allowSlidePrev && (t.isHorizontal() && 37 === s || t.isVertical() && 38 === s)) return !1;
            if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || f.activeElement && f.activeElement.nodeName && ("input" === f.activeElement.nodeName.toLowerCase() || "textarea" === f.activeElement.nodeName.toLowerCase()))) {
                if (t.params.keyboard.onlyInViewport && (37 === s || 39 === s || 38 === s || 40 === s)) {
                    var r = !1;
                    if (0 < t.$el.parents("." + t.params.slideClass).length && 0 === t.$el.parents("." + t.params.slideActiveClass).length) return;
                    var n = J.innerWidth,
                        o = J.innerHeight,
                        l = t.$el.offset();
                    a && (l.left -= t.$el[0].scrollLeft);
                    for (var d = [[l.left, l.top], [l.left + t.width, l.top], [l.left, l.top + t.height], [l.left + t.width, l.top + t.height]], p = 0; p < d.length; p += 1) {
                        var c = d[p];
                        0 <= c[0] && c[0] <= n && 0 <= c[1] && c[1] <= o && (r = !0);
                    }
                    if (!r) return;
                }
                t.isHorizontal() ? (37 !== s && 39 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), (39 === s && !a || 37 === s && a) && t.slideNext(), (37 === s && !a || 39 === s && a) && t.slidePrev()) : (38 !== s && 40 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), 40 === s && t.slideNext(), 38 === s && t.slidePrev()), t.emit("keyPress", s);
            }
        },
        enable: function enable() {
            this.keyboard.enabled || (L(f).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0);
        },
        disable: function disable() {
            this.keyboard.enabled && (L(f).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1);
        }
    },
        N = {
        name: "keyboard",
        params: {
            keyboard: {
                enabled: !1,
                onlyInViewport: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                keyboard: {
                    enabled: !1,
                    enable: A.enable.bind(this),
                    disable: A.disable.bind(this),
                    handle: A.handle.bind(this)
                }
            });
        },
        on: {
            init: function init() {
                this.params.keyboard.enabled && this.keyboard.enable();
            },
            destroy: function destroy() {
                this.keyboard.enabled && this.keyboard.disable();
            }
        }
    };
    var H = {
        lastScrollTime: ee.now(),
        event: -1 < J.navigator.userAgent.indexOf("firefox") ? "DOMMouseScroll" : function () {
            var e = "onwheel",
                t = e in f;
            if (!t) {
                var a = f.createElement("div");
                a.setAttribute(e, "return;"), t = "function" == typeof a[e];
            }
            return !t && f.implementation && f.implementation.hasFeature && !0 !== f.implementation.hasFeature("", "") && (t = f.implementation.hasFeature("Events.wheel", "3.0")), t;
        }() ? "wheel" : "mousewheel",
        normalize: function normalize(e) {
            var t = 0,
                a = 0,
                i = 0,
                s = 0;
            return "detail" in e && (a = e.detail), "wheelDelta" in e && (a = -e.wheelDelta / 120), "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, "deltaY" in e && (s = e.deltaY), "deltaX" in e && (i = e.deltaX), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
                spinX: t,
                spinY: a,
                pixelX: i,
                pixelY: s
            };
        },
        handleMouseEnter: function handleMouseEnter() {
            this.mouseEntered = !0;
        },
        handleMouseLeave: function handleMouseLeave() {
            this.mouseEntered = !1;
        },
        handle: function handle(e) {
            var t = e,
                a = this,
                i = a.params.mousewheel;
            if (!a.mouseEntered && !i.releaseOnEdges) return !0;
            t.originalEvent && (t = t.originalEvent);
            var s = 0,
                r = a.rtlTranslate ? -1 : 1,
                n = H.normalize(t);
            if (i.forceToAxis) {
                if (a.isHorizontal()) {
                    if (!(Math.abs(n.pixelX) > Math.abs(n.pixelY))) return !0;
                    s = n.pixelX * r;
                } else {
                    if (!(Math.abs(n.pixelY) > Math.abs(n.pixelX))) return !0;
                    s = n.pixelY;
                }
            } else s = Math.abs(n.pixelX) > Math.abs(n.pixelY) ? -n.pixelX * r : -n.pixelY;
            if (0 === s) return !0;
            if (i.invert && (s = -s), a.params.freeMode) {
                a.params.loop && a.loopFix();
                var o = a.getTranslate() + s * i.sensitivity,
                    l = a.isBeginning,
                    d = a.isEnd;
                if (o >= a.minTranslate() && (o = a.minTranslate()), o <= a.maxTranslate() && (o = a.maxTranslate()), a.setTransition(0), a.setTranslate(o), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!l && a.isBeginning || !d && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = ee.nextTick(function () {
                    a.slideToClosest();
                }, 300)), a.emit("scroll", t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), o === a.minTranslate() || o === a.maxTranslate()) return !0;
            } else {
                if (60 < ee.now() - a.mousewheel.lastScrollTime) if (s < 0) {
                    if (a.isEnd && !a.params.loop || a.animating) {
                        if (i.releaseOnEdges) return !0;
                    } else a.slideNext(), a.emit("scroll", t);
                } else if (a.isBeginning && !a.params.loop || a.animating) {
                    if (i.releaseOnEdges) return !0;
                } else a.slidePrev(), a.emit("scroll", t);
                a.mousewheel.lastScrollTime = new J.Date().getTime();
            }
            return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
        },
        enable: function enable() {
            var e = this;
            if (!H.event) return !1;
            if (e.mousewheel.enabled) return !1;
            var t = e.$el;
            return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.on("mouseenter", e.mousewheel.handleMouseEnter), t.on("mouseleave", e.mousewheel.handleMouseLeave), t.on(H.event, e.mousewheel.handle), e.mousewheel.enabled = !0;
        },
        disable: function disable() {
            var e = this;
            if (!H.event) return !1;
            if (!e.mousewheel.enabled) return !1;
            var t = e.$el;
            return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.off(H.event, e.mousewheel.handle), !(e.mousewheel.enabled = !1);
        }
    },
        G = {
        update: function update() {
            var e = this,
                t = e.params.navigation;
            if (!e.params.loop) {
                var a = e.navigation,
                    i = a.$nextEl,
                    s = a.$prevEl;
                s && 0 < s.length && (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && 0 < i.length && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
            }
        },
        onPrevClick: function onPrevClick(e) {
            e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev();
        },
        onNextClick: function onNextClick(e) {
            e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext();
        },
        init: function init() {
            var e,
                t,
                a = this,
                i = a.params.navigation;
            (i.nextEl || i.prevEl) && (i.nextEl && (e = L(i.nextEl), a.params.uniqueNavElements && "string" == typeof i.nextEl && 1 < e.length && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = L(i.prevEl), a.params.uniqueNavElements && "string" == typeof i.prevEl && 1 < t.length && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && 0 < e.length && e.on("click", a.navigation.onNextClick), t && 0 < t.length && t.on("click", a.navigation.onPrevClick), ee.extend(a.navigation, {
                $nextEl: e,
                nextEl: e && e[0],
                $prevEl: t,
                prevEl: t && t[0]
            }));
        },
        destroy: function destroy() {
            var e = this,
                t = e.navigation,
                a = t.$nextEl,
                i = t.$prevEl;
            a && a.length && (a.off("click", e.navigation.onNextClick), a.removeClass(e.params.navigation.disabledClass)), i && i.length && (i.off("click", e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
        }
    },
        B = {
        update: function update() {
            var e = this,
                t = e.rtl,
                s = e.params.pagination;
            if (s.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var r,
                    a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el,
                    n = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
                if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > a - 1 - 2 * e.loopedSlides && (r -= a - 2 * e.loopedSlides), n - 1 < r && (r -= n), r < 0 && "bullets" !== e.params.paginationType && (r = n + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === s.type && e.pagination.bullets && 0 < e.pagination.bullets.length) {
                    var o,
                        l,
                        d,
                        p = e.pagination.bullets;
                    if (s.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), i.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (s.dynamicMainBullets + 4) + "px"), 1 < s.dynamicMainBullets && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > s.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = s.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), o = r - e.pagination.dynamicBulletIndex, d = ((l = o + (Math.min(p.length, s.dynamicMainBullets) - 1)) + o) / 2), p.removeClass(s.bulletActiveClass + " " + s.bulletActiveClass + "-next " + s.bulletActiveClass + "-next-next " + s.bulletActiveClass + "-prev " + s.bulletActiveClass + "-prev-prev " + s.bulletActiveClass + "-main"), 1 < i.length) p.each(function (e, t) {
                        var a = L(t),
                            i = a.index();
                        i === r && a.addClass(s.bulletActiveClass), s.dynamicBullets && (o <= i && i <= l && a.addClass(s.bulletActiveClass + "-main"), i === o && a.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), i === l && a.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next"));
                    });else if (p.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets) {
                        for (var c = p.eq(o), u = p.eq(l), h = o; h <= l; h += 1) {
                            p.eq(h).addClass(s.bulletActiveClass + "-main");
                        }c.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), u.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next");
                    }
                    if (s.dynamicBullets) {
                        var v = Math.min(p.length, s.dynamicMainBullets + 4),
                            f = (e.pagination.bulletSize * v - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize,
                            m = t ? "right" : "left";
                        p.css(e.isHorizontal() ? m : "top", f + "px");
                    }
                }
                if ("fraction" === s.type && (i.find("." + s.currentClass).text(s.formatFractionCurrent(r + 1)), i.find("." + s.totalClass).text(s.formatFractionTotal(n))), "progressbar" === s.type) {
                    var g;
                    g = s.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                    var b = (r + 1) / n,
                        w = 1,
                        y = 1;
                    "horizontal" === g ? w = b : y = b, i.find("." + s.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + w + ") scaleY(" + y + ")").transition(e.params.speed);
                }
                "custom" === s.type && s.renderCustom ? (i.html(s.renderCustom(e, r + 1, n)), e.emit("paginationRender", e, i[0])) : e.emit("paginationUpdate", e, i[0]), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](s.lockClass);
            }
        },
        render: function render() {
            var e = this,
                t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                    i = e.pagination.$el,
                    s = "";
                if ("bullets" === t.type) {
                    for (var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, n = 0; n < r; n += 1) {
                        t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                    }i.html(s), e.pagination.bullets = i.find("." + t.bulletClass);
                }
                "fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
            }
        },
        init: function init() {
            var a = this,
                e = a.params.pagination;
            if (e.el) {
                var t = L(e.el);
                0 !== t.length && (a.params.uniqueNavElements && "string" == typeof e.el && 1 < t.length && 1 === a.$el.find(e.el).length && (t = a.$el.find(e.el)), "bullets" === e.type && e.clickable && t.addClass(e.clickableClass), t.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (t.addClass("" + e.modifierClass + e.type + "-dynamic"), a.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && t.addClass(e.progressbarOppositeClass), e.clickable && t.on("click", "." + e.bulletClass, function (e) {
                    e.preventDefault();
                    var t = L(this).index() * a.params.slidesPerGroup;
                    a.params.loop && (t += a.loopedSlides), a.slideTo(t);
                }), ee.extend(a.pagination, {
                    $el: t,
                    el: t[0]
                }));
            }
        },
        destroy: function destroy() {
            var e = this,
                t = e.params.pagination;
            if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
                var a = e.pagination.$el;
                a.removeClass(t.hiddenClass), a.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && a.off("click", "." + t.bulletClass);
            }
        }
    },
        X = {
        setTranslate: function setTranslate() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.rtlTranslate,
                    i = e.progress,
                    s = t.dragSize,
                    r = t.trackSize,
                    n = t.$dragEl,
                    o = t.$el,
                    l = e.params.scrollbar,
                    d = s,
                    p = (r - s) * i;
                a ? 0 < (p = -p) ? (d = s - p, p = 0) : r < -p + s && (d = r + p) : p < 0 ? (d = s + p, p = 0) : r < p + s && (d = r - p), e.isHorizontal() ? (te.transforms3d ? n.transform("translate3d(" + p + "px, 0, 0)") : n.transform("translateX(" + p + "px)"), n[0].style.width = d + "px") : (te.transforms3d ? n.transform("translate3d(0px, " + p + "px, 0)") : n.transform("translateY(" + p + "px)"), n[0].style.height = d + "px"), l.hide && (clearTimeout(e.scrollbar.timeout), o[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function () {
                    o[0].style.opacity = 0, o.transition(400);
                }, 1e3));
            }
        },
        setTransition: function setTransition(e) {
            this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
        },
        updateSize: function updateSize() {
            var e = this;
            if (e.params.scrollbar.el && e.scrollbar.el) {
                var t = e.scrollbar,
                    a = t.$dragEl,
                    i = t.$el;
                a[0].style.width = "", a[0].style.height = "";
                var s,
                    r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
                    n = e.size / e.virtualSize,
                    o = n * (r / e.size);
                s = "auto" === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? a[0].style.width = s + "px" : a[0].style.height = s + "px", i[0].style.display = 1 <= n ? "none" : "", e.params.scrollbarHide && (i[0].style.opacity = 0), ee.extend(t, {
                    trackSize: r,
                    divider: n,
                    moveDivider: o,
                    dragSize: s
                }), t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
            }
        },
        setDragPosition: function setDragPosition(e) {
            var t,
                a = this,
                i = a.scrollbar,
                s = a.rtlTranslate,
                r = i.$el,
                n = i.dragSize,
                o = i.trackSize;
            t = ((a.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY) - r.offset()[a.isHorizontal() ? "left" : "top"] - n / 2) / (o - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
            var l = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
            a.updateProgress(l), a.setTranslate(l), a.updateActiveIndex(), a.updateSlidesClasses();
        },
        onDragStart: function onDragStart(e) {
            var t = this,
                a = t.params.scrollbar,
                i = t.scrollbar,
                s = t.$wrapperEl,
                r = i.$el,
                n = i.$dragEl;
            t.scrollbar.isTouched = !0, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css("opacity", 1), t.emit("scrollbarDragStart", e);
        },
        onDragMove: function onDragMove(e) {
            var t = this.scrollbar,
                a = this.$wrapperEl,
                i = t.$el,
                s = t.$dragEl;
            this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), a.transition(0), i.transition(0), s.transition(0), this.emit("scrollbarDragMove", e));
        },
        onDragEnd: function onDragEnd(e) {
            var t = this,
                a = t.params.scrollbar,
                i = t.scrollbar.$el;
            t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = ee.nextTick(function () {
                i.css("opacity", 0), i.transition(400);
            }, 1e3)), t.emit("scrollbarDragEnd", e), a.snapOnRelease && t.slideToClosest());
        },
        enableDraggable: function enableDraggable() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.touchEventsTouch,
                    i = e.touchEventsDesktop,
                    s = e.params,
                    r = t.$el[0],
                    n = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                },
                    o = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.touch ? (r.addEventListener(a.start, e.scrollbar.onDragStart, n), r.addEventListener(a.move, e.scrollbar.onDragMove, n), r.addEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.addEventListener(i.start, e.scrollbar.onDragStart, n), f.addEventListener(i.move, e.scrollbar.onDragMove, n), f.addEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        disableDraggable: function disableDraggable() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.touchEventsTouch,
                    i = e.touchEventsDesktop,
                    s = e.params,
                    r = t.$el[0],
                    n = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !1,
                    capture: !1
                },
                    o = !(!te.passiveListener || !s.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.touch ? (r.removeEventListener(a.start, e.scrollbar.onDragStart, n), r.removeEventListener(a.move, e.scrollbar.onDragMove, n), r.removeEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.removeEventListener(i.start, e.scrollbar.onDragStart, n), f.removeEventListener(i.move, e.scrollbar.onDragMove, n), f.removeEventListener(i.end, e.scrollbar.onDragEnd, o));
            }
        },
        init: function init() {
            var e = this;
            if (e.params.scrollbar.el) {
                var t = e.scrollbar,
                    a = e.$el,
                    i = e.params.scrollbar,
                    s = L(i.el);
                e.params.uniqueNavElements && "string" == typeof i.el && 1 < s.length && 1 === a.find(i.el).length && (s = a.find(i.el));
                var r = s.find("." + e.params.scrollbar.dragClass);
                0 === r.length && (r = L('<div class="' + e.params.scrollbar.dragClass + '"></div>'), s.append(r)), ee.extend(t, {
                    $el: s,
                    el: s[0],
                    $dragEl: r,
                    dragEl: r[0]
                }), i.draggable && t.enableDraggable();
            }
        },
        destroy: function destroy() {
            this.scrollbar.disableDraggable();
        }
    },
        Y = {
        setTransform: function setTransform(e, t) {
            var a = this.rtl,
                i = L(e),
                s = a ? -1 : 1,
                r = i.attr("data-swiper-parallax") || "0",
                n = i.attr("data-swiper-parallax-x"),
                o = i.attr("data-swiper-parallax-y"),
                l = i.attr("data-swiper-parallax-scale"),
                d = i.attr("data-swiper-parallax-opacity");
            if (n || o ? (n = n || "0", o = o || "0") : this.isHorizontal() ? (n = r, o = "0") : (o = r, n = "0"), n = 0 <= n.indexOf("%") ? parseInt(n, 10) * t * s + "%" : n * t * s + "px", o = 0 <= o.indexOf("%") ? parseInt(o, 10) * t + "%" : o * t + "px", null != d) {
                var p = d - (d - 1) * (1 - Math.abs(t));
                i[0].style.opacity = p;
            }
            if (null == l) i.transform("translate3d(" + n + ", " + o + ", 0px)");else {
                var c = l - (l - 1) * (1 - Math.abs(t));
                i.transform("translate3d(" + n + ", " + o + ", 0px) scale(" + c + ")");
            }
        },
        setTranslate: function setTranslate() {
            var i = this,
                e = i.$el,
                t = i.slides,
                s = i.progress,
                r = i.snapGrid;
            e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                i.parallax.setTransform(t, s);
            }), t.each(function (e, t) {
                var a = t.progress;
                1 < i.params.slidesPerGroup && "auto" !== i.params.slidesPerView && (a += Math.ceil(e / 2) - s * (r.length - 1)), a = Math.min(Math.max(a, -1), 1), L(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                    i.parallax.setTransform(t, a);
                });
            });
        },
        setTransition: function setTransition(s) {
            void 0 === s && (s = this.params.speed);
            this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
                var a = L(t),
                    i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || s;
                0 === s && (i = 0), a.transition(i);
            });
        }
    },
        V = {
        getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
            if (e.targetTouches.length < 2) return 1;
            var t = e.targetTouches[0].pageX,
                a = e.targetTouches[0].pageY,
                i = e.targetTouches[1].pageX,
                s = e.targetTouches[1].pageY;
            return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
        },
        onGestureStart: function onGestureStart(e) {
            var t = this,
                a = t.params.zoom,
                i = t.zoom,
                s = i.gesture;
            if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !te.gestures) {
                if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return;
                i.fakeGestureTouched = !0, s.scaleStart = V.getDistanceBetweenTouches(e);
            }
            s.$slideEl && s.$slideEl.length || (s.$slideEl = L(e.target).closest(".swiper-slide"), 0 === s.$slideEl.length && (s.$slideEl = t.slides.eq(t.activeIndex)), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent("." + a.containerClass), s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), t.zoom.isScaling = !0) : s.$imageEl = void 0;
        },
        onGestureChange: function onGestureChange(e) {
            var t = this.params.zoom,
                a = this.zoom,
                i = a.gesture;
            if (!te.gestures) {
                if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;
                a.fakeGestureMoved = !0, i.scaleMove = V.getDistanceBetweenTouches(e);
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = te.gestures ? e.scale * a.currentScale : i.scaleMove / i.scaleStart * a.currentScale, a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, .5)), a.scale < t.minRatio && (a.scale = t.minRatio + 1 - Math.pow(t.minRatio - a.scale + 1, .5)), i.$imageEl.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
        },
        onGestureEnd: function onGestureEnd(e) {
            var t = this.params.zoom,
                a = this.zoom,
                i = a.gesture;
            if (!te.gestures) {
                if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
                if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !m.android) return;
                a.fakeGestureTouched = !1, a.fakeGestureMoved = !1;
            }
            i.$imageEl && 0 !== i.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, i.maxRatio), t.minRatio), i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (i.$slideEl = void 0));
        },
        onTouchStart: function onTouchStart(e) {
            var t = this.zoom,
                a = t.gesture,
                i = t.image;
            a.$imageEl && 0 !== a.$imageEl.length && (i.isTouched || (m.android && e.preventDefault(), i.isTouched = !0, i.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, i.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY));
        },
        onTouchMove: function onTouchMove(e) {
            var t = this,
                a = t.zoom,
                i = a.gesture,
                s = a.image,
                r = a.velocity;
            if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
                s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = ee.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = ee.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), t.rtl && (s.startX = -s.startX, s.startY = -s.startY));
                var n = s.width * a.scale,
                    o = s.height * a.scale;
                if (!(n < i.slideWidth && o < i.slideHeight)) {
                    if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
                        if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
                        if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
                    }
                    e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)");
                }
            }
        },
        onTouchEnd: function onTouchEnd() {
            var e = this.zoom,
                t = e.gesture,
                a = e.image,
                i = e.velocity;
            if (t.$imageEl && 0 !== t.$imageEl.length) {
                if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void (a.isMoved = !1);
                a.isTouched = !1, a.isMoved = !1;
                var s = 300,
                    r = 300,
                    n = i.x * s,
                    o = a.currentX + n,
                    l = i.y * r,
                    d = a.currentY + l;
                0 !== i.x && (s = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
                var p = Math.max(s, r);
                a.currentX = o, a.currentY = d;
                var c = a.width * e.scale,
                    u = a.height * e.scale;
                a.minX = Math.min(t.slideWidth / 2 - c / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - u / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(p).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)");
            }
        },
        onTransitionEnd: function onTransitionEnd() {
            var e = this.zoom,
                t = e.gesture;
            t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform("translate3d(0,0,0) scale(1)"), t.$imageWrapEl.transform("translate3d(0,0,0)"), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0);
        },
        toggle: function toggle(e) {
            var t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e);
        },
        in: function _in(e) {
            var t,
                a,
                i,
                s,
                r,
                n,
                o,
                l,
                d,
                p,
                c,
                u,
                h,
                v,
                f,
                m,
                g = this,
                b = g.zoom,
                w = g.params.zoom,
                y = b.gesture,
                x = b.image;
            (y.$slideEl || (y.$slideEl = g.clickedSlide ? L(g.clickedSlide) : g.slides.eq(g.activeIndex), y.$imageEl = y.$slideEl.find("img, svg, canvas"), y.$imageWrapEl = y.$imageEl.parent("." + w.containerClass)), y.$imageEl && 0 !== y.$imageEl.length) && (y.$slideEl.addClass("" + w.zoomedSlideClass), void 0 === x.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = x.touchesStart.x, a = x.touchesStart.y), b.scale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, b.currentScale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, e ? (f = y.$slideEl[0].offsetWidth, m = y.$slideEl[0].offsetHeight, i = y.$slideEl.offset().left + f / 2 - t, s = y.$slideEl.offset().top + m / 2 - a, o = y.$imageEl[0].offsetWidth, l = y.$imageEl[0].offsetHeight, d = o * b.scale, p = l * b.scale, h = -(c = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - p / 2, 0)), (r = i * b.scale) < c && (r = c), h < r && (r = h), (n = s * b.scale) < u && (n = u), v < n && (n = v)) : n = r = 0, y.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"), y.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + b.scale + ")"));
        },
        out: function out() {
            var e = this,
                t = e.zoom,
                a = e.params.zoom,
                i = t.gesture;
            i.$slideEl || (i.$slideEl = e.clickedSlide ? L(e.clickedSlide) : e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + a.zoomedSlideClass), i.$slideEl = void 0);
        },
        enable: function enable() {
            var e = this,
                t = e.zoom;
            if (!t.enabled) {
                t.enabled = !0;
                var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.gestures ? (e.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
            }
        },
        disable: function disable() {
            var e = this,
                t = e.zoom;
            if (t.enabled) {
                e.zoom.enabled = !1;
                var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                te.gestures ? (e.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
            }
        }
    },
        F = {
        loadInSlide: function loadInSlide(e, l) {
            void 0 === l && (l = !0);
            var d = this,
                p = d.params.lazy;
            if (void 0 !== e && 0 !== d.slides.length) {
                var c = d.virtual && d.params.virtual.enabled ? d.$wrapperEl.children("." + d.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : d.slides.eq(e),
                    t = c.find("." + p.elementClass + ":not(." + p.loadedClass + "):not(." + p.loadingClass + ")");
                !c.hasClass(p.elementClass) || c.hasClass(p.loadedClass) || c.hasClass(p.loadingClass) || (t = t.add(c[0])), 0 !== t.length && t.each(function (e, t) {
                    var i = L(t);
                    i.addClass(p.loadingClass);
                    var s = i.attr("data-background"),
                        r = i.attr("data-src"),
                        n = i.attr("data-srcset"),
                        o = i.attr("data-sizes");
                    d.loadImage(i[0], r || s, n, o, !1, function () {
                        if (null != d && d && (!d || d.params) && !d.destroyed) {
                            if (s ? (i.css("background-image", 'url("' + s + '")'), i.removeAttr("data-background")) : (n && (i.attr("srcset", n), i.removeAttr("data-srcset")), o && (i.attr("sizes", o), i.removeAttr("data-sizes")), r && (i.attr("src", r), i.removeAttr("data-src"))), i.addClass(p.loadedClass).removeClass(p.loadingClass), c.find("." + p.preloaderClass).remove(), d.params.loop && l) {
                                var e = c.attr("data-swiper-slide-index");
                                if (c.hasClass(d.params.slideDuplicateClass)) {
                                    var t = d.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + d.params.slideDuplicateClass + ")");
                                    d.lazy.loadInSlide(t.index(), !1);
                                } else {
                                    var a = d.$wrapperEl.children("." + d.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                                    d.lazy.loadInSlide(a.index(), !1);
                                }
                            }
                            d.emit("lazyImageReady", c[0], i[0]);
                        }
                    }), d.emit("lazyImageLoad", c[0], i[0]);
                });
            }
        },
        load: function load() {
            var i = this,
                t = i.$wrapperEl,
                a = i.params,
                s = i.slides,
                e = i.activeIndex,
                r = i.virtual && a.virtual.enabled,
                n = a.lazy,
                o = a.slidesPerView;
            function l(e) {
                if (r) {
                    if (t.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
                } else if (s[e]) return !0;
                return !1;
            }
            function d(e) {
                return r ? L(e).attr("data-swiper-slide-index") : L(e).index();
            }
            if ("auto" === o && (o = 0), i.lazy.initialImageLoaded || (i.lazy.initialImageLoaded = !0), i.params.watchSlidesVisibility) t.children("." + a.slideVisibleClass).each(function (e, t) {
                var a = r ? L(t).attr("data-swiper-slide-index") : L(t).index();
                i.lazy.loadInSlide(a);
            });else if (1 < o) for (var p = e; p < e + o; p += 1) {
                l(p) && i.lazy.loadInSlide(p);
            } else i.lazy.loadInSlide(e);
            if (n.loadPrevNext) if (1 < o || n.loadPrevNextAmount && 1 < n.loadPrevNextAmount) {
                for (var c = n.loadPrevNextAmount, u = o, h = Math.min(e + u + Math.max(c, u), s.length), v = Math.max(e - Math.max(u, c), 0), f = e + o; f < h; f += 1) {
                    l(f) && i.lazy.loadInSlide(f);
                }for (var m = v; m < e; m += 1) {
                    l(m) && i.lazy.loadInSlide(m);
                }
            } else {
                var g = t.children("." + a.slideNextClass);
                0 < g.length && i.lazy.loadInSlide(d(g));
                var b = t.children("." + a.slidePrevClass);
                0 < b.length && i.lazy.loadInSlide(d(b));
            }
        }
    },
        R = {
        LinearSpline: function LinearSpline(e, t) {
            var a,
                i,
                s,
                r,
                n,
                o = function o(e, t) {
                for (i = -1, a = e.length; 1 < a - i;) {
                    e[s = a + i >> 1] <= t ? i = s : a = s;
                }return a;
            };
            return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
                return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
            }, this;
        },
        getInterpolateFunction: function getInterpolateFunction(e) {
            var t = this;
            t.controller.spline || (t.controller.spline = t.params.loop ? new R.LinearSpline(t.slidesGrid, e.slidesGrid) : new R.LinearSpline(t.snapGrid, e.snapGrid));
        },
        setTranslate: function setTranslate(e, t) {
            var a,
                i,
                s = this,
                r = s.controller.control;
            function n(e) {
                var t = s.rtlTranslate ? -s.translate : s.translate;
                "slide" === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && "container" !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses();
            }
            if (Array.isArray(r)) for (var o = 0; o < r.length; o += 1) {
                r[o] !== t && r[o] instanceof S && n(r[o]);
            } else r instanceof S && t !== r && n(r);
        },
        setTransition: function setTransition(t, e) {
            var a,
                i = this,
                s = i.controller.control;
            function r(e) {
                e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && ee.nextTick(function () {
                    e.updateAutoHeight();
                }), e.$wrapperEl.transitionEnd(function () {
                    s && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd());
                }));
            }
            if (Array.isArray(s)) for (a = 0; a < s.length; a += 1) {
                s[a] !== e && s[a] instanceof S && r(s[a]);
            } else s instanceof S && e !== s && r(s);
        }
    },
        q = {
        makeElFocusable: function makeElFocusable(e) {
            return e.attr("tabIndex", "0"), e;
        },
        addElRole: function addElRole(e, t) {
            return e.attr("role", t), e;
        },
        addElLabel: function addElLabel(e, t) {
            return e.attr("aria-label", t), e;
        },
        disableEl: function disableEl(e) {
            return e.attr("aria-disabled", !0), e;
        },
        enableEl: function enableEl(e) {
            return e.attr("aria-disabled", !1), e;
        },
        onEnterKey: function onEnterKey(e) {
            var t = this,
                a = t.params.a11y;
            if (13 === e.keyCode) {
                var i = L(e.target);
                t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)), t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)), t.pagination && i.is("." + t.params.pagination.bulletClass) && i[0].click();
            }
        },
        notify: function notify(e) {
            var t = this.a11y.liveRegion;
            0 !== t.length && (t.html(""), t.html(e));
        },
        updateNavigation: function updateNavigation() {
            var e = this;
            if (!e.params.loop) {
                var t = e.navigation,
                    a = t.$nextEl,
                    i = t.$prevEl;
                i && 0 < i.length && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)), a && 0 < a.length && (e.isEnd ? e.a11y.disableEl(a) : e.a11y.enableEl(a));
            }
        },
        updatePagination: function updatePagination() {
            var i = this,
                s = i.params.a11y;
            i.pagination && i.params.pagination.clickable && i.pagination.bullets && i.pagination.bullets.length && i.pagination.bullets.each(function (e, t) {
                var a = L(t);
                i.a11y.makeElFocusable(a), i.a11y.addElRole(a, "button"), i.a11y.addElLabel(a, s.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
            });
        },
        init: function init() {
            var e = this;
            e.$el.append(e.a11y.liveRegion);
            var t,
                a,
                i = e.params.a11y;
            e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl), t && (e.a11y.makeElFocusable(t), e.a11y.addElRole(t, "button"), e.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", e.a11y.onEnterKey)), a && (e.a11y.makeElFocusable(a), e.a11y.addElRole(a, "button"), e.a11y.addElLabel(a, i.prevSlideMessage), a.on("keydown", e.a11y.onEnterKey)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey);
        },
        destroy: function destroy() {
            var e,
                t,
                a = this;
            a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off("keydown", a.a11y.onEnterKey), t && t.off("keydown", a.a11y.onEnterKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off("keydown", "." + a.params.pagination.bulletClass, a.a11y.onEnterKey);
        }
    },
        W = {
        init: function init() {
            var e = this;
            if (e.params.history) {
                if (!J.history || !J.history.pushState) return e.params.history.enabled = !1, void (e.params.hashNavigation.enabled = !0);
                var t = e.history;
                t.initialized = !0, t.paths = W.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || J.addEventListener("popstate", e.history.setHistoryPopState));
            }
        },
        destroy: function destroy() {
            this.params.history.replaceState || J.removeEventListener("popstate", this.history.setHistoryPopState);
        },
        setHistoryPopState: function setHistoryPopState() {
            this.history.paths = W.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
        },
        getPathValues: function getPathValues() {
            var e = J.location.pathname.slice(1).split("/").filter(function (e) {
                return "" !== e;
            }),
                t = e.length;
            return {
                key: e[t - 2],
                value: e[t - 1]
            };
        },
        setHistory: function setHistory(e, t) {
            if (this.history.initialized && this.params.history.enabled) {
                var a = this.slides.eq(t),
                    i = W.slugify(a.attr("data-history"));
                J.location.pathname.includes(e) || (i = e + "/" + i);
                var s = J.history.state;
                s && s.value === i || (this.params.history.replaceState ? J.history.replaceState({
                    value: i
                }, null, i) : J.history.pushState({
                    value: i
                }, null, i));
            }
        },
        slugify: function slugify(e) {
            return e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
        },
        scrollToSlide: function scrollToSlide(e, t, a) {
            var i = this;
            if (t) for (var s = 0, r = i.slides.length; s < r; s += 1) {
                var n = i.slides.eq(s);
                if (W.slugify(n.attr("data-history")) === t && !n.hasClass(i.params.slideDuplicateClass)) {
                    var o = n.index();
                    i.slideTo(o, e, a);
                }
            } else i.slideTo(0, e, a);
        }
    },
        j = {
        onHashCange: function onHashCange() {
            var e = this,
                t = f.location.hash.replace("#", "");
            if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
                var a = e.$wrapperEl.children("." + e.params.slideClass + '[data-hash="' + t + '"]').index();
                if (void 0 === a) return;
                e.slideTo(a);
            }
        },
        setHash: function setHash() {
            var e = this;
            if (e.hashNavigation.initialized && e.params.hashNavigation.enabled) if (e.params.hashNavigation.replaceState && J.history && J.history.replaceState) J.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || "");else {
                var t = e.slides.eq(e.activeIndex),
                    a = t.attr("data-hash") || t.attr("data-history");
                f.location.hash = a || "";
            }
        },
        init: function init() {
            var e = this;
            if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
                e.hashNavigation.initialized = !0;
                var t = f.location.hash.replace("#", "");
                if (t) for (var a = 0, i = e.slides.length; a < i; a += 1) {
                    var s = e.slides.eq(a);
                    if ((s.attr("data-hash") || s.attr("data-history")) === t && !s.hasClass(e.params.slideDuplicateClass)) {
                        var r = s.index();
                        e.slideTo(r, 0, e.params.runCallbacksOnInit, !0);
                    }
                }
                e.params.hashNavigation.watchState && L(J).on("hashchange", e.hashNavigation.onHashCange);
            }
        },
        destroy: function destroy() {
            this.params.hashNavigation.watchState && L(J).off("hashchange", this.hashNavigation.onHashCange);
        }
    },
        U = {
        run: function run() {
            var e = this,
                t = e.slides.eq(e.activeIndex),
                a = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay), e.autoplay.timeout = ee.nextTick(function () {
                e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"));
            }, a);
        },
        start: function start() {
            var e = this;
            return void 0 === e.autoplay.timeout && !e.autoplay.running && (e.autoplay.running = !0, e.emit("autoplayStart"), e.autoplay.run(), !0);
        },
        stop: function stop() {
            var e = this;
            return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit("autoplayStop"), !0);
        },
        pause: function pause(e) {
            var t = this;
            t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1, t.autoplay.run())));
        }
    },
        K = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
                var i = e.slides.eq(a),
                    s = -i[0].swiperSlideOffset;
                e.params.virtualTranslate || (s -= e.translate);
                var r = 0;
                e.isHorizontal() || (r = s, s = 0);
                var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
                i.css({
                    opacity: n
                }).transform("translate3d(" + s + "px, " + r + "px, 0px)");
            }
        },
        setTransition: function setTransition(e) {
            var a = this,
                t = a.slides,
                i = a.$wrapperEl;
            if (t.transition(e), a.params.virtualTranslate && 0 !== e) {
                var s = !1;
                t.transitionEnd(function () {
                    if (!s && a && !a.destroyed) {
                        s = !0, a.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
                            i.trigger(e[t]);
                        }
                    }
                });
            }
        }
    },
        _ = {
        setTranslate: function setTranslate() {
            var e,
                t = this,
                a = t.$el,
                i = t.$wrapperEl,
                s = t.slides,
                r = t.width,
                n = t.height,
                o = t.rtlTranslate,
                l = t.size,
                d = t.params.cubeEffect,
                p = t.isHorizontal(),
                c = t.virtual && t.params.virtual.enabled,
                u = 0;
            d.shadow && (p ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
                height: r + "px"
            })) : 0 === (e = a.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), a.append(e)));
            for (var h = 0; h < s.length; h += 1) {
                var v = s.eq(h),
                    f = h;
                c && (f = parseInt(v.attr("data-swiper-slide-index"), 10));
                var m = 90 * f,
                    g = Math.floor(m / 360);
                o && (m = -m, g = Math.floor(-m / 360));
                var b = Math.max(Math.min(v[0].progress, 1), -1),
                    w = 0,
                    y = 0,
                    x = 0;
                f % 4 == 0 ? (w = 4 * -g * l, x = 0) : (f - 1) % 4 == 0 ? (w = 0, x = 4 * -g * l) : (f - 2) % 4 == 0 ? (w = l + 4 * g * l, x = l) : (f - 3) % 4 == 0 && (w = -l, x = 3 * l + 4 * l * g), o && (w = -w), p || (y = w, w = 0);
                var T = "rotateX(" + (p ? 0 : -m) + "deg) rotateY(" + (p ? m : 0) + "deg) translate3d(" + w + "px, " + y + "px, " + x + "px)";
                if (b <= 1 && -1 < b && (u = 90 * f + 90 * b, o && (u = 90 * -f - 90 * b)), v.transform(T), d.slideShadows) {
                    var E = p ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
                        S = p ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (p ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (p ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0));
                }
            }
            if (i.css({
                "-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
                "-moz-transform-origin": "50% 50% -" + l / 2 + "px",
                "-ms-transform-origin": "50% 50% -" + l / 2 + "px",
                "transform-origin": "50% 50% -" + l / 2 + "px"
            }), d.shadow) if (p) e.transform("translate3d(0px, " + (r / 2 + d.shadowOffset) + "px, " + -r / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");else {
                var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
                    M = 1.5 - (Math.sin(2 * C * Math.PI / 360) / 2 + Math.cos(2 * C * Math.PI / 360) / 2),
                    k = d.shadowScale,
                    P = d.shadowScale / M,
                    z = d.shadowOffset;
                e.transform("scale3d(" + k + ", 1, " + P + ") translate3d(0px, " + (n / 2 + z) + "px, " + -n / 2 / P + "px) rotateX(-90deg)");
            }
            var $ = I.isSafari || I.isUiWebView ? -l / 2 : 0;
            i.transform("translate3d(0px,0," + $ + "px) rotateX(" + (t.isHorizontal() ? 0 : u) + "deg) rotateY(" + (t.isHorizontal() ? -u : 0) + "deg)");
        },
        setTransition: function setTransition(e) {
            var t = this.$el;
            this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e);
        }
    },
        Z = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1) {
                var s = t.eq(i),
                    r = s[0].progress;
                e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
                var n = -180 * r,
                    o = 0,
                    l = -s[0].swiperSlideOffset,
                    d = 0;
                if (e.isHorizontal() ? a && (n = -n) : (d = l, o = -n, n = l = 0), s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length, e.params.flipEffect.slideShadows) {
                    var p = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
                        c = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
                    0 === p.length && (p = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "left" : "top") + '"></div>'), s.append(p)), 0 === c.length && (c = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "right" : "bottom") + '"></div>'), s.append(c)), p.length && (p[0].style.opacity = Math.max(-r, 0)), c.length && (c[0].style.opacity = Math.max(r, 0));
                }
                s.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
            }
        },
        setTransition: function setTransition(e) {
            var a = this,
                t = a.slides,
                i = a.activeIndex,
                s = a.$wrapperEl;
            if (t.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), a.params.virtualTranslate && 0 !== e) {
                var r = !1;
                t.eq(i).transitionEnd(function () {
                    if (!r && a && !a.destroyed) {
                        r = !0, a.animating = !1;
                        for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
                            s.trigger(e[t]);
                        }
                    }
                });
            }
        }
    },
        Q = {
        setTranslate: function setTranslate() {
            for (var e = this, t = e.width, a = e.height, i = e.slides, s = e.$wrapperEl, r = e.slidesSizesGrid, n = e.params.coverflowEffect, o = e.isHorizontal(), l = e.translate, d = o ? t / 2 - l : a / 2 - l, p = o ? n.rotate : -n.rotate, c = n.depth, u = 0, h = i.length; u < h; u += 1) {
                var v = i.eq(u),
                    f = r[u],
                    m = (d - v[0].swiperSlideOffset - f / 2) / f * n.modifier,
                    g = o ? p * m : 0,
                    b = o ? 0 : p * m,
                    w = -c * Math.abs(m),
                    y = o ? 0 : n.stretch * m,
                    x = o ? n.stretch * m : 0;
                Math.abs(x) < .001 && (x = 0), Math.abs(y) < .001 && (y = 0), Math.abs(w) < .001 && (w = 0), Math.abs(g) < .001 && (g = 0), Math.abs(b) < .001 && (b = 0);
                var T = "translate3d(" + x + "px," + y + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + g + "deg)";
                if (v.transform(T), v[0].style.zIndex = 1 - Math.abs(Math.round(m)), n.slideShadows) {
                    var E = o ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
                        S = o ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
                    0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (o ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (o ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = 0 < m ? m : 0), S.length && (S[0].style.opacity = 0 < -m ? -m : 0);
                }
            }
            (te.pointerEvents || te.prefixedPointerEvents) && (s[0].style.perspectiveOrigin = d + "px 50%");
        },
        setTransition: function setTransition(e) {
            this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
        }
    },
        ae = {
        init: function init() {
            var e = this,
                t = e.params.thumbs,
                a = e.constructor;
            t.swiper instanceof a ? (e.thumbs.swiper = t.swiper, ee.extend(e.thumbs.swiper.originalParams, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            }), ee.extend(e.thumbs.swiper.params, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })) : ee.isObject(t.swiper) && (e.thumbs.swiper = new a(ee.extend({}, t.swiper, {
                watchSlidesVisibility: !0,
                watchSlidesProgress: !0,
                slideToClickedSlide: !1
            })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
        },
        onThumbClick: function onThumbClick() {
            var e = this,
                t = e.thumbs.swiper;
            if (t) {
                var a = t.clickedIndex,
                    i = t.clickedSlide;
                if (!(i && L(i).hasClass(e.params.thumbs.slideThumbActiveClass) || null == a)) {
                    var s;
                    if (s = t.params.loop ? parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10) : a, e.params.loop) {
                        var r = e.activeIndex;
                        e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, r = e.activeIndex);
                        var n = e.slides.eq(r).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(),
                            o = e.slides.eq(r).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r < r - n ? o : n;
                    }
                    e.slideTo(s);
                }
            }
        },
        update: function update(e) {
            var t = this,
                a = t.thumbs.swiper;
            if (a) {
                var i = "auto" === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView;
                if (t.realIndex !== a.realIndex) {
                    var s,
                        r = a.activeIndex;
                    if (a.params.loop) {
                        a.slides.eq(r).hasClass(a.params.slideDuplicateClass) && (a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft, r = a.activeIndex);
                        var n = a.slides.eq(r).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(),
                            o = a.slides.eq(r).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
                        s = void 0 === n ? o : void 0 === o ? n : o - r == r - n ? r : o - r < r - n ? o : n;
                    } else s = t.realIndex;
                    a.visibleSlidesIndexes.indexOf(s) < 0 && (a.params.centeredSlides ? s = r < s ? s - Math.floor(i / 2) + 1 : s + Math.floor(i / 2) - 1 : r < s && (s = s - i + 1), a.slideTo(s, e ? 0 : void 0));
                }
                var l = 1,
                    d = t.params.thumbs.slideThumbActiveClass;
                if (1 < t.params.slidesPerView && !t.params.centeredSlides && (l = t.params.slidesPerView), a.slides.removeClass(d), a.params.loop) for (var p = 0; p < l; p += 1) {
                    a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + p) + '"]').addClass(d);
                } else for (var c = 0; c < l; c += 1) {
                    a.slides.eq(t.realIndex + c).addClass(d);
                }
            }
        }
    },
        ie = [C, M, k, P, $, O, N, {
        name: "mousewheel",
        params: {
            mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarged: "container"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                mousewheel: {
                    enabled: !1,
                    enable: H.enable.bind(e),
                    disable: H.disable.bind(e),
                    handle: H.handle.bind(e),
                    handleMouseEnter: H.handleMouseEnter.bind(e),
                    handleMouseLeave: H.handleMouseLeave.bind(e),
                    lastScrollTime: ee.now()
                }
            });
        },
        on: {
            init: function init() {
                this.params.mousewheel.enabled && this.mousewheel.enable();
            },
            destroy: function destroy() {
                this.mousewheel.enabled && this.mousewheel.disable();
            }
        }
    }, {
        name: "navigation",
        params: {
            navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                navigation: {
                    init: G.init.bind(e),
                    update: G.update.bind(e),
                    destroy: G.destroy.bind(e),
                    onNextClick: G.onNextClick.bind(e),
                    onPrevClick: G.onPrevClick.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.navigation.init(), this.navigation.update();
            },
            toEdge: function toEdge() {
                this.navigation.update();
            },
            fromEdge: function fromEdge() {
                this.navigation.update();
            },
            destroy: function destroy() {
                this.navigation.destroy();
            },
            click: function click(e) {
                var t = this.navigation,
                    a = t.$nextEl,
                    i = t.$prevEl;
                !this.params.navigation.hideOnClick || L(e.target).is(i) || L(e.target).is(a) || (a && a.toggleClass(this.params.navigation.hiddenClass), i && i.toggleClass(this.params.navigation.hiddenClass));
            }
        }
    }, {
        name: "pagination",
        params: {
            pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: function formatFractionCurrent(e) {
                    return e;
                },
                formatFractionTotal: function formatFractionTotal(e) {
                    return e;
                },
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                modifierClass: "swiper-pagination-",
                currentClass: "swiper-pagination-current",
                totalClass: "swiper-pagination-total",
                hiddenClass: "swiper-pagination-hidden",
                progressbarFillClass: "swiper-pagination-progressbar-fill",
                progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                clickableClass: "swiper-pagination-clickable",
                lockClass: "swiper-pagination-lock"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                pagination: {
                    init: B.init.bind(e),
                    render: B.render.bind(e),
                    update: B.update.bind(e),
                    destroy: B.destroy.bind(e),
                    dynamicBulletIndex: 0
                }
            });
        },
        on: {
            init: function init() {
                this.pagination.init(), this.pagination.render(), this.pagination.update();
            },
            activeIndexChange: function activeIndexChange() {
                this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
            },
            snapIndexChange: function snapIndexChange() {
                this.params.loop || this.pagination.update();
            },
            slidesLengthChange: function slidesLengthChange() {
                this.params.loop && (this.pagination.render(), this.pagination.update());
            },
            snapGridLengthChange: function snapGridLengthChange() {
                this.params.loop || (this.pagination.render(), this.pagination.update());
            },
            destroy: function destroy() {
                this.pagination.destroy();
            },
            click: function click(e) {
                var t = this;
                t.params.pagination.el && t.params.pagination.hideOnClick && 0 < t.pagination.$el.length && !L(e.target).hasClass(t.params.pagination.bulletClass) && t.pagination.$el.toggleClass(t.params.pagination.hiddenClass);
            }
        }
    }, {
        name: "scrollbar",
        params: {
            scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                scrollbar: {
                    init: X.init.bind(e),
                    destroy: X.destroy.bind(e),
                    updateSize: X.updateSize.bind(e),
                    setTranslate: X.setTranslate.bind(e),
                    setTransition: X.setTransition.bind(e),
                    enableDraggable: X.enableDraggable.bind(e),
                    disableDraggable: X.disableDraggable.bind(e),
                    setDragPosition: X.setDragPosition.bind(e),
                    onDragStart: X.onDragStart.bind(e),
                    onDragMove: X.onDragMove.bind(e),
                    onDragEnd: X.onDragEnd.bind(e),
                    isTouched: !1,
                    timeout: null,
                    dragTimeout: null
                }
            });
        },
        on: {
            init: function init() {
                this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
            },
            update: function update() {
                this.scrollbar.updateSize();
            },
            resize: function resize() {
                this.scrollbar.updateSize();
            },
            observerUpdate: function observerUpdate() {
                this.scrollbar.updateSize();
            },
            setTranslate: function setTranslate() {
                this.scrollbar.setTranslate();
            },
            setTransition: function setTransition(e) {
                this.scrollbar.setTransition(e);
            },
            destroy: function destroy() {
                this.scrollbar.destroy();
            }
        }
    }, {
        name: "parallax",
        params: {
            parallax: {
                enabled: !1
            }
        },
        create: function create() {
            ee.extend(this, {
                parallax: {
                    setTransform: Y.setTransform.bind(this),
                    setTranslate: Y.setTranslate.bind(this),
                    setTransition: Y.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
            },
            init: function init() {
                this.params.parallax && this.parallax.setTranslate();
            },
            setTranslate: function setTranslate() {
                this.params.parallax && this.parallax.setTranslate();
            },
            setTransition: function setTransition(e) {
                this.params.parallax && this.parallax.setTransition(e);
            }
        }
    }, {
        name: "zoom",
        params: {
            zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "swiper-zoom-container",
                zoomedSlideClass: "swiper-slide-zoomed"
            }
        },
        create: function create() {
            var i = this,
                t = {
                enabled: !1,
                scale: 1,
                currentScale: 1,
                isScaling: !1,
                gesture: {
                    $slideEl: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    $imageEl: void 0,
                    $imageWrapEl: void 0,
                    maxRatio: 3
                },
                image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {}
                },
                velocity: {
                    x: void 0,
                    y: void 0,
                    prevPositionX: void 0,
                    prevPositionY: void 0,
                    prevTime: void 0
                }
            };
            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function (e) {
                t[e] = V[e].bind(i);
            }), ee.extend(i, {
                zoom: t
            });
            var s = 1;
            Object.defineProperty(i.zoom, "scale", {
                get: function get() {
                    return s;
                },
                set: function set(e) {
                    if (s !== e) {
                        var t = i.zoom.gesture.$imageEl ? i.zoom.gesture.$imageEl[0] : void 0,
                            a = i.zoom.gesture.$slideEl ? i.zoom.gesture.$slideEl[0] : void 0;
                        i.emit("zoomChange", e, t, a);
                    }
                    s = e;
                }
            });
        },
        on: {
            init: function init() {
                this.params.zoom.enabled && this.zoom.enable();
            },
            destroy: function destroy() {
                this.zoom.disable();
            },
            touchStart: function touchStart(e) {
                this.zoom.enabled && this.zoom.onTouchStart(e);
            },
            touchEnd: function touchEnd(e) {
                this.zoom.enabled && this.zoom.onTouchEnd(e);
            },
            doubleTap: function doubleTap(e) {
                this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e);
            },
            transitionEnd: function transitionEnd() {
                this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
            }
        }
    }, {
        name: "lazy",
        params: {
            lazy: {
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                elementClass: "swiper-lazy",
                loadingClass: "swiper-lazy-loading",
                loadedClass: "swiper-lazy-loaded",
                preloaderClass: "swiper-lazy-preloader"
            }
        },
        create: function create() {
            ee.extend(this, {
                lazy: {
                    initialImageLoaded: !1,
                    load: F.load.bind(this),
                    loadInSlide: F.loadInSlide.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
            },
            init: function init() {
                this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load();
            },
            scroll: function scroll() {
                this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
            },
            resize: function resize() {
                this.params.lazy.enabled && this.lazy.load();
            },
            scrollbarDragMove: function scrollbarDragMove() {
                this.params.lazy.enabled && this.lazy.load();
            },
            transitionStart: function transitionStart() {
                var e = this;
                e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load();
            },
            transitionEnd: function transitionEnd() {
                this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
            }
        }
    }, {
        name: "controller",
        params: {
            controller: {
                control: void 0,
                inverse: !1,
                by: "slide"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                controller: {
                    control: e.params.controller.control,
                    getInterpolateFunction: R.getInterpolateFunction.bind(e),
                    setTranslate: R.setTranslate.bind(e),
                    setTransition: R.setTransition.bind(e)
                }
            });
        },
        on: {
            update: function update() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            resize: function resize() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            observerUpdate: function observerUpdate() {
                this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
            },
            setTranslate: function setTranslate(e, t) {
                this.controller.control && this.controller.setTranslate(e, t);
            },
            setTransition: function setTransition(e, t) {
                this.controller.control && this.controller.setTransition(e, t);
            }
        }
    }, {
        name: "a11y",
        params: {
            a11y: {
                enabled: !0,
                notificationClass: "swiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}"
            }
        },
        create: function create() {
            var t = this;
            ee.extend(t, {
                a11y: {
                    liveRegion: L('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
                }
            }), (0, _keys2.default)(q).forEach(function (e) {
                t.a11y[e] = q[e].bind(t);
            });
        },
        on: {
            init: function init() {
                this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
            },
            toEdge: function toEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            fromEdge: function fromEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
            },
            paginationUpdate: function paginationUpdate() {
                this.params.a11y.enabled && this.a11y.updatePagination();
            },
            destroy: function destroy() {
                this.params.a11y.enabled && this.a11y.destroy();
            }
        }
    }, {
        name: "history",
        params: {
            history: {
                enabled: !1,
                replaceState: !1,
                key: "slides"
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                history: {
                    init: W.init.bind(e),
                    setHistory: W.setHistory.bind(e),
                    setHistoryPopState: W.setHistoryPopState.bind(e),
                    scrollToSlide: W.scrollToSlide.bind(e),
                    destroy: W.destroy.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.params.history.enabled && this.history.init();
            },
            destroy: function destroy() {
                this.params.history.enabled && this.history.destroy();
            },
            transitionEnd: function transitionEnd() {
                this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
            }
        }
    }, {
        name: "hash-navigation",
        params: {
            hashNavigation: {
                enabled: !1,
                replaceState: !1,
                watchState: !1
            }
        },
        create: function create() {
            var e = this;
            ee.extend(e, {
                hashNavigation: {
                    initialized: !1,
                    init: j.init.bind(e),
                    destroy: j.destroy.bind(e),
                    setHash: j.setHash.bind(e),
                    onHashCange: j.onHashCange.bind(e)
                }
            });
        },
        on: {
            init: function init() {
                this.params.hashNavigation.enabled && this.hashNavigation.init();
            },
            destroy: function destroy() {
                this.params.hashNavigation.enabled && this.hashNavigation.destroy();
            },
            transitionEnd: function transitionEnd() {
                this.hashNavigation.initialized && this.hashNavigation.setHash();
            }
        }
    }, {
        name: "autoplay",
        params: {
            autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1
            }
        },
        create: function create() {
            var t = this;
            ee.extend(t, {
                autoplay: {
                    running: !1,
                    paused: !1,
                    run: U.run.bind(t),
                    start: U.start.bind(t),
                    stop: U.stop.bind(t),
                    pause: U.pause.bind(t),
                    onTransitionEnd: function onTransitionEnd(e) {
                        t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
                    }
                }
            });
        },
        on: {
            init: function init() {
                this.params.autoplay.enabled && this.autoplay.start();
            },
            beforeTransitionStart: function beforeTransitionStart(e, t) {
                this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop());
            },
            sliderFirstMove: function sliderFirstMove() {
                this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
            },
            destroy: function destroy() {
                this.autoplay.running && this.autoplay.stop();
            }
        }
    }, {
        name: "effect-fade",
        params: {
            fadeEffect: {
                crossFade: !1
            }
        },
        create: function create() {
            ee.extend(this, {
                fadeEffect: {
                    setTranslate: K.setTranslate.bind(this),
                    setTransition: K.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("fade" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "fade");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "fade" === this.params.effect && this.fadeEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "fade" === this.params.effect && this.fadeEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-cube",
        params: {
            cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: .94
            }
        },
        create: function create() {
            ee.extend(this, {
                cubeEffect: {
                    setTranslate: _.setTranslate.bind(this),
                    setTransition: _.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("cube" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "cube"), e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        resistanceRatio: 0,
                        spaceBetween: 0,
                        centeredSlides: !1,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "cube" === this.params.effect && this.cubeEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "cube" === this.params.effect && this.cubeEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-flip",
        params: {
            flipEffect: {
                slideShadows: !0,
                limitRotation: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                flipEffect: {
                    setTranslate: Z.setTranslate.bind(this),
                    setTransition: Z.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                if ("flip" === e.params.effect) {
                    e.classNames.push(e.params.containerModifierClass + "flip"), e.classNames.push(e.params.containerModifierClass + "3d");
                    var t = {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !0
                    };
                    ee.extend(e.params, t), ee.extend(e.originalParams, t);
                }
            },
            setTranslate: function setTranslate() {
                "flip" === this.params.effect && this.flipEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "flip" === this.params.effect && this.flipEffect.setTransition(e);
            }
        }
    }, {
        name: "effect-coverflow",
        params: {
            coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: !0
            }
        },
        create: function create() {
            ee.extend(this, {
                coverflowEffect: {
                    setTranslate: Q.setTranslate.bind(this),
                    setTransition: Q.setTransition.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this;
                "coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"), e.classNames.push(e.params.containerModifierClass + "3d"), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
            },
            setTranslate: function setTranslate() {
                "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
            },
            setTransition: function setTransition(e) {
                "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e);
            }
        }
    }, {
        name: "thumbs",
        params: {
            thumbs: {
                swiper: null,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-container-thumbs"
            }
        },
        create: function create() {
            ee.extend(this, {
                thumbs: {
                    swiper: null,
                    init: ae.init.bind(this),
                    update: ae.update.bind(this),
                    onThumbClick: ae.onThumbClick.bind(this)
                }
            });
        },
        on: {
            beforeInit: function beforeInit() {
                var e = this.params.thumbs;
                e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
            },
            slideChange: function slideChange() {
                this.thumbs.swiper && this.thumbs.update();
            },
            update: function update() {
                this.thumbs.swiper && this.thumbs.update();
            },
            resize: function resize() {
                this.thumbs.swiper && this.thumbs.update();
            },
            observerUpdate: function observerUpdate() {
                this.thumbs.swiper && this.thumbs.update();
            },
            setTransition: function setTransition(e) {
                var t = this.thumbs.swiper;
                t && t.setTransition(e);
            },
            beforeDestroy: function beforeDestroy() {
                var e = this.thumbs.swiper;
                e && this.thumbs.swiperCreated && e && e.destroy();
            }
        }
    }];
    return void 0 === S.use && (S.use = S.Class.use, S.installModule = S.Class.installModule), S.use(ie), S;
});
//# sourceMappingURL=swiper.min.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showPaginate) ? _c('div', {
    staticClass: "swiper-pagination",
    class: _vm.paginateCls
  }) : _vm._e(), _vm._v(" "), (_vm.showScrollbar) ? _c('div', {
    staticClass: "swiper-scrollbar",
    class: _vm.scrollbarCls
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(157);

var _api2 = _interopRequireDefault(_api);

var _browser = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = '未知服务器错误';
var JS_API_LIST = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'];
function noop() {}
var DEFAULT_OPTIONS = {
  title: '野兽派 - The Beast Shop',
  content: 'default content',
  group: '', // 需要分享朋友圈的文案，如果该字段缺省则分享朋友圈为title
  link: 'https://m.thebeastshop.com',
  image: 'https://img.thebeastshop.com/images/mcatlog/banner/share.png',
  success: noop,
  cancel: noop
};

var config = null;

module.exports = function (options) {
  var isShare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!(0, _browser.weixin)()) {
    return;
  }
  var _option = (0, _assign2.default)(DEFAULT_OPTIONS, options);
  // wx.checkJsApi({
  //   jsApiList: JS_API_LIST,
  //   success: function(res) {
  _getConfig().then(function (_ref) {
    var data = _ref.data;

    config = data;
    // alert(JSON.stringify(data))
    _config(data);
    _ready(_option, isShare);
  });
  //   }
  // })
  // _checkJsApi()
  // .then((_apis) => {
  //   _getConfig()
  //   .then(({data}) => {
  //     _config(data)
  //     _ready(options)
  //   })
  // })
};

// function _checkJsApi(){
//   return new Promise((resolve, reject) => {
//     wx.checkJsApi({
//       jsApiList: JS_API_LIST,
//       success: function(res) {
//         let _result = res.checkResult
//         let weixinApiList = []
//         Object.keys(_result).forEach((name) => {
//           if(_result[name]){
//             weixinApiList.push(name)
//           }
//         })
//         if(weixinApiList.length > 0) {
//           resolve(weixinApiList)
//         }else{
//           reject()
//         }
//       }
//     })
//   })
// }
function _getConfig() {
  if (config) {
    return _promise2.default.resolve({
      data: config
    });
  }
  var data = { url: location.href
    // let postData = JSON.stringify(data)
  };return _api2.default.signature(data);
}

function _config(_ref2) {
  var appId = _ref2.appId,
      timestamp = _ref2.timestamp,
      nonceStr = _ref2.nonceStr,
      signature = _ref2.signature;

  wx.config({
    // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名，见附录1
    jsApiList: JS_API_LIST // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
}

function _ready(_ref3, isShare) {
  var title = _ref3.title,
      content = _ref3.content,
      link = _ref3.link,
      image = _ref3.image,
      group = _ref3.group,
      _success = _ref3.success,
      _cancel = _ref3.cancel;

  wx.ready(function () {
    if (!isShare) {
      wx.hideMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:favorite', 'menuItem:share:weiboApp', 'menuItem:copyUrl', 'menuItem:share:email', 'menuItem:share:brand', 'menuItem:openWithSafari', 'menuItem:originPage']
      });
      return;
    }
    wx.onMenuShareTimeline({ // 分享到朋友圈
      title: group || title, // 分享标题
      link: link, // 分享链接
      imgUrl: image, // 分享图标
      success: function success() {
        _success('Timeline');
      },
      cancel: function cancel() {
        _cancel('Timeline');
      }
    });

    wx.onMenuShareAppMessage({ // 分享给朋友
      title: title, // 分享标题
      desc: content, // 分享描述
      link: link, // 分享链接
      imgUrl: image, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function success() {
        _success('WeChat');
      },
      cancel: function cancel() {
        _cancel('WeChat');
      }
    });
  });
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  signature: function signature(jsonData) {
    return (0, _axiosMock2.default)({
      url: '/app/weixin/signature',
      method: 'POST',
      json: jsonData
    });
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(176)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'main',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    errorMsg: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.loading && this.$showLoading();
  },

  methods: {
    reload: function reload() {
      window.location.reload();
    }
  }
};

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      error: _vm.errorMsg
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMsg),
      expression: "errorMsg"
    }],
    staticClass: "page-error"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/images/wap/page-error/page-error.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("重新加载")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _lazyload = __webpack_require__(56);

var _urlUtil = __webpack_require__(21);

var _sdk = __webpack_require__(57);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vipLevelImages = {
  '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
  '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
  '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
  '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png'
};

exports.default = {
  name: 'simple-product',
  props: {
    data: {
      type: Object,
      require: true
    },
    addToCart: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sdk: null,
      env: 'm-web'
    };
  },
  components: {
    price: _price2.default,
    beastImage: _image2.default
  },
  mounted: function mounted() {
    (0, _lazyload.lazyload)();
  },
  created: function created() {
    var _this = this;

    (0, _sdk.getEnv)().then(function (sdk) {
      sdk.init({
        vue: _this
      });
      _this.sdk = sdk;
      _this.env = sdk.adapter.env;
    });
  },


  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    },

    offShelfStyle: function offShelfStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/off-shelf-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    },
    soldOutStyle: function soldOutStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/sold-out-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    },


    priceTags: function priceTags() {
      var data = this.data;
      if (data.discount) {
        return {
          vipLevelImage: data.discount.vipLevel !== null && vipLevelImages[data.discount.vipLevel],
          // appOnlyImage: data.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
          birthdayImage: data.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
        };
      } else {
        return {};
      }
    }
  },
  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },
  methods: {
    jump: function jump() {
      var linkData = '';

      switch (this.env) {
        case 'wx-web':
        case 'm-web':
          linkData = '/product/' + this.data.id;
          break;
        case 'miniprogram':
          linkData = {
            url: '/pages/product/detail/detail?code=' + this.data.id,
            mpType: 'navigate'
          };
          break;
        case 'app':
          linkData = 'beastapp://product/' + this.data.id;
          break;
      }

      if (this.env === 'miniprogram') {
        this.sdk.navigate.jumpTo(linkData);
      } else if (this.env === 'app') {
        _bridge2.default.open({
          url: linkData
        });
      } else {
        window.location.href = linkData;
      }
      // window.location.href = `/product/${this.data.id}`
    },
    getVariant: function getVariant() {
      return this.sdk.request({
        url: '/app/product/' + this.data.id + '/spvs',
        method: 'GET'
      });
    },
    selectVariant: function selectVariant() {
      return this.$selectVariant({
        pack: this.transform(this.variant.spvs[0]),
        variant: this.variant,
        selectAmount: true
      }).then(function (result) {
        return _promise2.default.resolve({ result: result });
      });
    },
    transform: function transform(spv) {
      return {
        product: {
          brand: {
            name: spv.brand ? spv.brand.name : ''
          },
          name: spv.name
        },
        count: spv.minAmount || 1,
        variant: spv.id
      };
    },
    toCart: function toCart(result) {
      var _this2 = this;

      this.$showLoading();
      this.add(result.spvId, result.count).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        _this2.$hideLoading();
        _this2.$toast('加入购物车成功！');
        _this2.$emit('after-add');
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this2.$hideLoading();
        _this2.$alert(message);
      });
    },
    add: function add(spvId) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return this.sdk.request({
        url: '/app/cart/packs',
        method: 'POST',
        json: [{
          spvId: spvId,
          count: count,
          source: 'RAW'
        }]
      });
    },
    addCart: function addCart() {
      var _this3 = this;

      this.$showLoading();
      this.getVariant().then(function (_ref3) {
        var data = _ref3.data;

        _this3.$hideLoading();
        _this3.variant = data;
        if (_this3.variant.spvs.length > 1) {
          _this3.selectVariant().then(function (_ref4) {
            var result = _ref4.result;

            if (!result) {
              return;
            }
            _this3.toCart(result);
          });
        } else {
          var spv = _this3.variant.spvs[0];
          _this3.toCart({
            spvId: spv.id,
            count: spv.minAmount || 1
          });
        }
      }).catch(function (_ref5) {
        var message = _ref5.message;

        _this3.$hideLoading();
        _this3.$alert(message);
      });
    }

    // axios({
    //   url: '/app/cart/packs',
    //   method: 'POST',
    //   json: [{
    //     spvId: this.data.spv.id,
    //     count: 1,
    //     source: "RAW"
    //   }]
    // })
    //   .then(() => {
    //     this.$hideLoading()
    //     this.$toast('加入购物车成功！')
    //     this.$emit('after-add', this.data)
    //   })
    //   .catch(({ message }) => {
    //     this.$hideLoading()
    //     this.$alert(message)
    //   })

  }
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "src": _vm.productImage
    }
  }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
    staticClass: "foretell-box"
  }, [_c('div', {
    staticClass: "foretell"
  }, [_vm._v("即将开售")])]) : _vm._e(), _vm._v(" "), (_vm.data.activityDesc) ? _c('div', {
    staticClass: "activity-desc"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.offShelfStyle)
  })]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.soldOutStyle)
  })]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
    staticClass: "add-cart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCart($event)
      }
    }
  }, [_c('beast-image', {
    attrs: {
      "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.summary))]), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tags-wrap"
  }, [(_vm.priceTags.vipLevelImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.vipLevelImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.appOnlyImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.appOnlyImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.birthdayImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.birthdayImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.rush) ? _c('div', {
    staticClass: "panic-tag"
  }, [_vm._v("抢购")]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _lazyload = __webpack_require__(56);

var _urlUtil = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};
// if (process.env.NODE_ENV === 'development') {
//   Object.assign(headers, {
//     'Authorization': 'f85abb3c-9304-44de-b8fe-5bebe4055926',
//     'Platform': 'Android/24',
//     'TBS-Source': 1
//   })
// }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vipLevelImages = {
  '0': 'http://img.thebeastshop.com/apppictures/2017-07-12/5f7fdc7bd73dc83f4318a918cfb771ac.jpg',
  '1': 'http://img.thebeastshop.com/apppictures/2017-07-12/9460e395b4ee15b1f8426b9f5d87e1a0.png',
  '2': 'http://img.thebeastshop.com/apppictures/2017-07-12/65decd7cdc9d6f45fd34dfa4aaf2ba8b.png',
  '3': 'http://img.thebeastshop.com/apppictures/2017-07-12/cc963fc32858fbf03e6d9b80d842d8e9.png'
};

exports.default = {
  name: 'simple-product',
  props: {
    data: {
      type: Object,
      require: true
    },
    index: {
      type: Number
    },
    addToCart: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String
    },
    sdk: Object,
    env: String,
    isJump: {
      type: Boolean,
      default: true
    },
    business: {
      type: String
    }
  },
  data: function data() {
    return {
      _images: [],
      swiperConfig: {
        loop: true
      }
    };
  },

  components: {
    price: _price2.default,
    beastImage: _image2.default,
    swiper: _index2.default
  },

  created: function created() {
    this.data.images.shift();
    this.data.images.unshift(this.data.featureImage);
  },
  mounted: function mounted() {
    (0, _lazyload.lazyload)();
  },

  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },
  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    },
    priceTags: function priceTags() {
      var data = this.data;
      if (data.discount) {
        return {
          vipLevelImage: data.discount.vipLevel !== null && vipLevelImages[data.discount.vipLevel],
          // appOnlyImage: data.discount.appOnly && 'http://img.thebeastshop.com/apppictures/2017-07-12/a139293dcdbcd72afa4d2b77a5698d42.png',
          birthdayImage: data.discount.birthday && 'http://img.thebeastshop.com/apppictures/2017-07-12/7860dfcf031b72f2d3bf0c14b3e6f7c3.png'
        };
      } else {
        return {};
      }
    }
  },
  methods: {
    jump: function jump() {

      var _suggestType = this.data.markInfo ? JSON.parse(this.data.markInfo).RecommendType : '';
      if (!this.isJump) return;
      switch (this.env) {
        case 'm-web':
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
        case 'wx-web':
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
        case 'miniprogram':
          var linkData = {
            url: '/pages/product/detail/detail?code=' + this.data.id,
            mpType: 'navigate'
          };
          this.sdk.navigate.jumpTo(linkData);
          break;
        case 'app':
          _bridge2.default.open({
            url: 'beastapp://product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType)
          });
          break;
        default:
          window.location.href = '/product/' + this.data.id + '?suggestType=' + encodeURIComponent(_suggestType);
          break;
      }

      if (this.searchKey) {
        sa.track('SearchResultClick', {
          search_word: this.searchKey,
          position_number: this.index - 0 + 1,
          commodity_spu_id: this.data.id,
          commodity_name: this.data.name,
          hot_label: sa.getActivity(this.data.labels),
          original_price: this.data.rawPrice,
          discount_price: this.data.price
        });
      } else {
        var bu = this.data.recommendEngine ? '\u731C\u4F60\u559C\u6B22-' + this.data.recommendEngine : '猜你喜欢';
        sa.track('CommodityClick', {
          position_number: this.index - 0 + 1,
          commodity_spu_id: this.data.id,
          commodity_name: this.data.name,
          hot_label: [],
          original_price: this.data.rawPrice,
          discount_price: this.data.price,
          business_case: this.business === 'suggest' ? bu : '其他'
        });
      }

      if (this.data.markInfo) {
        // this.data.markInfo = JSON.parse(this.data.markInfo) || null

        (0, _track2.default)({
          name: 'click-result-suggest',
          attrs: {
            suggestType: _suggestType
          },
          productId: this.data.id
        });
      }
    },
    getVariant: function getVariant() {
      return (0, _axiosMock2.default)({
        headers: headers,
        url: '/app/product/' + this.data.id + '/spvs',
        method: 'GET'
      });
    },
    selectVariant: function selectVariant() {
      return this.$selectVariant({
        pack: this.transform(this.variant.spvs[0]),
        variant: this.variant,
        selectAmount: true
      }).then(function (result) {
        return _promise2.default.resolve({ result: result });
      });
    },
    transform: function transform(spv) {
      return {
        product: {
          brand: {
            name: spv.brand ? spv.brand.name : ''
          },
          name: spv.name
        },
        count: spv.minAmount || 1,
        variant: spv.id
      };
    },
    toCart: function toCart(result) {
      var _this = this;

      this.$showLoading();
      this.add(result.spvId, result.count).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        _this.$hideLoading();
        _this.$toast('加入购物车成功！');
        if (_browser2.default.app()) {
          _bridge2.default.broadcast({
            type: 'refreshPreview'
          });
          _bridge2.default.notify('cart_size_change');
        }
        _this.$emit('after-add');
      }).catch(function (_ref2) {
        var message = _ref2.message;

        _this.$hideLoading();
        _this.$alert(message);
      });
    },
    add: function add(spvId) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return (0, _axiosMock2.default)({
        headers: headers,
        url: '/app/cart/packs',
        method: 'POST',
        json: [{
          spvId: spvId,
          count: count,
          source: 'RAW'
        }]
      });
    },
    addCart: function addCart() {
      var _this2 = this;

      this.$showLoading();
      this.getVariant().then(function (_ref3) {
        var data = _ref3.data;

        _this2.$hideLoading();
        _this2.variant = data;
        if (_this2.variant.spvs.length > 1) {
          _this2.selectVariant().then(function (_ref4) {
            var result = _ref4.result;

            if (!result) {
              return;
            }
            _this2.toCart(result);
          });
        } else {
          var spv = _this2.variant.spvs[0];
          _this2.toCart({
            spvId: spv.id,
            count: spv.minAmount || 1
          });
        }
      }).catch(function (_ref5) {
        var message = _ref5.message;

        _this2.$hideLoading();
        _this2.$alert(message);
      });
    }

    // axios({
    //   url: '/app/cart/packs',
    //   method: 'POST',
    //   json: [{
    //     spvId: this.data.spv.id,
    //     count: 1,
    //     source: "RAW"
    //   }]
    // })
    //   .then(() => {
    //     this.$hideLoading()
    //     this.$toast('加入购物车成功！')
    //     this.$emit('after-add', this.data)
    //   })
    //   .catch(({ message }) => {
    //     this.$hideLoading()
    //     this.$alert(message)
    //   })

  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('swiper', {
    staticClass: "product-image",
    attrs: {
      "config": _vm.swiperConfig
    }
  }, _vm._l((_vm.data.images), function(img, index) {
    return _c('div', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (index),
        expression: "index"
      }],
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "cover-line left"
    }), _vm._v(" "), _c('div', {
      staticClass: "cover-line right"
    }), _vm._v(" "), (_vm.data._big) ? _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": _vm.data.bigPic.src
      }
    }) : _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": img
      }
    }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("即将开售")])])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("下架")])])]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addCart($event)
        }
      }
    }, [_c('beast-image', {
      attrs: {
        "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
      }
    })], 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "product-infos"
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.mainStationFirst) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }), _c('span', {
    staticClass: "newn-tag-shoudan"
  }, [_vm._v("首单价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : (_vm.data.newcomerTag && !_vm.data.newcomerUsed) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e(), _vm._v(" "), (_vm.data.soldOut) ? _c('div', {
    staticClass: "stats-tag-empty"
  }, [_c('span', [_vm._v("售罄")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.isIphoneX = isIphoneX;
exports.isWeibo = isWeibo;
exports.isQQ = isQQ;
exports.isMobile = isMobile;
exports.getScrollTop = getScrollTop;
exports.getScrollHeight = getScrollHeight;
exports.getWindowHeight = getWindowHeight;
exports.formatMultiNum = formatMultiNum;
exports.zipImage = zipImage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIphoneX() {
  return (/iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375 || screen.height == 896 && screen.width == 414)
  );
}

function isWeibo() {
  var isWeibo = !!u.match(/WeiBo/i);
  return isWeibo;
}

function isQQ() {
  var isQQ = !!u.match(/QQ\//i);
  return isQQ;
}

function isMobile() {
  var isMobile = !!u.match(/AppleWebKit.*Mobile.*/);
  return isMobile;
}

function getScrollTop() {
  var scrollTop = 0,
      bodyScrollTop = 0,
      documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}

function getScrollHeight() {
  var scrollHeight = 0,
      bodyScrollHeight = 0,
      documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight = bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
  return scrollHeight;
}

function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}

function formatMultiNum(num) {
  if (!num) {
    return 0;
  } else {
    var numArr = num.toString().split(".");
    var intNum = numArr.length > 1 ? numArr[1] : numArr[0];
    var reverseNums = intNum.split("").reverse();
    var len = reverseNums.length;
    var newNums = [];

    reverseNums.forEach(function (n, index) {
      if ((index + 1) % 3 === 0) {
        newNums.push(n);
        if (index + 1 !== len) {
          newNums.push(",");
        }
      } else {
        newNums.push(n);
      }
    });

    return newNums.reverse().join("");
  }
}

function zipImage(image, zipWidth) {
  if (!image || !image.src) {
    return '';
  }

  var baseWidth = 750;
  var src = '';
  var newSrc = '';
  if (typeof image === 'string') {
    src = image;
    var width = zipWidth || baseWidth;
    newSrc = formatZipImage(src, width);
    return newSrc;
  }

  if ((typeof image === "undefined" ? "undefined" : (0, _typeof3.default)(image)) === 'object') {
    src = image.src;
    var imageWidth = image.width;
    var myWidth = imageWidth < baseWidth ? imageWidth : baseWidth;
    var _width = zipWidth || myWidth;
    newSrc = formatZipImage(src, _width);
    return {
      src: newSrc,
      width: image.width,
      height: image.height
    };
  }

  return image;
}

function formatZipImage(src, width) {
  var stuffIndex = src.lastIndexOf('.');
  var stuff = src.substring(stuffIndex);
  var stuffStr = stuff.toLowerCase();

  if (stuffStr == ".jpg" || stuffStr == ".jpeg" || stuffStr == ".png" || stuffStr == ".webp") {
    return src + "@0o_0l_" + width + "w_90q";
  } else if (stuffStr == ".gif") {
    return src + "?x-oss-process=image/resize,w_" + width + "/quality,q_90";
  } else {
    return src;
  }
}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _main = __webpack_require__(178);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var searchIcon = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/images/menu-tab/menu-search.png');

exports.default = {
  components: {
    search: _main2.default
  },

  props: ['mode', 'searchText', 'show', 'isCouponSearch'],

  data: function data() {
    return {
      searchIcon: searchIcon,
      isShow: false
    };
  },


  watch: {
    show: function show(val) {
      sa.setCurrentPage('搜索页');
      if (val) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },

  methods: {
    goSearch: function goSearch(e) {
      this.isShow = true;
      this.$emit('showsearch');
      sa.track('SearchButtonClick', {});
      sa.setCurrentPage('搜索页');
    },
    close: function close() {
      this.isShow = false;
      this.$emit('hidesearch');
    }
  }

};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _appMain = __webpack_require__(158);

var _appMain2 = _interopRequireDefault(_appMain);

var _navbar = __webpack_require__(168);

var _navbar2 = _interopRequireDefault(_navbar);

var _simpleProduct = __webpack_require__(167);

var _simpleProduct2 = _interopRequireDefault(_simpleProduct);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _list = __webpack_require__(205);

var _list2 = _interopRequireDefault(_list);

var _associateList = __webpack_require__(209);

var _associateList2 = _interopRequireDefault(_associateList);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _util = __webpack_require__(137);

var _link2 = __webpack_require__(55);

var _apis = __webpack_require__(213);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queParams = _queryString2.default.parse(window.location.search); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var KEY_CODE = {
  13: 'iOS'
};

var MIN_HEIGHT = 35;

exports.default = {
  components: {
    beastMain: _appMain2.default,
    navBar: _navbar2.default,
    searchList: _list2.default,
    associateList: _associateList2.default
  },

  props: ['isShow', 'isCouponSearch'],

  data: function data() {
    return {
      ipt: null,
      query: '',
      key: '',
      aKey: '',
      items: [],
      banners: [],
      associateList: null,
      defaultKey: '',
      suggest: null,
      hotItem: null,
      history: [],
      isSearch: false,
      increase: 0,
      loaded: false,
      isDefault: false,
      isAssociate: false,
      enable: true,
      hideMore: false,
      maxIndex: 7,
      seaching: false,
      searchType: '搜索词',
      sortField: 'SYNTHESIS', // PRICE
      sortOrder: 'DESC' // ASC
    };
  },
  created: function created() {
    var _this = this;

    this.getHotSearch();
    this.history = this.getKeys().split('-');

    this.$nextTick(function () {
      var hist = document.querySelector('#history-key');
      console.log(hist, '11');
      if (!hist) return;
      console.log(hist.clientHeight, 'hhs');
      if (hist.clientHeight >= MIN_HEIGHT * 2) {
        _this.hideMore = true;
      } else {
        _this.hideMore = false;
      }
    });
  },
  mounted: function mounted() {
    this.ipt = document.querySelector('input[name="search-input"]');
    this.ipt.focus();
  },


  watch: {
    defaultKey: function defaultKey(val) {
      var _this2 = this;

      if (!val) {
        this.reset();
        this.isSearch = false;
        this.isAssociate = false;
        return;
      }

      if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) !== 'object') {
        this.isDefault = false;
      }

      if (this.enable && (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) !== 'object') {
        setTimeout(function () {
          _this2.getAssociate(val);
        }, 50);
      } else {
        this.isAssociate = false;
      }
    }
  },

  methods: {
    init: function init() {
      var bd = document.body;
      var vm = this;

      this.ipt.value = '';

      bd.addEventListener('keyup', function (e) {
        if (!(e.keyCode in KEY_CODE)) return;
        vm.reset();
        vm.isAssociate = false;

        if (vm.isDefault) {
          sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
            search_type: '默认词',
            search_word: vm.defaultKey.name,
            if_directional_skip: true
          }));
          vm.goLink(vm.defaultKey);
          (0, _track2.default)({
            name: 'default-search',
            attrs: {
              keyword: vm.defaultKey.name,
              type: vm.defaultKey.linkType
            },
            wait: false
          });
        } else {
          vm.key = vm.ipt.value || vm.defaultKey.name;
          vm.getResult(vm.key);
        }
      });
    },
    getAssociate: function getAssociate(keyword) {
      var _this3 = this;

      (0, _apis.getAssociate)(keyword).then(function (_ref) {
        var data = _ref.data;

        _this3.associateList = data;

        if (data.length) {
          _this3.aKey = keyword;
          _this3.isAssociate = true;
        } else {
          _this3.isAssociate = false;
        }
      }).catch(function (err) {});
    },
    showMoreHist: function showMoreHist() {
      this.hideMore = false;
      this.maxIndex = this.history.length;
    },
    onScroll: function onScroll(e) {
      var tar = e.currentTarget;
      var height = tar.clientHeight;
      var scrollTop = tar.scrollTop;
      var scrollHeight = tar.scrollHeight;

      if (scrollTop + height >= scrollHeight) {
        this.getResult(this.key, this.query);
      }
    },
    focusInput: function focusInput() {
      this.searchType = '搜索词';
      this.getAssociate(this.key);
    },
    search: function search(item) {
      console.log('search11');
      this.reset();
      this.enable = false;
      this.goLink(item, false, '联想词');
    },
    action: function action(type, sort) {
      var _this4 = this;

      this.sortField = type;
      this.sortOrder = sort;
      this.reset();
      this.$nextTick(function () {
        _this4.getResult(_this4.key, _this4.query);
      });
    },
    list: function list(query, selected) {
      var _this5 = this;

      this.showlist = true;
      this.clearFilter = false;

      if (!query) return;

      this.reset();

      this.$nextTick(function () {
        _this5.getResult(_this5.key, query);
      });
    },
    navshow: function navshow(select) {
      this.showlist = false;
    },
    reset: function reset() {
      this.items = [];
      this.increase = 0;
      // this.finish = false
      // this.netError = false
      // this.isEnded = false
    },
    goLink: function goLink(item, flag, searchType) {
      console.log('search22', searchType);
      if (flag) {
        (0, _track2.default)({
          name: 'hot-search',
          attrs: {
            keyword: item.name,
            type: item.linkType
          },
          wait: false
        });
      }

      this.searchType = searchType || '搜索词';

      if (!item.deeplink) {
        this.getResult(item.name);
        return;
      }

      var link = (0, _util.getLink)(item.deeplink);
      sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
        search_type: this.searchType,
        search_word: item.name,
        if_directional_skip: true
      }));
      window.location.href = link;
    },
    jumpBanner: function jumpBanner(link) {
      var _link = (0, _link2.transformLink)({ link: link });

      window.location.href = _link;
    },
    getResult: function getResult(key, query) {
      var _this6 = this;

      if (!key) return;

      this.ipt.blur();
      this.enable = false;
      this.defaultKey = key;
      this.key = key;
      this.setKeys(key);

      (0, _track2.default)({
        name: 'search',
        attrs: {
          keyword: key
        },
        wait: false
      });

      this.$showLoading();

      var que = query;

      if (!que) {
        que = 'keyword=' + key;
      }

      this.query = queParams && queParams.couponSampleId ? que + '&couponSampleId=' + queParams.couponSampleId : '' + que;

      (0, _apis.searchByKeywords)(this.query + '&sortField=' + this.sortField + '&sortOrder=' + this.sortOrder, this.increase).then(function (_ref2) {
        var data = _ref2.data;

        _this6.$hideLoading();

        var list = data.list,
            suggest = data.suggest,
            jump = data.jump;

        // 发起搜索请求

        sa.track('SearchClick', (0, _extends3.default)({}, sa.getReferPageName(), {
          search_type: _this6.searchType,
          search_word: key,
          if_directional_skip: jump ? true : false
        }));

        if (jump) {
          var link = (0, _link2.transformLink)({
            link: jump
          });
          window.location.href = link;
          return;
        }

        if (!list) return;

        _this6.isSearch = true;

        var items = list.items;


        _this6.increase++;

        _this6.items = _this6.items.concat(items);

        _this6.enable = true;
        _this6.seaching = false;
        _this6.suggest = suggest;
      }).catch(function (err) {
        _this6.$hideLoading();
        _this6.$alert(err.message || '系统异常');
      });
      this.isAssociate = false;
    },
    getHotSearch: function getHotSearch() {
      var _this7 = this;

      (0, _apis.getHotSearch)().then(function (data) {
        _this7.hotItem = data;
        _this7.defaultKey = data.defaultKeyword;
        _this7.banners = data.banners;

        if (_this7.defaultKey && _this7.defaultKey.deeplink) {
          _this7.isDefault = true;
        }

        _this7.$nextTick(function () {
          _this7.init();
        });
      });
    },
    goSearch: function goSearch(key, searchType) {
      this.key = key;
      this.searchType = searchType;
      this.getResult(key);
    },
    getKeys: function getKeys() {
      var history = localStorage.getItem('__bstkeys') || '';
      return history;
    },
    setKeys: function setKeys(val) {
      var history = this.getKeys();
      var temp = history.split('-');

      if (~temp.indexOf(val)) {
        return;
      }

      history += val + '-';

      localStorage.setItem('__bstkeys', history);
    },
    clearSearch: function clearSearch() {
      var _this8 = this;

      localStorage.removeItem('__bstkeys');
      this.history = [];

      this.$nextTick(function () {
        _this8.ipt.value = '';
      });
    },
    cancel: function cancel() {
      this.isSearch = false;
      this.$emit('close');
    },
    goCart: function goCart() {
      window.location.href = '/cart';
    }
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _nav = __webpack_require__(183);

var _nav2 = _interopRequireDefault(_nav);

var _apis = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAV_NAME = ['综合', '新品', '价格', '筛选']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var NAV_TYPE = ['SYNTHESIS', 'RELEASE', 'PRICE', 'FILTER'];
var ENUM_SORT = ['DEFAULT', 'ASC', 'DESC', ''];

exports.default = {
  name: 'navBar',

  components: {
    Slide: _slide2.default,
    navList: _nav2.default
  },

  props: ['query', 'clearFilter', 'type', 'new', 'label', 'discountSelected', 'tips', 'sortField', 'isCouponSearch'],

  data: function data() {
    return {
      navName: NAV_NAME,
      navType: NAV_TYPE,
      logined: false,
      level: 0,
      isDesc: false,
      showSlide: false,
      sort: 1,
      curActive: NAV_TYPE.indexOf(this.sortField) || 0,
      sortField: this.sortField || 'SYNTHESIS',
      sortOrder: 'DEFAULT',
      isKindActive: false,
      selected: {},
      selectObject: null,
      selectQuery: {
        cateSelected: '',
        brandSelected: '',
        hotSelected: ''
      }
    };
  },
  created: function created() {
    console.log(this.isCouponSearch, 'sdsf');
    if (this.new == 1) {
      this.sortField = 'RELEASE';
      this.curActive = 1;
    }
  },


  methods: {
    show: function show(selected) {
      var _this = this;

      this.selectObject = {
        que: this.query,
        selected: selected
      };

      this.$nextTick(function () {
        _this.showSlide = true;
      });

      this.$emit('navshow', selected);
    },
    selectNav: function selectNav(type, index, e) {
      var _this2 = this;

      var tar = e.currentTarget;

      if (type === 'FILTER') {
        if (this.clearFilter) {
          this.selectQuery = {
            cateSelected: '',
            brandSelected: '',
            hotSelected: ''
          };
        }

        var _selectQuery = this.selectQuery,
            cateSelected = _selectQuery.cateSelected,
            brandSelected = _selectQuery.brandSelected,
            hotSelected = _selectQuery.hotSelected;


        this.show(cateSelected + ',' + brandSelected + ',' + hotSelected);
      } else {
        // init sort
        if (type === this.sortField && type !== 'PRICE') return;
        if (type !== this.sortField) {
          this.sortField = type;
          this.sort = 2;
        } else if (type === this.sortField && type !== 'PRICE') {
          this.sort = 2;
          // if (this.type === 'search' && this.sortField) {
          //   this.sortField = ''
          //   this.sort = 3
          //   type = ''
          //   index = -1
          // }
          // else {

          // }
        }

        this.curActive = index;

        this.$nextTick(function () {
          if (type === 'PRICE') {
            _this2.sort = _this2.sort - 1;

            if (_this2.sort === 3) {
              type = '';
              _this2.curActive = -1;
            }
            // set sort
            tar.classList.remove('DESC');
            tar.classList.remove('ASC');
            if (ENUM_SORT[_this2.sort]) {
              tar.classList.add(ENUM_SORT[_this2.sort]);
            }
          }

          _this2.$emit('action', type, ENUM_SORT[_this2.sort]);

          if (_this2.type !== 'search') {
            _this2.sort = _this2.sort == 1 ? 3 : _this2.sort;
          } else {
            if (_this2.sort == 2) {
              _this2.sort = 2;
            } else if (_this2.sort == 3) {
              _this2.sort = 2;
            } else {
              _this2.sort = _this2.sort == 1 ? 3 : _this2.sort;
            }
          }
        });
      }
    },
    labelJump: function labelJump(label) {
      var title = '';

      if (label.linkDesc) {
        title = label.linkDesc.replace(/查看/, '');
      }

      window.location.href = label.link + '&title=' + encodeURIComponent(title);
    },
    onSelect: function onSelect(query, selected, saleSelected, isSelected) {
      if (query) {
        this.isKindActive = true;
      } else {
        this.isKindActive = false;
      }

      var _filter = document.querySelectorAll('.nav-item')[3];
      console.log(isSelected, '123');
      if (isSelected || saleSelected) {
        _filter.classList.add('active');
      } else {
        _filter.classList.remove('active');
      }

      this.showSlide = false;
      this.$emit('list', query, saleSelected);
    }
  }
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _appHeader = __webpack_require__(136);

var _appHeader2 = _interopRequireDefault(_appHeader);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _moreList = __webpack_require__(199);

var _moreList2 = _interopRequireDefault(_moreList);

var _apis = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _que = _queryString2.default.parse(window.location.search); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    cateList: _moreList2.default,
    AppHeader: _appHeader2.default
  },

  props: ['selectObject', 'clearFilter', 'discountSelected', 'isCouponSearch'],

  data: function data() {
    return {
      query: '',
      categories: null,
      brands: null,
      hots: null,
      selected: {},
      nameSelected: {},
      isReset: false,
      hideCate: false,
      hideBrand: false,
      isSale: false,
      saleSelected: false,
      isWechat: _browser2.default.weixin()
    };
  },
  created: function created() {
    this.initQuery();
    this.getCateg(this.query);
  },


  watch: {
    selectObject: function selectObject() {
      this.saleSelected = this.discountSelected;
      if (this.clearFilter) {
        this.initQuery();
        this.getCateg(this.query);
      }
    }
  },

  methods: {
    initQuery: function initQuery() {
      var _selectObject = this.selectObject,
          selected = _selectObject.selected,
          que = _selectObject.que;


      var tempSel = {};
      if (selected) {
        var cate = selected.split(',');
        cate.forEach(function (item, index) {
          var select = item.split('_');
          select.forEach(function (sel) {
            if (sel) {
              var tag = 'hot';
              switch (index) {
                case 0:
                  tag = 'cate';
                  break;
                case 1:
                  tag = 'brand';
                  break;
              }
              tempSel[sel] = tag;
            }
          });
        });
      }

      // 
      que = que.replace(/(&)+$/, '');

      if (_que.isCoupon == 'true') {
        que = que + '&couponSampleId=' + _que.couponSampleId;
      }

      this.query = que + '&selected=' + selected;
      this.selected = tempSel;
      this.isReset = (0, _keys2.default)(tempSel).length;
    },
    getCateg: function getCateg(query, notDel) {
      var _this = this;

      this.$showLoading();
      (0, _apis.getFilter)(query).then(function (_ref) {
        var data = _ref.data;

        _this.$hideLoading();
        _this.categories = data[1].items;
        _this.brands = data[2].items, // 品牌
        _this.hots = data[3].items; // 热门

        _this.isSale = data[0].items.length ? true : false;

        if (!notDel) {
          _this.delSelected();
        }

        if (_this.categories.length > 9 && !_this.getIsSelected('cate')) {
          _this.hideCate = true;
        }

        if (_this.brands.length > 9 && !_this.getIsSelected('brand')) {
          _this.hideBrand = true;
        }
      });
    },
    delSelected: function delSelected() {
      var categories = this.categories,
          brands = this.brands,
          hots = this.hots,
          selected = this.selected,
          nameSelected = this.nameSelected;


      var collects = [];
      var temp = {};

      categories.forEach(function (el) {
        collects.push(el.id);
      });

      brands.forEach(function (el) {
        collects.push(el.id);
      });

      hots.forEach(function (el) {
        collects.push(el.id);
      });

      for (var k in selected) {
        var sel = selected[k];

        if (~collects.indexOf(k)) {
          temp[k] = sel;
        } else {
          delete nameSelected[k];
        }
      }

      this.selected = temp;
      this.nameSelected = nameSelected;
      this.isReset = (0, _keys2.default)(temp).length;
    },
    getIsSelected: function getIsSelected(type) {
      for (var key in this.selected) {
        if (this.selected[key] === type) {
          return true;
        }
      }

      return false;
    },
    goSelect: function goSelect() {
      var _this2 = this;

      var query = this.query;
      var cateSelected = '';
      var brandSelected = '';
      var hotSelected = '';

      (0, _keys2.default)(this.selected).forEach(function (i) {
        var type = _this2.selected[i];
        if (type === 'cate') {
          cateSelected += i + '_';
        }
        if (type === 'brand') {
          brandSelected += i + '_';
        }

        if (type == 'hot') {
          hotSelected += i + '_';
        }
      });

      var selected = {
        cateSelected: cateSelected,
        brandSelected: brandSelected,
        hotSelected: hotSelected
      };

      query = query.replace(/(&)+$/, '');
      var tempQuery = query.replace(/selected=[A-Za-z0-9_,]+&?/g, '').replace(/(discountOnly=true&)$/, '');

      if (this.saleSelected) {
        query = tempQuery + 'discountOnly=true&';
      } else {
        query = tempQuery + 'selected=' + cateSelected + ',' + brandSelected + ',' + hotSelected + '&';
      }

      var _cateSelected = '';
      var _brandSelected = '';
      var _hotSelected = '';

      (0, _keys2.default)(this.nameSelected).forEach(function (i) {
        var obj = _this2.nameSelected[i];
        var type = obj.type;
        var name = obj.name;

        if (type === 'cate') {
          _cateSelected += name + '_';
        }
        if (type === 'brand') {
          _brandSelected += name + '_';
        }

        if (type == 'hot') {
          _hotSelected += name + '_';
        }
      });

      sa.track('CommodityScreen', {
        screen_classify: _cateSelected.split('_'),
        screen_brand_commodity: _brandSelected.split('_'),
        hot_label: _hotSelected.split('_')
      });

      this.$emit('select', query, selected, this.saleSelected, (0, _keys2.default)(this.selected).length);
    },
    goSale: function goSale() {
      this.saleSelected = !this.saleSelected;

      this.isReset = this.saleSelected;
      if (this.saleSelected) {
        this.selected = {};
        this.getCateg('&selected=,,,&' + this.query, true);
      }
    },
    selectItem: function selectItem(id, type, name, e) {
      var tar = e.currentTarget;
      var isActive = tar.dataset.active;

      var selected = this.selected,
          nameSelected = this.nameSelected,
          query = this.query;


      if (id in selected) {
        delete selected[id];
        delete nameSelected[id];
        tar.classList.remove('active');
      } else {
        selected[id] = type;
        nameSelected[id] = {
          type: type,
          name: name
        };
        tar.classList.add('active');
      }

      this.selected = selected;
      this.nameSelected = nameSelected;
      this.isReset = (0, _keys2.default)(selected);

      this.saleSelected = false;

      var selQue = this.formatSeled();

      this.getCateg('&selected=' + selQue + '&' + query);
    },


    goReset: function goReset() {
      var isReset = this.isReset,
          query = this.query;


      if (isReset) {
        this.getCateg('&selected=,,,&' + query);
      }

      this.selected = {};
      this.nameSelected = {};
      this.isReset = false;
      this.saleSelected = false;
    },

    getMore: function getMore(type) {
      if (type === 'brand') {
        this.hideBrand = !this.hideBrand;
      } else {
        this.hideCate = !this.hideCate;
      }
    },


    formatSeled: function formatSeled() {
      var _this3 = this;

      var cateQue = '';
      var brandQue = '';
      var hotQue = '';

      (0, _keys2.default)(this.selected).forEach(function (i) {
        var type = _this3.selected[i];

        if (type === 'cate') {
          cateQue += i + '_';
        }
        if (type === 'brand') {
          brandQue += i + '_';
        }
        if (type === 'hot') {
          hotQue += i + '_';
        }
      });

      return cateQue + ',' + brandQue + ',' + hotQue;
    }
  }
};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _appMenu = __webpack_require__(188);

var _appMenu2 = _interopRequireDefault(_appMenu);

var _search = __webpack_require__(159);

var _search2 = _interopRequireDefault(_search);

var _events = __webpack_require__(25);

var _events2 = _interopRequireDefault(_events);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _api = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.use(_events2.default);
exports.default = {
  components: {
    AppMenu: _appMenu2.default,
    Search: _search2.default
  },
  name: 'header',
  props: {
    cart: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    isHidden: { // hide navbar or not
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '加载中...'
    }
  },

  data: function data() {
    return {
      isApp: (0, _browser.app)(),
      isWechat: (0, _browser.weixin)(),
      cartNum: 0
    };
  },
  created: function created() {
    var _this = this;

    console.log(this._on, 'o');
    this._on('change-title', function (data) {
      console.log(data, 'tsr');
      _this.title = data;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // if (this.isWechat) {
    //   const searchWrap = document.querySelector('.detail-icon .search-wrap')

    //   if (searchWrap) {
    //     searchWrap.parentElement.style.display = 'none'
    //   }
    // }

    if (this.cart) {
      (0, _api.getCartNum)().then(function (data) {
        _this2.cartNum = data || 0;
      });
    }
  },


  computed: {
    headerClass: function headerClass() {
      return this.isWechat && this.isHidden ? 'header-wechat' : 'header-wap';
    }
  },

  methods: {
    goCarts: function goCarts() {
      window.location.href = '/cart';
    }
  }
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _main = __webpack_require__(191);

var _main2 = _interopRequireDefault(_main);

var _apis = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  components: {
    appMenu: _main2.default
  },

  data: function data() {
    return {
      isShow: false,
      config: null
    };
  },


  methods: {
    getConfig: function getConfig() {
      var cfg = this.getStorage();

      if (cfg) {
        this.config = cfg;
        this.reqConfig();
      } else {
        this.reqConfig(true);
      }
    },
    reqConfig: function reqConfig(flag) {
      var _this = this;

      (0, _apis.getConfig)().then(function (data) {
        if (flag) {
          _this.config = data.modules;
        }
        _this.setStorage(data.modules);
      });
    },
    goMenu: function goMenu() {
      this.getConfig();
      this.isShow = !this.isShow;
    },
    close: function close() {
      this.isShow = false;
    },
    getStorage: function getStorage() {
      var config = window.localStorage.getItem('__beast_config');

      return config ? JSON.parse(config) : null;
    },
    setStorage: function setStorage(cfg) {
      window.localStorage.setItem('__beast_config', (0, _stringify2.default)(cfg));
    }
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _util = __webpack_require__(137);

var _apis = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['data'],

  data: function data() {
    return {
      menu: this.data,
      member: null,
      isShow: false
    };
  },
  created: function created() {
    var _this = this;

    if (!this.member) {
      (0, _apis.getMember)().then(function (data) {
        _this.member = data;
      }).catch(function (err) {});
    }
  },


  methods: {
    jump: function jump(expand, link, e) {
      if (expand && expand.length) {
        this.showChild(e);
      } else {
        link = this.formatLink(link);

        var url = (0, _util.getLink)(link);
        window.location.href = url;
      }
    },
    closeMenu: function closeMenu() {
      this.$emit('close');
    },
    showChild: function showChild(e) {
      var tar = e.currentTarget;
      var item = tar.nextElementSibling;
      var isShow = item.dataset.show;

      if (isShow !== 'block') {
        isShow = 'block';
      } else {
        isShow = 'none';
      }

      tar.dataset.show = isShow;
      item.dataset.show = isShow;
      item.style.display = isShow;
    },
    formatLink: function formatLink(link) {
      var type = link.type,
          value = link.value;


      if (type == 'none') return false;

      var deeplink = 'beastapp://';

      switch (type) {
        case 'article':
          deeplink = deeplink + 'article/' + value;
          break;
        case 'shop':
          deeplink = deeplink + 'shop/' + value;
          break;
        case 'shop-story':
          deeplink = deeplink + 'entry?name=shop-story&shopId=' + value;
          break;
        case 'list':
          deeplink = deeplink + 'search?listId=' + value;
          break;
        case 'category':
          deeplink = deeplink + 'search?categoryId=' + value;
          break;
        case 'product':
          deeplink = deeplink + 'product/' + value;
          break;
        case 'oversea':
          deeplink = deeplink + 'search?overseasOnly=true';
          break;
        case 'categoryOversea':
          deeplink = deeplink + 'search?overseasOnly=true&categoryId=' + value;
          break;
        case 'deeplink':
          deeplink = '' + value;
          break;
        case 'brand':
          deeplink = deeplink + 'search?brandId=' + value;
          break;
        case 'tag':
          deeplink = deeplink + 'search?labelId=' + value;
          break;
        case 'group':
          deeplink = deeplink + 'entry?name=group-purchase&productId=' + value;
          break;
        case 'new':
          deeplink = deeplink + 'search?new=1';
          break;
        case 'custom':
          deeplink = deeplink + 'entry?name=customization-list';
          break;
        case 'discount':
          deeplink = deeplink + 'search?param=discount&title=\u6298\u6263';
          break;
        case 'retail':
          deeplink = deeplink + 'entry?name=retail&title=\u5B9E\u4F53\u5E97';
          break;
        case 'index':
          deeplink = deeplink + 'index';
          break;
      }

      return deeplink;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    staticClass: "menu-member"
  }, [_c('div', {
    staticClass: "member-logo"
  }, [(_vm.member) ? _c('img', {
    attrs: {
      "src": _vm.member && _vm.member.level.avatarUrl
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(195)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "member-infos"
  }, [_c('div', {
    staticClass: "member-name"
  }, [_vm._v(_vm._s(_vm.member && _vm.member.profile.nickName))]), _vm._v(" "), (_vm.member) ? _c('div', {
    staticClass: "member-account"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "member-account no-login"
  }, [_vm._m(1)])]), _vm._v(" "), _c('span', {
    staticClass: "close-member",
    on: {
      "click": _vm.closeMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('div', {
    staticClass: "menu-group"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'index',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.menu), function(item) {
    return _c('div', {
      staticClass: "menu-item"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          return _vm.jump(item.data.subCategory, item.data.link, $event)
        }
      }
    }, [_vm._v(_vm._s(item.data.title)), (item.data.subCategory.length) ? _c('i') : _vm._e()]), _vm._v(" "), (item.data.subCategory.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.expand),
        expression: "item.expand"
      }],
      staticClass: "menu-item-child",
      attrs: {
        "data-show": item.expand && 'block'
      }
    }, _vm._l((item.data.subCategory), function(child) {
      return _c('li', {
        staticClass: "menu-child-item",
        on: {
          "click": function($event) {
            return _vm.jump(null, child.link, $event)
          }
        }
      }, [_vm._v("\n              " + _vm._s(child.title) + "\n            ")])
    }), 0) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'custom',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("高级定制")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'discount',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("折扣优惠")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'retail',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("实体店")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("我的账号"), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("登录/快速注册"), _c('i')])
}]}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu-wrap"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.goMenu
    }
  }), _vm._v(" "), (_vm.config && _vm.isShow) ? _c('app-menu', {
    attrs: {
      "show": _vm.isShow,
      "data": _vm.config
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.getCartNum = getCartNum;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};

function getCartNum() {
  return (0, _axiosMock2.default)({
    url: '/app/cart/packs/size'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  }).catch(function (err) {
    return _promise2.default.reject(err);
  });
}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isApp) ? _c('div', {
    class: _vm.headerClass
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "z-index": "2000"
    }
  }, [_c('div', {
    staticClass: "header-left"
  }, [(_vm.menu) ? _c('app-menu', {
    staticClass: "header-left-menu"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.isWechat) ? _c('p', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._t("default"), _vm._v(" "), (_vm.cart) ? _c('div', {
    staticClass: "detail-icon detail-group"
  }, [_c('div', {
    staticClass: "carts-icon",
    on: {
      "click": _vm.goCarts
    }
  }, [_c('i'), _vm._v(" "), (_vm.cartNum > 0) ? _c('div', {
    staticClass: "fix-num"
  }, [_c('div', {
    staticClass: "cart-num"
  }, [_vm._v(_vm._s(_vm.cartNum))]), _vm._v(" "), _c('div', {
    staticClass: "triangle-right"
  })]) : _vm._e()])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appHeader = __webpack_require__(136);

var _appHeader2 = _interopRequireDefault(_appHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    AppHeader: _appHeader2.default
  },

  props: ['data']
}; //
//
//
//
//
//
//
//

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "more-list"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      attrs: {
        "data-id": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kind-wrap"
  }, [(_vm.isSale) ? _c('div', {
    staticClass: "sale",
    class: {
      'active': _vm.saleSelected
    },
    on: {
      "click": _vm.goSale
    }
  }, [_vm._v("查看折扣商品")]) : _vm._e(), _vm._v(" "), (_vm.categories && _vm.categories.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("分类\n      "), (_vm.categories.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('cate')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideCate ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideCate
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideCate
    }
  }, _vm._l((_vm.categories), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'cate', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brands && _vm.brands.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("品牌\n      "), (_vm.brands.length > 9) ? _c('div', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.getMore('brand')
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hideBrand ? '更多' : '收起'))]), _c('div', {
    staticClass: "icon",
    class: {
      'hide': !_vm.hideBrand
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ul-list",
    class: {
      'hide-cate': _vm.hideBrand
    }
  }, _vm._l((_vm.brands), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'brand', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.hots && _vm.hots.length) ? _c('div', {
    staticClass: "kind-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ul-list"
  }, _vm._l((_vm.hots), function(item, index) {
    return _c('div', {
      staticClass: "list",
      class: {
        'cancel-margin': (index + 1) % 3 == 0,
          'active': _vm.selected[item.id]
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(item.id, 'hot', item.name, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "kind-footer"
  }, [_c('span', {
    staticClass: "reset",
    class: {
      'active': _vm.isReset
    },
    on: {
      "click": _vm.goReset
    }
  }, [_vm._v("重置筛选项")]), _vm._v(" "), _c('span', {
    staticClass: "select",
    on: {
      "click": _vm.goSelect
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_vm._v("热门标签\n      "), _c('p')])
}]}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrap"
  }, [_c('div', {
    staticClass: "nav-bar"
  }, [_c('div', {
    staticClass: "nav-kinds",
    class: 'no-member'
  }, _vm._l((_vm.navName), function(item, index) {
    return _c('div', {
      staticClass: "nav-item",
      class: {
        active: index == _vm.curActive
      },
      on: {
        "click": function($event) {
          return _vm.selectNav(_vm.navType[index], index, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n        "), (_vm.navType[index] === 'PRICE') ? _c('span', {
      staticClass: "icon-sort"
    }, [_c('i', {
      class: {
        'icon-kinds': _vm.navType[index] == 'FILTER',
          'active': _vm.isKindActive
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('slide', {
    attrs: {
      "from": "right",
      "height": "100%",
      "show": _vm.showSlide,
      "maskOpacity": 0
    }
  }, [(_vm.selectObject) ? _c('nav-list', {
    attrs: {
      "discountSelected": _vm.discountSelected,
      "selectObject": _vm.selectObject,
      "clearFilter": _vm.clearFilter,
      "isCouponSearch": _vm.isCouponSearch
    },
    on: {
      "select": _vm.onSelect
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.tips) ? _c('div', {
    staticClass: "top-tip"
  }, [_vm._v(_vm._s(_vm.tips))]) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "label-tag",
    class: {
      valid: !_vm.label.valid
    }
  }, [_c('div', {
    staticClass: "tag-name",
    style: ({
      'background-color': _vm.label.typeBgColor,
      'color': _vm.label.typeColor
    })
  }, [_vm._v(_vm._s(_vm.label.type))]), _vm._v(" "), _c('div', {
    staticClass: "tag-desc"
  }, [_vm._v(_vm._s(_vm.label.summary))]), _vm._v(" "), (_vm.label.jump) ? _c('div', {
    staticClass: "tag-link",
    on: {
      "click": function($event) {
        return _vm.labelJump(_vm.label)
      }
    }
  }, [_vm._v(_vm._s(_vm.label.linkDesc)), _c('i')]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _simpleProductNew = __webpack_require__(166);

var _simpleProductNew2 = _interopRequireDefault(_simpleProductNew);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _sdk = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    simpleProduct: _simpleProductNew2.default
  },

  props: ['data', 'keys', 'suggest'],

  data: function data() {
    return {
      list: null,
      sdk: null,
      env: 'm-web'
    };
  },
  created: function created() {
    var _this = this;

    (0, _sdk.getEnv)().then(function (sdk) {
      sdk.init({
        vue: _this
      });
      _this.sdk = sdk;
      _this.env = sdk.adapter.env;
    });
  },


  methods: {
    goPro: function goPro(pid) {
      if (this.enable) {
        return;
      }
      location.href = '/product/' + pid;
    },
    trackData: function trackData(index) {
      (0, _track2.default)({
        name: 'click-result',
        attrs: {
          index: index
        },
        wait: true
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    staticClass: "product-list"
  }, [(_vm.suggest) ? _c('div', {
    staticClass: "suggest"
  }, [_c('p', [_vm._v("没找到\"" + _vm._s(_vm.keys) + "\"的搜索结果\"")]), _vm._v(" "), _c('p', [_vm._v("为你推荐\"" + _vm._s(_vm.suggest.keyword) + "\"的相关商品")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.data.length) ? _c('simple-product', {
      class: {
        'no-margin': (index + 1) % 2 === 0
      },
      attrs: {
        "sdk": _vm.sdk,
        "env": _vm.env,
        "index": index,
        "searchKey": _vm.keys,
        "data": item
      },
      on: {
        "click": function($event) {
          return _vm.trackData(index)
        }
      }
    }) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    list: {
      type: Array
    },
    aKey: {
      type: String
    }
  },

  methods: {
    selectKey: function selectKey(item) {
      this.$emit('selectItem', item);
    },
    output: function output(item) {
      var reg = new RegExp('(' + this.aKey + ')', 'i');

      return item.name.replace(reg, '<span class="associate-key">$1</span>');
    }
  }
};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associate"
  }, [_c('ul', {
    staticClass: "associate-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(_vm.output(item))
      },
      on: {
        "click": function($event) {
          return _vm.selectKey(item)
        }
      }
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

exports.searchByKeywords = searchByKeywords;
exports.getHotSearch = getHotSearch;
exports.getAssociate = getAssociate;

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headers = {};

function searchByKeywords(query) {
  var increase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var limit = 20;
  var offset = increase * limit;

  return (0, _axiosMock2.default)({
    headers: headers,
    url: '/app/search/product?' + query + '&limit=' + limit + '&offset=' + offset
  });
}

function getHotSearch() {
  return (0, _axiosMock2.default)({
    headers: headers,
    url: '/app/search/suggest'
  }).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;

    return _promise2.default.resolve(data);
  });
}

function getAssociate(keyword) {
  return (0, _axiosMock2.default)({
    url: '/app/search/associate?keyword=' + keyword
  });
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    on: {
      "scroll": _vm.onScroll
    }
  }, [_c('div', {
    staticClass: "search-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultKey),
      expression: "defaultKey"
    }],
    attrs: {
      "type": "search",
      "name": "search-input",
      "placeholder": (typeof _vm.defaultKey == 'object' && _vm.defaultKey && _vm.defaultKey.name) || '搜索全网商品'
    },
    domProps: {
      "value": (_vm.defaultKey)
    },
    on: {
      "focus": _vm.focusInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "search-cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), (_vm.isSearch) ? _c('div', {
    staticClass: "result-list"
  }, [_c('nav-bar', {
    staticClass: "p-nav-bar",
    attrs: {
      "query": ("keyword=" + _vm.key),
      "type": 'search'
    },
    on: {
      "navshow": _vm.navshow,
      "action": _vm.action,
      "list": _vm.list
    }
  }), _vm._v(" "), (!_vm.seaching && !_vm.items.length) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(215)
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有搜索到你要的结果")])]) : _vm._e(), _vm._v(" "), _c('search-list', {
    attrs: {
      "data": _vm.items,
      "keys": _vm.key,
      "suggest": _vm.suggest
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "go-cart",
    on: {
      "click": _vm.goCart
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAssociate && !_vm.isCouponSearch) ? _c('associate-list', {
    attrs: {
      "list": _vm.associateList,
      "aKey": _vm.aKey
    },
    on: {
      "selectItem": _vm.search
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSearch && !_vm.isCouponSearch) ? _c('div', {
    staticClass: "search-key"
  }, [(_vm.history.length > 1) ? _c('div', {
    staticClass: "latest-key"
  }, [_c('span', {
    staticClass: "search-clear",
    on: {
      "click": _vm.clearSearch
    }
  }), _vm._v(" "), _c('h2', [_vm._v("搜索历史")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "history-key"
    }
  }, [_vm._l((_vm.history), function(item, index) {
    return (item && index < _vm.maxIndex) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.goSearch(item, '历史词')
        }
      }
    }, [_vm._v(_vm._s(item) + " ")]) : _vm._e()
  }), _vm._v(" "), (_vm.hideMore && _vm.history.length > 6) ? _c('li', {
    staticClass: "item-more",
    on: {
      "click": _vm.showMoreHist
    }
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.hotItem && _vm.hotItem.hotKeys.length > 0) ? _c('div', {
    staticClass: "hot-key"
  }, [_c('h2', [_vm._v("热门发现")]), _vm._v(" "), _c('ul', _vm._l((_vm.hotItem.hotKeys), function(item) {
    return _c('li', {
      class: {
        'high-light': item.highlight
      },
      on: {
        "click": function($event) {
          return _vm.goLink(item, true, '热门搜索')
        }
      }
    }, [_c('i'), _vm._v(_vm._s(item.name) + " ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.banners.length) ? _c('div', {
    staticClass: "search-banner"
  }, _vm._l((_vm.banners), function(banner) {
    return _c('div', {
      staticClass: "img-item",
      on: {
        "click": function($event) {
          return _vm.jumpBanner(banner.link)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": banner.src
      }
    })])
  }), 0) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "s/img/icon-empty.eb42237.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrap"
  }, [(_vm.mode === 'input') ? _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    attrs: {
      "placeholder": "点击搜索"
    },
    on: {
      "click": _vm.goSearch
    }
  })]) : (_vm.mode === 'line-input' && !_vm.isCouponSearch) ? _c('div', {
    staticClass: "line-search-wrap"
  }, [_c('div', {
    staticClass: "line-search-box",
    on: {
      "click": _vm.goSearch
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-pa search-text"
  }, [_vm._v(_vm._s(_vm.searchText))])])]) : _c('div', {
    staticClass: "search-icon",
    on: {
      "click": _vm.goSearch
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.searchIcon
    }
  })]), _vm._v(" "), (_vm.isShow) ? _c('search', {
    attrs: {
      "show": _vm.isShow,
      "isCouponSearch": _vm.isCouponSearch
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-pa search-icon"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(217)
    }
  })])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAS1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADmYDp0AAAAGHRSTlMA0hORsyro+rLw1szHvqaZa2RPRT4c3YYni5VJAAABOklEQVRYw+2W626DMAyFA7lSCFAohfd/0tWk1bQJHHdnqiqV84/Y+Uh8SaIOHXqtRh1q510d9Pin+Ze2Wr5VtZdnAdYsv2XsUwS9bEnLAWV8TCpMN3emeHzGUrqJa5rQ9NN9ZOqbNHS1sjUkwmn4MTqcEkO0jrizb532Io2kP29Yzl4WU7uQiLDBWG3ZcJj0J2aFJleTayR3zWtMM3Xaks+wax7I3PKIiuqBsTfUL3xv0l96xqEnhzGb0YlxmLJ5DdQXihP1S+AcakpaNuk15+BuDh2L6G4ejnOgEp5ZxEzl/3+rwGOBZwSvC7w68R7BOxU/L/BTCz874RM8wPeIL0rsNiMRA7hT7wzgZvcMQ/a+CAWzDuErp2QY0rcWz8i/+HhGXgfjgxhRoQxnFcggAsYgAsaIVh16V30Bv1o1NG/U1poAAAAASUVORK5CYII="

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _dialog = __webpack_require__(11);

var _dialog2 = _interopRequireDefault(_dialog);

var _controller = __webpack_require__(225);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winWidth = window.innerWidth; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    BDialog: _dialog2.default,
    controller: _controller2.default
  },

  props: {
    wrap: {
      default: ''
    },
    videoId: {
      default: ''
    },
    videoIndex: {
      default: 0
    },
    totalVideo: {
      default: 0
    },
    width: {
      default: 'auto'
    },
    height: {
      default: 'auto'
    },
    controls: {
      default: true
    },
    poster: {
      default: './assets/poster.jpeg'
    },
    source: String,
    autoplay: {
      default: false
    },
    videoFormat: {
      default: ''
    },
    muted: {
      default: 'muted'
    },
    radius: {
      default: '0'
    },
    multiVideo: {
      default: false
    },
    videoPopData: {
      default: null
    },
    playVideo: {
      default: false
    }
  },

  data: function data() {
    return {
      w: 0,
      h: 0,
      // showControls: false,
      showControls: true, //视频controls一直展示，controls字段用来控制进度条是否展示
      container: null,
      added: false,
      video: null,
      videoPop: null,
      video_wrap: null,
      poster_dom: null,
      loading: null,
      loading_dom: null,
      updateTime: 0,
      duration: 0,
      showLoading: false,
      isShowContr: false,
      isFullScreen: false,
      loop: this.autoplay && !this.controls ? true : false,
      wxAndroidFlag: _browser2.default.weixin() && _browser2.default.android()
      // wxAndroidFlag: true
    };
  },


  // watch: {
  //   videoIndex: function(){
  //     console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$')
  //     for(var i = 0; i<this.totalVideo; i++) {
  //       if(this.videoId) {
  //         this.pause()
  //       }
  //     }
  //   }
  // },

  mounted: function mounted() {
    var wrap = document.querySelector('.' + this.wrap);
    // console.log(wrap, 'wrap')
    this.container = wrap.querySelector('.video-container');
    this.video = this.container.querySelector('.j_video');
    // this.videoPop = this.container.querySelector('.j_video_pop')
    this.video_wrap = this.container.querySelector('.j_video_wrap');
    this.poster_dom = this.container.querySelector('.poster');
    this.loading_dom = this.container.querySelector('.j_loading');
    this.loading = this.container.querySelector('.j_loading_img');

    this.container.style.height = this.height + 'px';
    this.w = this.container.clientWidth || this.width + 'px';
    this.h = this.height;

    //默认都有自定义controls  通过controlsFlag控制是否展示播放暂停 进度调节等按钮
    // if (this.controls) {
    //   this.showControls = true
    // }
    if (this.wxAndroidFlag) {
      // this.video.muted = false
      this.showControls = false;
    }

    if (this.autoplay && _browser2.default.app() || this.playVideo) {
      this.onPlay();
    }
    // if ((this.autoplay && browser.app()) || (this.autoplay && this.muted) || this.playVideo) {
    //   this.onPlay()//app里面可以自动播放  非app但是静音模式可以自动播放 
    // }

    if (_browser2.default.app() && _browser2.default.android()) {
      if (this.muted) {
        this.video.muted = true;
      }
    }
  },


  methods: {
    onPlay: function onPlay() {
      if (this.wxAndroidFlag && this.multiVideo) {
        //安卓的微信环境且是多视频 触发浮层视频
        this.$emit('video-pop', this.videoPopData);
      } else {
        if (!this.added) {
          this._showLoading();
          this._addVideo();
        } else {
          this.play();
        }
      }
    },
    play: function play() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.video.currentTime = time;
      this.poster_dom.style.display = 'none';
      this.video.play();
    },
    pause: function pause() {
      this.video.pause();
      // if (this.controls) {
      //   this.controls.set('pause')
      // }
    },
    cPlay: function cPlay() {
      this.play(this.video.currentTime);
      this.isShowContr = false;
    },
    cPause: function cPause() {
      // console.log(this.video.paused, '###########')
      if (this.videoId) {
        !this.video.paused && this.pause();
      } else {
        this.pause();
      }
    },
    cJump: function cJump(time) {
      this.video.currentTime = time;
    },
    cFull: function cFull() {
      if (_browser2.default.ios()) {
        this.isFullScreen = true;
      } else {
        this.controls && (this.showControls = false);
        this.video.requestFullScreen && this.video.requestFullScreen();
        this.video.webkitRequestFullScreen && this.video.webkitRequestFullScreen();
      }
    },
    cExitFull: function cExitFull() {
      if (_browser2.default.ios()) {
        this.isFullScreen = false;
      }
    },
    cMuted: function cMuted() {
      this.video.muted = true;
    },
    cVoice: function cVoice() {
      this.video.muted = false;
    },
    posterLoaded: function posterLoaded(e) {
      var posterImg = e.currentTarget;

      this.fit(posterImg);
      posterImg.style.pointerEvents = 'all';
    },
    fit: function fit(el) {
      this._scale(el);

      el.style.visibility = 'visible';
    },
    toggleContr: function toggleContr() {
      if (document.webkitIsFullScreen) {
        return;
      }
      // this.controls && (this.isShowContr = true)
      this.isShowContr = true;
    },
    controlAction: function controlAction() {
      if (document.webkitIsFullScreen) {
        return;
      }
      this.isShowContr = !this.isShowContr;
    },
    _scale: function _scale(el) {
      this.w = parseInt(this.w);
      this.h = parseInt(this.h);

      if (this.w && !this.h) {
        el.style.width = '100%';
        this.container.style.height = el.clientHeight + 'px';
        this.h = el.clientHeight + 'px';
        // this.controls && this.controls.setMask(this.height - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }

      if (!this.w && this.h) {
        el.style.height = this.h + 'px';
        el.style.position = 'absolute';
        el.style.webkitTransform = 'translateX(-50%)';
        el.style.transform = 'translateX(-50%)';
        el.style.left = '50%';
        el.style.top = 0;

        this.container.style.width = el.clientWidth + 'px';
        this.w = el.clientWidth + 'px';
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }

      if (this.w && this.h) {
        var containerScale = this.w / this.h;
        var elScale = el.clientWidth / el.clientHeight;

        el.style.position = 'absolute';

        if (containerScale > elScale) {
          el.style.height = this.h + 'px';
          el.style.webkitTransform = 'translateX(-50%)';
          el.style.transform = 'translateX(-50%)';
          el.style.left = '50%';
          el.style.top = 0;
        } else {
          el.style.width = this.w + 2 + 'px';
          el.style.height = '100%';
          // el.style.webkitTransform = 'translateY(-50%)'
          // el.style.transform = 'translateY(-50%)'
          // el.style.top = '50%'
          el.style.transform = 'translateY(0)';
          el.style.top = '-1px';
          el.style.left = '-1px';
        }
        // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
        return;
      }
      // this.controls && this.controls.setMask(this.h - (Math.round(16 * winWidth / 375) + Math.round(26 * winWidth / 375)))
    },
    _addVideo: function _addVideo() {
      var _this = this;

      // this.video.controls = false
      this.added = true;

      this.video.on = function (event, callback) {
        _this.video.addEventListener(event, callback);
        return _this.video;
      };

      this.video.removeAttribute('controls');
      //fuck ios10, onresize only works in ios10
      this.video.onresize = function (e) {
        if (e.srcElement === window) {
          _this.video.removeAttribute('controls');
        }
      };

      this.video.on('play', function () {
        // this.controls && this.controls.set('play')
        _this.$emit('play');
      }).on('pause', function () {
        // this.controls && this.controls.set('pause')
        _this.$emit('pause');
      }).on('waiting', function () {
        _this._showLoading();
      }).on('canplay', function () {
        _this._hideLoading();
      }).on('loadedmetadata', function () {
        _this.fit(_this.video, _this.video_wrap);
        _this.controls && (_this.duration = _this.video.duration);
      }).on('loadeddata', function () {
        _this.play();
      }).on('timeupdate', function () {
        _this.updateTime = _this.video.currentTime + '-' + _this.video.duration;
        _this.$emit('playing', _this.video.currentTime);
      }).on('ended', function () {
        _this.$emit('ended');
        if (_this.controls) {
          _this.isShowContr = false;
          _this.updateTime = '0-' + _this.video.duration;
        }
        _this.poster_dom.style.display = '';
      }).on('error', function (e) {
        console.log('error', e);
        _this.$emit('error', e);
      }).on('abort', function (e) {
        console.log('abort', e);
        _this.$emit('abort', e);
      });

      this.video.src = this.source;
      this.play();
    },
    _showLoading: function _showLoading() {
      // this.showControls = false
      this.showLoading = true;
      this.loading_dom.style.display = 'block';
      this.loading.style.display = 'block';
    },
    _hideLoading: function _hideLoading() {
      this.showLoading = false;
      this.loading_dom.style.display = 'none';
    },
    resume: function resume() {
      this.video.currentTime = 0;
      this.video.pause();
      this.poster_dom.style.display = 'block';
      this.$emit('resume');
    },
    isPaused: function isPaused() {
      return this.video.paused;
    }
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var winWidth = window.innerWidth; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['updateTime', 'duration', 'width', 'wrap', 'mutedD', 'controlsFlag', 'videoId', 'videoIndex', 'totalVideo', 'autoplay', 'loop'],

  data: function data() {
    return {
      container: null,
      progress_bar: null,
      controls: null,
      startTime: null,
      endTime: null,
      played: false,
      isFullScreen: false,
      bar: null,
      c_wrap: null,
      mutedData: this.mutedD
    };
  },


  watch: {
    updateTime: function updateTime(time) {
      var t = time.split('-');

      this._updateTime(t[0], t[1]);
    },
    duration: function duration(_duration) {
      var t = this._format(_duration);

      this.endTime.innerHTML = t.m + ':' + t.s;
    },
    width: function width() {
      //65 padding15*2+voice20+voicepadding15*2
      // console.log(this.width, '$$$$$$$$$width')
      this.bar.style.width = this.width - 4 - (winWidth / 375 * 80 + this.startTime.clientWidth + this.endTime.clientWidth) + 'px';
    },
    videoIndex: function videoIndex(_videoIndex) {
      console.log(this.videoId, this.totalVideo, this.videoIndex, '$$$$$$$$$$$$$$$$');
      if (!this.autoplay || !this.loop) {
        //非背景自动播放模式 swiper滑动暂停视频播放
        for (var i = 0; i < this.totalVideo; i++) {
          if (this.videoId) {
            this.pause();

            // const videoIndex = this.videoIndex || 1
            // this.controls.style.zIndex=videoIndex+6
          }
        }
      }
    }
  },

  mounted: function mounted() {
    this.c_wrap = document.querySelector('.' + this.wrap);
    this.container = this.c_wrap.querySelector('.controls');
    this.progress_bar = this.container.querySelector('.j_progress_bar');
    this.controls = this.container.querySelector('.j_controls');
    this.playBtn = this.container.querySelector('.j_play');
    this.pauseBtn = this.container.querySelector('.j_pause');
    this.full_btn = this.container.querySelector('.j_full');
    this.exitFullBtn = this.container.querySelector('.j_exit_full');
    this.voiceBtn = this.container.querySelector('.j_voice');
    this.mutedBtn = this.container.querySelector('.j_muted');
    this.startTime = this.container.querySelector('.j_start_time');
    this.endTime = this.container.querySelector('.j_end_time');
    this.bar = this.container.querySelector('.j_bar');
  },


  methods: {
    controlAction: function controlAction() {
      this.$emit('control-action');
    },
    play: function play() {
      this.played = false;
      this.$emit('play');
    },
    pause: function pause() {
      this.played = true;
      this.$emit('pause');
    },
    jumpTime: function jumpTime(e) {
      var bar = e.currentTarget;
      var pos = e.layerX;
      var total = bar.clientWidth;
      var time = this.computeTime(pos, total);

      this.$emit('jump', time);
      this._updateTime(time, this.duration);
    },
    fullScreen: function fullScreen() {
      this._fullScreen();
      this.$emit('full');
    },
    exitFullScreen: function exitFullScreen() {
      this._exitFullScreen();
      this.$emit('exitfull');
    },
    _fullScreen: function _fullScreen() {
      if (_browser2.default.ios) {
        this.isFullScreen = true;
      }
    },
    _exitFullScreen: function _exitFullScreen() {
      if (_browser2.default.ios) {
        this.isFullScreen = false;
      }
    },
    muted: function muted() {
      this.mutedData = true;
      this.$emit('mutedA');
    },
    voice: function voice() {
      this.mutedData = false;
      this.$emit('voice');
    },
    computeTime: function computeTime(cur, total) {
      return (cur / total).toFixed(2) * this.duration;
    },
    _updateTime: function _updateTime(time, duration) {
      var t = this._format(time);
      this.startTime.innerHTML = t.m + ':' + t.s;

      if (duration) {
        this.progress_bar.style.width = time / duration * 100 + '%';
      }
    },
    _format: function _format(time) {
      var t = Math.floor(time);
      var m = Math.floor(t / 60);
      var s = t - m * 60;
      return {
        m: m < 10 ? '0' + m : m,
        s: s < 10 ? '0' + s : s
      };
    }
  }
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls j_controls",
    on: {
      "click": _vm.controlAction
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.played),
      expression: "played"
    }],
    staticClass: "play-icon j_play",
    class: {
      'disnone': !_vm.controlsFlag
    },
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.play($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(229)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.played),
      expression: "!played"
    }],
    staticClass: "pause-icon j_pause",
    class: {
      'disnone': !_vm.controlsFlag
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pause($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(230)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask1 j_mask1"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask2 j_mask2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mask3 j_mask3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "left",
    class: {
      'opa0': !_vm.controlsFlag
    }
  }, [_c('div', {
    staticClass: "time j_start_time"
  }, [_vm._v("00:00")]), _vm._v(" "), _c('div', {
    staticClass: "bar-wrap j_bar"
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "click": _vm.jumpTime
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "time j_end_time"
  }, [_vm._v("00:00")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mutedData),
      expression: "!mutedData"
    }],
    staticClass: "voice j_voice",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.muted($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(231)
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutedData),
      expression: "mutedData"
    }],
    staticClass: "exit voice j_muted",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.voice($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(232)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar j_progress_bar"
  }, [_c('div', {
    staticClass: "bar-circle"
  })])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA6CAYAAADP/mu6AAAABGdBTUEAALGPC/xhBQAAAn1JREFUaAXVmk8uBEEUxqdFLK25ADcwFg5gwSGmD8ACwRFIcASzcAMk7CWMG7BkQWIjsWMxvjeZN6lUurvqddffTp7q+kP/3jdVn+qe7vVyPsbj8RViObscAP2NeEMMEEU2CUzBCZ7iDrGaBbwGTvBfiEPEQqoJTKYFgdcAvqJ9pyiKp5r+aM1zhiuvoJ+mzjli0TA2aLcJnGFKnDwDfosbYpe24MS5hCDbTMI6JeAsMqk+QgJRrdO0OBm2rqRFu4vF+1I3wFd7G8VVlnVUHqD+ESKodXZVXE0iqHV2VVwFD2qdLsE5iRIn3q3TBzgl4N06fYGz+mydJRav012ny8XJsHXlCB2073Finb4VV5Poo+LMOkMqribR2TpDKq6Cd7bOWOCcRIkTss5tbrAtY02VKr4bNB5g8X5UdeptsRVXecg6SX0r60xJcTUJo3WmpLgKbrTOVBVXk6i0zlQVV8HZOi8w/2c37DmAcxIDnMysMydwTmBS5gQ+BHEfPn9N5PP0I/GDFifdkD+qnCkr/gfQU8SGDk0JpKp4dv+AfiDmHmITKjfecKSk+C2A9wFstclKAfwTwLQrnLgFzq2O2ItzCMqZxVkRTwfFUrzS4lIGJ4s7R5xhavxKQPWxIRU3WpwO11QPMcetLa4JVO/zrbjI4nS4prov8FYW1wSq9/mYKpe4SCuL0+Ga6i4Vr7zFarp4lz4XipPFnSBoFxfsi9yuiju1OMkn0FZxLxYnAW+juOhRmQRGMlYC7t3iJOC2U4Usbk269ZSASMeaFA9qcVL4Hp4Q8dtBXNKLNseIoN8WdwW/B3BWrza9A9jq2bRYGV+/AOAk3kHxlV9Sf/cfk4hP2K18hugAAAAASUVORK5CYII="

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAA6CAYAAADybArcAAAABGdBTUEAALGPC/xhBQAAALtJREFUaAXtksENgCAAxMQJ3H9KN8C4QrHGmPrvCS3b9pNv3PeYc54r9xljHCv8E//fVw7wJbaLfKnGfZaKVEQy0NOSxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngRWRxOLZimB1ElgRSSyerQhWJ4EVkcTi2YpgdRJYEUksnq0IVieBFZHE4tmKYHUSWBFJLJ6tCFYngb8pIvl5f/YCAuMIcFqvJvcAAAAASUVORK5CYII="

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container",
    class: {
      'full-screen': _vm.isFullScreen
    }
  }, [(_vm.wxAndroidFlag) ? _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  })]) : _c('div', {
    staticClass: "video-wrap j_video_wrap",
    attrs: {
      "id": _vm.videoId
    }
  }, [(_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "loop": "loop",
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && _vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true",
      "muted": "muted"
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : (!_vm.loop && !_vm.muted) ? _c('video', {
    staticClass: "j_video video",
    class: {
      'cover-fit': _vm.videoFormat === 'COVER'
    },
    style: ({
      'border-radius': ("" + _vm.radius)
    }),
    attrs: {
      "autoplay": "",
      "x5-video-player-type": "h5",
      "x-webkit-airplay": "true",
      "x5-playsinline": "true",
      "webkit-playsinline": "true",
      "playsinline": "true"
    },
    on: {
      "click": _vm.toggleContr
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "poster j_poster"
  }, [_c('img', {
    staticClass: "poster-img j_poster_img",
    attrs: {
      "src": _vm.poster
    },
    on: {
      "load": _vm.posterLoaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "play-mask"
  }, [_c('img', {
    staticClass: "play-icon j_play_btn",
    attrs: {
      "src": __webpack_require__(234)
    },
    on: {
      "click": _vm.onPlay
    }
  })])]), _vm._v(" "), (_vm.showControls) ? _c('controller', {
    class: {
      'c-hidden': !_vm.isShowContr
    },
    attrs: {
      "updateTime": _vm.updateTime,
      "duration": _vm.duration,
      "width": _vm.w,
      "wrap": _vm.wrap,
      "mutedD": _vm.muted,
      "controlsFlag": _vm.controls,
      "videoId": _vm.videoId,
      "videoIndex": _vm.videoIndex,
      "totalVideo": _vm.totalVideo,
      "autoplay": _vm.autoplay,
      "loop": _vm.loop
    },
    on: {
      "play": _vm.cPlay,
      "pause": _vm.cPause,
      "jump": _vm.cJump,
      "full": _vm.cFull,
      "exitfull": _vm.cExitFull,
      "mutedA": _vm.cMuted,
      "voice": _vm.cVoice,
      "control-action": _vm.controlAction
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading j_loading"
  }, [_c('div', {
    staticClass: "img-wrap j_loading_img"
  }, [_c('span')])])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataStr = '[{"name":"华北","value":[{"name":"北京","value":[{"name":"北京市","value":["东城区","西城区","朝阳区","海淀区","丰台区","石景山区","通州区","顺义区","大兴区","昌平区"]}]},{"name":"天津","value":[{"name":"天津市","value":["和平区","河东区","河西区","南开区","河北区","红桥区","北辰区","东丽区","津南区","西青区","武清区","滨海新区"]}]},{"name":"山东","value":[{"name":"滨州市","value":["滨城区"]},{"name":"淄博市","value":["淄川区","张店区","周村区"]},{"name":"济南市","value":["历下区","市中区","槐荫区","天桥区","历城区","长清区"]},{"name":"烟台市","value":["芝罘区","福山区","牟平区","莱山区"]},{"name":"泰安市","value":["岱岳区","泰山区"]},{"name":"临沂市","value":["罗庄区","河东区","兰山区"]},{"name":"聊城市","value":["东昌府区"]},{"name":"潍坊市","value":["坊子区","奎文区","潍城区","开发区","寒亭区"]},{"name":"青岛市","value":["市南区","市北区","四方区","崂山区","李沧区"]},{"name":"枣庄市","value":["市中区","峄城区","滕州市","薛城区"]},{"name":"德州市","value":["德城区"]},{"name":"莱芜市","value":["莱城区"]},{"name":"东营市","value":["东营区","西城区","东城区"]},{"name":"威海市","value":["环翠区"]},{"name":"济宁市","value":["任城区","市中区"]},{"name":"日照市","value":["东港区"]},{"name":"菏泽市","value":["牡丹区"]}]},{"name":"河北","value":[{"name":"秦皇岛市","value":["海港区","经济技术开发区"]},{"name":"张家口市","value":["桥东区","桥西区"]},{"name":"保定市","value":["北市区","南市区","新市区","高开区"]},{"name":"唐山市","value":["丰南区","开平区","路北区","路南区"]},{"name":"廊坊市","value":["安次区","广阳区"]},{"name":"沧州市","value":["新华区","运河区"]},{"name":"邯郸市","value":["邯山区","丛台区","复兴区","邯郸县"]},{"name":"衡水市","value":["桃城区"]},{"name":"邢台市","value":["桥东区","桥西区"]},{"name":"石家庄市","value":["长安区","桥东区","桥西区","新华区","裕华区"]}]},{"name":"山西","value":[{"name":"运城市","value":["盐湖区"]},{"name":"晋中市","value":["榆次区"]},{"name":"长治市","value":["城区","郊区"]},{"name":"晋城市","value":["城区","泽州县"]},{"name":"临汾市","value":["尧都区"]},{"name":"太原市","value":["小店区","迎泽区","杏花岭区","尖草坪区","万柏林区","晋源区"]}]},{"name":"内蒙古自治区","value":[{"name":"包头市","value":["昆都仑区","东河区","青山区","石拐区","九原区"]},{"name":"鄂尔多斯市","value":["东胜区","伊金霍洛旗"]},{"name":"呼和浩特市","value":["回民区","新城区","玉泉区","赛罕区"]},{"name":"赤峰市","value":["红山区","松山区"]}]}]},{"name":"华东","value":[{"name":"上海","value":[{"name":"上海市","value":["黄浦区","徐汇区","长宁区","静安区","普陀区","闸北区","虹口区","杨浦区","闵行区","奉贤区","青浦区","宝山区","嘉定区","浦东新区","松江区","金山区"]}]},{"name":"浙江","value":[{"name":"杭州市","value":["上城区","下城区","西湖区","拱墅区","滨江区","江干区","余杭区","萧山区"]},{"name":"湖州市","value":["吴兴区"]},{"name":"绍兴市","value":["越城区"]},{"name":"温州市","value":["鹿城区","瓯海区","龙湾区"]},{"name":"台州市","value":["椒江区","黄岩区","路桥区"]},{"name":"舟山市","value":["定海区","普陀区"]},{"name":"金华市","value":["婺城区","金东区"]},{"name":"丽水市","value":["莲都区"]},{"name":"宁波市","value":["海曙区","江北区","江东区","镇海区","鄞州区"]},{"name":"嘉兴市","value":["南湖区","秀洲区"]},{"name":"衢州市","value":["柯城区","衢江区"]}]},{"name":"江苏","value":[{"name":"南京市","value":["玄武区","白下区","建邺区","鼓楼区","下关区","栖霞区","江宁区","雨花台区","秦淮区"]},{"name":"徐州市","value":["鼓楼区","云龙区","泉山区","铜山区"]},{"name":"泰州市","value":["海陵区","高港区"]},{"name":"常州市","value":["天宁区","钟楼区","戚墅堰区","新北区","武进区"]},{"name":"镇江市","value":["京口区","润州区","丹徒区"]},{"name":"宿迁市","value":["宿城区","宿豫区"]},{"name":"苏州市","value":["沧浪区","平江区","金阊区","虎丘区","吴中区","相城区","园区","新区","姑苏区"]},{"name":"无锡市","value":["崇安区","南长区","北塘区","锡山区","惠山区","滨湖区","新区"]},{"name":"连云港市","value":["连云区","新浦区","海州区"]},{"name":"盐城市","value":["亭湖区"]},{"name":"扬州市","value":["广陵区","邗江区","经济开发区","维扬区"]},{"name":"淮安市","value":["清河区","淮阴区","清浦区"]},{"name":"南通市","value":["崇川区","港闸区","通州区","开发区"]}]},{"name":"江西","value":[{"name":"吉安市","value":["吉州区","青原区"]},{"name":"鹰潭市","value":["月湖区"]},{"name":"九江市","value":["庐山区","浔阳区"]},{"name":"萍乡市","value":["安源区"]},{"name":"抚州市","value":["临川区"]},{"name":"南昌市","value":["东湖区","西湖区","青云谱区","湾里区","青山湖区","红谷滩新区","经济技术开发区"]},{"name":"上饶市","value":["信州区"]},{"name":"新余市","value":["渝水区"]},{"name":"赣州市","value":["章贡区","赣县"]},{"name":"景德镇市","value":["昌江区","珠山区"]},{"name":"宜春市","value":["袁州区"]}]},{"name":"安徽","value":[{"name":"淮南市","value":["大通区","田家庵区"]},{"name":"黄山市","value":["屯溪区","徽州区"]},{"name":"安庆市","value":["迎江区","大观区"]},{"name":"蚌埠市","value":["龙子湖区","蚌山区","禹会区","淮上区"]},{"name":"六安市","value":["金安区","裕安区"]},{"name":"马鞍山市","value":["金家庄区","花山区","雨山区"]},{"name":"合肥市","value":["瑶海区","庐阳区","蜀山区","包河区","高新区"]},{"name":"滁州市","value":["琅琊区","南谯区"]},{"name":"阜阳市","value":["颍州区","颍东区","颍泉区"]},{"name":"芜湖市","value":["镜湖区","鸠江区","弋江区"]}]}]},{"name":"华南","value":[{"name":"广东","value":[{"name":"潮州市","value":["湘桥区","枫溪区"]},{"name":"珠海市","value":["香洲区","斗门区","金唐区","金湾区","南湾区"]},{"name":"阳江市","value":["江城区"]},{"name":"东莞市","value":["全境"]},{"name":"茂名市","value":["茂南区"]},{"name":"韶关市","value":["武江区","浈江区","曲江区"]},{"name":"梅州市","value":["梅江区"]},{"name":"肇庆市","value":["端州区","鼎湖区"]},{"name":"中山市","value":["全境"]},{"name":"湛江市","value":["赤坎区"]},{"name":"清远市","value":["清城区"]},{"name":"佛山市","value":["禅城区","南海区","顺德区","三水区","高明区"]},{"name":"广州市","value":["荔湾区","越秀区","海珠区","天河区","白云区","黄埔区","花都区","番禺区","南沙区","萝岗区"]},{"name":"汕尾市","value":["城区"]},{"name":"惠州市","value":["惠城区"]},{"name":"深圳市","value":["罗湖区","福田区","南山区","宝安区","龙岗区","龙华新区","盐田区"]},{"name":"汕头市","value":["龙湖区","金平区"]},{"name":"江门市","value":["蓬江区","江海区"]},{"name":"云浮市","value":["云城区"]},{"name":"河源市","value":["源城区"]},{"name":"揭阳市","value":["东山区"]}]},{"name":"广西","value":[{"name":"钦州市","value":["钦南区","钦北区"]},{"name":"柳州市","value":["城中区","柳北区","柳南区","鱼峰区"]},{"name":"桂林市","value":["叠彩区","七星区","象山区","秀峰区","雁山区"]},{"name":"玉林市","value":["玉州区"]},{"name":"梧州市","value":["万秀区","长洲区"]},{"name":"南宁市","value":["兴宁区","青秀区","江南区","西乡塘区","良庆区","邕宁区"]},{"name":"北海市","value":["海城区","银海区"]}]},{"name":"福建","value":[{"name":"福州市","value":["鼓楼区","台江区","仓山区","马尾区","晋安区"]},{"name":"厦门市","value":["思明区","海沧区","湖里区","同安区","翔安区","集美区"]},{"name":"泉州市","value":["鲤城区","丰泽区"]},{"name":"漳州市","value":["芗城区","龙文区"]},{"name":"龙岩市","value":["新罗区"]},{"name":"莆田市","value":["城厢区","涵江区","荔城区","秀屿区"]}]},{"name":"海南省","value":[{"name":"三亚市","value":["吉阳区","天涯区"]},{"name":"海口市","value":["秀英区","龙华区","琼山区","美兰区"]}]}]},{"name":"华中","value":[{"name":"湖北","value":[{"name":"黄石市","value":["黄石港区","西塞山区","下陆区"]},{"name":"襄阳市","value":["樊城区","襄城区","襄州区"]},{"name":"武汉市","value":["江岸区","江汉区","硚口区","武昌区","洪山区","青山区","东西湖区","汉阳区"]},{"name":"宜昌市","value":["西陵区","伍家岗区","点军区","夷陵区","葛洲坝区"]},{"name":"黄冈市","value":["黄州区"]},{"name":"荆州市","value":["沙市区","荆州区"]}]},{"name":"湖南","value":[{"name":"常德市","value":["武陵区","鼎城区"]},{"name":"长沙市","value":["芙蓉区","天心区","开福区","雨花区","长沙县","岳麓区"]},{"name":"永州市","value":["冷水滩区"]},{"name":"岳阳市","value":["岳阳楼区","云溪区","君山区"]},{"name":"郴州市","value":["北湖区","苏仙区"]},{"name":"衡阳市","value":["石鼓区","雁峰区","珠晖区"]},{"name":"怀化市","value":["鹤城区"]},{"name":"益阳市","value":["资阳区","赫山区"]},{"name":"娄底市","value":["娄星区"]},{"name":"邵阳市","value":["双清区","大祥区","北塔区"]},{"name":"湘潭市","value":["雨湖区","岳塘区"]},{"name":"株洲市","value":["荷塘区","芦淞区","石峰区","天元区"]}]},{"name":"河南","value":[{"name":"洛阳市","value":["老城区","西工区","涧西区","洛龙区","瀍河回族区","高新区"]},{"name":"周口市","value":["川汇区"]},{"name":"安阳市","value":["文峰区","北关区","殷都区","龙安区"]},{"name":"商丘市","value":["梁园区","睢阳区"]},{"name":"平顶山市","value":["新华区","卫东区"]},{"name":"濮阳市","value":["华龙区"]},{"name":"郑州市","value":["中原区","二七区","管城回族区","金水区","惠济区","郑东新区","高新区","上街区"]},{"name":"驻马店市","value":["驿城区"]},{"name":"信阳市","value":["浉河区"]},{"name":"南阳市","value":["宛城区","卧龙区"]},{"name":"焦作市","value":["解放区","中站区","山阳区"]},{"name":"新乡市","value":["红旗区","卫滨区","凤泉区","牧野区"]},{"name":"开封市","value":["龙亭区","顺河回族区","鼓楼区","禹王台区"]}]}]},{"name":"西北","value":[{"name":"陕西","value":[{"name":"咸阳市","value":["秦都区","渭城区"]},{"name":"西安市","value":["碑林区","莲湖区","灞桥区","未央区","雁塔区","长安区","新城区"]}]},{"name":"甘肃","value":[{"name":"兰州市","value":["城关区"]}]},{"name":"宁夏","value":[{"name":"银川市","value":["兴庆区","西夏区","金凤区"]}]}]},{"name":"西南","value":[{"name":"云南","value":[{"name":"昆明市","value":["五华区","盘龙区","官渡区","西山区"]}]},{"name":"贵州","value":[{"name":"贵阳市","value":["南明区","云岩区","小河区","白云区","乌当区"]}]},{"name":"四川","value":[{"name":"成都市","value":["锦江区","青羊区","金牛区","武侯区","成华区","龙泉驿区","新都区","温江区","成都高新区","成都天府新区"]},{"name":"绵阳市","value":["涪城区","游仙区"]},{"name":"南充市","value":["高坪区","嘉陵区","顺庆区"]}]},{"name":"重庆","value":[{"name":"重庆市","value":["渝中区","大渡口区","江北区","沙坪坝区","九龙坡区","南岸区","巴南区","渝北区"]}]}]},{"name":"东北","value":[{"name":"黑龙江省","value":[{"name":"哈尔滨市","value":["道里区","南岗区","道外区","松北区","香坊区"]}]},{"name":"吉林","value":[{"name":"长春市","value":["南关区","宽城区","朝阳区","二道区","经济技术开发区"]}]},{"name":"辽宁","value":[{"name":"沈阳市","value":["大东区","皇姑区","铁西区","沈河区","和平区","于洪区"]},{"name":"大连市","value":["中山区","西岗区","沙河口区","甘井子区",null]}]}]}]';

exports.default = JSON.parse(dataStr);

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-0cb1a52b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _jsCookie = __webpack_require__(59);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(23);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROTOCOL = location.protocol; //
//
//
//
//
//
//
//

var IOS_LINK = PROTOCOL + '//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast';
var TD_PREFIX = PROTOCOL + '//lnk0.com/';

var hostname = location.hostname;
var search = location.search.slice(1);
var urlParams = _queryString2.default.parse(search);
var tdMap = {
  'index': {
    'i': 'JxdoMh',
    'a': '1UNxBd'
  },
  'article': {
    'i': 'JZN9k4',
    'a': 'wpE5ss'
  },
  'story': {
    'i': 'c8ABVd',
    'a': 'J5gU9g'
  },
  'list': {
    'i': 'wNV9At',
    'a': 'dE5IZt'
  },
  'product': {
    'i': '10UtQd',
    'a': 'xJFBxt'
  }
  // const dParam = urlParams._d
};var iParam = urlParams._i || _jsCookie2.default.get('_b_i');
var aParam = urlParams._a || _jsCookie2.default.get('_b_a');

exports.default = {
  name: 'open-app',
  props: {
    cls: {
      type: String,
      default: 'open-app-area'
    },
    text: {
      type: String,
      default: '打开APP'
    },
    link: {
      type: String,
      default: ''
    },
    talkingData: {
      type: Object,
      default: null
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      formatLink: null
    };
  },

  computed: {
    iosShow: function iosShow() {
      if ((0, _browser.ios)()) {
        return true;
      } else {
        return false;
      }
    },
    iosLink: function iosLink() {
      // const il = iParam?`${TD_PREFIX}${iParam}`:IOS_LINK
      var il = iParam ? (0, _browser.weixin)() ? IOS_LINK : '' + TD_PREFIX + iParam : IOS_LINK; //微信无法打开我们的appstore短链 所以微信浏览器里面打开应用宝 这样会丢失一部分短链打点
      return PROTOCOL + '//' + "app.thebeastshop.com" + '/r?r=' + (0, _b2a.btoa)(il) + '&_d=' + (0, _b2a.btoa)(this.formatLink);
      // return `beastapp://${this.formatLink}`
    }
  },
  created: function created() {
    if (!iParam) {
      iParam = tdMap[this.pageType] ? tdMap[this.pageType]['i'] : '';
    }
    if (!aParam) {
      aParam = tdMap[this.pageType] ? tdMap[this.pageType]['a'] : '';
    }
    this.initLink();
  },

  methods: {
    initLink: function initLink() {
      if (!iParam && this.talkingData) {
        iParam = this.talkingData._i;
      }
      if (!aParam && this.talkingData) {
        aParam = this.talkingData._a;
      }
      var link = this.link;
      var redirectLink = "";
      if (!link) {
        if (iParam || aParam) {
          redirectLink = 'index?_i=' + iParam + '&_a=' + aParam;
        } else {
          redirectLink = 'index';
        }
      } else {
        var index = link.indexOf("?");
        if (iParam || aParam) {
          if (index !== -1) {
            if (link.indexOf("_i=") !== -1 || link.indexOf("_a=") !== -1) {
              redirectLink = link;
            } else {
              redirectLink = link + '&_i=' + iParam + '&_a=' + aParam;
            }
          } else {
            redirectLink = link + '?_i=' + iParam + '&_a=' + aParam;
          }
        } else {
          redirectLink = link;
        }
      }
      this.formatLink = redirectLink;
    },
    recordIosTrack: function recordIosTrack() {
      this.trackData('ios');
    },
    toDownloadPage: function toDownloadPage() {
      var _this = this;

      this.trackData('android');

      setTimeout(function () {
        window.location.href = 'https://m.thebeastshop.com/dl?_d=' + (0, _b2a.btoa)(_this.formatLink) + '&_i=' + iParam + '&_a=' + aParam;
      }, 200);
    },
    trackData: function trackData(devide) {
      var trackData = {
        name: 'download-banner',
        attrs: {
          pageType: this.pageType,
          device: devide
        },
        wait: false
      };
      console.log(trackData, "trackData");

      (0, _track2.default)(trackData);
    }
  }
};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cls
  }, [(_vm.iosShow) ? _c('a', {
    attrs: {
      "href": _vm.iosLink
    },
    on: {
      "click": _vm.recordIosTrack
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _c('span', {
    on: {
      "click": _vm.toDownloadPage
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(63);

var _from2 = _interopRequireDefault(_from);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _urlUtil = __webpack_require__(21);

var _link = __webpack_require__(55);

var _data = __webpack_require__(237);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { lazyload } from '@/lazyload'
var headers = {}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var isApp = _browser2.default.app();
var defaultImage = (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/images/mcatlog/banner/p.png");

exports.default = {
  name: 'list-v1',

  props: {
    data: {
      require: true
    },
    float: {
      require: true
    },
    index: {
      default: false
    },
    source: {
      default: 'CART'
    },
    miniEnv: {
      default: false
    },
    noJump: {
      default: false
    },
    noCorner: {
      default: false
    },
    businessCase: {
      default: '其他'
    }
  },

  data: function data() {
    return {
      defaultImage: defaultImage,
      productData: this.data,
      swiperConfig: {
        loop: true
      }
    };
  },

  components: {
    price: _price2.default,
    beastImage: _image2.default,
    swiper: _index2.default
  },

  created: function created() {
    this.data.images.shift();
    this.data.images.unshift(this.data.featureImage);
  },
  mounted: function mounted() {
    // console.log(this.float)
    // lazyload()
  },


  watch: {
    // data (d) {
    //   if (typeof d === 'object') {
    //     this.fit()
    //   }
    // }
  },

  computed: {
    productImage: function productImage() {
      var data = this.data;
      return data.featureImage ? data.featureImage : data.images ? data.images[0] : '';
    },

    offShelfStyle: function offShelfStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/off-shelf-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    },
    soldOutStyle: function soldOutStyle() {
      var img = (0, _urlUtil.ensure_protocol)('http://img.thebeastshop.com/app/product/list/sold-out-new.png');
      return 'background: url(' + img + ');background-repeat:no-repeat;background-size:cover;';
    }
  },
  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  },
  methods: {
    jump: function jump(e) {
      if (this.noJump) {
        return;
      }

      var tar = e.currentTarget;
      var pindex = tar.dataset.index;

      if (!this.data || !this.data.id) {
        return;
      }

      var link = (0, _link.transformLink)({
        link: {
          type: "product",
          value: this.data.id
        },
        isMini: this.miniEnv
      });

      var _suggestType = this.data.markInfo ? JSON.parse(this.data.markInfo).RecommendType : '';

      if (_suggestType && !this.miniEnv) {
        link += '?suggestType=' + encodeURIComponent(_suggestType);
      }

      var trackData = {
        trackData: {
          name: this.source === 'CART' ? 'cart-suggest-product-more' : 'click-result-suggest',
          attrs: {
            productId: this.data.id,
            index: pindex,
            suggestType: _suggestType
          }
        },
        link: link,
        isMini: this.miniEnv
      };

      var prod = this.data;
      var bu = prod.recommendEngine ? this.businessCase + '-' + prod.recommendEngine : this.businessCase;
      sa.track('CommodityClick', {
        position_number: this.float,
        commodity_spu_id: prod.id,
        commodity_name: prod.name,
        original_price: prod.rawPrice,
        discount_price: prod.price,
        commodity_need_point: prod.point || 0,
        // business_case: '猜你喜欢'
        business_case: this.businessCase ? bu : '其他'
      });

      (0, _link.trackSkip)(trackData);
    },
    fit: function fit() {
      var tagItem = document.querySelectorAll('.prices');
      var tagArr = (0, _from2.default)(tagItem);
      tagArr.forEach(function (elem) {
        var discount = elem.querySelector('.discount-price');
        var rawcount = elem.querySelector('.raw-price');
        var tags = elem.querySelector('.tags-wrap');

        var dw = discount && discount.clientWidth || 0;
        var rw = rawcount ? rawcount.clientWidth : 0;
        var tw = tags && tags.clientWidth || 0;

        if (dw + rw + tw > elem.clientWidth) {
          tags.style.display = 'none';
        }
      });
    }
  }
};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-product-v1 exposurer-item",
    attrs: {
      "data-id": _vm.data.id,
      "data-index": _vm.index,
      "data-price": _vm.data.price,
      "data-name": _vm.data.name,
      "data-rawprice": _vm.data.rawPrice,
      "data-labels": _vm.data.labels,
      "data-recommend": _vm.data.recommendEngine
    },
    on: {
      "click": _vm.jump
    }
  }, [(_vm.productImage) ? _c('swiper', {
    staticClass: "product-image",
    attrs: {
      "config": _vm.swiperConfig
    }
  }, _vm._l((_vm.data.images), function(img, index) {
    return _c('div', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (index),
        expression: "index"
      }],
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "cover-line left"
    }), _vm._v(" "), _c('div', {
      staticClass: "cover-line right"
    }), _vm._v(" "), _c('beast-image', {
      attrs: {
        "lazy": true,
        "defaultImage": _vm.defaultImage,
        "src": img
      }
    }), _vm._v(" "), (!_vm.noCorner) ? _c('div', {
      staticClass: "image-info"
    }, [(_vm.data.foretell) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("即将开售")])])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("下架")])])]) : (_vm.data.soldOut) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("缺货")])])]) : _vm._e()]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-infos"
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-name gro-book"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.mainStationFirst) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price gro-demi"
  }, [(_vm.data.price) ? _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }) : _vm._e(), _c('span', {
    staticClass: "newn-tag-shoudan"
  }, [_vm._v("首单价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price grotesk"
  }, [(_vm.data.rawPrice) ? _c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  }) : _vm._e()], 1) : _vm._e()]) : (_vm.data.newcomerTag) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price gro-demi"
  }, [(_vm.data.price) ? _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }) : _vm._e(), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price grotesk"
  }, [(_vm.data.rawPrice) ? _c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  }) : _vm._e()], 1) : _vm._e()]) : _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price gro-demi"
  }, [(_vm.data.price) ? _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price grotesk"
  }, [(_vm.data.rawPrice) ? _c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(250);

var _index2 = _interopRequireDefault(_index);

var _toast = __webpack_require__(26);

var _toast2 = _interopRequireDefault(_toast);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_toast2.default);
var isApp = _browser2.default.app();
var uniapp = _browser2.default.uniapp();
var vm = void 0,
    _resolve = void 0,
    _reject = void 0;
var plugin = {
  install: function install(vue, options) {

    vue.prototype.$selectVariant = function (data, noApp) {
      if (isApp && !noApp && !uniapp) {
        return _bridge2.default.selectProductVariant(data);
      }

      if (data.variant.dimensionGroup && data.variant.dimensionGroup.length) {
        var _g = {};

        data.variant.dimensionGroup.forEach(function (g) {
          var v = g.value[0];
          _g[v] = g.name;
        });

        data._dimensionGroup = _g;
      }

      vm = new _vue2.default({
        el: document.createElement('div'),
        template: '<slide from="bottom" :slidecls="data.slideCls" :show="show" @maskTap="maskTap" :style="{top: showPreview ? 0 : \'auto\'}">\n          <select-variant :data="data" :show="show" @complete="complete" @preview-image="previewImage"/>\n          </slide>',
        data: {
          data: data,
          show: false,
          showPreview: false
        },
        components: {
          'select-variant': _index2.default,
          slide: _slide2.default
        },
        methods: {
          complete: function complete(result) {
            this.close();
            result === null ? _reject(cancelError()) : _resolve(result);
          },

          // error (message) {
          //   this.close()
          //   _reject(message)
          // },
          close: function close() {
            this.show = false;
            document.body.removeChild(vm.$el);
          },
          maskTap: function maskTap() {
            this.close();
            _reject(cancelError());
          },
          previewImage: function previewImage() {
            console.log(1);
            this.showPreview = true;
          }
        }
      });
      document.body.appendChild(vm.$el);
      setTimeout(function () {
        vm.show = true;
      }, 0);

      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
  }
};

_vue2.default.use(plugin);

function cancelError() {
  var error = new Error('USER_CANCEL');
  error.code = 'USER_CANCEL';
  return error;
}

// this.$selectVariant({
//   data:123
// })
//   .then((result) => {

//   })
//   .catch(() => {

//   })

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _variantModel = __webpack_require__(253);

var _variantModel2 = _interopRequireDefault(_variantModel);

var _price = __webpack_require__(54);

var _price2 = _interopRequireDefault(_price);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'selcet-variant',
  props: ['data', 'show'],
  data: function data() {
    return {
      dataLoaded: false,
      spvId: null,
      spv: {
        brand: {
          name: null
        },
        name: null,
        price: null,
        minAmount: null,
        quota: null
      },
      oldCount: this.data.pack.count,
      count: this.data.pack.count,
      variantMatrix: [],
      disabledConfirm: false,
      minCount: null,
      maxCount: null,
      previewImgs: [],
      previewShow: false,
      swiper: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        spaceBetween: 30,
        centeredSlides: true,
        paginateCls: 'number-paginate',
        // autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    };
  },

  components: {
    price: _price2.default,
    beastImage: _image2.default,
    Swiper: _index2.default
  },
  created: function created() {
    var _this = this;

    //at first time, get spvId from data.pack.spvId
    this.spv = this.getSpv(this.data.pack.variant);
    if (this.data.pack.product.point) {
      this.spv.point = this.data.pack.product.point;
    }

    var availables = this.getAvailables(this.data.variant.spvs);

    this.model = new _variantModel2.default({
      availables: availables,
      dimensions: this.data.variant.dimensions,
      variant: this.data.pack.variant
    }).on('change', function (result) {
      _this.count = 1;
      _this.updateData(result);
    });
  },

  methods: {
    close: function close() {
      this.$emit('complete', null);
    },
    sub: function sub() {
      if (this.count <= this.minCount) {
        return;
      }
      this.count--;
    },
    add: function add() {
      if (this.count >= this.maxCount) {
        return;
      }
      this.count++;
    },
    variantTap: function variantTap(variant_index, item_index) {
      var status = this.variantMatrix[variant_index][item_index];
      if (!status.available || status.selected) {
        return;
      }
      this.model.select(item_index, variant_index);

      if (this.data.confirm) {
        this.confirm();
      }

      // todo 最后一行选
      var _dimension = this.variantMatrix;
      var _length = _dimension.length;
      if (variant_index == _length - 1) return;

      var _ch_index = -1;

      _dimension[_length - 1].forEach(function (choice, index) {
        if (_ch_index > -1 || !choice.available) return;
        _ch_index = index;
      });

      if (_ch_index === -1) return;
      this.model.select(_ch_index, _length - 1);
    },
    updateData: function updateData(result) {
      this.spvId = this.model.val();

      if (this.spvId) {
        this.spv = this.getSpv(this.spvId);
        if (this.data.pack.product.point) {
          this.spv.point = this.data.pack.product.point;
        }
        this.maxCount = this.getMax(this.spv);
        this.minCount = this.spv.minAmount || 1;
      }

      this.disabledConfirm = !result.done;
      this.variantMatrix = result.matrix;
      this.dataLoaded = true;
    },
    checkCount: function checkCount() {
      var val = this.count;
      if (val === '' || isNaN(val)) {
        this.count = this.oldCount;
        return false;
      }
      if (val > this.maxCount) {
        this.$toast('超过最大购买数量');
        this.oldCount = this.count = this.maxCount;
        return false;
      }
      if (val < this.minCount) {
        this.$toast('\u6700\u5C0F\u8D2D\u4E70\u6570\u91CF\u4E3A' + this.minCount);
        this.oldCount = this.count = this.minCount;
        return false;
      }
      this.oldCount = this.count;
      return true;
    },
    getSpv: function getSpv(spvId) {
      return this.data.variant.spvs.filter(function (spv) {
        return spv.id == spvId;
      })[0] || {};
    },
    getAvailables: function getAvailables(spvs) {
      var _this2 = this;

      return spvs.filter(function (spv) {
        var max = _this2.getMax(spv);

        return spv.minAmount ? spv.minAmount <= max : max > 0;
      });
    },
    getMax: function getMax(spv) {
      return spv.quota ? Math.min(spv.left, spv.quota.left) : spv.left;
    },
    showPreviewImage: function showPreviewImage(curImage) {
      var spvImages = [curImage];

      this.data.variant.spvs.forEach(function (spv) {
        spvImages.push(spv.image);
      });

      this.previewImgs = spvImages;
      this.previewShow = true;

      var doc = document.querySelector('.beast_slider');

      doc.style.top = 0;
    },
    hidePrivew: function hidePrivew() {
      this.previewShow = false;
      this.previewImgs = [];
      var doc = document.querySelector('.beast_slider');

      doc.style.top = 'auto';
    },
    confirm: function confirm() {

      if (this.disabledConfirm || this.spv.quota && this.spv.quota.left <= 0) {
        return;
      }
      this.$emit('complete', {
        spvId: this.spvId,
        count: this.count,
        price: this.spv.price,
        rawPrice: this.spv.rawPrice,
        pointPrice: this.spv.pointPrice
      });
    }
    // getMatrix (matrix) {
    //   let m = JSON.parse(JSON.stringify(matrix))
    //   this.dimensions.forEach((variant, variant_index) => {
    //     d.choices.forEach((item, item_index) => {
    //       m[variant_index][item_index].name = item
    //     })
    //   })
    //   return m
    // },

  }

};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getPrototypeOf = __webpack_require__(139);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(140);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(141);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(147),
    EventEmitter = _require.EventEmitter;

// ## Usage
// let vc = new VariantModel(options)
//   // matrix[][]
//   .on('change', (matrix) => {
//     // {
//     //   selected: `Boolean`,
//     //   available: `Boolean`
//     // }
//     updateView(matrix)
//   })

// updateView(matrix)

// vc.select(1, 0)
// vc.val() // null or variant.id

var UNDEFINED = void 0;

module.exports = function (_EventEmitter) {
  (0, _inherits3.default)(VariantModel, _EventEmitter);

  function VariantModel(_ref) {
    var availables = _ref.availables,
        dimensions = _ref.dimensions,
        variant = _ref.variant;
    (0, _classCallCheck3.default)(this, VariantModel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VariantModel.__proto__ || (0, _getPrototypeOf2.default)(VariantModel)).call(this));

    _this.availables = availables;
    _this.dimensions = dimensions;
    _this.variant = [];
    _this.cache = {};

    _this._memoize('_availableVariants');
    _this._initSelect(variant);
    setTimeout(function () {
      _this._emitChange();
    });
    return _this;
  }

  (0, _createClass3.default)(VariantModel, [{
    key: '_initSelect',
    value: function _initSelect(variant) {
      var _this2 = this;

      var choosen = void 0;

      this.availables.some(function (a) {
        if (a.id === variant) {
          choosen = a.group;
          return true;
        }
      });

      if (!this.availables.length) return;

      if (!choosen) {
        choosen = this.availables[0].group;
      }

      if (!choosen) {
        this.availables[0].group = choosen = [];
      }
      choosen.some(function (value, index) {
        return !_this2._select(value, index);
      });
    }
  }, {
    key: '_matrix',
    value: function _matrix() {
      var _this3 = this;

      return this.dimensions.map(function (dimension, index) {
        return dimension.choices.map(function (choice, i) {
          return {
            selected: _this3._selected(i, index),
            available: _this3._isAvailable(i, index)
          };
        });
      });
    }
  }, {
    key: '_emitChange',
    value: function _emitChange() {
      var done = this.variant.length === this.dimensions.length && this.variant.every(function (value) {
        return value !== UNDEFINED;
      });
      var matrix = this._matrix();
      if (this.dimensions.length === 0) {
        done = true;
      }
      this.emit('change', {
        matrix: matrix,
        // true if all dimensions are set
        done: done
      });
    }
  }, {
    key: 'val',
    value: function val() {
      var _this4 = this;

      var selected = void 0;
      this.availables.some(function (a) {
        var match = equal(a.group, _this4.variant);
        if (match) {
          selected = a;
          return true;
        }

        return match;
      });

      return selected && selected.id || null;
    }
  }, {
    key: 'select',
    value: function select(value, index) {
      return this._select(value, index, true);
    }
  }, {
    key: '_selected',
    value: function _selected(value, index) {
      return this.variant[index] === value;
    }

    // try to select a dimension

  }, {
    key: '_select',
    value: function _select(value, index, emit) {
      if (this._selected(value, index)) {
        return;
      }

      var available = this._isAvailable(value, index);
      // not set
      if (!available) {
        return false;
      }

      this.variant[index] = value;

      var length = this.dimensions.length;
      // check all latter dimensions
      while (++index < length) {
        this._check(index);
      }

      if (emit) {
        this._emitChange();
      }

      return true;
    }

    // check the current value of a dimension,
    // if validation fails, unset the value

  }, {
    key: '_check',
    value: function _check(index) {
      var value = this.variant[index];
      if (value !== UNDEFINED && !this._isAvailable(value, index)) {
        this.variant[index] = UNDEFINED;
      }
    }
  }, {
    key: '_availableVariants',
    value: function _availableVariants(choosen) {
      var length = choosen.length;
      if (length === 0) {
        return this.availables;
      }

      if (length >= this.dimensions.length) {
        return [];
      }

      length--;
      var sub = choosen.slice(0, length);
      var last = choosen[length];

      return this._availableVariants(sub).filter(function (a) {
        return last === UNDEFINED || a.group[length] === last;
      });
    }
  }, {
    key: '_memoize',
    value: function _memoize(name) {
      var _this5 = this;

      var method = this[name];
      this[name] = function (array) {
        var atom = join(array);
        if (atom in _this5.cache) {
          return _this5.cache[atom];
        }

        return _this5.cache[atom] = method.call(_this5, array);
      };
    }
  }, {
    key: '_isAvailable',
    value: function _isAvailable(value, index) {
      var choosen = this.variant.slice(0, index);
      var availables = this._availableVariants(choosen);

      if (!availables || !availables.length) {
        return false;
      }

      return availables.some(function (a) {
        return a.group[index] === value;
      });
    }
  }]);
  return VariantModel;
}(EventEmitter);

function join(array) {
  return array.join('_');
}

function equal(a, b) {
  return join(a) === join(b);
}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.dataLoaded) ? _c('div', {
    staticClass: "selcet-variant"
  }, [_c('div', {
    staticClass: "spv-info"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "close-wrap j_close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spv",
    on: {
      "click": function($event) {
        return _vm.showPreviewImage(_vm.spv.image)
      }
    }
  }, [_c('beast-image', {
    staticClass: "spv-img j_spv_img",
    attrs: {
      "src": _vm.spv.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "brand"
  }, [_vm._v(_vm._s(_vm.spv.brand && _vm.spv.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.spv.name))]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "price j_price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spv.price
    }
  }), _vm._v(" "), (_vm.spv.newcomerTag) ? _c('div', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.spv.point) ? _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "point"
  }, [_vm._v("兑换点数：" + _vm._s(_vm.spv.point))])]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "variants"
  }, _vm._l((_vm.data.variant.dimensions), function(i, variant_index) {
    return _c('div', {
      staticClass: "variants-item"
    }, [(_vm.data._dimensionGroup && _vm.data._dimensionGroup[variant_index]) ? _c('div', {
      staticClass: "group-title"
    }, [_vm._v(_vm._s(_vm.data._dimensionGroup[variant_index]))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(i.name))]), _vm._v(" "), _c('div', {
      staticClass: "items"
    }, _vm._l((i.choices), function(k, item_index) {
      return _c('div', {
        staticClass: "item",
        class: {
          'disabled': _vm.variantMatrix.length && !_vm.variantMatrix[variant_index][item_index].available,
            'on': _vm.variantMatrix.length && _vm.variantMatrix[variant_index][item_index].selected
        },
        on: {
          "click": function($event) {
            return _vm.variantTap(variant_index, item_index)
          }
        }
      }, [_vm._v("\n              " + _vm._s(k) + "    \n            ")])
    }), 0)])
  }), 0), _vm._v(" "), (_vm.data.selectAmount) ? _c('div', {
    staticClass: "variant-operation"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "operation"
  }, [_c('div', {
    staticClass: "sub j_sub",
    class: {
      disabled: _vm.count <= _vm.minCount
    },
    on: {
      "click": _vm.sub
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.count),
      expression: "count",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "number j_input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "change": _vm.checkCount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "add j_add",
    class: {
      disabled: _vm.count >= _vm.maxCount
    },
    on: {
      "click": _vm.add
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [(_vm.spv.minAmount && _vm.spv.minAmount > 1) ? [_vm._v("\n          " + _vm._s(_vm.spv.minAmount) + "件起售\n        ")] : _vm._e(), _vm._v(" "), (_vm.spv.minAmount && _vm.spv.minAmount > 1 && _vm.spv.quota) ? [_vm._v("\n          ，\n        ")] : _vm._e(), _vm._v(" "), (_vm.spv.quota) ? [_vm._v("\n          限购" + _vm._s(_vm.spv.quota.total) + "件\n        ")] : _vm._e(), _vm._v(" "), (_vm.spv.quota && _vm.spv.quota.left > 0) ? [_vm._v("\n           , 还可买" + _vm._s(_vm.spv.quota.left) + "件\n        ")] : _vm._e(), _vm._v(" "), (_vm.spv.quota && _vm.spv.quota.left <= 0) ? [_vm._v("\n           , 你已超限\n        ")] : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), (_vm.data.exchangeButton) ? _c('div', {
    staticClass: "confirm-button-box"
  }, [_c('div', {
    staticClass: "confirm-text"
  }, [_vm._v("可用点数：" + _vm._s(_vm.data.myPoint))]), _vm._v(" "), _c('div', {
    staticClass: "confirm-inner-button",
    class: {
      disabled: _vm.disabledConfirm
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("立即兑换")])]) : _c('div', {
    staticClass: "confirm-button",
    class: {
      disabled: _vm.disabledConfirm || (_vm.spv.quota && _vm.spv.quota.left <= 0)
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), (_vm.previewShow) ? _c('div', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.hidePrivew
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/beast-lesson/icon-back-arrow.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-wrap"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.swiper.paginateCls
    }
  }, _vm._l((_vm.previewImgs), function(item) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": item
      }
    })])
  }), 0)], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__(258);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;
var _resolve = void 0;
var _reject = void 0;

(function () {
  function install(Vue) {
    var SelectArea = Vue.extend(_index2.default);
    var selectArea = function selectArea() {
      if (!$vm) {
        $vm = new SelectArea({
          el: document.createElement('div')
        });
        document.body.appendChild($vm.$el);
      }
      //clearVm($vm)
      $vm.$on('on-cancel', function () {
        $vm.show = false;
        _resolve(null);
      });
      $vm.$on('on-confirm', function (data) {
        $vm.show = false;
        _resolve(data);
      });
      setTimeout(function () {
        $vm.show = true;
      }, 0);
      return new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });
    };
    Vue.mixin({
      created: function created() {
        this.$selectArea = selectArea;
      }
    });
  }

  if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
    module.exports = install;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return install;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (window.Vue) {
    Vue.use(install);
  }
})();

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _selectArea = __webpack_require__(260);

var _selectArea2 = _interopRequireDefault(_selectArea);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

var handler = function handler(e) {
  e.preventDefault();
};
exports.default = {
  components: {
    SelectArea: _selectArea2.default,
    Slide: _slide2.default
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    cancel: function cancel() {
      this.$emit('on-cancel');
    },
    confirm: function confirm(data) {
      this.$emit('on-confirm', data);
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$el.addEventListener('touchmove', handler, false);
      } else {
        this.$el.removeEventListener('touchmove', handler, false);
      }
    }
  }
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__(11);

var _dialog2 = _interopRequireDefault(_dialog);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _item = __webpack_require__(263);

var _item2 = _interopRequireDefault(_item);

var _data2 = __webpack_require__(266);

var _data3 = _interopRequireDefault(_data2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var handler = function handler(e) {
  e.preventDefault();
};
var _history = {};
exports.default = {
  components: {
    Item: _item2.default,
    Slide: _slide2.default
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    change: function change(val, index) {
      var _this = this;

      if (val !== undefined && index !== undefined) {
        _data3.default._changeChoose(val, index);
        if (index === 2) {
          return;
        }
      }

      this.pedding = true;
      _data3.default._selectChange().then(function (_data) {
        // let _province = _data.province
        // let _city = _data.city
        // let _district = _data.district
        var _province = _data.province,
            _city = _data.city,
            _district = _data.district;


        if (_history.province === undefined || _history.province !== _province) {
          _history.province = _province;
          _this.province = _province;
        }
        if (_history.city === undefined || _history.city !== _city) {
          _history.city = _city;
          _this.city = _city;
        }

        if (_history.district === undefined || _history.district !== _district) {
          _history.district = _district;
          _this.district = _district;
        }

        // this.city = city
        // this.district = district
        _this.pedding = false;
      });
    },
    cancel: function cancel() {

      this.$emit('on-cancel');
    },
    confirm: function confirm() {
      if (this.pedding) {
        return;
      }
      // this.$el.removeEventListener('touchmove', handler, false)
      this.$emit('on-confirm', _data3.default._getChoose());
    }
  },
  watch: {
    show: function show(val) {

      if (!val) {
        return false;
      }
      // this.$el.addEventListener('touchmove', handler, false)
      this.change();
      // this.pedding = true
      // data._selectChange()
      // .then((_data) => {
      //   let {province ,city , district} = JSON.parse(JSON.stringify(_data))
      //   this.province =province
      //   this.city = city
      //   this.district = district
      //   this.pedding = false
      // })
    }
  },
  created: function created() {
    this.change();
  },
  // mounted: function(){
  //   console.log(222)
  //   this.$el.addEventListener('touchmove', handler, false)
  // },
  data: function data() {
    return {
      province: [],
      city: [],
      district: [],
      pedding: false
    };
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _betterScroll = __webpack_require__(64);

var _betterScroll2 = _interopRequireDefault(_betterScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const scrollOptions = 
exports.default = {
  props: {
    list: Array,
    column: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      selectIndex: 0
    };
  },


  computed: {
    currentShow: function currentShow() {
      return this.show;
    }
  },
  watch: {
    show: function show(val) {
      // if(this.scroll){
      //   return
      // }
      // this._index =0
      // let _warp = this.$el.querySelector(".scroll-warp")
      // let defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight
      // this.scroll = new IScroll(_warp, scrollOptions )
      // let _this = this
      // this.scroll.on('scrollEnd', function(){
      //   let _y = this.y
      //   let index = parseInt(Math.abs(_y) / defaultHeight)
      //   if(_this._index !== index){
      //     _this._index = index
      //     _this.$emit("on-change" , index , _this.column)
      //   }
      // });
    },
    list: function list(val) {
      if (!this.scroll) {
        this._index = 0;
        var _warp = this.$el.querySelector(".scroll-warp");
        var defaultHeight = this.$el.querySelector(".scroll-warp").offsetHeight;
        this.defaultHeight = defaultHeight;
        this.scroll = new _betterScroll2.default(_warp, {
          // snap: true,
          // bounce: true,
          // useTransform: true,
          // useTransition: true,
          // momentum: false
          wheel: {
            selectedIndex: this.selectIndex
            /** 默认值就是下面配置的两个，为了展示二者的作用，这里再配置一下 */
            // wheelWrapperClass: 'wheel-scroll',
            // wheelItemClass: 'wheel-item'
          },
          probeType: 3
        });
        var _this = this;
        this.scroll.on('scrollEnd', function () {
          console.log(_this.scroll.selectedIndex);

          var _y = this.y;
          var index = parseInt(Math.abs(_y) / defaultHeight);
          console.log(index);
          if (_this._index !== index) {
            _this._index = index;
            _this.$emit("on-change", index, _this.column);
          }
        });
      }
      this.$nextTick(function () {
        var _scroll = this.scroll;
        var _column = this.column;
        setTimeout(function () {
          _scroll.refresh();
          if (_column > 0) {
            _scroll.scrollTo(0, 0);
          }
        }, 100);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-item-warp"
  }, [_c('div', {
    staticClass: "scroll-warp"
  }, [_c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', {
      style: ({
        height: _vm.defaultHeight + 'px'
      })
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mock = {
  province: null,
  city: null,
  district: null,
  show: false,
  choose: [0, 0, 0],
  history: null
};

var requestHistory = {};

function selectProvince() {
  var regionId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;


  if (mock.province) {
    return _promise2.default.resolve(mock.province);
  } else {
    mock.choose[0] = 0;
    var _url = '/app/area/region/' + regionId + '/province';
    var _history = requestHistory[_url];

    if (_history !== undefined) {
      return _promise2.default.resolve(_history);
    }

    return new _promise2.default(function (resolve, reject) {
      (0, _axiosMock2.default)({
        url: _url
      }).then(function (_ref) {
        var data = _ref.data;


        resolve(data);
        requestHistory[_url] = data;
      }).catch(function (error) {
        reject(error);
      });
      // instance.get(_url)
      //   .then(function (response) {
      //     let data = response.data
      //     resolve(data)
      //     requestHistory[_url] = data
      //   })
      //   .catch(function (error) {
      //     reject(error)
      //   })
    });
  }
}
function selectCity(province) {
  var provinceId = province.id;
  if (mock.history && mock.city && provinceId === mock.history.province) {
    return _promise2.default.resolve(mock.city);
  } else {
    mock.choose[1] = 0;
    var _url = '/app/area/province/' + provinceId + '/city';
    var _history = requestHistory[_url];
    if (_history !== undefined) {
      return _promise2.default.resolve(_history);
    }
    return new _promise2.default(function (resolve, reject) {
      (0, _axiosMock2.default)({
        url: _url
      }).then(function (_ref2) {
        var data = _ref2.data;

        resolve(data);
        requestHistory[_url] = data;
      }).catch(function (error) {
        reject(error);
      });
      // instance.get(_url)
      //   .then(function (response) {
      //     let data = response.data
      //     resolve(data)
      //     requestHistory[_url] = data
      //   })
      //   .catch(function (error) {
      //     reject(error)
      //   })
    });
  }
}
function selectDistrict(city) {
  var cityId = city.id;

  if (mock.history && mock.district && cityId === mock.history.city) {
    return _promise2.default.resolve(mock.district);
  } else {
    mock.choose[2] = 0;
    var _url = '/app/area/city/' + cityId + '/district';
    var _history = requestHistory[_url];
    if (_history !== undefined) {
      return _promise2.default.resolve(_history);
    }
    return new _promise2.default(function (resolve, reject) {
      (0, _axiosMock2.default)({
        url: _url
      }).then(function (_ref3) {
        var data = _ref3.data;

        data = data.filter(function (item) {
          return item.name !== '卢湾区' && item.name !== '闸北区';
        });
        resolve(data);
        requestHistory[_url] = data;
      }).catch(function (error) {
        reject(error);
      });
    });
  }
}

exports.default = {
  _changeChoose: function _changeChoose(val, index) {
    mock.choose[index] = val;
  },
  _getChoose: function _getChoose() {
    return {
      province: {
        id: mock.province[mock.choose[0]].id,
        name: mock.province[mock.choose[0]].name
      },
      city: {
        id: mock.city[mock.choose[1]].id,
        name: mock.city[mock.choose[1]].name
      },
      district: {
        id: mock.district[mock.choose[2]].id,
        name: mock.district[mock.choose[2]].name
      }
    };
  },
  _selectChange: function _selectChange() {
    var _regionId = mock.province ? mock.province[mock.choose[0]].id : 1;
    return new _promise2.default(function (resolve, reject) {
      selectProvince(_regionId).then(function (data) {

        mock.province = data;
        return selectCity(data[mock.choose[0]]);
      }).then(function (data) {

        mock.city = data;
        return selectDistrict(data[mock.choose[1]]);
      }).then(function (data) {

        mock.district = data;
        mock.history = {
          province: mock.province[mock.choose[0]].id,
          city: mock.city[mock.choose[1]].id,
          district: mock.district[mock.choose[2]].id
        };
        resolve(mock);
      });
    });
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-area-warp"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "fl",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', [_vm._v("选择地址")]), _vm._v(" "), _c('div', {
    staticClass: "fr",
    class: {
      'available': _vm.pedding
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "select-area"
  }, [_c('div', {
    staticClass: "indicator"
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.province,
      "column": 0,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.city,
      "column": 1,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  }), _vm._v(" "), _c('item', {
    attrs: {
      "list": _vm.district,
      "column": 2,
      "show": _vm.show
    },
    on: {
      "on-change": _vm.change
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('slide', {
    attrs: {
      "from": "bottom",
      "show": _vm.show
    }
  }, [_c('select-area', {
    on: {
      "on-cancel": _vm.cancel,
      "on-confirm": _vm.confirm
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _browser = __webpack_require__(1);

var _urlUtil = __webpack_require__(21);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _openApp = __webpack_require__(241);

var _openApp2 = _interopRequireDefault(_openApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { testData } from './test/data.js'


var search = location.search.slice(1); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var urlParams = _queryString2.default.parse(search);
var iParam = urlParams._i;
var aParam = urlParams._a;
var logoImage = (0, _urlUtil.ensure_protocol)("http://img.thebeastshop.com/app/activity/download/download-logo.png");
var pageData = {
  index: {
    _i: 'JxdoMh',
    _a: '1UNxBd'
  },
  list: {
    _i: 'wNV9At',
    _a: 'dE5IZt'
  },
  product: {
    _i: '10UtQd',
    _a: 'xJFBxt'
  },
  article: {
    _i: 'JZN9k4',
    _a: 'wpE5ss'
  },
  story: {
    _i: 'c8ABVd',
    _a: 'J5gU9g'
  }
};

exports.default = {
  name: 'download-banner',
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    pageType: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '立即下载'
    }
    // talkingData: {
    //   type: Object,
    //   default: null
    // }
  },

  data: function data() {
    return {
      showFlag: false,
      logoImage: logoImage,
      downloadData: null,
      talkingData: null
    };
  },


  components: {
    openApp: _openApp2.default
  },

  mounted: function mounted() {},
  created: function created() {
    if ((0, _browser.app)()) {
      this.showFlag = false;
      return;
    }

    //抖音环境 关闭下载条
    var dySession = sessionStorage.getItem('dy-downloader');
    console.log(dySession, 'dysession');
    if (dySession === 'close') {
      this.showFlag = false;
      this.$emit('banner-close');
      return;
    }

    var storage = this.getStorage("time");
    if (!storage) {
      //过期或者没缓存
      this.getBanner();
    } else {
      this.$emit('banner-close');
    }
    // this.formatData(testData)
  },


  computed: {
    positionCls: function positionCls() {
      if (this.position === 'top') {
        return {
          'top': true
        };
      }
      if (this.position === 'bottom') {
        return {
          'bottom': true
        };
      }
    }
  },

  methods: {
    getBanner: function getBanner() {
      var _this = this;

      this.getBannerData().then(function (data) {
        if (data) {
          _this.formatData(data);
        }
      }).catch(function (err) {
        console.log(err);
        return;
      });
    },
    formatData: function formatData(data) {
      this.downloadData = data;
      var pageObj = pageData[this.pageType];
      if (!iParam && pageObj) {
        iParam = pageObj['_i'];
      }
      if (!aParam && pageObj) {
        aParam = pageObj['_a'];
      }
      this.talkingData = {
        _i: iParam,
        _a: aParam
      };
      this.showFlag = true;
    },
    getBannerData: function getBannerData() {
      return (0, _axiosMock2.default)({
        url: '/app/config/downloadContext',
        method: 'GET'
      }).then(function (_ref) {
        var code = _ref.code,
            data = _ref.data;

        return _promise2.default.resolve(data);
      }).catch(function (err) {
        return _promise2.default.reject(err);
      });
    },
    closeBannerAction: function closeBannerAction() {
      this.showFlag = false;
      this.setStorage("time", "close");
      this.$emit('close-banner');
    },
    setStorage: function setStorage(key, stringVal, time) {
      try {
        // if(!localStorage){return false;}
        if (!time || isNaN(time)) {
          // time=2*60
          time = 1 * 24 * 60 * 60;
        }
        var cacheExpireDate = new Date() - 1 + time * 1000;
        var cacheVal = {
          val: stringVal,
          exp: cacheExpireDate
        };
        localStorage.setItem(key, (0, _stringify2.default)(cacheVal)); //存入缓存值
        //console.log(key+":存入缓存，"+new Date(cacheExpireDate)+"到期");
      } catch (e) {}
    },
    getStorage: function getStorage(key) {
      try {
        // if(!localStorage){return false;}
        var cacheVal = localStorage.getItem(key);
        var result = JSON.parse(cacheVal);
        var now = new Date() - 1;
        if (!result) {
          //缓存不存在
          return null;
        }
        if (now > result.exp) {
          //缓存过期
          this.removeStorage(key);
          return "";
        }
        //console.log("get cache:"+key);
        return result.val;
      } catch (e) {
        this.removeStorage(key);
        return null;
      }
    },
    removeStorage: function removeStorage(key) {
      // if(!localStorage){return false;}
      localStorage.removeItem(key);
    },
    permissionAction: function permissionAction() {
      window.location.href = '/article?articleId=1048753';
    },
    ruleAction: function ruleAction() {
      window.location.href = '/rule';
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showFlag) ? _c('div', {
    staticClass: "download-banner-box",
    class: _vm.positionCls
  }, [_c('div', {
    staticClass: "download-banner"
  }, [_c('div', {
    staticClass: "fix-l",
    on: {
      "click": _vm.closeBannerAction
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "fluid-wrap"
  }, [_c('div', {
    staticClass: "fluid-box"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logoImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('p', {
    staticClass: "text title"
  }, [_vm._v(_vm._s(_vm.downloadData.title))]), _vm._v(" "), _c('p', {
    staticClass: "text content"
  }, [_vm._v(_vm._s(_vm.downloadData.describe))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fix-r"
  }, [_c('open-app', {
    staticClass: "download-btn",
    attrs: {
      "text": _vm.text,
      "link": _vm.link,
      "pageType": _vm.pageType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-prompt"
  }, [_vm._v("开发者: Shanghai Yi-pai E-commerce Co.,Ltd   版本号: 5.2.2   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.permissionAction
    }
  }, [_vm._v("用户权限")]), _vm._v("   "), _c('span', {
    staticClass: "prompt-link",
    on: {
      "click": _vm.ruleAction
    }
  }, [_vm._v("隐私条款")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close-box"
  }, [_c('div', {
    staticClass: "close"
  })])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(42);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $vm = void 0;

var Exposure = function () {
    function Exposure(callback) {
        var _this = this;

        (0, _classCallCheck3.default)(this, Exposure);

        if (!callback || typeof callback !== 'function') {
            throw new Error("need callback or selector param");
            return;
        }
        this.intersectionObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (item) {
                if (item.intersectionRatio > 0) {
                    if (item.target) {
                        callback(item.target, item);
                        _this.intersectionObserver.unobserve(item.target);
                    }
                }
            });
        });
    }

    (0, _createClass3.default)(Exposure, [{
        key: 'observe',
        value: function observe(selector, ignoreExposured) {
            var _this2 = this;

            if (!this.intersectionObserver || !selector) {
                return;
            }
            var nodes = [];
            if (this.isDOM(selector)) {
                // dom节点
                nodes = [selector];
            } else {
                // 选择器
                nodes = document.querySelectorAll(selector);
            }
            if (!nodes.length) {
                return;
            }
            nodes.forEach(function (node) {
                if (!ignoreExposured && node.__wg__tracker__exposured__) {
                    return;
                }
                node.__wg__tracker__exposured__ = true;
                // 开始观察
                _this2.intersectionObserver.observe(node);
            });
        }
    }, {
        key: 'disconnect',
        value: function disconnect() {
            if (!this.intersectionObserver) {
                return;
            }
            this.intersectionObserver.disconnect();
        }
    }, {
        key: 'isDOM',
        value: function isDOM(obj) {
            if (!obj) {
                return false;
            }
            if ((typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object') {
                return obj instanceof HTMLElement;
            }
            if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string') {
                return true;
            }
            return false;
        }
    }]);
    return Exposure;
}();

(function () {
    function install(Vue) {
        Vue.mixin({
            created: function created() {
                this.$exposure = Exposure;
            }
        });
    }

    if (( false ? 'undefined' : (0, _typeof3.default)(exports)) == "object") {
        module.exports = install;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return install;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (window.Vue) {
        Vue.use(install);
    }
})();

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = __webpack_require__(284);

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    tab: _tab2.default
  },

  data: function data() {
    return {
      isShow: false
    };
  },


  methods: {
    menuToggle: function menuToggle() {
      // sa.track('NavigationBar', {
      //   navigation_location: '页面左上角'
      // })
      this.isShow = !this.isShow;
    },
    tabClose: function tabClose() {
      this.isShow = false;
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _jsCookie = __webpack_require__(59);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _browser = __webpack_require__(1);

var _b2a = __webpack_require__(23);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGE = {
  arrow: 'http://img.thebeastshop.com/images/menu-tab/menu-arrow.png',
  category: 'http://img.thebeastshop.com/images/menu-tab/menu-category.png',
  index: 'http://img.thebeastshop.com/images/menu-tab/menu-index.png',
  menu: 'http://img.thebeastshop.com/images/menu-tab/menu-menu.png',
  my: 'http://img.thebeastshop.com/images/menu-tab/menu-my.png'
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'menu-tab',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      image: IMAGE
    };
  },

  computed: {
    iosShow: function iosShow() {
      if ((0, _browser.ios)()) {
        return true;
      } else {
        return false;
      }
    },
    iosLink: function iosLink() {
      var il = iParam ? '' + TD_PREFIX + iParam : IOS_LINK;
      return PROTOCOL + '//' + "app.thebeastshop.com" + '/r?r=' + (0, _b2a.btoa)(il) + '&_d=' + (0, _b2a.btoa)(this.formatLink);
    }
  },
  created: function created() {
    if (!iParam) {
      iParam = tdMap[this.pageType] ? tdMap[this.pageType]['i'] : '';
    }
    if (!aParam) {
      aParam = tdMap[this.pageType] ? tdMap[this.pageType]['a'] : '';
    }
    this.initLink();
  },

  methods: {
    menuAction: function menuAction(type) {
      var url = "/";
      if (type === 'category') {
        url = "/category/v2";
      }
      if (type === 'my') {
        url = "/my";
      }

      window.location.href = url;
    }
  }
};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-tab-container",
    attrs: {
      "show": _vm.isShow
    }
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "arrow-wrap"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item first",
    on: {
      "click": function($event) {
        return _vm.menuAction('index')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.index,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "menu-item second",
    on: {
      "click": function($event) {
        return _vm.menuAction('category')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.category,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "menu-item third",
    on: {
      "click": function($event) {
        return _vm.menuAction('my')
      }
    }
  }, [_c('div', {
    staticClass: "item-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.my,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text"
  }, [_c('span', [_vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text"
  }, [_c('span', [_vm._v("选购")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-text last"
  }, [_c('span', [_vm._v("我的")])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-tab-wrap"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.menuToggle
    }
  }), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "menu-tab-mask",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.tabClose($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('tab', {
    attrs: {
      "show": _vm.isShow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'labels',
  props: ['data'],
  data: function data() {
    return {};
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.data), function(label) {
    return _c('li', {
      staticClass: "label",
      class: {
        'invalid': !label.valid
      }
    }, [_c('span', {
      staticClass: "summary",
      style: ({
        color: label.summaryColor
      })
    }, [_c('span', {
      staticClass: "type",
      style: ({
        color: label.typeColor,
        backgroundColor: label.typeBgColor
      })
    }, [_vm._v(_vm._s(label.type))]), _vm._v(" "), (label.summary) ? _c('span', [_vm._v(_vm._s(label.summary))]) : _vm._e()]), _vm._v(" "), (label.count) ? _c('span', {
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(label.count))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(431)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _listV = __webpack_require__(242);

var _listV2 = _interopRequireDefault(_listV);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _lazyload = __webpack_require__(56);

var _browser = __webpack_require__(1);

var _sdk = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'suggest-products',
  props: {
    offset: {
      default: 0
    },
    limit: {
      default: 20
    },
    source: {
      default: 'CART'
    },
    miniEnv: {
      default: false
    },
    title: {
      default: '你可能喜欢'
    },
    productId: {
      default: ''
    },
    orderId: {
      default: ''
    }
  },
  data: function data() {
    return {
      android: (0, _browser.android)(),
      dataLoaded: false,
      products: [],
      icon: '//img.thebeastshop.com/apppictures/2017-12-22/c57d173ff71cb42b64c9fb5e21cc6c07.png',
      border: '//img.thebeastshop.com/apppictures/2017-12-22/befe87ce675f2eeac6669bb98ec0eda4.png',
      businessCase: '猜你喜欢',
      sdk: null,
      env: ''
    };
  },
  created: function created() {
    var _this = this;

    (0, _sdk.getEnv)().then(function (sdk) {
      _this.sdk = sdk;
      _this.env = _this.sdk.adapter.env;
      _this.getProducts(sdk).then(function (_ref) {
        var data = _ref.data;

        _this.products = data;
        _this.dataLoaded = true;
        _this.$nextTick(function () {
          (0, _lazyload.lazyload)();
          var exposurer = new _this.$exposure(function (node) {
            console.log(node, '曝光啦');
            var recommendEngine = node.getAttribute('data-recommend') || '';
            var bu = recommendEngine ? '\u731C\u4F60\u559C\u6B22-' + recommendEngine : '猜你喜欢';
            sa.track('CommodityExposure', {
              commodity_spu_id: node.getAttribute('data-id'),
              commodity_name: node.getAttribute('data-name'),
              activity_type: sa.getActivity(node.getAttribute('data-labels') || []),
              original_price: node.getAttribute('data-rawprice'),
              discount_price: node.getAttribute('data-price'),
              position_number: node.getAttribute('data-index') - 0 + 1,
              business_case: bu
            });
          });

          exposurer.observe('.list-product-v1');
        });
      }).catch(function () {});
    });
  },

  components: {
    product: _listV2.default
  },
  methods: {
    getProducts: function getProducts(sdk) {
      // return Promise.resolve({ data:require('./test/data.js')})
      var query = "";
      if (this.source === 'CART') {
        query = 'offset=' + this.offset + '&limit=' + this.limit + '&source=' + this.source;
      } else if (this.source === 'PRODUCT' && this.productId) {
        query = 'productId=' + this.productId + '&offset=' + this.offset + '&limit=' + this.limit + '&source=' + this.source;
      } else if (this.source === 'ORDER') {
        query = 'orderId=' + this.orderId + '&offset=' + this.offset + '&limit=' + this.limit + '&source=' + this.source;
      } else {
        query = 'offset=' + this.offset + '&limit=' + this.limit + '&source=' + this.source;
      }
      console.log(this.source, 'sss');
      return sdk.request({
        url: '/app/product/suggest?' + query
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded && _vm.products && _vm.products.length) ? _c('div', {
    staticClass: "suggest-products"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_vm._v(_vm._s(_vm.android ? '随便逛逛' : _vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "products flex-wrap"
  }, _vm._l((_vm.products), function(item, index, i) {
    return _c('product', {
      attrs: {
        "source": _vm.source,
        "data": item,
        "miniEnv": _vm.miniEnv,
        "businessCase": _vm.businessCase,
        "index": index,
        "float": (index >= 0) ? index + 1 : (i + 1)
      }
    })
  }), 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _sdk = __webpack_require__(146);

var _sdk2 = _interopRequireDefault(_sdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = _sdk2.default.request; // import axios from '@/axios-mock'

module.exports = {
  getProduct: function getProduct(productId, source) {
    var url = '/app/product/' + productId;
    if (source) {
      url = '/app/product/' + productId + '?source=' + source;
    }
    return request({
      url: url
    });
  },
  getDetail: function getDetail(productId) {
    var legacy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var nocache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return request({
      url: '/app/product/' + productId + '/details?legacy=' + legacy + '&nocache=' + nocache
    });
  },

  getTags: function getTags(productId) {
    return request({
      url: '/app/product/' + productId + '/tickets'
    });
  },
  getCartNum: function getCartNum() {
    return request({
      url: '/app/cart/packs/size'
    });
  },
  isDistribution: function isDistribution(productId, districtId) {
    return request({
      url: '/app/product/' + productId + '/district/' + districtId + '/available'
    });
  },
  addCart: function addCart(spvId) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return request({
      url: '/app/cart/packs',
      method: 'POST',
      json: [{
        spvId: spvId,
        count: count,
        source: 'RAW'
      }]
    });
  },
  orderPreview: function orderPreview(spvId) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var orderType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'NORMAL';

    return request({
      url: '/app/order/preview',
      method: 'POST',
      json: {
        pack: {
          spvId: spvId,
          count: count
        },
        orderType: orderType
      }
    });
  },
  favorite: function favorite(id) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'POST';

    return request({
      url: '/app/favorite/PRODUCT?id=' + id,
      method: type
    });
  },

  foreShow: function foreShow(_ref) {
    var id = _ref.id,
        productCode = _ref.productCode,
        productName = _ref.productName,
        reminded = _ref.reminded;

    var url = '/app/foreshow/' + productCode;
    if (reminded) {
      url += '?id=' + id;
    }
    return request({
      url: url,
      json: !reminded ? {
        productName: productName,
        id: id
      } : '',
      method: reminded ? 'DELETE' : 'POST'
    }).then(function (_ref2) {
      var code = _ref2.code,
          data = _ref2.data;

      return _promise2.default.resolve(data);
    }).catch(function (err) {
      return _promise2.default.reject(err);
    });
  },

  getLessonDetail: function getLessonDetail(productCode) {
    return request({
      url: '/app/beastLesson/course/' + productCode
    });
  },
  reminderLesson: function reminderLesson(courseCode) {
    return request({
      url: '/app/beastLesson/' + courseCode + '/remind',
      method: 'PUT'
    });
  },
  cancelReminderLesson: function cancelReminderLesson(courseCode) {
    return request({
      url: '/app/beastLesson/' + courseCode + '/cancel_remind',
      method: 'PUT'
    });
  },
  getCommentBy: function getCommentBy(_ref3) {
    var productCode = _ref3.productCode,
        _ref3$increase = _ref3.increase,
        increase = _ref3$increase === undefined ? 0 : _ref3$increase,
        _ref3$scene = _ref3.scene,
        scene = _ref3$scene === undefined ? '' : _ref3$scene;

    var limit = 3;
    var offset = increase * limit;
    return request({
      url: '/app/shareOrder/evaluate?prodCode=' + productCode + '&offset=' + offset + '&limit=' + limit + '&scene=' + scene
    });
  },
  doArrival: function doArrival(productCode) {
    return request({
      url: '/app/product/arrival/subscribe/' + productCode,
      method: 'PUT'
    });
  },
  getCouponsByProduct: function getCouponsByProduct(productCode, productId) {
    var isGet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return request({
      url: '/app/coupon/getProdCoupons?prodcode=' + productCode + '&productId=' + productId + '&isGet=' + isGet
    });
  },
  getCouponByCode: function getCouponByCode(couponId, prodCode) {
    return request({
      url: '/app/coupon/getProdCoupon?couponId=' + couponId + '&prodcode=' + prodCode
    });
  },
  shareNotice: function shareNotice(productCode) {
    return request({
      url: '/app/share/notice',
      method: 'POST',
      json: {
        pageType: 'PRODUCT',
        busiParam: productCode || ''
      }
    });
  }
};

/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(27);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(2);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spreadDetail = ['保养说明', '质检说明', '运输说明', '退换货说明'];

module.exports = {
  clean: function clean(data) {
    data._address = null;
    data.unavailable = false;
    clean_rush(data);
    clean_forecast(data);
    spvs_sort(data);
    clean_price(data);
    clean_presell(data);
  },
  cleanDetail: function cleanDetail(item) {
    var reTag = /<(?:.|\s)*?>/g;
    var styleAttr = /style="[^"]*"/g;
    var remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g;

    var _content = item.content.replace(styleAttr, "").replace(remoeveTable, "");
    var _content_arr = _content.split('</p>');
    _content_arr.forEach(function (__content, index) {
      _content_arr[index] = __content.replace(reTag, "").replace(/&nbsp;/ig, "");
    });

    item._content = _content_arr;
    item._spreadAll = false;
    item._spread = false;
    spreadDetail.some(function (detail) {
      item._spreadAll = true;
      if (item.title.trim() === detail) {
        item._spreadAll = false;
        return true;
      }
    });
    return item;
  },
  get_variant_data: function get_variant_data(product) {
    var _product = product;
    var _pack = {
      product: {
        pic: _product.featureImage,
        brand: _product.brand,
        name: _product.name,
        rawPrice: _product.rawPrice,
        price: _product.price
      },
      variant: _product.variant.spvs[0].id,
      count: _product.variant.spvs[0].minAmount
      // labels: _product.labels
    };

    return {
      selectAmount: true,
      pack: _pack,
      spvId: _product.variant.spvs[0].id,
      variant: _product.variant,
      count: _product.variant.spvs[0].minAmount
    };
  },
  deepCopy: function deepCopy(target) {
    var copyed_objs = []; //此数组解决了循环引用和相同引用的问题，它存放已经递归到的目标对象 
    function _deepCopy(target) {
      if ((typeof target === 'undefined' ? 'undefined' : (0, _typeof3.default)(target)) !== 'object' || !target) {
        return target;
      }
      for (var i = 0; i < copyed_objs.length; i++) {
        if (copyed_objs[i].target === target) {
          return copyed_objs[i].copyTarget;
        }
      }
      var obj = {};
      if (Array.isArray(target)) {
        obj = []; //处理target是数组的情况 
      }
      copyed_objs.push({ target: target, copyTarget: obj });
      (0, _keys2.default)(target).forEach(function (key) {
        if (obj[key]) {
          return;
        }
        obj[key] = _deepCopy(target[key]);
      });
      return obj;
    }
    return _deepCopy(target);
  }
};

function clean_price(product) {
  var _price = {
    price: {},
    rawPrice: {}
  },
      _variant = product.variant,

  //根据spv的价格排序过的数据
  min = _variant.spvsSort[0],
      priceMin = min && min.price,
      rawPriceMin = min && min.rawPrice;
  _price.price['min'] = priceMin;
  _price.rawPrice['min'] = rawPriceMin;

  if (_variant.spvsSort.length > 1) {
    var max = _variant.spvsSort[_variant.spvsSort.length - 1],
        priceMax = max && max.price,
        rawPriceMax = max && max.rawPrice;
    _price.price['max'] = priceMax;
    _price.rawPrice['max'] = rawPriceMax;
  }
  product.format_price = _price;
}

function clean_presell(product) {
  var _presell = product.presell;
  if (_presell) {
    var date = new Date(_presell.deliverAt);
    _presell.text = '\u8BE5\u5546\u54C1\u9884\u552E\uFF0C\u9884\u8BA1\u5C06\u4E8E' + zero_plus(date.getMonth() + 1) + '\u6708' + zero_plus(date.getDate()) + '\u65E5\u5F00\u59CB\u53D1\u8D27';
  }
}

function zero_plus(num) {
  return num >= 10 ? num : '0' + num;
}

function spvs_sort(product) {
  var _variant = product.variant;
  _variant.spvsSort = _variant.spvs;
  _variant.spvsSort.sort(function (a, b) {
    return a.price - b.price;
  });
}

function clean_forecast(product) {
  var _forecast = product.priceForecast;
  if (!_forecast) {
    return false;
  }
  var _range = _forecast.range;
  if (_range.length > 1) {
    _forecast._price = _range[0] === _range[1] ? '\xA5' + _range[0] : '\xA5' + _range[0] + '-\xA5' + _range[1];
  } else {
    _forecast._price = '\xA5' + _range[0];
  }
  var date = new Date(_forecast.since);
  _forecast._since = zero_plus(date.getMonth() + 1) + '\u6708' + zero_plus(date.getDate()) + '\u65E5\n                        ' + zero_plus(date.getHours()) + ':' + zero_plus(date.getMinutes()) + '\u751F\u6548';
}

function clean_rush(product) {
  var spvs = product.variant.spvs;
  var firstFlash = spvs && spvs.length ? spvs[0].flashSale : null;
  var rush = {};
  // console.log('spvs',spvs)
  // if(spvs.length==1){
  //   if(firstFlash){
  //     rush.flashSale = firstFlash
  //     rush._djs = firstFlash.expiresAt
  //   }
  //   return false
  // }
  // console.log(1)
  rush.state = spvs.some(function (spv) {
    return spv.flashSale && spv.flashSale !== null;
  });
  rush.notAll = spvs.some(function (spv) {
    return spv.flashSale && spv.flashSale === null;
  });

  if (rush.state) {
    var _spv = spvs.filter(function (spv) {
      return spv.flashSale && spv.flashSale !== null && spv.left > 0;
    })[0];

    if (!_spv) return;
    rush.flashSale = _spv.flashSale;
    rush._djs = _spv.flashSale.expiresAt;
  }
  product._rush = rush;
}

/***/ }),
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(990);

var _index2 = _interopRequireDefault(_index);

var _page = __webpack_require__(51);

var _selectArea = __webpack_require__(257);

var _selectArea2 = _interopRequireDefault(_selectArea);

var _selectVariant = __webpack_require__(249);

var _selectVariant2 = _interopRequireDefault(_selectVariant);

var _selectCoupon = __webpack_require__(1062);

var _selectCoupon2 = _interopRequireDefault(_selectCoupon);

var _exposure = __webpack_require__(274);

var _exposure2 = _interopRequireDefault(_exposure);

var _login = __webpack_require__(84);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_exposure2.default);
_vue2.default.use(_selectArea2.default);
_vue2.default.use(_selectVariant2.default);
_vue2.default.use(_selectCoupon2.default);
_vue2.default.use(_login2.default);

(0, _page.Page)("product-detail", {
  el: '#app',
  template: '<Detail/>',
  components: { Detail: _index2.default },
  pageType: '商品详情页'
});

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(991)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(992),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _index = __webpack_require__(54);

var _index2 = _interopRequireDefault(_index);

var _appMain = __webpack_require__(158);

var _appMain2 = _interopRequireDefault(_appMain);

var _appHeader = __webpack_require__(136);

var _appHeader2 = _interopRequireDefault(_appHeader);

var _suggestProducts = __webpack_require__(430);

var _suggestProducts2 = _interopRequireDefault(_suggestProducts);

var _downloadBanner = __webpack_require__(270);

var _downloadBanner2 = _interopRequireDefault(_downloadBanner);

var _queryString = __webpack_require__(10);

var _queryString2 = _interopRequireDefault(_queryString);

var _wechatShare = __webpack_require__(156);

var _wechatShare2 = _interopRequireDefault(_wechatShare);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _util = __webpack_require__(175);

var _simpleSemver = __webpack_require__(155);

var simpleSemver = _interopRequireWildcard(_simpleSemver);

var _sdk = __webpack_require__(146);

var _sdk2 = _interopRequireDefault(_sdk);

var _axiosM = __webpack_require__(65);

var _axiosM2 = _interopRequireDefault(_axiosM);

var _productImages = __webpack_require__(993);

var _productImages2 = _interopRequireDefault(_productImages);

var _coupons = __webpack_require__(997);

var _coupons2 = _interopRequireDefault(_coupons);

var _downPayment = __webpack_require__(1000);

var _downPayment2 = _interopRequireDefault(_downPayment);

var _productInfo = __webpack_require__(1003);

var _productInfo2 = _interopRequireDefault(_productInfo);

var _selectAddress = __webpack_require__(1007);

var _selectAddress2 = _interopRequireDefault(_selectAddress);

var _labels = __webpack_require__(1011);

var _labels2 = _interopRequireDefault(_labels);

var _productBadges = __webpack_require__(1014);

var _productBadges2 = _interopRequireDefault(_productBadges);

var _detailTab = __webpack_require__(1018);

var _detailTab2 = _interopRequireDefault(_detailTab);

var _descNew = __webpack_require__(1021);

var _descNew2 = _interopRequireDefault(_descNew);

var _desc = __webpack_require__(1024);

var _desc2 = _interopRequireDefault(_desc);

var _footer = __webpack_require__(1027);

var _footer2 = _interopRequireDefault(_footer);

var _productBanner = __webpack_require__(1032);

var _productBanner2 = _interopRequireDefault(_productBanner);

var _comment = __webpack_require__(1036);

var _comment2 = _interopRequireDefault(_comment);

var _productDetail = __webpack_require__(1040);

var _productDetail2 = _interopRequireDefault(_productDetail);

var _productInfo3 = __webpack_require__(1043);

var _productInfo4 = _interopRequireDefault(_productInfo3);

var _footer3 = __webpack_require__(1047);

var _footer4 = _interopRequireDefault(_footer3);

var _giftBox = __webpack_require__(1051);

var _giftBox2 = _interopRequireDefault(_giftBox);

var _link = __webpack_require__(55);

var _api = __webpack_require__(525);

var _api2 = _interopRequireDefault(_api);

var _util2 = __webpack_require__(851);

var _util3 = _interopRequireDefault(_util2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// lession-components
var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

// product-components
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var query = _queryString2.default.parse(window.location.search);

// let __init
// if (query.productId) {
//  __init = { productId : query.productId}// test id
// }

var shareData = {};

var _pending_f = false;
var _rush_count_down = null;

exports.default = {
  name: 'product-detail',

  components: {
    DownBanner: _downloadBanner2.default,
    BeastHeader: _appHeader2.default,
    BeastMain: _appMain2.default,
    ProductImages: _productImages2.default,
    Coupons: _coupons2.default,
    DownPayment: _downPayment2.default,
    ProductInfo: _productInfo2.default,
    SelectAddress: _selectAddress2.default,
    Labels: _labels2.default,
    ProductBadges: _productBadges2.default,
    DetailTab: _detailTab2.default,
    ProductDesc: _desc2.default,
    ProductDescNew: _descNew2.default,
    ProductFooter: _footer2.default,
    Suggest: _suggestProducts2.default,
    LessonProductBanner: _productBanner2.default,
    LessonComment: _comment2.default,
    LessonProductDetail: _productDetail2.default,
    LessonProductInfo: _productInfo4.default,
    LessonFooter: _footer4.default,
    GiftWechatBox: _giftBox2.default,
    Price: _index2.default
  },

  data: function data() {
    return {
      productId: '',
      product: null,
      detail: null,
      detailNew: null,
      cmtRecommand: null,
      isApp: _browser2.default.app(),
      isWeixin: _browser2.default.weixin(),
      isIphoneX: (0, _util.isIphoneX)(),
      showDownBanner: true,
      djsformat: null,
      pageType: query.pageType || '',
      pageTypeImage: query.pageType === 'image' ? true : false,
      checkNavHeight: clientWidth / 375 * 3,
      showTagInfo: false,
      errorMsg: '',
      prodCoupons: [],
      prodCouponsList: [],
      showCouponList: false,
      sdk: {},
      nocache: query.nocache == 'true' ? true : false,
      env: 'm-web',
      fundPrice: [],
      zcInit: false,
      receiveMsgs: [],
      offMessageCount: 0,
      suggestType: decodeURIComponent(query.suggestType || ''),
      showDownMask: false,
      isShowWechatGift: false,
      curRcActive: 0,
      showQXLpBox: false,
      category: null,
      custData: {},
      qxlpChecked: false,
      initPage: false,
      title: '加载中...'
    };
  },
  created: function created() {
    var _this = this;

    this.productId = this.getProductId();

    _sdk2.default.init({
      vue: this
    });

    getEnv().then(function (sdk) {
      _this.sdk = sdk;
      _this.env = _this.sdk.adapter.env;

      _this.init();
    });
    sessionStorage.removeItem('_cards');
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getMember().then(function (data) {
      setTimeout(function () {
        _this2.loadService(data);
      }, 300);
    });
  },


  computed: {
    favoriteClass: function favoriteClass() {
      return this.product && this.product.favorited ? 'icon-like-active' : 'icon-like';
    }
  },

  provide: function provide() {
    return {
      toggleQXLpBox: this.toggleQXLpBox
    };
  },


  methods: {
    init: function init() {
      var _this3 = this;

      this.$setTitle('');
      this.$showLoading();
      if (this.pageType === 'LESSON') {
        this.getLessonDetail();

        window.onscroll = function () {
          var scrollTop = (0, _util.getScrollTop)();

          if (_this3.checkVersion()) {
            if (scrollTop >= _this3.checkNavHeight) {
              _this3.setNav('活动详情', {
                shadowColor: '#ffffff',
                bgColor: '#ffffff'
              });
            } else {
              _this3.setNav('', {
                shadowColor: '#ffffff',
                bgColor: '#ffffff'
              });
            }
          }
        };
      } else {
        this.getProductDetail();
      }
    },
    jumpLink: function jumpLink(link) {

      var jumpLink = (0, _link.transformLink)({
        link: {
          value: 'beastapp://article/2010821',
          type: 'deeplink'
        }
      });

      window.location.href = jumpLink;
    },
    setNav: function setNav(title, opts) {
      this.$setTitle(title);

      if (_browser2.default.app()) {
        _bridge2.default.setNavigation(opts);
      }
    },
    changeFund: function changeFund(funds) {
      this.fundPrice = funds;
    },
    showCoupons: function showCoupons(prodCouponsList) {
      this.showCouponList = true;
      this.prodCouponsList = prodCouponsList;

      document.body.style.overflow = 'hidden';
    },
    confirmCustomCard: function confirmCustomCard(type) {
      var custData = this.custData;


      if (type == true && !this.qxlpChecked) {
        this.$toast('请先勾选规则须知');
        return;
      }

      var query = 'spvId=' + custData.spvId + '&orderType=' + custData.orderType + '&count=' + custData.count + '&type=edit&source=detail';

      if (type == true) {
        if (this.isApp) {
          // window.location.href = `beastapp://entry?name=qx-lp&${query}`
          _bridge2.default.open({
            url: 'beastapp://entry?name=qx-lp&' + query
          });
        } else {
          window.location.href = '/activity/qxlp?' + query;
        }
      } else {
        if (_browser2.default.app()) {
          _bridge2.default.open({
            url: 'beastapp://order',
            data: custData.orderData
          });
        } else {
          sessionStorage.orderData = (0, _stringify2.default)(custData.orderData);
          window.location.href = '/order';
        }
      }
    },
    checkQxlpChecked: function checkQxlpChecked() {
      this.qxlpChecked = !this.qxlpChecked;
    },
    toggleQXLpBox: function toggleQXLpBox(id, count, orderType, orderData) {
      this.showQXLpBox = !this.showQXLpBox;
      this.custData = (0, _assign2.default)({}, {
        spvId: id,
        count: count,
        orderType: orderType,
        orderData: orderData
      });
    },
    getScrollW: function getScrollW(index) {
      this.contentScrollW = document.querySelector('.rc-list').clientWidth;
      var item = document.querySelectorAll('.rc-item');
      var category = [];
      for (var n in item) {
        category.push({
          left: item[n].offsetLeft,
          width: item[n].clientWidth
        });
      }
      this.category = category;

      var ele = document.querySelector('.rc-list');
      // this.product = null
      ele.scrollLeft = this.category[index].left - this.contentScrollW / 2 + this.category[index].width / 2;
    },
    goDetail: function goDetail(code, type, index, pname) {
      var _this4 = this;

      if (type === 'rc') {
        clearTimeout(_rush_count_down);
        sa.track('MoreColourStyleClick', {
          MoreColourStyle_mainprodcode: this.productId,
          MoreColourStyle_mainprodname: this.product.name,
          MoreColourStyleClick_prodcode: code,
          MoreColourStyleClick_prodname: pname
        });

        var ele = document.querySelector('.rc-list');

        // this.product = null
        this.productId = code;
        this.djsformat = null;
        this.curRcActive = index;
        this.init();

        this.$nextTick(function () {
          ele.scrollLeft = _this4.category[index].left - _this4.contentScrollW / 2 + _this4.category[index].width / 2;
        });
        return;
      }
      window.location.href = '/product/' + code;
    },
    getCouponById: function getCouponById(couponid) {
      var _this5 = this;

      var _TYPE = {
        'CHEAPEN_LINE': '满减',
        'DISCOUNT_LINE': '折扣',
        'FIXEDPRICE_LINE': '定价'
      };

      var _range = '';

      var id = this.product.id;

      this.$ensureLogged().then(function () {
        _api2.default.getCouponByCode(couponid, id).then(function (_ref) {
          var data = _ref.data;

          _this5.$toast('领取成功,优惠券可至个人中心-我的卡券查');

          if (data.discountType === 'CHEAPEN_LINE') {
            _range = '\u51CF' + data.discount + '\u5143';
          } else if (data.discountType === 'DISCOUNT_LINE') {
            _range = '\u6253' + data.discountRatio * 10 + '\u6298';
          } else {
            _range = '\u5B9A\u4EF7' + data.discount + '\u5143';
          }

          sa.track('ReceiveDiscount', {
            discount_id: couponid,
            discount_name: data.title,
            discount_type: _TYPE[data.discountType],
            discount_amount_range: _range
          });

          _this5.getLists();
          // this.getProdCoupons(this.product)
        }).catch(function (err) {
          _this5.$toast(err.message);
        });
      });
    },
    getLists: function getLists() {
      var _this6 = this;

      var _product2 = this.product,
          productId = _product2.productId,
          id = _product2.id;


      _api2.default.getCouponsByProduct(id, productId, true).then(function (_ref2) {
        var data = _ref2.data;

        _this6.prodCouponsList = data;
        _this6.showCouponList = true;
      });
    },
    hideCouponsList: function hideCouponsList() {
      this.showCouponList = false;
      document.body.style.overflow = 'auto';
    },
    getProdCoupons: function getProdCoupons(product) {
      var _this7 = this;

      var productId = product.productId,
          id = product.id;


      _api2.default.getCouponsByProduct(id, productId, false).then(function (_ref3) {
        var data = _ref3.data;


        if (!data.length) return;

        _this7.prodCoupons = data;
      });
    },
    getProductDetail: function getProductDetail() {
      var _this8 = this;

      _api2.default.getProduct(this.productId, query.source).then(function (_ref4) {
        var data = _ref4.data;

        var rcIndex = 0;
        if (data.matchProducts && data.matchProducts.length) {

          data.matchProducts.forEach(function (pro, ind) {
            if (pro.productCode === _this8.productId) {
              rcIndex = ind;
            }
          });

          sa.track('MoreColourStyleExposure', {
            MoreColourStyle_mainprodcode: _this8.productId,
            MoreColourStyle_mainprodname: data.name
          });
        }

        _this8.curRcActive = rcIndex;
        var _init = _this8.initPage;

        _this8.$hideLoading();
        _this8.renderData(data);
        _this8.getProdCoupons(data);
        _this8.initPage = true;

        _this8.$nextTick(function () {
          if (!_init && rcIndex > 0) {
            _this8.getScrollW(rcIndex);
          } else if (!_this8.curRcActive) {
            _this8.getScrollW();
          }
        });

        sa.setCurrentPageWithOutRefer('商品详情页', '\u5546\u54C1\u8BE6\u60C5\u9875:' + data.name, _this8.productId);

        sa.track('CommodityDetail', (0, _extends3.default)({}, sa.getReferPageName(), {
          commodity_spu_id: _this8.productId,
          commodity_name: data.name,
          activity_type: sa.getActivity(data.labels),
          hot_label: [],
          original_price: data.rawPrice,
          discount_price: data.price,
          commodity_need_point: data.pointPrice || 0
        }));

        sa.setCurrentPage('商品详情页', '\u5546\u54C1\u8BE6\u60C5\u9875:' + data.name, _this8.productId);
      }).catch(function (err) {
        _this8.$hideLoading();
        _this8.errorMsg = err.message || '系统异常';
        _this8.$alert(_this8.errorMsg);
      });
    },
    getLessonDetail: function getLessonDetail() {
      var _this9 = this;

      _api2.default.getLessonDetail(this.productId).then(function (_ref5) {
        var data = _ref5.data;

        _this9.product = data;

        _api2.default.getDetail(_this9.productId, false).then(function (_ref6) {
          var data = _ref6.data;

          _this9.detailNew = data;
        }).catch(function (err) {});

        if (_browser2.default.app()) {
          _this9.initAppShare(data.share);
        } else if (_this9.isWeixin) {
          _this9.initWechatShare(data, _this9.pageType);
        }

        _this9.getComment();

        _this9.$nextTick(function () {
          _this9.$hideLoading();
        });
      }).catch(function (err) {
        _this9.$hideLoading();
        _this9.errorMsg = err.message || '系统异常';
      });
    },
    checkVersion: function checkVersion() {
      var version = _browser2.default.app() ? _browser2.default.app().version : '';

      if (_browser2.default.app() && version && simpleSemver.gte(version, '3.6.0')) {
        return true;
      } else {
        return false;
      }
    },
    showPriceTag: function showPriceTag(flag) {
      this.showTagInfo = flag;
    },
    closeTagInfo: function closeTagInfo() {
      this.showTagInfo = false;
    },
    getComment: function getComment() {
      var _this10 = this;

      _api2.default.getCommentBy({
        productCode: this.productId,
        increase: 0,
        scene: 'BEAST_CLASS'
      }).then(function (_ref7) {
        var data = _ref7.data;

        if (!data.items.length) return;

        var type = data.items[0].annex.type;
        var items = [];
        data.items.some(function (item) {
          if (type === 'NONE') {
            items.push(item);
            return true;
          }

          if (item.annex.type === 'VIDEO' || item.annex.type === 'IMAGE') {
            items.push(item);
          }
        });

        _this10.cmtRecommand = {
          type: type,
          items: items
        };

        console.log(_this10.cmtRecommand, "cmtRecommend");
      });
    },
    renderData: function renderData(data) {
      var _this11 = this;

      // if (!this.nocache && this.unShow(data)) {
      //   return this.$alert("商品已下架")
      //   .then(() => {
      //     location.href = process.env.WEBFRONT_URL
      //   })
      // }

      if (data.downPayment && !data.downPayment.show) {
        //预付定金不展示 相当于该商品不是预付定金商品
        data.downPayment = null;
      }
      if (data.downPayment) {
        //格式化 抵扣金额
        var deductionFlag = true;
        var priceSingle = true;
        var price = 0;
        var deductionSingle = true;
        var deduction = 0;
        var finalSingle = true;
        var final = 0;
        var tips = [];

        var downPayment = data.downPayment;
        var details = downPayment ? downPayment.details : [];
        details.forEach(function (d) {
          if (!d.deduction) {
            deductionFlag = false;
          }

          if (price == 0) {
            price = d.price;
          }
          if (price && price !== d.price) {
            priceSingle = false;
          }
          if (deduction == 0) {
            deduction = d.deduction;
          }
          if (deduction !== 0 && deduction !== d.deduction) {
            deductionSingle = false;
          }
          if (final == 0) {
            final = d.finalPrice;
          }
          if (final !== 0 && final !== d.finalPrice) {
            finalSingle = false;
          }

          if (d.tip) {
            tips.push(d.tip);
          }
        });
        data.downPayment.deductionFlag = deductionFlag;
        data.downPayment.priceSingle = priceSingle;
        data.downPayment.deductionSingle = deductionSingle;
        data.downPayment.finalSingle = finalSingle;
        if (tips.length) {
          data.downPayment.tips = tips;
        }

        var discount = data.downPayment.discount;
        if (discount) {
          var coupons = discount.coupons;
          if (coupons && coupons.length > 3) {
            coupons = coupons.slice(0, 3);
          }
          data.downPayment.discount._coupons = coupons;
        }
      }
      _util3.default.clean(data);

      var _priceTags = [];
      var _stockWarn = [];
      data.variant.spvs.forEach(function (spv) {
        if (spv.priceTags && spv.priceTags.length) {
          _priceTags.push({
            priceTags: spv.priceTags,
            priceInfo: spv.priceInfo
          });
        }
        _stockWarn.push(spv.stockWarn || '');
      });

      if (_priceTags.length) {
        var _tag = _priceTags[0];
        data.spvPriceTag = _tag.priceTags;
        data.spvPriceInfo = _tag.priceInfo;
      }

      if (_stockWarn.length) {
        data.spvStockWarn = _stockWarn[0];
      }

      this.product = data;

      this.$setTitle(data.brand && data.brand.name);

      if (data._rush && data._rush._djs) {
        this.getCountDown();
      }

      if (this.nocache) {
        setTimeout(function () {
          _this11.closeBanner();
        }, 300);
      }

      _api2.default.getDetail(this.productId, this.product.legacyDetails, query.nocache).then(function (_ref8) {
        var data = _ref8.data;

        _this11.$hideLoading();
        if (!_this11.product.legacyDetails) {
          _this11.detailNew = data;
        } else {
          data.forEach(_util3.default.cleanDetail);
          _this11.detail = data;
        }
      }).catch(function (err) {});

      if (this.isWeixin) {
        this.initWechatShare(data);
      }
    },
    initWechatShare: function initWechatShare(data) {
      var _this12 = this;

      var pageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      (0, _wechatShare2.default)({
        title: '' + data.share.title,
        content: '' + data.share.content,
        link: "https://m.thebeastshop.com" + '/product/' + (data.id ? data.id : data.productCode) + '?pageType=' + pageType,
        success: function success(channel) {
          (0, _track2.default)({
            name: 'product-share-success',
            attrs: {
              channel: channel
            }
          });
          _this12.shareNoticeAction();
        }
      });
    },
    initAppShare: function initAppShare(data) {
      var _this13 = this;

      if (data) {
        data.link = "https://m.thebeastshop.com" + '/product/' + this.productId + '?pageType=' + this.pageType;
      }
      _bridge2.default.setButtons('RT', [{
        type: 'SHARE',
        handle: function handle() {
          (0, _track2.default)({
            name: 'lesson-share'
          });
          _bridge2.default.share(data, function () {
            _this13.shareNoticeAction();
          });
        }
      }], function () {});
    },
    getProductId: function getProductId() {
      var productId = '';

      // productId = query.productId
      if (this.isApp) {
        productId = query.productId;
      } else {
        productId = query.productId ? query.productId : __init.productId;
      }

      return productId;
    },
    unSale: function unSale() {
      var _product = this.product;
      return _product.soldOut || !_product.buyable || _product.offShelf;
    },
    goPurchase: function goPurchase(link) {
      var query = link.split('?')[1];
      window.location.href = '/group/purchase?' + query;
    },
    favorite: function favorite() {
      var _this14 = this;

      if (_pending_f) return;

      _pending_f = true;

      var _tip = this.product.favorited ? '取消收藏' : '收藏';
      this.$ensureLogged().then(function () {
        (0, _track2.default)({
          name: 'product-favorite',
          attrs: {
            value: !_this14.product.favorited
          }
        });
        var _type = _this14.product.favorited ? 'DELETE' : 'POST';
        var _saType = _type === 'POST' ? 'CollectCommodity' : 'CancelCollectCommodity';

        sa.track(_saType, {
          commodity_spu_id: _this14.product.id,
          commodity_name: _this14.product.name,
          original_price: _this14.product.rawPrice,
          discount_price: _this14.product.price
        });

        _api2.default.favorite(_this14.productId, _type).then(function () {

          _this14.$toast(_tip + '\u6210\u529F');
          _this14.product.favorited = !_this14.product.favorited;
          _pending_f = false;
        }).catch(function () {
          _this14.$toast(_tip + '\u5931\u8D25');
          _pending_f = false;
        });
      }).catch(function () {
        _pending_f = false;
      });
    },
    buyWechatGift: function buyWechatGift() {
      this.$refs.pFooter.tapBuy('wechat-gift');
    },
    getCountDown: function getCountDown() {
      var _this15 = this;

      var endDate = new Date(this.product._rush._djs),
          _now = new Date();

      var leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
          leftsecond = parseInt(leftTime),
          day1 = Math.floor(leftsecond / (60 * 60 * 24)),
          hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
          minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
          second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);
      hour += day1 * 24;
      if (hour == 0 && minute == 0 && second == 0) {
        this.djsformat = null;
        clearTimeout(_rush_count_down);
        return false;
      }

      if (day1 > 0) {
        var h = hour - day1 * 24;
        this.djsformat = day1 + '\u5929 ' + (h < 10 ? '0' + h : h) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
      } else {
        this.djsformat = (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second);
      }

      _rush_count_down = setTimeout(function () {
        _this15.getCountDown();
      }, 1000);
    },
    unShow: function unShow(data) {
      var _product = data;

      return _product.invisible;
    },
    closeBanner: function closeBanner() {
      this.showDownBanner = false;
    },
    shareNoticeAction: function shareNoticeAction() {
      _api2.default.shareNotice(this.productId).then(function (data) {}).catch(function (err) {
        console.log(err || 'shareNoticeAction出错啦');
        return;
      });
    },
    openService: function openService() {
      var _this16 = this;

      if (this.zcInit) return;

      this.$ensureLogged().then(function (data) {
        _this16.loadService(data);
      });
    },
    openZC: function openZC() {
      this.zc.expand();
    },
    doShowWechatGift: function doShowWechatGift() {
      this.isShowWechatGift = !this.isShowWechatGift;
    },
    checkMember: function checkMember() {
      var _this17 = this;

      this.getMember().then(function (data) {
        if (!data) {
          if (loginFlag) {
            return;
          }
          _this17.$ensureLogged(function (status) {
            loginFlag = true;
            if (status.alreadyLogged || status.logged) {
              _this17.checkMember();
            }
          }).catch(function (err) {
            return;
          });
        } else {
          _this17.loadService(data);
        }
      }).catch(function (err) {
        console.log(err, "getMember出错啦");
      });
    },
    getMember: function getMember() {
      return (0, _axiosM2.default)({
        url: '/app/member',
        method: 'GET'
      }).then(function (_ref9) {
        var code = _ref9.code,
            data = _ref9.data;

        return _promise2.default.resolve(data);
      }).catch(function (err) {
        return _promise2.default.reject(err);
      });
    },
    showDownloadMask: function showDownloadMask() {
      this.showDownMask = true;
    },
    loadService: function loadService(data) {
      var memberId = data ? data.memberId : '';
      this.createInstance(memberId);
    },
    createInstance: function createInstance(memberId) {
      var _self = this;

      (function (w, d, e, x) {
        w[e] = function () {
          w.cbk = w.cbk || [];
          w.cbk.push(arguments);
        };
        x = d.createElement('script');
        x.async = true;
        x.id = 'zhichiScript';
        x.className = 'service';
        x.src = 'https://www.sobot.com/chat/frame/v2/entrance.js?sysnum=46d89a7a70354f90bc09728734838699';
        d.body.appendChild(x);
      })(window, document, 'zc');

      zc('config', {
        custom: true, //设置自定义生效 第二步
        partnerid: memberId
      });

      zc("frame_manual", function (res) {
        _self.zcInit = true;
      });

      // zc('receive_message', res => {
      //   _self.receiveMsgs = res
      // })

      // zc('offline_message_count', res => {
      //   if (!res) return
      //   _self.offMessageCount = res.size
      // })
    }
  },

  filters: {
    formatTime: function formatTime(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month = date.getMonth() - 0 + 1;
      var day = date.getDate();

      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }

      return year + '-' + month + '-' + day;
    }
  }
};


function getEnv() {
  return new _promise2.default(function (resolve, reject) {
    _sdk2.default.adapter.invoke(function () {
      resolve(_sdk2.default);
    });
  });
}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(995),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

var _menuTab = __webpack_require__(281);

var _menuTab2 = _interopRequireDefault(_menuTab);

var _api = __webpack_require__(525);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _rush_count_down = null; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['product', 'djsformat', 'nocache'],

  components: {
    Swiper: _index2.default,
    BeastImage: _image2.default,
    BeastVideo: _video2.default,
    MenuTab: _menuTab2.default
  },

  data: function data() {
    return {
      isApp: _browser2.default.app(),
      showPriceFloor: false,
      prevueFormat: null,
      prevueFormatNew: null,
      isToast: false,
      toastTitle: null,
      toastContent: null,
      swiper: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        paginateCls: { 'number-paginate': true },
        // paginateCls: 'number-paginate',
        // autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    };
  },
  created: function created() {
    if (!this.product) return;
    this.getCountDown();
    this.formatTime();
  },


  computed: {
    favoriteClass: function favoriteClass() {
      return this.product && this.product.favorited ? 'icon-like-active' : 'icon-like';
    },

    soldOut: function soldOut() {
      if (!this.product) return false;
      var downPay = this.product.downPayment || null;

      if (!downPay) return this.product.soldOut;

      var soldOut = true;
      downPay.details.forEach(function (spv) {
        if (spv.stock > 0) {
          soldOut = false;
        }
      });

      if (this.product.soldOut && soldOut) {
        soldOut = true;
      } else if (this.product.soldOut && !soldOut) {
        soldOut = false;
      } else {
        soldOut = false;
      }

      return soldOut;
    }
  },

  methods: {
    favorite: function favorite() {
      this.$emit('favorite');
    },
    doReminder: function doReminder(id, reminded) {
      var _this = this;

      var d = {
        productCode: this.product.id,
        productName: this.product.name,
        id: id,
        reminded: reminded
      };

      this.$ensureLogged({
        event: '开售提醒'
      }).then(function () {
        (0, _api.foreShow)(d).then(function (data) {
          if (!reminded) {
            _this.product.prevue.remind = true;
            _this.toastTitle = data.title;
            _this.toastContent = data.message;
            _this.isToast = true;

            setTimeout(function () {
              _this.isToast = false;
            }, 2000);
          } else {
            _this.toastTitle = data.title;
            _this.toastContent = '';
            _this.isToast = true;

            setTimeout(function () {
              _this.isToast = false;
            }, 2000);
            _this.product.prevue.remind = false;
          }
        }).catch(function (err) {
          _this.$toast('' + err.message);
        });
      }).catch(function () {
        // sa.registerButtonClick()
      });
    },


    getCountDown: function getCountDown() {
      var _this2 = this;

      // let endDate = new Date(this.product.prevue.since) , _now = new Date()
      if (!this.product.prevue || !this.product.prevue.vipSince) {
        return;
      }
      var endDate = new Date(this.product.prevue.vipSince),
          _now = new Date();
      var leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
          leftsecond = parseInt(leftTime),
          day1 = Math.floor(leftsecond / (60 * 60 * 24)),
          hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
          minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
          second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);

      if (hour == 0 && minute == 0 && second == 0) {
        this.prevueFormat = null;
        clearTimeout(_rush_count_down);
        window.location.reload();
        return false;
      }

      if (day1 == 0) {
        this.prevueFormat = '\u8DDD\u79BB\u5F00\u552E\u8FD8\u6709' + hour + '\u5C0F\u65F6' + minute + '\u5206' + second + '\u79D2';
      } else {
        this.prevueFormat = '\u8DDD\u79BB\u5F00\u552E\u8FD8\u6709' + day1 + '\u5929' + hour + '\u5C0F\u65F6' + minute + '\u5206' + second + '\u79D2';
      }

      _rush_count_down = setTimeout(function () {
        _this2.getCountDown();
      }, 1000);
    },

    formatTime: function formatTime() {
      if (!this.product.prevue || !this.product.prevue.since) {
        return;
      }
      var date = new Date(parseInt(this.product.prevue.since, 10));
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hh = date.getHours();
      var mm = date.getMinutes();
      var ss = date.getSeconds();

      month = this.addZero(month);
      day = this.addZero(day);
      hh = this.addZero(hh);
      mm = this.addZero(mm);
      ss = this.addZero(ss);
      var timeStr = month + '\u6708' + day + '\u65E5 ' + hh + ':' + mm + ':' + ss;
      this.prevueFormatNew = timeStr;
    },
    addZero: function addZero(str) {
      if (str < 10) {
        str = "0" + str;
      }
      return str;
    },
    ensureImage: function ensureImage(src) {
      return (0, _urlUtil.ensure_protocol)(src);
    }
  }
};

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "p-images",
    class: {
      'hide-bottom': (_vm.product.downPayment && _vm.product.downPayment.discount)
    }
  }, [(!_vm.isApp && !_vm.nocache) ? _c('div', {
    staticClass: "detail-menu-wrap"
  }, [_c('menu-tab')], 1) : _vm._e(), _vm._v(" "), (!_vm.isApp && !_vm.nocache) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product),
      expression: "product"
    }],
    staticClass: "icon",
    class: _vm.favoriteClass,
    on: {
      "click": _vm.favorite
    }
  }) : _vm._e(), _vm._v(" "), _c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": _vm.swiper.paginateCls
    }
  }, [_vm._l((_vm.product.videos), function(video, index) {
    return (_vm.product.videos.length) ? _c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "product-video",
      class: 'p' + index
    }, [_c('beast-video', {
      attrs: {
        "wrap": 'p' + index,
        "isHeight": true,
        "poster": _vm.ensureImage(video.thumbnailUrl),
        "autoplay": false,
        "source": video.url,
        "controls": true
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.product.images), function(item) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [(_vm.soldOut) ? _c('div', {
      staticClass: "mask"
    }) : _vm._e(), _vm._v(" "), _c('beast-image', {
      attrs: {
        "src": _vm.ensureImage(item)
      }
    }), _vm._v(" "), (!_vm.product.invisible && !_vm.product.buyable) ? _c('div', {
      staticClass: "stats-tag buyable"
    }, [_c('span', [_vm._v("该渠道不可售")])]) : _vm._e(), _vm._v(" "), (_vm.product.foretell) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("即将开售")])]) : _vm._e(), _vm._v(" "), (_vm.soldOut) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("售罄")])]) : _vm._e(), _vm._v(" "), ((!_vm.nocache && _vm.product.offShelf) || _vm.product.invisible) ? _c('div', {
      staticClass: "stats-tag"
    }, [_c('span', [_vm._v("下架")])]) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.isToast) ? _c('div', {
    staticClass: "toast-box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.toastTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toastContent))])]) : _vm._e(), _vm._v(" "), (!_vm.product.prevue && _vm.djsformat) ? _c('div', {
    staticClass: "forecast-detail"
  }, [_c('span', {
    staticClass: "forecast-detail-name"
  }, [_vm._v("限时抢购")]), _vm._v(" "), _c('span', {
    staticClass: "forecast-detail-price"
  }, [_vm._v(_vm._s(_vm.djsformat) + " 后恢复原价")])]) : _vm._e(), _vm._v(" "), (_vm.product.prevue) ? _c('div', {
    staticClass: "forecast-detail forecast-ys"
  }, [_c('div', {
    staticClass: "left-box"
  }, [_c('div', {
    staticClass: "forecast-detail-item name"
  }, [_vm._v("即将开售: " + _vm._s(_vm.prevueFormatNew) + " 开售")]), _vm._v(" "), (_vm.product.prevue.desc) ? _c('div', {
    staticClass: "forecast-detail-item desc"
  }, [_vm._v(_vm._s(_vm.product.prevue.desc))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('span', {
    staticClass: "forecast-detail-price",
    class: {
      'two': _vm.product.prevue.desc
    },
    on: {
      "click": function($event) {
        return _vm.doReminder(_vm.product.prevue.id, _vm.product.prevue.remind)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.product.prevue.remind ? '关闭提醒' : '开售提醒') + "\n      ")])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(525);

exports.default = {
  props: ['product', 'prodCoupons'],

  methods: {
    showCoupons: function showCoupons() {
      var _this = this;

      var _product = this.product,
          productId = _product.productId,
          id = _product.id;


      (0, _api.getCouponsByProduct)(id, productId, true).then(function (_ref) {
        var data = _ref.data;


        _this.$emit('show', data);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.prodCoupons) ? _c('div', {
    staticClass: "valid-coupons",
    on: {
      "click": _vm.showCoupons
    }
  }, [_c('div', {
    staticClass: "coupon-items"
  }, _vm._l((_vm.prodCoupons), function(item) {
    return _c('div', {
      staticClass: "c-item"
    }, [_vm._v("\n      " + _vm._s(item.couponContentDesc) + "\n    ")])
  }), 0), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-coupon"
  }, [_vm._v("去领券"), _c('i')])
}]}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlUtil = __webpack_require__(21);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['product'],
  components: {
    BeastImage: _image2.default
  },
  methods: {
    ensureImage: function ensureImage(src) {
      return (0, _urlUtil.ensure_protocol)(src);
    },
    getCounponAction: function getCounponAction(coupons) {
      this.$selectCoupon(coupons).then(function () {}).catch(function (err) {});
    }
  }
};

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "down-payment"
  }, [(_vm.product.strikePriceTag) ? _c('div', {
    staticClass: "downpay-strike"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.ensureImage(_vm.product.strikePriceTag.bgImage)
    }
  }), _vm._v(" "), (_vm.product.strikePriceTag.showType == '1') ? _c('div', {
    staticClass: "discount-price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_c('div', {
    staticClass: "discount-price"
  }, [_c('div', {
    staticClass: "price-item"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title1))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.originalPrice ? _vm.product.strikePriceTag.originalPrice.toFixed() : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-item min"
  }, [_c('div', {
    staticClass: "price-label math"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box math",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "price-item"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title2))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.couponPrice ? _vm.product.strikePriceTag.couponPrice.toFixed() : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-item min"
  }, [_c('div', {
    staticClass: "price-label math"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box math",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("=")])]), _vm._v(" "), _c('div', {
    staticClass: "price-item last"
  }, [_c('div', {
    staticClass: "price-label",
    style: ({
      'color': _vm.product.strikePriceTag.titleColor
    })
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.title3))]), _vm._v(" "), _c('div', {
    staticClass: "price-box",
    style: ({
      'color': _vm.product.strikePriceTag.priceColor
    })
  }, [_vm._v("¥ "), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.product.strikePriceTag.strikePrice ? _vm.product.strikePriceTag.strikePrice.toFixed() : 0))]), (_vm.product.variant.spvs.length > 1) ? _c('span', [_vm._v("起")]) : _vm._e()])])])]) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1004)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(54);

var _index2 = _interopRequireDefault(_index);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _util = __webpack_require__(137);

var _link = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['product', 'fundPrice'],

  data: function data() {
    return {
      downpayData: null,
      myFundPrice: this.fundPrice,
      refundsName: '',
      finalDetails: []
    };
  },


  components: {
    Price: _index2.default
  },

  created: function created() {
    var _this = this;

    this.product.variant.spvs.forEach(function (spv) {
      if (!spv.refunds) return;
      _this.myFundPrice.push(spv.refunds);
      _this.refundsName = spv.refundsName;
    });
    this.myFundPrice = this.fundPrice.sort(this.sort);
    this.formatData();
  },


  watch: {
    fundPrice: function fundPrice(price) {
      if (!this.fundPrice.length) {
        this.myFundPrice = [];
      } else if (this.fundPrice.length === 1) {
        this.myFundPrice = [this.fundPrice[0]];
      } else if (this.fundPrice.length > 1 && this.fundPrice[0] == this.fundPrice[this.fundPrice.length - 1]) {
        this.myFundPrice = [this.fundPrice[0]];
      } else {
        this.myFundPrice = [this.fundPrice[0], this.fundPrice[this.fundPrice.length - 1]];
      }
    }
  },

  computed: {
    isNewTag: function isNewTag() {
      var newComer = false;
      if (!this.product) return;

      this.product.variant.spvs.forEach(function (spv) {
        if (spv.newcomerTag) {
          newComer = true;
        }
      });

      return newComer;
    }
  },

  methods: {
    formatData: function formatData() {
      var downPayment = this.product.downPayment;
      var details = downPayment && downPayment.details;
      var finalDetails = [];

      if (details) {
        details.forEach(function (d) {
          if (finalDetails.indexOf(d.finalPrice) === -1) {
            finalDetails.push(d.finalPrice);
          }
        });
      }

      // finalDetails = [10, 20, 9, 30]
      finalDetails.sort(function (a, b) {
        return a > b ? 1 : -1;
      });

      if (finalDetails.length) {
        this.finalDetails = finalDetails.length > 1 ? [finalDetails[0], finalDetails[finalDetails.length - 1]] : finalDetails;
        // this.finalDetails = finalDetails
      }
    },
    sort: function sort(a, b) {
      return a > b;
    },


    tagPath: function tagPath(name) {
      return 'https://img.thebeastshop.com/app/product/detail/' + name + '.png';
    },

    jump: function jump(link) {
      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: link
        });
      } else {
        window.location.href = (0, _util.getLink)(link);
      }

      // let _link = link
      // if (!browser.app()) {
      //   _link = getLink(link)
      // }

      // window.location.href = _link
    },
    downpayRuleAction: function downpayRuleAction() {
      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: 'beastapp://article/1033174'
        });
      } else {
        window.location.href = '/article?articleId=1033174';
      }
    },
    goFunds: function goFunds() {
      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: 'beastapp://article?articleId=1040184'
        });
      } else {
        window.location.href = '/article?articleId=1040184';
      }
    },
    getCounponAction: function getCounponAction(coupons) {
      this.$selectCoupon(coupons).then(function () {}).catch(function (err) {});
    },
    showPriceTag: function showPriceTag() {
      this.$emit('showPriceTag', true);
    },
    downpayImageAction: function downpayImageAction() {
      var myLink = this.product.waterMarkImage[1];
      if (myLink) {
        if (typeof myLink === 'string') {
          myLink = JSON.parse(myLink);
        }

        (0, _link.trackSkip)({
          trackData: {
            name: 'product-downpay-image',
            wait: false
          },
          link: (0, _link.transformLink)({
            link: myLink
          })
        });
      }
    }
  },

  filters: {
    formatPrice: function formatPrice(value) {
      var v = String(Math.floor(value * Math.pow(10, 1)) / Math.pow(10, 1));
      var temp = v.split('.');
      return temp.length > 1 ? v : v + '.0';
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-base-info"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "brand",
    on: {
      "click": function($event) {
        return _vm.jump(("beastapp://brand/" + (_vm.product.brand.id) + "?title=" + (_vm.product.brand.name)))
      }
    }
  }, [_vm._v(_vm._s(_vm.product.brand && _vm.product.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "prices"
  }, [(_vm.product.mainStationFirst) ? _c('div', {
    staticClass: "mainStationFirst"
  }, [_vm._v("首单价: ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "real",
    class: {
      'firstColor': _vm.product.mainStationFirst
    }
  }, [_c('div', {
    staticClass: "price",
    class: {
      rush: _vm.product._rush.state
    }
  }, [_c('price', {
    attrs: {
      "data": _vm.product.format_price.price.min
    }
  })], 1), _vm._v(" "), (_vm.product.format_price.price.max && _vm.product.format_price.price.max > _vm.product.format_price.price.min) ? _c('div', {
    staticClass: "price",
    class: {
      rush: _vm.product._rush.state
    }
  }, [_vm._v("\n          - "), _c('price', {
    attrs: {
      "data": _vm.product.format_price.price.max
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "raw"
  }, [(_vm.product.format_price.price.min != _vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "rawPrice"
  }, [(_vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.format_price.rawPrice.min
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product.format_price.rawPrice.max && _vm.product.format_price.rawPrice.max > _vm.product.format_price.rawPrice.min) ? _c('div', {
    staticClass: "price"
  }, [_vm._v("\n            - "), _c('price', {
    attrs: {
      "data": _vm.product.format_price.rawPrice.max
    }
  })], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isNewTag && !_vm.product.mainStationFirst) ? _c('div', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")]) : _vm._e(), _vm._v(" "), (_vm.product.spvPriceTag && _vm.product.spvPriceTag.length) ? _c('div', {
    staticClass: "price-tag-wrap"
  }, [_vm._l((_vm.product.spvPriceTag), function(priceTag) {
    return _c('div', {
      staticClass: "price-tag"
    }, [_c('span', {
      staticClass: "price-tag-text",
      style: ({
        color: priceTag.textColor,
        borderColor: priceTag.edgeColor
      })
    }, [_vm._v(_vm._s(priceTag.text))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "price-tag-more"
  }, [_c('span', {
    staticClass: "price-more",
    on: {
      "click": _vm.showPriceTag
    }
  }, [_vm._v("···")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product.spvStockWarn) ? _c('div', {
    staticClass: "stocks-warn"
  }, [_vm._v(_vm._s(_vm.product.spvStockWarn || ''))]) : _vm._e(), _vm._v(" "), (_vm.myFundPrice.length === 1) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + "元" + _vm._s(_vm.refundsName))]) : (_vm.myFundPrice.length && _vm.myFundPrice[0] == _vm.myFundPrice[_vm.myFundPrice.length - 1]) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + "元" + _vm._s(_vm.refundsName))]) : (_vm.myFundPrice.length > 0) ? _c('div', {
    staticClass: "refunds",
    on: {
      "click": _vm.goFunds
    }
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.myFundPrice[0])) + " ~ " + _vm._s(_vm._f("formatPrice")(this.fundPrice[_vm.myFundPrice.length - 1])) + "元" + _vm._s(_vm.refundsName))]) : _vm._e(), _vm._v(" "), (_vm.product.downPayment) ? _c('div', {
    staticClass: "downpay-infos"
  }, [_c('div', {
    staticClass: "downpay-price-box"
  }, [_c('div', {
    staticClass: "downpay-label"
  }, [_vm._v("预付定金价：")]), _vm._v(" "), (_vm.product.downPayment.range[0] !== _vm.product.downPayment.range[1]) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[0]
    }
  }), _vm._v("\n            - "), _c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[1]
    }
  })], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.downPayment.range[0]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "downpay-desc-box"
  }, [_c('div', {
    staticClass: "downpay-desc"
  }, [_c('div', {
    staticClass: "desc-box"
  }, [_vm._l((_vm.product.downPayment.details), function(item, index) {
    return _c('div', {
      key: item.spvId,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("定金 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-price"
    }, [_c('price', {
      attrs: {
        "data": item.price
      }
    })], 1) : (!_vm.product.downPayment.priceSingle) ? _c('span', {
      staticClass: "desc-price"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item.price
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.product.downPayment.details), function(item, index) {
    return (_vm.product.downPayment.deductionFlag) ? _c('div', {
      key: item.spvId,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("可抵 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-deduction"
    }, [_c('price', {
      attrs: {
        "data": item.deduction
      }
    })], 1) : (!_vm.product.downPayment.deductionSingle) ? _c('span', {
      staticClass: "desc-deduction"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item.deduction
      }
    })], 1) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "desc-time"
  }, [_vm._v("| " + _vm._s(_vm.product.downPayment.downTimeStr))])], 2), _vm._v(" "), _c('div', {
    staticClass: "desc-box",
    class: {
      'none': _vm.product.downPayment.tips ? false : true
    }
  }, [_vm._l((_vm.finalDetails), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "desc-item"
    }, [(index == 0) ? _c('span', {
      staticClass: "desc-label"
    }, [_vm._v("尾款 ")]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('span', {
      staticClass: "desc-price"
    }, [_c('price', {
      attrs: {
        "data": item
      }
    })], 1) : (!_vm.product.downPayment.finalSingle) ? _c('span', {
      staticClass: "desc-price"
    }, [_vm._v("\n                - "), _c('price', {
      attrs: {
        "data": item
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "desc-time"
  }, [_vm._v("| " + _vm._s(_vm.product.downPayment.finalTimeStr))])], 2), _vm._v(" "), (_vm.product.downPayment.tips) ? _c('div', {
    staticClass: "desc-tips"
  }, _vm._l((_vm.product.downPayment.tips), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "desc-tip"
    }, [_c('span', [_vm._v("*")]), _vm._v(" " + _vm._s(item))])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "downpay-rule",
    on: {
      "click": _vm.downpayRuleAction
    }
  })]), _vm._v(" "), (_vm.product.waterMarkImage && _vm.product.waterMarkImage.length && _vm.product.waterMarkImage[0].indexOf('homegift.jpg') !== -1) ? _c('div', {
    staticClass: "downpay-image",
    on: {
      "click": _vm.downpayImageAction
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.product.waterMarkImage[0]
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.product.priceForecast) ? _c('div', {
    staticClass: "price-forecasts"
  }, [_c('div', {
    staticClass: "forecast-details"
  }, [_c('span', {
    staticClass: "forecast-details-name"
  }, [_vm._v(_vm._s(_vm.product.priceForecast.name))]), _vm._v(" "), _c('span', {
    staticClass: "forecast-details-price"
  }, [_vm._v(_vm._s(_vm.product.priceForecast._price))]), _vm._v(" "), _c('span', {
    staticClass: "forecast-details-date"
  }, [_c('i', [_vm._v(" | ")]), _vm._v(" " + _vm._s(_vm.product.priceForecast._since) + " " + _vm._s((_vm.product._rush.notAll && _vm.product._rush.state) ? '(商品部分规格不支持抢购)' : ''))])])]) : _vm._e(), _vm._v(" "), (_vm.product.presell) ? _c('div', {
    staticClass: "presell"
  }, [_vm._v("\n    " + _vm._s(_vm.product.presell && _vm.product.presell.content) + " "), (_vm.product._rush.notAll && _vm.product._rush.state) ? void 0 : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product.customPrintTemplate == 6) ? _c('div', {
    staticClass: "custom-card"
  }, [_vm._v("本商品享受"), _c('span', [_vm._v("「刻字服务」")]), _vm._v("，请在下单时选择")]) : (_vm.product.canCustomCard) ? _c('div', {
    staticClass: "custom-card"
  }, [_vm._v("该商品支持定制"), _c('span', [_vm._v("专属标签")]), _vm._v("，请在下单时选择")]) : _vm._e(), _vm._v(" "), (_vm.product.furniture || (_vm.product.needVerifyAddress && !_vm.product.monthSend)) ? _c('div', {
    staticClass: "p-info-tip"
  }, [_c('div', {
    staticClass: "tips"
  }, _vm._l((_vm.product.tips), function(tip) {
    return _c('div', {
      staticClass: "tip"
    }, [(tip.presentation) ? _c('div', {
      staticClass: "address-tip-title"
    }, [_vm._v(_vm._s(tip.presentation))]) : _vm._e(), _vm._v(" "), (tip.content) ? _c('p', [_vm._v(_vm._s(tip.title)), _c('span', {
      staticClass: "content"
    }, [_vm._v(_vm._s(tip.content))])]) : _vm._e()])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1008)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1009),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(525);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['product'],

  methods: {
    changAddress: function changAddress(e) {
      var _this = this;

      this.$selectArea().then(function (data) {
        if (data === null) {
          return _promise2.default.resolve(null);
        }
        _this.product._address = data.province.name + ' ' + data.city.name + ' ' + data.district.name;
        return _api2.default.isDistribution(_this.product.id, data.district.id);
      }).then(function (data) {
        if (data !== null) {
          _this.product.unavailable = !data.data;
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && (_vm.product.needVerifyAddress && !_vm.product.monthSend)) ? _c('div', {
    staticClass: "product-address"
  }, [_c('div', {
    staticClass: "address-input",
    on: {
      "click": _vm.changAddress
    }
  }, [_c('div', {
    staticClass: "addr-text",
    class: {
      empty: !_vm.product._address
    }
  }, [_vm._v(_vm._s(_vm.product._address ? _vm.product._address : '请选择配送区域'))]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.product.unavailable) ? _c('div', {
    staticClass: "unavailable"
  }, [_vm._v("\n      当前位置不支持配送，请选择地址\n    ")]) : (_vm.product._address) ? _c('div', {
    staticClass: "available"
  }, [_vm._v("\n      支持配送\n    ")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow"
  })])
}]}

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1012),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(256);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['product'],

  components: {
    Labels: _index2.default
  },

  data: function data() {
    return {
      moreopen: false
    };
  },


  methods: {
    showLabelMore: function showLabelMore() {
      this.moreopen = !this.moreopen;
    },
    jump: function jump(label) {
      var title = '';

      if (label.campaign) {
        title = label.campaign.name;
      }
      window.location.href = label.link + '&showCampaign=true';
      // window.location.href = `${label.link}&title=${encodeURIComponent(title)}&showCampaign=true`
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && (_vm.product.labels && _vm.product.labels.length)) ? _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.product.labels), function(label, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!_vm.moreopen && index > 2) ? false : true),
        expression: "(!moreopen && index > 2) ? false : true"
      }],
      staticClass: "label",
      class: {
        'invalid': !label.valid
      },
      on: {
        "click": function($event) {
          return _vm.jump(label)
        }
      }
    }, [_c('span', {
      staticClass: "summary",
      style: ({
        color: label.summaryColor
      })
    }, [_c('div', {
      staticClass: "tg"
    }, [_c('span', {
      staticClass: "type",
      style: ({
        color: label.typeColor,
        backgroundColor: label.typeBgColor
      })
    }, [_vm._v(_vm._s(label.type))])]), _vm._v(" "), (label.summary) ? _c('span', {
      staticClass: "sm"
    }, [_vm._v(_vm._s(label.summary))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (label.count) ? _c('span', {
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(label.count))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })])
  }), 0)]), _vm._v(" "), (_vm.product.labels.length > 3) ? _c('div', {
    staticClass: "more"
  }, [(!_vm.moreopen) ? _c('div', {
    on: {
      "click": _vm.showLabelMore
    }
  }, [_vm._v("查看其他" + _vm._s(_vm.product.labels.length - 3) + "个活动"), _c('i')]) : _c('div', {
    on: {
      "click": _vm.showLabelMore
    }
  }, [_vm._v("收起"), _c('i', {
    staticClass: "up"
  })])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1015)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _link2 = __webpack_require__(55);

exports.default = {
  props: ['product'],

  methods: {
    jump: function jump(_ref) {
      var link = _ref.link;

      var _link = (0, _link2.transformLink)({
        link: {
          type: 'deeplink',
          value: link
        }
      });

      window.location.href = _link;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.product.badges.length) ? _c('div', {
    staticClass: "product-badges",
    class: {
      'border-none': (_vm.product.labels && _vm.product.labels.length)
    }
  }, _vm._l((_vm.product.badges), function(badge, index) {
    return _c('div', {
      staticClass: "badges-item",
      style: ({
        'color': badge.color
      }),
      on: {
        "click": function($event) {
          return _vm.jump(badge)
        }
      }
    }, [(index !== 0) ? _c('div', {
      staticClass: "circle"
    }, [_vm._v("·")]) : _vm._e(), _vm._v("\n    " + _vm._s(badge.text) + "\n  ")])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1019),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-tab"
  }, [_c('div', {
    staticClass: "div-wrap",
    attrs: {
      "id": "scroll-tab"
    }
  }, [_c('div', {
    staticClass: "scroll-fix"
  }, [_c('div', {
    staticClass: "item active",
    attrs: {
      "data-type": "detail",
      "bindtap": "switchTab"
    }
  }, [_vm._v("商品详情")])])])])
}]}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1022),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _util = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isApp = _browser2.default.app(); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// test
exports.default = {
  components: {
    beastImage: _image2.default
  },

  props: {
    data: {
      type: Object
    },
    pageTypeImage: Boolean
  },

  data: function data() {
    return {
      isApp: isApp,
      isHide: true
    };
  },


  methods: {
    unescape: function unescape(str) {
      return str.replace(/\\n/gi, "<br/>");
    },
    formatHtml: function formatHtml(text) {
      var reTag = /<(?:.|\s)*?>/g;
      var styleAttr = /style="[^"]*"/g;
      var remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g;

      if (!text) return text;

      var content = text.replace(styleAttr, "").replace(remoeveTable, "");

      // return content.replace(/[\n\r]/gi, "<br/>");
      return content.replace(/\r\n/gi, "<br/>");
    },
    toggleDetail: function toggleDetail(e) {
      var tar = e.currentTarget;
      var arrow = tar.querySelector(".arrow");
      var box = tar.nextElementSibling;
      var isHide = box.style.display === "block" ? true : false;

      arrow.classList.remove("arrow-up", "arrow-down");

      if (isHide) {
        arrow.classList.add("arrow-down");
      } else {
        arrow.classList.add("arrow-up");
      }

      box.style.display = isHide ? "none" : "block";
    },
    noMargin: function noMargin(index, imageMargin, modules) {
      //判断逻辑：栏目imageMargin标记为false，当前模块是图片，有上一个模块，上一个模块是图片，上一个模块没有图片描述，则追加‘no-margin’样式
      if (!imageMargin && modules && modules[index].type == "IMAGE" && modules[index - 1] && modules[index - 1].type == "IMAGE" && !modules[index - 1].desc) {
        console.log(imageMargin);
        return "no-margin";
      }
    }
  },

  filters: {
    formatLink: function formatLink(link) {
      if (isApp) {
        return link;
      }

      return (0, _util.getLink)(link);
    }
  }
};

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "product-newbox"
  }, _vm._l((_vm.data.details), function(item, index) {
    return _c('div', {
      staticClass: "p-detail-new nomargin",
      class: {
        'expanded': !item.expanded,
          'page-image': _vm.pageTypeImage,
          'first': index === 0
      }
    }, [_c('div', {
      staticClass: "p-title-box"
    }, [_c('div', {
      staticClass: "title-box",
      on: {
        "click": _vm.toggleDetail
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (!item._spreadAll) ? _c('div', {
      staticClass: "arrow arrow-down"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "content-box",
      style: ('display:' + (_vm.pageTypeImage || index === 0 || item.expanded ? 'block' : 'none'))
    }, _vm._l((item.modules), function(modules, index) {
      return _c('div', {
        staticClass: "p-detail-content"
      }, [(modules.type == 'TEXT') ? _c('div', {
        staticClass: "p-child-content"
      }, [_c('div', {
        staticClass: "p-child-tit",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.title))
        }
      })]) : _vm._e(), _vm._v(" "), ((modules.type !== 'LINK') && modules.text) ? _c('div', {
        staticClass: "p-text",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.text))
        }
      }) : _vm._e(), _vm._v(" "), (modules.image) ? _c('div', {
        class: {
          'p-img': true,
          'no-margin': _vm.noMargin(index, _vm.data.imageMargin, item.modules) //如果上一张图片没有描述，则清楚图片间间隔
        }
      }, [_c('beast-image', {
        attrs: {
          "src": modules.image.src,
          "width": modules.image.width,
          "height": modules.image.height
        }
      }), _vm._v(" "), (modules.desc && modules.desc != '') ? _c('p', {
        staticClass: "p-img-desc"
      }, [_vm._v(_vm._s(modules.desc || ''))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((modules.table), function(table) {
        return (modules.type == 'TABLE') ? _c('div', {
          staticClass: "p-variant"
        }, [_c('div', {
          staticClass: "p-variant-name"
        }, [_vm._v(_vm._s(table.tableRow[0]))]), _vm._v(" "), _c('div', {
          staticClass: "p-variant-info",
          class: {
            'fixed-variant': _vm.pageTypeImage
          }
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(_vm.unescape(table.tableRow[1]))
          }
        })])]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "p-brand-wrap"
      }, [(!_vm.pageTypeImage && modules.type == 'LINK') ? _c('div', {
        staticClass: "p-brand-index"
      }, [_c('a', {
        attrs: {
          "href": _vm._f("formatLink")(modules.link)
        }
      }, [_vm._v(_vm._s(modules.text))]), _vm._v(" "), _c('i')]) : _vm._e()])], 2)
    }), 0)])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1025),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    detail: {
      type: Array
    }
  },

  methods: {
    toggleDetail: function toggleDetail(index, event) {
      var item = this.detail[index];
      if (item._spreadAll) {
        return;
      }
      item._spread = !item._spread;
      this.detail.splice(index, 1, item);
    }
  }
};

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detail && _vm.detail.length) ? _c('div', {
    staticClass: "product-detail-box"
  }, _vm._l((_vm.detail), function(item, index) {
    return _c('div', {
      staticClass: "product-detail"
    }, [_c('div', {
      staticClass: "detail-box"
    }, [_c('div', {
      staticClass: "title-box",
      on: {
        "click": function($event) {
          return _vm.toggleDetail(index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (!item._spreadAll) ? _c('div', {
      staticClass: "arrow",
      class: [item._spread ? 'arrow-up' : 'arrow-down']
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "content-box",
      class: {
        'spread': (item._spreadAll || item._spread)
      }
    }, _vm._l((item._content), function(itemContent) {
      return _c('div', {
        staticClass: "content"
      }, [_vm._v(_vm._s(itemContent))])
    }), 0)])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1028)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1029),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(7);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(24);

var _extends3 = _interopRequireDefault(_extends2);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _track = __webpack_require__(9);

var _track2 = _interopRequireDefault(_track);

var _b2a = __webpack_require__(23);

var _util = __webpack_require__(851);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(525);

var _api2 = _interopRequireDefault(_api);

var _index = __webpack_require__(54);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(241);

var _index4 = _interopRequireDefault(_index3);

var _iframeDeeplink = __webpack_require__(852);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _rush_count_down = null; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['product', 'suggestType', 'msgCount', 'env'],

  data: function data() {
    return {
      djsformat: null,
      app: _browser2.default.app(),
      ios: _browser2.default.ios(),
      android: _browser2.default.android(),
      weixin: _browser2.default.weixin(),
      booked: false,
      downpayPrice: null,
      downpayDeduction: null,
      openAppLink: 'product/' + this.product.id,
      gifUrl: '//img.thebeastshop.com/app/4.0/icon/gift/icon-panda.png'
    };
  },


  components: {
    Price: _index2.default,
    openApp: _index4.default
  },

  computed: {
    aul: function aul() {
      var PROTOCOL = location.protocol;
      var IOS_LINK = (0, _b2a.btoa)(PROTOCOL + '//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast');
      var DEEP_LINK = (0, _b2a.btoa)('product/' + this.product.id);
      return _browser2.default.ios() ? PROTOCOL + '//' + "app.thebeastshop.com" + '/r?r=' + IOS_LINK + '&_d=' + DEEP_LINK : 'https://m.thebeastshop.com/dl?_d=' + DEEP_LINK;
    },

    iosAul: function iosAul() {
      var PROTOCOL = location.protocol;
      var IOS_LINK = PROTOCOL + '//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast';
      var TD_PREFIX = PROTOCOL + '//lnk0.com/';
      // const iosTD = '10UtQd'
      var iosTD = 'BRhIds';
      var il = iosTD ? '' + TD_PREFIX + iosTD : IOS_LINK;
      var iLink = (0, _b2a.btoa)(il);
      var DEEP_LINK = (0, _b2a.btoa)('product/' + this.product.id);
      return PROTOCOL + '//' + "app.thebeastshop.com" + '/r?r=' + iLink + '&_d=' + DEEP_LINK;
    },

    downpayOriginSoldOut: function downpayOriginSoldOut() {
      return this.product.downPayment && this.product.soldOut ? true : false; //普通商品正常显示，定金商品时普通商品售罄隐藏
    }
  },

  created: function created() {
    this.formatDownpayData();
  },
  mounted: function mounted() {
    // let timer = setInterval(() => {
    //   this.gifUrl = ''
    //   this.$nextTick(() => {
    //     this.gifUrl = `//img.thebeastshop.com/app/4.0/icon/gift/icon-panda-gif-v2.gif?t=${new Date().getTime()}`
    //   })
    //   // clearInterval(timer)
    //   // timer = null
    // },2500)
  },


  inject: ['toggleQXLpBox'],

  methods: {
    gifLoaded: function gifLoaded() {
      var _this = this;

      var timer = setInterval(function () {
        _this.gifUrl = '';
        _this.$nextTick(function () {
          _this.gifUrl = '//img.thebeastshop.com/app/4.0/icon/gift/icon-panda-gif-v2.gif?t=' + new Date().getTime();
        });
        clearInterval(timer);
        timer = null;
      }, 2500);
    },
    iosDownloadApp: function iosDownloadApp() {
      this.$emit('showMask');
      return;
    },
    androidDownloadApp: function androidDownloadApp() {
      if (this.env === 'wx-web' && this.android) {
        this.$emit('showMask');
        return;
      }

      var deepUrl = 'beastapp://product/' + this.product.id;
      (0, _iframeDeeplink.ensure_deeplink)(deepUrl);

      var PROTOCOL = location.protocol;
      var TD_PREFIX = PROTOCOL + '//lnk0.com/';
      var androidTD = 'xJFBxt';
      var ANDROID_LINK = PROTOCOL + '//static.thebeastshop.com/app/beast.apk';
      var redirectLink = androidTD ? '' + TD_PREFIX + androidTD : ANDROID_LINK;
      window.location.href = redirectLink;
    },
    formatDownpayData: function formatDownpayData() {
      var downpayPrice = [];
      var downpayDeduction = [];
      if (!this.product.downPayment) {
        return;
      }
      var details = this.product.downPayment.details;
      if (details.length > 1) {
        var downpayData = details.sort(this.downpaySort);
        downpayPrice.push(downpayData[0].price);
        downpayPrice.push(downpayData[downpayData.length - 1].price);

        downpayDeduction.push(downpayData[0].deduction);
        downpayDeduction.push(downpayData[downpayData.length - 1].deduction);
      } else {
        downpayPrice.push(details[0].price);
        downpayDeduction.push(details[0].deduction);
      }

      this.downpayPrice = downpayPrice;
      this.downpayDeduction = downpayDeduction;

      console.log(this.downpayPrice, this.downpayDeduction);
    },
    showWechatGiftBox: function showWechatGiftBox() {
      this.$emit('showWechatGift');
    },
    bookProduct: function bookProduct(pid) {
      var _this2 = this;

      this.$ensureLogged({
        event: '补货提醒'
      }).then(function () {
        _this2.arrival(pid);

        sa.track('ApplyCommodity', (0, _extends3.default)({}, sa.getReferPageName(), {
          commodity_spu_id: pid,
          commodity_name: _this2.product.name,
          activity_type: sa.getActivity(_this2.product.labels),
          original_price: _this2.product.rawPrice,
          discount_price: _this2.product.price
        }));
      }).catch(function (err) {});
    },
    arrival: function arrival(pid) {
      var _this3 = this;

      this.$showLoading();
      _api2.default.doArrival(pid).then(function (_ref) {
        var data = _ref.data;

        _this3.$hideLoading();
        _this3.$toast('登记成功，若补货成功会优先短信提醒你！');
        _this3.booked = true;
      }).catch(function (err) {
        _this3.$hideLoading();
        _this3.$toast(err.message || '未知错误');
      });
    },
    toCart: function toCart() {
      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: 'beastapp://cart'
        });
      } else {
        window.location.href = '/cart';
      }
    },
    toService: function toService() {
      if (_browser2.default.app()) {
        _bridge2.default.open({
          url: 'beastapp://entry?name=customer-service'
        });
      } else {
        this.$emit('openService');
      }
    },
    tapBuyCustom: function tapBuyCustom() {
      var _this4 = this;

      this.$ensureLogged().then(function (status) {
        _this4.checkBuy().then(function (spv) {
          _api2.default.orderPreview(spv.id, spv.count, _this4.product.orderType).then(function (_ref2) {
            var code = _ref2.code,
                data = _ref2.data;

            _this4.toggleQXLpBox(spv.id, spv.count, data.orderType, data);
          }).catch(function (_ref3) {
            var code = _ref3.code;

            if (code == '4001') {
              _this4.$verifiedMobile().then(function () {}).catch(function () {});
            }
          });
        });
      });
    },


    tapBuy: function tapBuy(type) {
      var _this5 = this;

      if (this.unSale()) {
        return false;
      }

      (0, _track2.default)({
        name: 'buy',
        attrs: {
          suggestType: this.suggestType
        }
      });

      this.$ensureLogged({
        event: '立即购买'
      }).then(function (status) {
        if (_this5.product.monthSend) {
          window.location.href = '/week/flower?productId=' + _this5.product.id + '&distType=' + _this5.product.monthSendDistType;
          return;
        }
        _this5.checkBuy().then(function (data) {
          // 神策
          var _ck_spv = data.spv;
          sa.buyNow((0, _extends3.default)({}, sa.getReferPageName(), {
            commodity_spu_id: _this5.product.id,
            commodity_spv_id: data.id,
            commodity_name: _this5.product.name,
            activity_type: sa.getActivity(_this5.product.labels),
            commodity_number: data.count,
            original_price: _ck_spv.rawPrice,
            discount_price: _ck_spv.price,
            commodity_need_point: _ck_spv.point
          }));

          var _orderType = _this5.product.furniture ? 'FURNITURE' : 'NORMAL';
          if (type === 'wechat-gift') {
            _orderType = 'WECHAT_GIFT';
          }

          _api2.default.orderPreview(data.id, data.count, _orderType).then(function (_ref4) {
            var code = _ref4.code,
                data = _ref4.data;

            sa.track('commodity_account');
            if (_browser2.default.app()) {
              _bridge2.default.open({
                url: 'beastapp://order',
                data: data
              });
            } else {
              sessionStorage.orderData = (0, _stringify2.default)(data);
              window.location.href = "/order";
            }
          }).catch(function (_ref5) {
            var code = _ref5.code,
                message = _ref5.message;

            if (code == '4001') {
              _this5.$verifiedMobile().then(function () {}).catch(function () {});
            }

            _this5.$toast(message || '系统未知错误');
          });
        });
      }).catch(function () {
        //
      });
    },

    tapCart: function tapCart() {
      var _this6 = this;

      if (this.unSale()) {
        return false;
      }

      (0, _track2.default)({
        name: 'addCart',
        attrs: {
          suggestType: this.suggestType
        }
      });

      this.checkBuy().then(function (data) {
        if (data === null) {
          return false;
        }

        var _ck_spv = data.spv;

        sa.addCart((0, _extends3.default)({}, sa.getReferPageName(), {
          commodity_spu_id: _this6.product.id,
          commodity_spv_id: data.id,
          commodity_name: _this6.product.name,
          activity_type: sa.getActivity(_this6.product.labels),
          commodity_number: data.count,
          original_price: _ck_spv.rawPrice,
          discount_price: _ck_spv.price,
          commodity_need_point: _ck_spv.point || 0
        }));

        _api2.default.addCart(data.id, data.count).then(function (_ref6) {
          var code = _ref6.code,
              data = _ref6.data;

          _this6.$toast('加入购物车成功');
          // this.broadcast('cart-change')
          _api2.default.getCartNum().then(function (_ref7) {
            var data = _ref7.data;

            _this6.cart_num = data || 0;
          });
        }).catch(function (err) {
          _this6.$toast(err.message || '\u7CFB\u7EDF\u672A\u77E5\u9519\u8BEF\uFF0C\u9519\u8BEF\u7801' + err.code);
        });
      }).catch(function () {});
    },


    //   -----------   定金代码， 待优化  ------------------//
    downpayAction: function downpayAction() {
      var _this7 = this;

      this.$ensureLogged().then(function () {
        var _variant = _this7.product.variant;
        var downSpvs = _this7.product.downPayment.details;
        var downFlag = false;
        downSpvs.forEach(function (dp) {
          //判断是不是全部没库存
          if (dp.stock) {
            downFlag = true;
          }
        });
        if (!downFlag) {
          _this7.$alert('预售机会已抢空');
          return;
        }

        if (_variant.dimensions && _variant.dimensions.length > 0 || _variant.spvs.length == 1 && _variant.spvs[0].minAmount > 1) {
          var product = _util2.default.get_variant_data(_this7.product);
          // product.selectAmount = false

          var newProduct = _util2.default.deepCopy(product);
          var newSpvs = [];
          if (_this7.product.downPayment) {
            var newVariant = newProduct.variant;
            var spvs = newVariant.spvs;
            spvs.forEach(function (sp, index) {
              downSpvs.forEach(function (dp, i) {
                if (sp.id == dp.spvId) {
                  var spv = newProduct.variant.spvs[index];
                  spv.left = downSpvs[i].stock;
                  spv.price = downSpvs[i].price;
                  newSpvs.push(spv);
                  // newProduct.variant.spvs[index].left = downSpvs[i].stock
                  // newProduct.variant.spvs[index].price = downSpvs[i].price
                }
              });
            });
          }
          newProduct.variant.spvs = newSpvs;
          // console.log(newProduct, 'newProduct')

          _this7.$selectVariant(newProduct).then(function (data) {
            if (data === null) {
              return;
            }
            // return

            var downPayment = _this7.product.downPayment;
            var _spv = downPayment.details.find(function (spv) {
              return spv.spvId == data.spvId;
            });

            if (_spv.stock === 0) {
              _this7.$alert('商品已售罄');
              return;
            }
            var spv = {
              id: _spv.virtual,
              count: data.count
            };
            _this7.downpayOrder(spv);
          });
        } else {
          var _spv = _this7.product.downPayment.details[0];
          if (_spv.stock === 0) {
            _this7.$alert('商品已售罄');
            return;
          }
          _this7.downpayOrder({
            id: _spv.virtual,
            count: 1
          });
        }
      }).catch(function () {});
    },
    downpayOrder: function downpayOrder(pack) {
      var _this8 = this;

      this.$showLoading();
      _api2.default.orderPreview(pack.id, pack.count, 'DEPOSIT').then(function (_ref8) {
        var code = _ref8.code,
            data = _ref8.data;

        data.orderType = 'DEPOSIT';
        _this8.$hideLoading();
        if (_browser2.default.app()) {
          _bridge2.default.open({
            url: 'beastapp://order',
            data: data
          });
        } else {
          sessionStorage.orderData = (0, _stringify2.default)(data);
          window.location.href = "/order";
        }
      }).catch(function (_ref9) {
        var code = _ref9.code,
            message = _ref9.message;

        _this8.$hideLoading();
        if (code == '4001') {
          _this8.$verifiedMobile().then(function () {}).catch(function () {});
        } else {
          _this8.$alert(message);
        }
      });
    },
    getFinalPrice: function getFinalPrice(range) {
      if (range.length === 2) {
        return '\xA5' + range[0] + '-\xA5' + range[1];
      } else {
        return '\xA5' + range[0];
      }
    },
    checkBuy: function checkBuy() {
      var _this9 = this;

      var _variant = this.product.variant;

      return new _promise2.default(function (resolve, reject) {
        _this9.checkUnavailable().then(function () {
          if (true) {
            var product = _util2.default.get_variant_data(_this9.product);
            // console.log(product)
            _this9.$selectVariant(product).then(function (data) {
              if (data === null) {
                return reject();
              }
              resolve({
                id: data.spvId,
                count: data.count,
                spv: data
              });
              _this9.selectSpv(data.spvId);
            });
          } else {
            resolve({
              id: _this9.product.variant.spvs[0].id,
              count: 1
            });
          }
        }).catch(function () {
          reject();
        });
      });
    },
    selectSpv: function selectSpv(spvId) {
      var _spv = this.product.variant.spvs.find(function (spv) {
        return spv.id == spvId;
      });

      var fundPrice = [];

      if (_spv.refunds) {
        fundPrice.push(_spv.refunds);
      }

      this.product._rush = {
        state: _spv.flashSale ? !_spv.flashSale.soldOut : false,
        notAll: false,
        flashSale: _spv.flashSale ? _spv.flashSale : null,
        _djs: _spv.flashSale ? _spv.flashSale.expiresAt : null
      };

      this.product.format_price = {
        price: {
          min: _spv.price
        },
        rawPrice: {
          min: _spv.rawPrice
        }
      };

      this.product.spvPriceTag = _spv.priceTags;
      this.product.spvPriceInfo = _spv.priceInfo;

      this.$emit('change', fundPrice);
      this.djsformat = null;
      clearTimeout(_rush_count_down);
      this.product._rush._djs && getCountDown();
    },


    checkUnavailable: function checkUnavailable() {
      var _this10 = this;

      if (this.product.needVerifyAddress && !(!this.product.unavailable && this.product._address)) {}
      return new _promise2.default(function (resolve, reject) {
        return resolve();
        if (_this10.product.needVerifyAddress && !(!_this10.product.unavailable && _this10.product._address)) {
          _this10.$alert('请选择配送区域').then(function () {
            return _this10.$selectArea();
          }).then(function (data) {
            if (data === null) {
              return reject();
            }
            _this10.product._address = data.province.name + ' ' + data.city.name + ' ' + data.district.name; // resolve()
            return _api2.default.isDistribution(_this10.product.id, data.district.id);
          }).then(function (_ref10) {
            var data = _ref10.data;

            _this10.product.unavailable = !data;
            return data ? resolve() : reject();
          }).catch(function () {
            return reject();
          });
        } else {
          return resolve();
        }
      });
    },

    getCountDown: function getCountDown() {
      var _this11 = this;

      var endDate = new Date(this.product._rush._djs),
          _now = new Date();

      var leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
          leftsecond = parseInt(leftTime),
          day1 = Math.floor(leftsecond / (60 * 60 * 24)),
          hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
          minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
          second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);
      hour += day1 * 24;
      if (hour == 0 && minute == 0 && second == 0) {
        this.djsformat = null;
        clearTimeout(_rush_count_down);
        return false;
      }
      this.djsformat = hour + ':' + minute + ':' + second;
      _rush_count_down = setTimeout(function () {
        _this11.getCountDown();
      }, 1000);
    },
    unSale: function unSale() {
      var _product = this.product;
      return _product.soldOut || !_product.buyable || _product.offShelf || !_product.invisible && !_product.buyable;
    },
    downpaySort: function downpaySort(prev, next) {
      return prev.price - next.price;
    }
  }
};

/***/ }),
/* 1030 */,
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-footer",
    class: {
      'downpay': _vm.product.downPayment, 'downPayOriginSoldOut': _vm.downpayOriginSoldOut
    }
  }, [(_vm.product.downPayment) ? _c('div', {
    staticClass: "downpay-footer",
    on: {
      "click": _vm.downpayAction
    }
  }, [_c('div', {
    staticClass: "downpay-desc"
  }, [(_vm.downpayPrice) ? _c('div', {
    staticClass: "desc-main"
  }, [_c('div', {
    staticClass: "downpay-label"
  }, [_vm._v("定金")]), _vm._v(" "), (_vm.downpayPrice.length > 1) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayPrice[0]
    }
  }), _vm._v(" "), (!_vm.product.downPayment.priceSingle) ? _c('span', [_vm._v(" - "), _c('price', {
    attrs: {
      "data": _vm.downpayPrice[1]
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayPrice[0]
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.downpayDeduction && _vm.product.downPayment.deductionFlag) ? _c('div', {
    staticClass: "desc-sub"
  }, [_vm._v("（ 可抵\n        "), (_vm.downpayDeduction.length > 1) ? _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayDeduction[0]
    }
  }), _vm._v(" "), (!_vm.product.downPayment.deductionSingle) ? _c('span', [_vm._v(" - "), _c('price', {
    attrs: {
      "data": _vm.downpayDeduction[1]
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "downpay-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.downpayDeduction[0]
    }
  })], 1), _vm._v(" ）\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arrow-text"
  }, [_vm._v("立即预订")]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "normal-footer"
  }, [_c('div', {
    staticClass: "minicart",
    on: {
      "click": _vm.toCart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "service",
    on: {
      "click": _vm.toService
    }
  }, [(_vm.msgCount > 0) ? _c('i') : _vm._e()]), _vm._v(" "), (_vm.product.isWechatGift && !_vm.product.offShelf && !_vm.product.soldOut) ? _c('div', {
    staticClass: "wechat-gift-box",
    on: {
      "click": _vm.showWechatGiftBox
    }
  }, [(_vm.gifUrl) ? _c('img', {
    attrs: {
      "id": "panda-gif",
      "src": _vm.gifUrl
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.app && (_vm.product.id === 'PROD001032623' || _vm.product.id === 'PROD001032622')) ? _c('div', {
    staticClass: "action",
    class: _vm.no - _vm.buy
  }, [(_vm.ios) ? _c('a', {
    staticClass: "btn dark",
    attrs: {
      "href": _vm.iosAul
    },
    on: {
      "click": _vm.iosDownloadApp
    }
  }, [_vm._v("去APP购买")]) : _vm._e(), _vm._v(" "), (_vm.android) ? _c('div', {
    staticClass: "btn dark",
    on: {
      "click": _vm.androidDownloadApp
    }
  }, [_vm._v("去APP购买")]) : _vm._e()]) : (_vm.product.arrival && _vm.product.arrival.show) ? _c('div', {
    staticClass: "action booking"
  }, [(!_vm.product.arrival.subscribe && !_vm.booked) ? _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.bookProduct(_vm.product.id)
      }
    }
  }, [_c('p', [_vm._v("我也想买")]), _vm._v(" "), _c('p', {
    staticClass: "sm"
  }, [_vm._v("(补货后提醒我)")])])]) : _c('div', {}, [_vm._m(1), _vm._v(" "), _vm._m(2)])]) : (!_vm.product.soldOut && _vm.product.customPrintTemplate == 6) ? _c('div', {
    staticClass: "action",
    class: {
      'no-buy': _vm.unSale()
    }
  }, [_c('div', {
    staticClass: "btn btn-buy dark",
    on: {
      "click": _vm.tapBuyCustom
    }
  }, [_vm._v("立即定制")])]) : (!_vm.product.downPayment || (_vm.product.downPayment && !_vm.product.soldOut)) ? _c('div', {
    staticClass: "action",
    class: {
      'no-buy': _vm.unSale()
    }
  }, [(!_vm.product.prevue && !_vm.product.customizable) ? _c('div', {
    staticClass: "btn btn-buy",
    class: {
      'small-btn': _vm.product.isWechatGift
    },
    on: {
      "click": _vm.tapBuy
    }
  }, [_vm._v("立即购买")]) : _vm._e(), _vm._v(" "), (!_vm.product.customizable && !_vm.product.monthSend) ? _c('div', {
    staticClass: "btn btn-cart dark",
    class: {
      'small-btn': _vm.product.isWechatGift
    },
    on: {
      "click": _vm.tapCart
    }
  }, [_vm._v("加入购物车")]) : _vm._e(), _vm._v(" "), (_vm.product.customizable) ? _c('a', {
    staticClass: "btn dark",
    attrs: {
      "href": _vm.aul
    }
  }, [_vm._v("去APP购买")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "texts"
  }, [_c('p', [_vm._v("若想要人数较多,")]), _vm._v(" "), _c('p', [_vm._v("将有补货可能哦!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "texts"
  }, [_c('p', [_vm._v("若补货成功会优先短信提醒你!")]), _vm._v(" "), _c('p', [_vm._v("若未补货,将不再另行通知!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn"
  }, [_c('p', {
    staticClass: "booked"
  }, [_vm._v("已登记")])])
}]}

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1033)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1034),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(218);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    product: Object
  },

  components: {
    Swiper: _index2.default,
    BeastImage: _image2.default,
    BeastVideo: _video2.default
  },

  data: function data() {
    return {
      signNum: 0, // 已报名人数
      swiper: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        paginateCls: { 'number-paginate': true },
        // paginateCls: 'number-paginate',
        // autoplay: 3000,
        autoplayDisableOnInteraction: false
      }
    };
  },
  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      var stock = this.product.stock;

      // this.signNum = stock.total - stock.left

      this.signNum = stock.left;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-banner"
  }, [_c('div', {
    staticClass: "lesson-title"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), (_vm.signNum > 0) ? _c('p', [_vm._v("还剩" + _vm._s(_vm.signNum) + "个名额")]) : _c('p', [_vm._v("名额已满")])]), _vm._v(" "), _c('div', {
    staticClass: "p-images l-images"
  }, [_c('swiper', {
    attrs: {
      "config": _vm.swiper,
      "paginateCls": ("" + (_vm.swiper.paginateCls))
    }
  }, [_vm._l((_vm.product.videos), function(video, index) {
    return (_vm.product.videos.length) ? _c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "product-video",
      class: 'p' + index
    }, [_c('beast-video', {
      attrs: {
        "wrap": 'p' + index,
        "isHeight": true,
        "poster": video.thumbnailUrl,
        "autoplay": false,
        "source": video.url,
        "controls": true
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.product.images), function(item) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('beast-image', {
      attrs: {
        "src": item
      }
    })], 1)
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1037)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1038),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(135);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Swiper: _index2.default
  },

  props: ['comment', 'productId', 'sdk', 'env'],

  data: function data() {
    return {
      swiper: {
        slidesPerView: 'auto'
      }
    };
  },


  methods: {
    allCommentAction: function allCommentAction() {
      var productId = this.productId;

      var linkData = {
        url: '/comment?productId=' + productId,
        mpType: 'web'
      };

      switch (this.env) {
        case 'app':
          linkData.url = 'beastapp://entry?name=comment&productId=' + productId;
          break;
      }

      this.sdk.navigate.jumpTo(linkData);
    }
  },

  filters: {
    formatTime: function formatTime(time) {
      var d = new Date(time);

      var month = d.getMonth() - 0 + 1;
      var date = d.getDate();

      month = month < 10 ? '0' + month : month;
      date = date < 10 ? '0' + date : date;

      return d.getFullYear() + '-' + month + '-' + date;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.comment) ? _c('div', {
    staticClass: "lesson-comment"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("用户评价"), _c('div', {
    staticClass: "look-more",
    on: {
      "click": _vm.allCommentAction
    }
  }, [_vm._v("查看全部")])]), _vm._v(" "), _c('div', {
    staticClass: "cmt-wrap"
  }, [(_vm.comment.type === 'IMAGE' || _vm.comment.type === 'VIDEO') ? _c('swiper', {
    attrs: {
      "config": _vm.swiper
    }
  }, [_vm._l((_vm.comment.items), function(cmt, index) {
    return _c('div', {
      staticClass: "swiper-slide comment-item comment-image",
      on: {
        "click": _vm.allCommentAction
      }
    }, [_c('div', {
      staticClass: "image"
    }, [(cmt.annex.type === 'IMAGE') ? _c('img', {
      attrs: {
        "src": cmt.annex.images[0].src
      }
    }) : (cmt.annex.type === 'VIDEO') ? _c('img', {
      attrs: {
        "src": cmt.annex.video.coverImage.src
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "user"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "avator"
    }, [_c('img', {
      attrs: {
        "src": cmt.evaluator.avatarUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(cmt.evaluator.nickName))])]), _vm._v(" "), _c('div', {
      staticClass: "cmt-content",
      domProps: {
        "innerHTML": _vm._s(cmt.content)
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide comment-more"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/app/4.0/icon/beast-lesson/icon-more.png"
    },
    on: {
      "click": _vm.allCommentAction
    }
  })])], 2) : _c('div', {
    staticClass: "comment-item comment-text",
    on: {
      "click": _vm.allCommentAction
    }
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "avator"
  }, [_c('img', {
    attrs: {
      "src": _vm.comment.items[0].evaluator.avatarUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.comment.items[0].evaluator.nickName))]), _vm._v(" "), _c('div', {
    staticClass: "star"
  }, [_c('div', {
    staticClass: "top",
    style: (("width:" + (_vm.comment.items[0].recommend.starNumber * 20) + "%;}"))
  }), _vm._v(" "), _c('div', {
    staticClass: "btm"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.comment.items[0].createTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "cmt-content",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.items[0].content)
    }
  })])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _image = __webpack_require__(20);

var _image2 = _interopRequireDefault(_image);

var _util = __webpack_require__(137);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENUM_TITLE = ['活动介绍', '讲师介绍', '退换货说明', '特别说明']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// test


var isApp = _browser2.default.app();

exports.default = {
  components: {
    beastImage: _image2.default
  },

  props: {
    data: {
      type: Object
    },
    pageTypeImage: Boolean
  },

  data: function data() {
    return {
      details: [],
      isApp: isApp,
      isHide: false
    };
  },
  created: function created() {
    var details = [];
    this.data.details.forEach(function (detail) {
      if (~ENUM_TITLE.indexOf(detail.title)) {
        details.push(detail);
      }
    });

    this.details = details;
  },


  methods: {
    unescape: function unescape(str) {
      return str.replace(/\\n/gi, '<br/>');
    },
    formatHtml: function formatHtml(text) {
      var reTag = /<(?:.|\s)*?>/g;
      var styleAttr = /style="[^"]*"/g;
      var remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g;

      if (!text) return text;

      var content = text.replace(styleAttr, "").replace(remoeveTable, "");

      // return content.replace(/[\n\r]/gi, '<br/>')
      return content.replace(/\r\n/gi, "<br/>");
    }
  },

  filters: {
    formatLink: function formatLink(link) {

      if (isApp) {
        return link;
      }

      return (0, _util.getLink)(link);
    }
  }
};

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.details.length) ? _c('div', {
    staticClass: "product-newbox lesson-detail"
  }, _vm._l((_vm.details), function(item, index) {
    return _c('div', {
      staticClass: "p-detail-new nomargin",
      class: {
        'expanded': !item.expanded
      }
    }, [_c('div', {
      staticClass: "p-title-box"
    }, [_c('div', {
      staticClass: "title-box"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content-box"
    }, _vm._l((item.modules), function(modules) {
      return _c('div', {
        staticClass: "p-detail-content"
      }, [(modules.type == 'TEXT') ? _c('div', {
        staticClass: "p-child-content"
      }, [_c('div', {
        staticClass: "p-child-tit",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.title))
        }
      })]) : _vm._e(), _vm._v(" "), ((modules.type !== 'LINK') && modules.text) ? _c('div', {
        staticClass: "p-text",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.text))
        }
      }) : _vm._e(), _vm._v(" "), (modules.image) ? _c('div', {
        staticClass: "p-img"
      }, [_c('beast-image', {
        attrs: {
          "src": modules.image.src,
          "width": modules.image.width,
          "height": modules.image.height
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "p-img-desc"
      }, [_vm._v(_vm._s(modules.desc || ''))])], 1) : _vm._e(), _vm._v(" "), _vm._l((modules.table), function(table) {
        return (modules.type == 'TABLE') ? _c('div', {
          staticClass: "p-variant"
        }, [_c('div', {
          staticClass: "p-variant-name"
        }, [_vm._v(_vm._s(table.tableRow[0]))]), _vm._v(" "), _c('div', {
          staticClass: "p-variant-info",
          class: {
            'fixed-variant': _vm.pageTypeImage
          }
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(_vm.unescape(table.tableRow[1]))
          }
        })])]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "p-brand-wrap"
      }, [(!_vm.pageTypeImage && modules.type == 'LINK') ? _c('div', {
        staticClass: "p-brand-index"
      }, [_c('a', {
        attrs: {
          "href": _vm._f("formatLink")(modules.link)
        }
      }, [_vm._v(_vm._s(modules.text))]), _c('i')]) : _vm._e()])], 2)
    }), 0)])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1044)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1045),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(54);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMUM_PRICE_TYPE = ['FREE', 'CASH_ONLY', 'CASH_POINT']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Price: _index2.default
  },

  props: {
    product: Object
  },

  data: function data() {
    return {
      priceType: EMUM_PRICE_TYPE[0],
      spvPoint: null,
      spvCash: null,
      classTime: '',
      classCity: ''
    };
  },
  created: function created() {
    this.classTime = this.product.date.join('/');
    this.classCity = this.product.cityNames.join('/');

    this.getPrice(this.product.times);
  },


  methods: {
    getPrice: function getPrice(times) {
      var arrPointPrice = [];
      var arrCashPrice = [];

      times.forEach(function (spv, index) {
        var _spv$price = spv.price,
            point = _spv$price.point,
            price = _spv$price.price;


        if (point > 0) {
          arrPointPrice.push(spv);
        }

        if (price >= 0) {
          arrCashPrice.push(spv);
        }
      });

      if (arrPointPrice.length) {
        this.spvPoint = this.pointPrice(arrPointPrice);
        this.spvCash = this.cashPrice(arrCashPrice);

        this.priceType = EMUM_PRICE_TYPE[2]; // POINT_CASH
      } else {
        this.spvCash = this.cashPrice(arrCashPrice);

        if (this.spvCash.free) {
          this.priceType = EMUM_PRICE_TYPE[0]; // FREE
        } else {
          this.priceType = EMUM_PRICE_TYPE[1]; // CASH_ONLY
        }
      }
    },
    pointPrice: function pointPrice(arrPointPrice) {
      var price = arrPointPrice.sort(this.pointSort);
      var single = false;

      if (price[0].price.pointPrice === price[price.length - 1].price.pointPrice) {
        single = true;
      }

      return {
        item: price[0],
        single: single
      };
    },
    cashPrice: function cashPrice(arrCashPrice) {
      var price = arrCashPrice.sort(this.cashSort);

      var single = false;
      var free = false;

      if (price[0].price.price === price[price.length - 1].price.price) {
        single = true;

        if (price[0].price.price === 0) {
          free = true;
        }
      }

      return {
        item: price[0],
        single: single,
        free: free
      };
    },
    pointSort: function pointSort(prev, next) {
      var point = prev.price.point - next.price.point;
      var pointPrice = prev.price.pointPrice - next.price.pointPrice;

      return point === 0 ? pointPrice : point;
    },
    cashSort: function cashSort(prev, next) {
      return prev.price.price - next.price.price;
    }
  }
};

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-info"
  }, [_c('div', {
    staticClass: "lesson-price"
  }, [(_vm.priceType === 'CASH_POINT') ? _c('div', {
    staticClass: "cash-point"
  }, [_c('div', {
    staticClass: "point-price"
  }, [_c('div', {
    staticClass: "price-tag"
  }, [_vm._v("积分价")]), _vm._v(" "), _c('div', {
    staticClass: "real-price"
  }, [(_vm.spvPoint.item.price.pointPrice > 0) ? _c('span', [_c('price', {
    attrs: {
      "data": _vm.spvPoint.item.price.pointPrice
    }
  }), _vm._v(" + ")], 1) : _vm._e(), _vm._v(_vm._s(_vm.spvPoint.item.price.point) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("积分" + _vm._s(_vm.spvPoint.single ? '' : '起'))])]), _vm._v(" "), _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvPoint.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvPoint.single ? '' : '起'))], 1)]), _vm._v(" "), (_vm.product.allowOnlyCash) ? _c('div', {
    staticClass: "cash-price"
  }, [_c('div', {
    staticClass: "price-tag"
  }, [_vm._v("现金价")]), _vm._v(" "), _c('div', {
    staticClass: "real-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.price
    }
  }), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))])], 1), _vm._v(" "), (_vm.spvCash.item.price.rawPrice != _vm.spvCash.item.price.price) ? _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))], 1) : _vm._e()]) : _vm._e()]) : (_vm.priceType === 'CASH_ONLY' && _vm.product.allowOnlyCash) ? _c('div', {
    staticClass: "cash-only"
  }, [_c('div', {
    staticClass: "cash-price"
  }, [_c('div', {
    staticClass: "real-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.price
    }
  }), _c('span', {
    staticClass: "unit"
  }, [_vm._v(" " + _vm._s(_vm.spvCash.single ? '' : '起'))])], 1), _vm._v(" "), (_vm.spvCash.item.price.rawPrice != _vm.spvCash.item.price.price) ? _c('div', {
    staticClass: "raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.spvCash.item.price.rawPrice
    }
  }), _vm._v(_vm._s(_vm.spvCash.single ? '' : '起'))], 1) : _vm._e()])]) : (_vm.priceType === 'FREE') ? _c('div', {
    staticClass: "free"
  }, [_vm._v("免费报名")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lesson-class"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("场次信息")]), _vm._v(" "), _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("时间: ")]), _vm._v(_vm._s(_vm.classTime))]), _vm._v(" "), _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("地点: ")]), _vm._v(_vm._s(_vm.classCity))]), _vm._v(" "), (_vm.product.status === 'REGISTER') ? _c('div', {
    staticClass: "class-item"
  }, [_c('span', [_vm._v("报名截止时间: ")]), _vm._v(_vm._s(_vm.product.registerEndTime))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1048)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1049),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

var _api = __webpack_require__(525);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENUM_NAME = ['注册会员', '松鼠会员', '小猫会员', '老虎会员', '大象会员', '兔子会员']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _pedding = false;

exports.default = {
  props: {
    product: Object,
    sdk: Object,
    env: String
  },

  data: function data() {
    return {
      status: '',
      vipLevel: [],
      remind: false
    };
  },
  created: function created() {
    this.status = this.product.status;
    this.remind = this.product.remind;
    this.vipLevel = this.product.vipLevel;
  },


  methods: {
    jump: function jump() {
      var _this = this;

      if (_pedding) return;

      _pedding = true;
      this.login().then(function (member) {
        var level = member.level.id;

        if (_this.vipLevel.indexOf(level + "") === -1) {
          var str = '';

          _this.vipLevel.forEach(function (id) {
            str += ENUM_NAME[id - 0 + 1] + ' ';
          });

          _this.$alert('\u6B64\u8BFE\u7A0B\u4EC5\u9650' + str + '\u62A5\u540D');
          _pedding = false;
          return;
        }

        if (!_this.product.allowOnlyCash && !_this.checkPoint(member.point)) {
          _this.$alert('积分不足，请先去购物获取积分');
          _pedding = false;
          return;
        }

        var linkData = {
          url: '/beast/lesson/variant?productId=' + _this.product.productCode,
          mpType: 'web'
        };

        switch (_this.env) {
          case 'app':
            linkData.url = 'beastapp://entry?name=beast-lesson-variant&productId=' + _this.product.productCode;
            break;
        }

        _pedding = false;
        _this.sdk.navigate.jumpTo(linkData);
      });
    },
    checkPoint: function checkPoint(memPoint) {
      var times = this.product.times;


      var pass = false;

      times.forEach(function (time) {
        if (time.price.point <= memPoint) {
          pass = true;
        }
      });

      return pass;
    },
    doReminder: function doReminder(courseCode) {
      var _this2 = this;

      this.$ensureLogged().then(function () {
        if (_this2.remind) {
          (0, _api.cancelReminderLesson)(courseCode).then(function (_ref) {
            var data = _ref.data;

            _this2.remind = false;

            _this2.$toast('报名提醒已关闭');
          });
        } else {
          (0, _api.reminderLesson)(courseCode).then(function (_ref2) {
            var data = _ref2.data;

            _this2.remind = true;

            _this2.$toast('报名提醒已开启，报名开始时会短信通知你，注意查收哦！');
          });
        }
      });
    },
    login: function login() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        _this3.sdk.ensureLogged().then(function (_ref3) {
          var member = _ref3.member;

          switch (_this3.env) {
            case 'app':
              _bridge2.default.getMember().then(function (member) {
                resolve(member);
              });
              break;
            case 'miniprogram':
              _this3.sdk.getMember().then(function (member) {
                resolve(member);
              });
              break;
            default:
              resolve(member);
          }
        });
      });
    }
  }
};

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-footer"
  }, [(_vm.status === 'NOTICE') ? [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doReminder(_vm.product.code)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.remind ? '已开启报名提醒' : '开始报名提醒我') + "\n    ")])] : (_vm.status === 'REGISTER') ? [(_vm.product.stock.left > 0) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("还剩" + _vm._s(_vm.product.stock.left) + "个名额，立即报名")]) : _c('div', {
    staticClass: "btn over"
  }, [_vm._v("来晚了，名额已满")])] : (_vm.status === 'OVER') ? [_c('div', {
    staticClass: "btn over"
  }, [_vm._v("已结束")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1052)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1053),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      showWechatGiftAni: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.showWechatGiftAni = true;
    }, 1);
  },


  methods: {
    doWechatGift: function doWechatGift() {
      this.showWechatGiftAni = false;
      this.$emit('hide');
      this.$emit('buyWechatGift');
    },
    close: function close() {
      this.$emit('hide');
    }
  }
};

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gift-wechat-box",
    class: {
      'ani': _vm.showWechatGiftAni
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "head"
  }), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("付款后24小时，若好友未领取将自动退款。")]), _vm._v(" "), _c('div', {
    staticClass: "btn-gift",
    on: {
      "click": _vm.doWechatGift
    }
  }, [_vm._v("立即送礼")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit"
  }, [_c('img', {
    attrs: {
      "src": "//img.thebeastshop.com/app/4.0/icon/gift/txt-title.png?t=2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "para"
  }, [_c('p', [_c('i', [_vm._v("1")]), _vm._v("为好友挑选礼物")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("2")]), _vm._v("定制祝福并付款("), _c('span', {
    staticStyle: {
      "color": "#87522E",
      "font-weight": "600"
    }
  }, [_vm._v("无需地址")]), _vm._v(")")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("3")]), _vm._v("赠送微信好友")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("4")]), _vm._v("好友收下你的心意")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("5")]), _vm._v("野兽派将礼物送至你的好友")])])
}]}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'iphone-x': _vm.isIphoneX
    }
  }, [(!_vm.nocache && (_vm.product && _vm.env === 'm-web')) ? _c('down-banner', {
    attrs: {
      "position": 'top',
      "pageType": 'product',
      "link": 'product/' + _vm.product.id
    },
    on: {
      "close-banner": _vm.closeBanner,
      "banner-close": _vm.closeBanner
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product && !_vm.product.invisible) ? _c('beast-main', {
    class: {
      'down-banner': _vm.env === 'm-web' && _vm.showDownBanner
    },
    attrs: {
      "errorMsg": _vm.errorMsg
    }
  }, [(_vm.pageType === 'LESSON' && _vm.product) ? _c('div', {
    staticClass: "l-detail-wrap"
  }, [_c('lesson-product-banner', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  }), _vm._v(" "), _c('lesson-product-info', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  }), _vm._v(" "), _c('lesson-comment', {
    attrs: {
      "comment": _vm.cmtRecommand,
      "sdk": _vm.sdk,
      "env": _vm.env,
      "productId": _vm.productId
    }
  }), _vm._v(" "), (_vm.detailNew) ? _c('lesson-product-detail', {
    attrs: {
      "data": _vm.detailNew
    }
  }) : _vm._e(), _vm._v(" "), _c('lesson-footer', {
    attrs: {
      "product": _vm.product,
      "sdk": _vm.sdk,
      "env": _vm.env
    }
  })], 1) : _c('div', {
    staticClass: "p-detail-wrap"
  }, [_c('product-images', {
    attrs: {
      "nocache": _vm.nocache,
      "product": _vm.product,
      "djsformat": _vm.djsformat
    },
    on: {
      "favorite": _vm.favorite
    }
  }), _vm._v(" "), (_vm.product) ? _c('down-payment', {
    attrs: {
      "product": _vm.product
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product && _vm.prodCoupons.length) ? _c('coupons', {
    attrs: {
      "product": _vm.product,
      "prodCoupons": _vm.prodCoupons
    },
    on: {
      "show": _vm.showCoupons
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.matchProducts && _vm.product.matchProducts.length) ? _c('div', {
    staticClass: "product-rc"
  }, [_c('div', {
    staticClass: "rc-list"
  }, [_c('div', {
    staticClass: "rc-wrap"
  }, _vm._l((_vm.product.matchProducts), function(rcProd, index) {
    return _c('div', {
      staticClass: "rc-item",
      class: {
        'active': _vm.curRcActive == index
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(rcProd.productCode, 'rc', index, rcProd.productName)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": rcProd.image
      }
    })])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('product-info', {
    attrs: {
      "product": _vm.product,
      "fundPrice": _vm.fundPrice
    },
    on: {
      "showPriceTag": _vm.showPriceTag
    }
  }) : _vm._e(), _vm._v(" "), _c('select-address', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('labels', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), (_vm.product && _vm.product.groupon) ? _c('div', {
    staticClass: "purchase-group",
    on: {
      "click": function($event) {
        return _vm.goPurchase(_vm.product.groupon.link)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("闺蜜团开团中")]), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.product.groupon.number) + "人组团每人只需￥" + _vm._s(_vm.product.groupon.range[0]) + " "), (_vm.product.groupon.range[0] != _vm.product.groupon.range[1]) ? _c('span', [_vm._v(" - ￥" + _vm._s(_vm.product.groupon.range[1]))]) : _vm._e(), _vm._v("，  快来参加吧！")]), _vm._v(" "), _c('i')]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.badges && _vm.product.badges.length) ? _c('product-badges', {
    attrs: {
      "product": _vm.product
    }
  }) : _vm._e(), _vm._v(" "), _c('detail-tab'), _vm._v(" "), (_vm.product && _vm.product.legacyDetails) ? _c('product-desc', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _c('product-desc-new', {
    attrs: {
      "data": _vm.detailNew,
      "pageTypeImage": _vm.pageTypeImage
    }
  }), _vm._v(" "), (!_vm.nocache) ? _c('suggest', {
    attrs: {
      "productId": _vm.productId,
      "source": 'PRODUCT'
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nocache && !_vm.product.invisible) ? _c('product-footer', {
    ref: "pFooter",
    attrs: {
      "env": _vm.env,
      "product": _vm.product,
      "isApp": _vm.isApp,
      "msgCount": _vm.receiveMsgs.length || _vm.offMessageCount,
      "suggestType": _vm.suggestType
    },
    on: {
      "showWechatGift": _vm.doShowWechatGift,
      "showMask": _vm.showDownloadMask,
      "openService": _vm.openService,
      "change": _vm.changeFund
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showTagInfo && _vm.product.spvPriceInfo) ? _c('div', {
    staticClass: "tag-infos"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("折扣明细")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "price-step"
  }, _vm._l((_vm.product.spvPriceInfo.priceSteps), function(priceStep) {
    return _c('div', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(priceStep.name)), (priceStep.jumpLink) ? _c('i', {
      staticClass: "i-shoudan",
      on: {
        "click": function($event) {
          return _vm.jumpLink(priceStep.jumpLink)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "price",
      style: ({
        color: priceStep.fontColor
      })
    }, [_c('price', {
      attrs: {
        "data": priceStep.priceChange
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "after-price"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("折后价")]), _vm._v(" "), _c('div', {
    staticClass: "item price"
  }, [_c('price', {
    attrs: {
      "data": _vm.product.spvPriceInfo.discountPrice
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.product.spvPriceInfo.desc) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.product.spvPriceInfo.desc || ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.closeTagInfo
    }
  }, [_vm._v("确定")])])]) : _vm._e(), _vm._v(" "), (_vm.showCouponList) ? _c('div', {
    staticClass: "coupon-wrap"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.hideCouponsList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupons-box"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("领取优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-list"
  }, _vm._l((_vm.prodCouponsList), function(item) {
    return _c('div', {
      staticClass: "coupon-item",
      class: {
        used: item.couponOwnerState !== 'ABLE'
      }
    }, [_c('div', {
      staticClass: "left"
    }, [(item.discount) ? _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(item.discount))]) : (item.discountRatio) ? _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.discountRatio * 10) + " 折")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.thresholdDesc))]), _vm._v(" "), (item.dateWay == 'NUMBER') ? _c('div', {
      staticClass: "date"
    }, [_vm._v("使用期限: 领取后" + _vm._s(item.dateNum) + "天")]) : _c('div', {
      staticClass: "date"
    }, [_vm._v("使用期限: " + _vm._s(_vm._f("formatTime")(item.startTime)) + " 至 " + _vm._s(_vm._f("formatTime")(item.expireTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "right",
      class: {
        used: item.couponOwnerState === 'ALABLE'
      }
    }, [(item.couponOwnerState === 'ABLE') ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.getCouponById(item.id)
        }
      }
    }, [_vm._v("立即领取")]) : _c('div', {}, [_vm._v("立即领取")])]), _vm._v(" "), (item.couponOwnerState == 'ALABLE') ? _c('img', {
      attrs: {
        "src": __webpack_require__(1056)
      }
    }) : _vm._e(), _vm._v(" "), (item.couponOwnerState == 'UNABLE') ? _c('img', {
      attrs: {
        "src": __webpack_require__(1057)
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.hideCouponsList
    }
  }, [_vm._v("确定")])])])]) : _vm._e()]) : (_vm.product && _vm.product.invisible) ? _c('beast-main', {
    class: {
      'down-banner': _vm.env === 'm-web' && _vm.showDownBanner
    },
    attrs: {
      "errorMsg": _vm.errorMsg
    }
  }, [_c('img', {
    staticClass: "p-invisible",
    attrs: {
      "src": "//img.thebeastshop.com/app/4.0/bg-invisible.jpeg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownMask),
      expression: "showDownMask"
    }],
    staticClass: "mask-wrap",
    on: {
      "click": function($event) {
        _vm.showDownMask = !_vm.showDownMask
      }
    }
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQXLpBox),
      expression: "showQXLpBox"
    }],
    staticClass: "qxlp-box-wrap"
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleQXLpBox
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.toggleQXLpBox
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("刻字服务规则须知")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rule-confirm"
  }, [_c('div', {
    staticClass: "chk-box",
    on: {
      "click": _vm.checkQxlpChecked
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qxlpChecked),
      expression: "qxlpChecked"
    }],
    attrs: {
      "src": "//img.thebeastshop.com/app/activity/qxlp/icon-checked.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.qxlpChecked),
      expression: "!qxlpChecked"
    }],
    attrs: {
      "src": "//img.thebeastshop.com/app/activity/qxlp/icon-check.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chk-txt"
  }, [_vm._v("本人已阅读并同意上述规则")])]), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('div', {
    staticClass: "btn-item",
    on: {
      "click": function($event) {
        return _vm.confirmCustomCard(true)
      }
    }
  }, [_vm._v("确认刻字")]), _vm._v(" "), _c('div', {
    staticClass: "btn-item grey",
    on: {
      "click": _vm.confirmCustomCard
    }
  }, [_vm._v("无需刻字")])])])]), _vm._v(" "), (_vm.isShowWechatGift) ? _c('gift-wechat-box', {
    on: {
      "buyWechatGift": function($event) {
        return _vm.buyWechatGift('wechatGift')
      },
      "hide": function($event) {
        _vm.isShowWechatGift = false;
        _vm.showWechatGiftAni = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prompt"
  }, [_vm._v("点击右上角菜单"), _c('br'), _vm._v("“在浏览器打开”并安装野兽派")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-content"
  }, [_c('p', [_vm._v("1. 目前仅支持每个输入框填写1个大写英文字母，共两个输入框可输入字符，不支持符号和表情；例如框内可分别输入：“M ”和“ L”。")]), _vm._v(" "), _c('p', [_vm._v("2. 本商品为专属定制商品，定制时我们会为您调整为合适的字体大小及位置，尽可能呈现良好的效果。实际效果以收到的实物为准；")]), _vm._v(" "), _c('p', [_vm._v("3. 确认刻字内容后一旦提交订单，不支持修改。")]), _vm._v(" "), _c('p', [_vm._v("4. 选择刻字服务的订单一经付款，即进入定制阶段，不支持无理由取消订单（即退货、退款）；")]), _vm._v(" "), _c('p', [_vm._v("5. 由于刻字工艺耗时，刻字订单将预计于付款后48小时内发货，且不为此类订单提供非质量问题的退换货服务；")]), _vm._v(" "), _c('p', [_vm._v("6. 因刻字服务需要，工作人员将打开香水瓶身的塑封包装进行刻字。外包装打开痕迹不可避免，敬请谅解。")])])
}]}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "s/img/icon-able.a6ad076.png";

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "s/img/icon-finish.20d23ff.png";

/***/ }),
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(5);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(4);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(1063);

var _index2 = _interopRequireDefault(_index);

var _axiosMock = __webpack_require__(3);

var _axiosMock2 = _interopRequireDefault(_axiosMock);

var _toast = __webpack_require__(26);

var _toast2 = _interopRequireDefault(_toast);

var _slide = __webpack_require__(8);

var _slide2 = _interopRequireDefault(_slide);

var _bridge = __webpack_require__(6);

var _bridge2 = _interopRequireDefault(_bridge);

var _browser = __webpack_require__(1);

var _browser2 = _interopRequireDefault(_browser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_toast2.default);
var isApp = _browser2.default.app();
var vm = void 0,
    _resolve = void 0,
    _reject = void 0;
var plugin = {
  install: function install(vue, options) {

    vue.prototype.$selectCoupon = function (data) {
      // if (isApp) {
      //   return bridge.selectProductVariant(data)
      // }

      var _pomise = new _promise2.default(function (resolve, reject) {
        _resolve = resolve;
        _reject = reject;
      });

      vm = new _vue2.default({
        el: document.createElement('div'),
        template: '<select-coupon :data="data" :show="show" @complete="complete" @select="select"/>\n          ',
        data: {
          data: data,
          show: false
        },
        components: {
          'select-coupon': _index2.default,
          slide: _slide2.default
        },
        methods: {
          complete: function complete(result) {
            this.close();

            result === null ? _reject(cancelError()) : _resolve(result);
          },
          select: function select(couponId) {
            var _this = this;

            this.$ensureLogged().then(function (_ref) {
              var alreadyLogged = _ref.alreadyLogged;

              (0, _axiosMock2.default)({
                url: '/app/activity/receive/coupon/' + couponId
              }).then(function (_ref2) {
                var data = _ref2.data;

                _this.$toast('优惠券已到账, 请在【个人中心】-【我的卡券】查询！');
              }).catch(function (err) {
                _this.$toast(err.message);
              });
            });
          },


          // error (message) {
          //   this.close()
          //   _reject(message)
          // },
          close: function close() {
            this.show = false;
            stopBodyScroll(false);

            document.body.style.position = 'initial';
            document.body.style.height = 'auto';
            if (vm) {
              document.body.removeChild(vm.$el);
            }
          },
          maskTap: function maskTap() {
            this.close();
            _reject(cancelError());
          }
        }
      });
      document.body.appendChild(vm.$el);
      setTimeout(function () {
        vm.show = true;
        stopBodyScroll(true);

        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      }, 0);

      // return new Promise((resolve, reject) => {
      //   _resolve = resolve
      //   _reject = reject
      // })
      return _pomise;
    };
  }
};

_vue2.default.use(plugin);

function cancelError() {
  var error = new Error('USER_CANCEL');
  error.code = 'USER_CANCEL';
  return error;
}

function bodyScroll(event) {
  event.preventDefault();
}

var top1 = 0;

function stopBodyScroll(isFixed) {
  var bodyEl = document.body;
  if (isFixed) {
    top1 = window.scrollY;
    bodyEl.style.position = 'fixed';
    bodyEl.style.top = -top1 + 'px';
  } else {
    bodyEl.style.position = '';
    bodyEl.style.top = '';
    window.scrollTo(0, top1);
  }
}

// this.$selectVariant({
//   data:123
// })
//   .then((result) => {

//   })
//   .catch(() => {

//   })

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1064)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1065),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['data', 'show'],

  methods: {
    close: function close() {
      this.$emit('complete', null);
    },
    getCoupon: function getCoupon(id) {
      this.$emit('select', id);
    }
  }
};

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "select-coupon-wrap"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("11.11大额券")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.data), function(item) {
    return (_vm.data && _vm.data.length) ? _c('div', {
      staticClass: "coupon-item",
      on: {
        "click": function($event) {
          return _vm.getCoupon(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}

/***/ })
],[989]);


// WEBPACK FOOTER //
// s/js/m-product-detail.01cc4bdfc41effa9bfd8.js